import name1 from "./../../assets/posts/1.jpg";
import name2 from "./../../assets/posts/2.jpg";
import name3 from "./../../assets/posts/3.jpg";
import name4 from "./../../assets/posts/4.jpg";
import name5 from "./../../assets/posts/5.jpg";
import name6 from "./../../assets/posts/6.png";
import name7 from "./../../assets/posts/7.jpg";
import name8 from "./../../assets/posts/8.jpg";
import name9 from "./../../assets/posts/9.jpg";
import name10 from "./../../assets/posts/10.jpg";
import name11 from "./../../assets/posts/11.jpg";
import name12 from "./../../assets/posts/12.jpg";
import name13 from "./../../assets/posts/13.jpg";
import name14 from "./../../assets/posts/14.jpg";
import name15 from "./../../assets/posts/15.jpg";
import name16 from "./../../assets/posts/16.png";
import name17 from "./../../assets/posts/17.jpg";
import name18 from "./../../assets/posts/18.jpg";
import name19 from "./../../assets/posts/19.jpg";
import name20 from "./../../assets/posts/20.jpg";
import name21 from "./../../assets/posts/21.jpg";
import name22 from "./../../assets/posts/22.jpg";
import name23 from "./../../assets/posts/23.jpg";
import name24 from "./../../assets/posts/24.jpg";
import name25 from "./../../assets/posts/25.jpg";
import name26 from "./../../assets/posts/26.jpg";
import name27 from "./../../assets/posts/27.jpg";
import name28 from "./../../assets/posts/28.jpg";
import name29 from "./../../assets/posts/29.jpg";
import name30 from "./../../assets/posts/30.jpg";
import name31 from "./../../assets/posts/31.jpg";
import name32 from "./../../assets/posts/32.jpg";
import name33 from "./../../assets/posts/33.jpg";
import name34 from "./../../assets/posts/34.jpg";
import name35 from "./../../assets/posts/35.jpg";
import name36 from "./../../assets/posts/36.jpg";
import name37 from "./../../assets/posts/37.jpg";
import name38 from "./../../assets/posts/38.jpg";
import name39 from "./../../assets/posts/39.jpg";
import name40 from "./../../assets/posts/40.jpg";
import name41 from "./../../assets/posts/41.jpg";
import name42 from "./../../assets/posts/42.jpg";
import name43 from "./../../assets/posts/43.jpg";
import name44 from "./../../assets/posts/44.jpg";
import name45 from "./../../assets/posts/45.jpg";
import name46 from "./../../assets/posts/46.jpg";
import name47 from "./../../assets/posts/47.jpg";
import name48 from "./../../assets/posts/48.jpg";
import name49 from "./../../assets/posts/49.jpg";
import name50 from "./../../assets/posts/50.png";
import name51 from "./../../assets/posts/51.jpg";
import name52 from "./../../assets/posts/52.jpg";
import name53 from "./../../assets/posts/53.jpg";
import name54 from "./../../assets/posts/54.jpg";
import name55 from "./../../assets/posts/55.jpg";
import name56 from "./../../assets/posts/56.jpg";
import name57 from "./../../assets/posts/57.jpg";
import name58 from "./../../assets/posts/58.jpg";
import name59 from "./../../assets/posts/59.jpg";
import name60 from "./../../assets/posts/60.jpg";
import name61 from "./../../assets/posts/61.jpg";
import name62 from "./../../assets/posts/62.jpg";
import name63 from "./../../assets/posts/63.jpg";
import name64 from "./../../assets/posts/64.jpg";
import name65 from "./../../assets/posts/65.jpg";
import name66 from "./../../assets/posts/66.jpg";
import name67 from "./../../assets/posts/67.jpg";
import name68 from "./../../assets/posts/68.jpg";
import name69 from "./../../assets/posts/69.jpg";
import name70 from "./../../assets/posts/70.jpg";
import name71 from "./../../assets/posts/71.jpg";
import name72 from "./../../assets/posts/72.jpg";
import name73 from "./../../assets/posts/73.jpg";
import name74 from "./../../assets/posts/74.jpg";
import name75 from "./../../assets/posts/75.jpg";
import name76 from "./../../assets/posts/76.jpg";
import name77 from "./../../assets/posts/77.jpg";
import name78 from "./../../assets/posts/78.jpg";
import name79 from "./../../assets/posts/79.jpg";
import name80 from "./../../assets/posts/80.jpg";
import name81 from "./../../assets/posts/81.jpg";
import name82 from "./../../assets/posts/82.jpg";
import name83 from "./../../assets/posts/83.jpg";
import name84 from "./../../assets/posts/84.jpg";
import name85 from "./../../assets/posts/85.jpg";
import name86 from "./../../assets/posts/86.jpg";
import name87 from "./../../assets/posts/87.jpg";
import name88 from "./../../assets/posts/88.jpg";
import name89 from "./../../assets/posts/89.jpg";
import name90 from "./../../assets/posts/90.jpg";
import name91 from "./../../assets/posts/91.jpg";
import name92 from "./../../assets/posts/92.jpg";
import name93 from "./../../assets/posts/93.jpg";
import name94 from "./../../assets/posts/94.jpg";
import name95 from "./../../assets/posts/95.jpg";
import name96 from "./../../assets/posts/96.jpg";
import name97 from "./../../assets/posts/97.jpg";
import name98 from "./../../assets/posts/98.jpg";
import name99 from "./../../assets/posts/99.jpg";
import name100 from "./../../assets/posts/100.jpg";
import name101 from "./../../assets/posts/101.jpg";
import name102 from "./../../assets/posts/102.jpg";
import name103 from "./../../assets/posts/103.jpg";
import name104 from "./../../assets/posts/104.jpg";
import name105 from "./../../assets/posts/105.jpg";
import name106 from "./../../assets/posts/106.jpg";
import name107 from "./../../assets/posts/107.jpg";
import name108 from "./../../assets/posts/108.jpg";
import name109 from "./../../assets/posts/109.jpg";
import name110 from "./../../assets/posts/110.jpg";
import name111 from "./../../assets/posts/111.jpg";
import name112 from "./../../assets/posts/112.jpg";
import name113 from "./../../assets/posts/113.jpg";
import name114 from "./../../assets/posts/114.jpg";
import name115 from "./../../assets/posts/115.jpg";
import name116 from "./../../assets/posts/116.jpg";
import name117 from "./../../assets/posts/117.jpg";
import name118 from "./../../assets/posts/118.jpg";
import name119 from "./../../assets/posts/119.png";
import name120 from "./../../assets/posts/120.jpg";
import name121 from "./../../assets/posts/121.jpg";
import name122 from "./../../assets/posts/122.jpg";
import name123 from "./../../assets/posts/123.jpg";
import name124 from "./../../assets/posts/124.jpg";
import name125 from "./../../assets/posts/125.jpg";
import name126 from "./../../assets/posts/126.jpg";
import name127 from "./../../assets/posts/127.jpg";
import name128 from "./../../assets/posts/128.jpg";
import name129 from "./../../assets/posts/129.jpg";
import name130 from "./../../assets/posts/130.jpg";
import name131 from "./../../assets/posts/131.jpg";
import name132 from "./../../assets/posts/132.jpg";
import name133 from "./../../assets/posts/133.jpg";
import name134 from "./../../assets/posts/134.jpg";
import name135 from "./../../assets/posts/135.jpg";
import name136 from "./../../assets/posts/136.jpg";
import name137 from "./../../assets/posts/137.jpg";
import name138 from "./../../assets/posts/138.jpg";
import name139 from "./../../assets/posts/139.jpg";
import name140 from "./../../assets/posts/140.jpg";
import name141 from "./../../assets/posts/141.jpg";
import name142 from "./../../assets/posts/142.jpg";
import name143 from "./../../assets/posts/143.jpg";
import name144 from "./../../assets/posts/144.jpg";
import name145 from "./../../assets/posts/145.jpg";
import name146 from "./../../assets/posts/146.jpg";
import name147 from "./../../assets/posts/147.jpg";
import name148 from "./../../assets/posts/148.jpg";
import name149 from "./../../assets/posts/149.jpg";
import name150 from "./../../assets/posts/150.jpg";
import name151 from "./../../assets/posts/151.jpg";
import name152 from "./../../assets/posts/152.jpg";
import name153 from "./../../assets/posts/153.jpg";
import name154 from "./../../assets/posts/154.jpg";
import name155 from "./../../assets/posts/155.jpg";
import name156 from "./../../assets/posts/156.jpg";
import name157 from "./../../assets/posts/157.jpg";
import name158 from "./../../assets/posts/158.jpg";
import name159 from "./../../assets/posts/159.jpg";
import name160 from "./../../assets/posts/160.jpg";
import name161 from "./../../assets/posts/161.jpg";
import name162 from "./../../assets/posts/162.jpg";
import name163 from "./../../assets/posts/163.jpg";
import name164 from "./../../assets/posts/164.jpg";
import name165 from "./../../assets/posts/165.jpg";
import name166 from "./../../assets/posts/166.jpg";
import name167 from "./../../assets/posts/167.jpg";
import name168 from "./../../assets/posts/168.jpg";
import name169 from "./../../assets/posts/169.jpg";
import name170 from "./../../assets/posts/170.jpg";
import name171 from "./../../assets/posts/171.jpg";
import name172 from "./../../assets/posts/172.jpg";
import name173 from "./../../assets/posts/173.jpg";
import name174 from "./../../assets/posts/174.jpg";
import name175 from "./../../assets/posts/175.jpg";
import name176 from "./../../assets/posts/176.jpg";
import name177 from "./../../assets/posts/177.jpg";
import name178 from "./../../assets/posts/178.jpg";
import name179 from "./../../assets/posts/179.jpg";
import name180 from "./../../assets/posts/180.jpg";
import name181 from "./../../assets/posts/181.jpg";
import name182 from "./../../assets/posts/182.jpg";
import name183 from "./../../assets/posts/183.jpg";
import name184 from "./../../assets/posts/184.jpg";
import name185 from "./../../assets/posts/185.jpg";
import name186 from "./../../assets/posts/186.jpg";
import name187 from "./../../assets/posts/187.jpg";
import name188 from "./../../assets/posts/188.jpg";
import name189 from "./../../assets/posts/189.jpg";
import name190 from "./../../assets/posts/190.jpg";
import name191 from "./../../assets/posts/191.jpg";
import name192 from "./../../assets/posts/192.jpg";
import name193 from "./../../assets/posts/193.jpg";
import name194 from "./../../assets/posts/194.jpg";
import name195 from "./../../assets/posts/195.jpg";
import name196 from "./../../assets/posts/196.jpg";
import name197 from "./../../assets/posts/197.jpg";
import name198 from "./../../assets/posts/198.jpg";
import name199 from "./../../assets/posts/199.jpg";
import name200 from "./../../assets/posts/200.jpg";
import name201 from "./../../assets/posts/201.jpg";
import name202 from "./../../assets/posts/202.jpg";
import name203 from "./../../assets/posts/203.jpg";
import name204 from "./../../assets/posts/204.jpg";
import name205 from "./../../assets/posts/205.jpg";
import name206 from "./../../assets/posts/206.jpg";
import name207 from "./../../assets/posts/207.jpg";
import name208 from "./../../assets/posts/208.jpg";
import name209 from "./../../assets/posts/209.jpg";
import name210 from "./../../assets/posts/210.jpg";
import name211 from "./../../assets/posts/211.jpg";
import name212 from "./../../assets/posts/212.jpg";
import name213 from "./../../assets/posts/213.jpg";
import name214 from "./../../assets/posts/214.jpg";
import name215 from "./../../assets/posts/215.jpg";
import name216 from "./../../assets/posts/216.jpg";
import name217 from "./../../assets/posts/217.jpg";
import name218 from "./../../assets/posts/218.jpg";
import name219 from "./../../assets/posts/219.jpg";
import name220 from "./../../assets/posts/220.jpg";
import name221 from "./../../assets/posts/221.jpg";
import name222 from "./../../assets/posts/222.jpg";
import name223 from "./../../assets/posts/223.jpg";
import name224 from "./../../assets/posts/224.jpg";
import name225 from "./../../assets/posts/225.jpg";
import name226 from "./../../assets/posts/226.jpg";
import name227 from "./../../assets/posts/227.jpg";
import name228 from "./../../assets/posts/228.jpg";
import name229 from "./../../assets/posts/229.jpg";
import name230 from "./../../assets/posts/230.jpg";
import name231 from "./../../assets/posts/231.jpg";
import name232 from "./../../assets/posts/232.jpg";
import name233 from "./../../assets/posts/233.jpg";
import name234 from "./../../assets/posts/234.jpg";
import name235 from "./../../assets/posts/235.jpg";
import name236 from "./../../assets/posts/236.jpg";
import name237 from "./../../assets/posts/237.jpg";
import name238 from "./../../assets/posts/238.jpg";
import name239 from "./../../assets/posts/239.jpg";
import name240 from "./../../assets/posts/240.jpg";
import name241 from "./../../assets/posts/241.jpg";
import name242 from "./../../assets/posts/242.jpg";
import name243 from "./../../assets/posts/243.jpg";
import name244 from "./../../assets/posts/244.jpg";
import name245 from "./../../assets/posts/245.jpg";
import name246 from "./../../assets/posts/246.jpg";
import name247 from "./../../assets/posts/247.jpg";
import name248 from "./../../assets/posts/248.jpg";
import name249 from "./../../assets/posts/249.jpg";
import name250 from "./../../assets/posts/250.jpg";
import name251 from "./../../assets/posts/251.jpg";
import name252 from "./../../assets/posts/252.jpg";
import name253 from "./../../assets/posts/253.jpg";
import name254 from "./../../assets/posts/254.jpg";
import name255 from "./../../assets/posts/255.jpg";
import name256 from "./../../assets/posts/256.jpg";
import name257 from "./../../assets/posts/257.jpg";
import name258 from "./../../assets/posts/258.jpg";
import name259 from "./../../assets/posts/259.jpg";
import name260 from "./../../assets/posts/260.jpg";
import name261 from "./../../assets/posts/261.jpg";
import name262 from "./../../assets/posts/262.jpg";
import name263 from "./../../assets/posts/263.jpg";
import name264 from "./../../assets/posts/264.jpg";
import name265 from "./../../assets/posts/265.jpg";
import name266 from "./../../assets/posts/266.jpg";
import name267 from "./../../assets/posts/267.jpg";
import name268 from "./../../assets/posts/268.jpg";
import name269 from "./../../assets/posts/269.jpg";
import name270 from "./../../assets/posts/270.jpg";
import name271 from "./../../assets/posts/271.jpg";
import name272 from "./../../assets/posts/272.jpg";
import name273 from "./../../assets/posts/273.jpg";
import name274 from "./../../assets/posts/274.jpg";
import name275 from "./../../assets/posts/275.jpg";
import name276 from "./../../assets/posts/276.jpg";
import name277 from "./../../assets/posts/277.jpg";
import name278 from "./../../assets/posts/278.jpg";
import name279 from "./../../assets/posts/279.jpg";
import name280 from "./../../assets/posts/280.jpg";
import name281 from "./../../assets/posts/281.jpg";
import name282 from "./../../assets/posts/282.jpg";
import name283 from "./../../assets/posts/283.jpg";
import name284 from "./../../assets/posts/284.jpg";
import name285 from "./../../assets/posts/285.jpg";
import name286 from "./../../assets/posts/286.jpg";
import name287 from "./../../assets/posts/287.jpg";
import name288 from "./../../assets/posts/288.jpg";
import name289 from "./../../assets/posts/289.jpg";
import name290 from "./../../assets/posts/290.jpg";
import name291 from "./../../assets/posts/291.jpg";
import name292 from "./../../assets/posts/292.jpg";
import name293 from "./../../assets/posts/293.jpg";
import name294 from "./../../assets/posts/294.jpg";
import name295 from "./../../assets/posts/295.jpg";
import name296 from "./../../assets/posts/296.jpg";
import name297 from "./../../assets/posts/297.jpg";
import name298 from "./../../assets/posts/298.jpg";
import name299 from "./../../assets/posts/299.jpg";
import name300 from "./../../assets/posts/300.jpg";
import name301 from "./../../assets/posts/301.jpg";
import name302 from "./../../assets/posts/302.jpg";
import name303 from "./../../assets/posts/303.jpg";
import name304 from "./../../assets/posts/304.jpg";
import name305 from "./../../assets/posts/305.jpg";
import name306 from "./../../assets/posts/306.jpg";
import name307 from "./../../assets/posts/307.jpg";
import name308 from "./../../assets/posts/308.jpg";
import name309 from "./../../assets/posts/309.jpg";
import name310 from "./../../assets/posts/310.jpg";
import name311 from "./../../assets/posts/311.jpg";
import name312 from "./../../assets/posts/312.jpg";
import name313 from "./../../assets/posts/313.jpg";
import name314 from "./../../assets/posts/314.jpg";
import name315 from "./../../assets/posts/315.jpg";
import name316 from "./../../assets/posts/316.jpg";
import name317 from "./../../assets/posts/317.jpg";
import name318 from "./../../assets/posts/318.jpg";
import name319 from "./../../assets/posts/319.jpg";
import name320 from "./../../assets/posts/320.jpg";
import name321 from "./../../assets/posts/321.jpg";
import name322 from "./../../assets/posts/322.jpg";
import name323 from "./../../assets/posts/323.jpg";
import name324 from "./../../assets/posts/324.jpg";
import name325 from "./../../assets/posts/325.jpg";
import name326 from "./../../assets/posts/326.jpg";
import name327 from "./../../assets/posts/327.jpg";
import name328 from "./../../assets/posts/328.jpg";
import name329 from "./../../assets/posts/329.jpg";
import name330 from "./../../assets/posts/330.jpg";
import name331 from "./../../assets/posts/331.jpg";
import name332 from "./../../assets/posts/332.jpg";
import name333 from "./../../assets/posts/333.jpg";
import name334 from "./../../assets/posts/334.jpg";
import name335 from "./../../assets/posts/335.jpg";
import name336 from "./../../assets/posts/336.jpg";
import name337 from "./../../assets/posts/337.jpg";
import name338 from "./../../assets/posts/338.jpg";
import name339 from "./../../assets/posts/339.jpg";
import name340 from "./../../assets/posts/340.jpg";
import name341 from "./../../assets/posts/341.jpg";
import name342 from "./../../assets/posts/342.jpg";
import name343 from "./../../assets/posts/343.jpg";
import name344 from "./../../assets/posts/344.jpg";
import name345 from "./../../assets/posts/345.jpg";
import name346 from "./../../assets/posts/346.jpg";
import name347 from "./../../assets/posts/347.jpg";
import name348 from "./../../assets/posts/348.jpg";
import name349 from "./../../assets/posts/349.jpg";
import name350 from "./../../assets/posts/350.jpg";
import name351 from "./../../assets/posts/351.jpg";
import name352 from "./../../assets/posts/352.jpg";
import name353 from "./../../assets/posts/353.jpg";
import name354 from "./../../assets/posts/354.jpg";
import name355 from "./../../assets/posts/355.jpg";
import name356 from "./../../assets/posts/356.jpg";
import name357 from "./../../assets/posts/357.jpg";
import name358 from "./../../assets/posts/358.jpg";
import name359 from "./../../assets/posts/359.jpg";
import name360 from "./../../assets/posts/360.jpg";
import name361 from "./../../assets/posts/361.jpg";
import name362 from "./../../assets/posts/362.jpg";
import name363 from "./../../assets/posts/363.jpg";
import name364 from "./../../assets/posts/364.jpg";
import name365 from "./../../assets/posts/365.jpg";
import name366 from "./../../assets/posts/366.jpg";
import name367 from "./../../assets/posts/367.jpg";
import name368 from "./../../assets/posts/368.jpg";
import name369 from "./../../assets/posts/369.jpg";
import name370 from "./../../assets/posts/370.jpg";
import name371 from "./../../assets/posts/371.jpg";
import name372 from "./../../assets/posts/372.jpg";
import name373 from "./../../assets/posts/373.jpg";
import name374 from "./../../assets/posts/374.jpg";
import name375 from "./../../assets/posts/375.jpg";
import name376 from "./../../assets/posts/376.jpg";
import name377 from "./../../assets/posts/377.jpg";
import name378 from "./../../assets/posts/378.jpg";
import name379 from "./../../assets/posts/379.jpg";
import name380 from "./../../assets/posts/380.jpg";
import name381 from "./../../assets/posts/381.jpg";
import name382 from "./../../assets/posts/382.jpg";
import name383 from "./../../assets/posts/383.jpg";
import name384 from "./../../assets/posts/384.jpg";
import name385 from "./../../assets/posts/385.jpg";
import name386 from "./../../assets/posts/386.jpg";
import name387 from "./../../assets/posts/387.jpg";
import name388 from "./../../assets/posts/388.jpg";
import name389 from "./../../assets/posts/389.jpg";
import name390 from "./../../assets/posts/390.jpg";
import name391 from "./../../assets/posts/391.jpg";
import name392 from "./../../assets/posts/392.jpg";
import name393 from "./../../assets/posts/393.jpg";
import name394 from "./../../assets/posts/394.jpg";
import name395 from "./../../assets/posts/395.jpg";
import name396 from "./../../assets/posts/396.jpg";
import name397 from "./../../assets/posts/397.jpg";
import name398 from "./../../assets/posts/398.jpg";
import name399 from "./../../assets/posts/399.jpg";
import name400 from "./../../assets/posts/400.jpg";
import name401 from "./../../assets/posts/401.jpg";
import name402 from "./../../assets/posts/402.jpg";
import name403 from "./../../assets/posts/403.jpg";
import name404 from "./../../assets/posts/404.jpg";
import name405 from "./../../assets/posts/405.jpg";
import name406 from "./../../assets/posts/406.jpg";
import name407 from "./../../assets/posts/407.jpg";
import name408 from "./../../assets/posts/408.jpg";
import name409 from "./../../assets/posts/409.jpg";
import name410 from "./../../assets/posts/410.jpg";
import name411 from "./../../assets/posts/411.jpg";
import name412 from "./../../assets/posts/412.jpg";
import name413 from "./../../assets/posts/413.jpg";
import name414 from "./../../assets/posts/414.jpg";
import name415 from "./../../assets/posts/415.jpg";
import name416 from "./../../assets/posts/416.jpg";
import name417 from "./../../assets/posts/417.jpg";
import name418 from "./../../assets/posts/418.jpg";
import name419 from "./../../assets/posts/419.jpg";
import name420 from "./../../assets/posts/420.jpg";
import name421 from "./../../assets/posts/421.jpg";
import name422 from "./../../assets/posts/422.jpg";
import name423 from "./../../assets/posts/423.jpg";
import name424 from "./../../assets/posts/424.jpg";
import name425 from "./../../assets/posts/425.jpg";
import name426 from "./../../assets/posts/426.jpg";
import name427 from "./../../assets/posts/427.jpg";
import name428 from "./../../assets/posts/428.jpg";
import name429 from "./../../assets/posts/429.jpg";
import name430 from "./../../assets/posts/430.jpg";
import name431 from "./../../assets/posts/431.jpg";
import name432 from "./../../assets/posts/432.jpg";
import name433 from "./../../assets/posts/433.jpg";
import name434 from "./../../assets/posts/434.jpg";

import name435 from "./../../assets/posts/435/0.jpg";
import post4351 from "./../../assets/posts/435/1.jpg";
import post4352 from "./../../assets/posts/435/2.jpg";
import post4353 from "./../../assets/posts/435/3.jpg";
import post4354 from "./../../assets/posts/435/4.jpg";

import name436 from "./../../assets/posts/436/0.jpg";
import post4361 from "./../../assets/posts/436/1.jpg";
import post4362 from "./../../assets/posts/436/2.jpg";
import post4363 from "./../../assets/posts/436/3.jpg";
import post4364 from "./../../assets/posts/436/4.jpg";

import name437 from "./../../assets/posts/437/0.jpg";
import post4371 from "./../../assets/posts/437/1.jpg";
import post4372 from "./../../assets/posts/437/2.jpg";
import post4373 from "./../../assets/posts/437/3.jpg";
import post4374 from "./../../assets/posts/437/4.jpg";
import post4375 from "./../../assets/posts/437/5.jpg";
import post4376 from "./../../assets/posts/437/6.jpg";
import post4377 from "./../../assets/posts/437/7.jpg";
import post4378 from "./../../assets/posts/437/8.jpg";

import name438 from "./../../assets/posts/438/0.jpg";
import post4381 from "./../../assets/posts/438/1.jpg";
import post4382 from "./../../assets/posts/438/2.jpg";

import name439 from "./../../assets/posts/439/0.jpg";
import post4391 from "./../../assets/posts/439/1.jpg";
import post4392 from "./../../assets/posts/439/2.jpg";
import post4393 from "./../../assets/posts/439/3.jpg";
import post4394 from "./../../assets/posts/439/4.jpg";
import post4395 from "./../../assets/posts/439/5.jpg";
import post4396 from "./../../assets/posts/439/6.jpg";
import post4397 from "./../../assets/posts/439/7.jpg";
import post4398 from "./../../assets/posts/439/8.jpg";
import post4399 from "./../../assets/posts/439/9.jpg";

import name440 from "./../../assets/posts/440/0.jpg";
import post4401 from "./../../assets/posts/440/1.jpg";

import name441 from "./../../assets/posts/441/0.jpg";
import post4411 from "./../../assets/posts/441/1.jpg";

import name442 from "./../../assets/posts/442/0.jpg";
import post4421 from "./../../assets/posts/442/1.jpg";
import post4422 from "./../../assets/posts/442/2.jpg";
import post4423 from "./../../assets/posts/442/3.jpg";
import post4424 from "./../../assets/posts/442/4.jpg";
import post4425 from "./../../assets/posts/442/5.jpg";
import post4426 from "./../../assets/posts/442/6.jpg";
import post4427 from "./../../assets/posts/442/7.jpg";
import post4428 from "./../../assets/posts/442/8.jpg";

import name443 from "./../../assets/posts/443/0.jpg";
import post4431 from "./../../assets/posts/443/1.jpg";
import post4432 from "./../../assets/posts/443/2.jpg";
import post4433 from "./../../assets/posts/443/3.jpg";
import post4434 from "./../../assets/posts/443/4.jpg";
import post4435 from "./../../assets/posts/443/5.jpg";
import post4436 from "./../../assets/posts/443/6.jpg";
import post4437 from "./../../assets/posts/443/7.jpg";
import post4438 from "./../../assets/posts/443/8.jpg";
import post4439 from "./../../assets/posts/443/9.jpg";
import post44310 from "./../../assets/posts/443/10.jpg";
import post44311 from "./../../assets/posts/443/11.jpg";
import post44312 from "./../../assets/posts/443/12.jpg";

import name444 from "./../../assets/posts/444/0.jpg";
import post4441 from "./../../assets/posts/444/1.jpg";
import post4442 from "./../../assets/posts/444/2.jpg";
import post4443 from "./../../assets/posts/444/3.jpg";
import post4444 from "./../../assets/posts/444/4.jpg";
import post4445 from "./../../assets/posts/444/5.jpg";
import post4446 from "./../../assets/posts/444/6.jpg";
import post4447 from "./../../assets/posts/444/7.jpg";

import name445 from "./../../assets/posts/445/0.jpg";
import post4451 from "./../../assets/posts/445/1.jpg";
import post4452 from "./../../assets/posts/445/2.jpg";
import post4453 from "./../../assets/posts/445/3.jpg";
import post4454 from "./../../assets/posts/445/4.jpg";
import post4455 from "./../../assets/posts/445/5.jpg";

import name446 from "./../../assets/posts/446/0.jpg";
import post4461 from "./../../assets/posts/446/1.jpg";
import post4462 from "./../../assets/posts/446/2.jpg";
import post4463 from "./../../assets/posts/446/3.jpg";

import name447 from "./../../assets/posts/447/0.jpg";
import post4471 from "./../../assets/posts/447/1.jpg";
import post4472 from "./../../assets/posts/447/2.jpg";
import post4473 from "./../../assets/posts/447/3.jpg";
import post4474 from "./../../assets/posts/447/4.jpg";

import name448 from "./../../assets/posts/448/0.jpg";
import post4481 from "./../../assets/posts/448/1.jpg";

import name449 from "./../../assets/posts/449/0.jpg";
import post4491 from "./../../assets/posts/449/1.jpg";
import post4492 from "./../../assets/posts/449/2.jpg";
import post4493 from "./../../assets/posts/449/3.jpg";
import post4494 from "./../../assets/posts/449/4.jpg";

import name450 from "./../../assets/posts/450/0.jpg";
import post4501 from "./../../assets/posts/450/1.jpg";
import post4502 from "./../../assets/posts/450/2.jpg";
import post4503 from "./../../assets/posts/450/3.jpg";
import post4504 from "./../../assets/posts/450/4.jpg";
import post4505 from "./../../assets/posts/450/5.jpg";

import name451 from "./../../assets/posts/451/0.jpg";
import post4511 from "./../../assets/posts/451/1.jpg";
import post4512 from "./../../assets/posts/451/2.jpg";
import post4513 from "./../../assets/posts/451/3.jpg";
import post4514 from "./../../assets/posts/451/4.jpg";
import post4515 from "./../../assets/posts/451/5.jpg";

import name452 from "./../../assets/posts/452/0.jpg";
import post4521 from "./../../assets/posts/452/1.jpg";
import post4522 from "./../../assets/posts/452/2.jpg";
import post4523 from "./../../assets/posts/452/3.jpg";
import post4524 from "./../../assets/posts/452/4.jpg";
import post4525 from "./../../assets/posts/452/5.jpg";
import post4526 from "./../../assets/posts/452/6.jpg";
import post4527 from "./../../assets/posts/452/7.jpg";
import post4528 from "./../../assets/posts/452/8.jpg";
import post4529 from "./../../assets/posts/452/9.jpg";
import post45210 from "./../../assets/posts/452/10.jpg";

import name453 from "./../../assets/posts/453/0.jpg";
import post4531 from "./../../assets/posts/453/1.jpg";
import post4532 from "./../../assets/posts/453/2.jpg";
import post4533 from "./../../assets/posts/453/3.jpg";
import post4534 from "./../../assets/posts/453/4.jpg";
import post4535 from "./../../assets/posts/453/5.jpg";
import post4536 from "./../../assets/posts/453/6.jpg";
import post4537 from "./../../assets/posts/453/7.jpg";

import name454 from "./../../assets/posts/454/0.jpg";
import post4541 from "./../../assets/posts/454/1.jpg";
import post4542 from "./../../assets/posts/454/2.jpg";
import post4543 from "./../../assets/posts/454/3.jpg";
import post4544 from "./../../assets/posts/454/4.jpg";
import post4545 from "./../../assets/posts/454/5.jpg";
import post4546 from "./../../assets/posts/454/6.jpg";
import post4547 from "./../../assets/posts/454/7.jpg";
import post4548 from "./../../assets/posts/454/8.jpg";

import name455 from "./../../assets/posts/455/0.jpg";
import post4551 from "./../../assets/posts/455/1.jpg";
import post4552 from "./../../assets/posts/455/2.jpg";
import post4553 from "./../../assets/posts/455/3.jpg";
import post4554 from "./../../assets/posts/455/4.jpg";
import post4555 from "./../../assets/posts/455/5.jpg";
import post4556 from "./../../assets/posts/455/6.jpg";
import post4557 from "./../../assets/posts/455/7.jpg";

import name456 from "./../../assets/posts/456/0.jpg";
import post4561 from "./../../assets/posts/456/1.jpg";
import post4562 from "./../../assets/posts/456/2.jpg";
import post4563 from "./../../assets/posts/456/3.jpg";
import post4564 from "./../../assets/posts/456/4.jpg";

import name457 from "./../../assets/posts/457/0.jpg";
import post4571 from "./../../assets/posts/457/1.jpg";
import post4572 from "./../../assets/posts/457/2.jpg";
import post4573 from "./../../assets/posts/457/3.jpg";
import post4574 from "./../../assets/posts/457/4.jpg";
import post4575 from "./../../assets/posts/457/5.jpg";
import post4576 from "./../../assets/posts/457/6.jpg";
import post4577 from "./../../assets/posts/457/7.jpg";
import post4578 from "./../../assets/posts/457/8.jpg";

import name458 from "./../../assets/posts/458/0.jpg";
import post4581 from "./../../assets/posts/458/1.jpg";
import post4582 from "./../../assets/posts/458/2.jpg";
import post4583 from "./../../assets/posts/458/3.jpg";
import post4584 from "./../../assets/posts/458/4.jpg";
import post4585 from "./../../assets/posts/458/5.jpg";
import post4586 from "./../../assets/posts/458/6.jpg";
import post4587 from "./../../assets/posts/458/7.jpg";
import post4588 from "./../../assets/posts/458/8.jpg";
import post4589 from "./../../assets/posts/458/9.jpg";

import name459 from "./../../assets/posts/459/0.jpg";
import post4591 from "./../../assets/posts/459/1.jpg";
import post4592 from "./../../assets/posts/459/2.jpg";
import post4593 from "./../../assets/posts/459/3.jpg";
import post4594 from "./../../assets/posts/459/4.jpg";
import post4595 from "./../../assets/posts/459/5.jpg";
import post4596 from "./../../assets/posts/459/6.jpg";
import post4597 from "./../../assets/posts/459/7.jpg";
import post4598 from "./../../assets/posts/459/8.jpg";
import post4599 from "./../../assets/posts/459/9.jpg";
import post45910 from "./../../assets/posts/459/10.jpg";

import name460 from "./../../assets/posts/460/0.jpg";
import post4601 from "./../../assets/posts/460/1.jpg";
import post4602 from "./../../assets/posts/460/2.jpg";
import post4603 from "./../../assets/posts/460/3.jpg";
import post4604 from "./../../assets/posts/460/4.jpg";
import post4605 from "./../../assets/posts/460/5.jpg";
import post4606 from "./../../assets/posts/460/6.jpg";

import name461 from "./../../assets/posts/461/0.jpg";
import post4611 from "./../../assets/posts/461/1.jpg";
import post4612 from "./../../assets/posts/461/2.jpg";
import post4613 from "./../../assets/posts/461/3.jpg";
import post4614 from "./../../assets/posts/461/4.jpg";
import post4615 from "./../../assets/posts/461/5.jpg";
import post4616 from "./../../assets/posts/461/6.jpg";
import post4617 from "./../../assets/posts/461/7.jpg";

import name462 from "./../../assets/posts/462/0.jpg";
import post4621 from "./../../assets/posts/462/1.jpg";
import post4622 from "./../../assets/posts/462/2.jpg";

import name463 from "./../../assets/posts/463/0.jpg";
import post4631 from "./../../assets/posts/463/1.jpg";
import post4632 from "./../../assets/posts/463/2.jpg";
import post4633 from "./../../assets/posts/463/3.jpg";
import post4634 from "./../../assets/posts/463/4.jpg";
import post4635 from "./../../assets/posts/463/5.jpg";
import post4636 from "./../../assets/posts/463/6.jpg";
import post4637 from "./../../assets/posts/463/7.jpg";
import post4638 from "./../../assets/posts/463/8.jpg";

import name464 from "./../../assets/posts/464/0.jpg";
import post4641 from "./../../assets/posts/464/1.jpg";
import post4642 from "./../../assets/posts/464/2.jpg";
import post4643 from "./../../assets/posts/464/3.jpg";
import post4644 from "./../../assets/posts/464/4.jpg";
import post4645 from "./../../assets/posts/464/5.jpg";
import post4646 from "./../../assets/posts/464/6.jpg";
import post4647 from "./../../assets/posts/464/7.jpg";
import post4648 from "./../../assets/posts/464/8.jpg";
import post4649 from "./../../assets/posts/464/9.jpg";

import name465 from "./../../assets/posts/465/0.jpg";
import post4651 from "./../../assets/posts/465/1.jpg";
import post4652 from "./../../assets/posts/465/2.jpg";
import post4653 from "./../../assets/posts/465/3.jpg";
import post4654 from "./../../assets/posts/465/4.jpg";

import name466 from "./../../assets/posts/466/0.jpg";
import post4661 from "./../../assets/posts/466/1.jpg";
import post4662 from "./../../assets/posts/466/2.jpg";
import post4663 from "./../../assets/posts/466/3.jpg";
import post4664 from "./../../assets/posts/466/4.jpg";

import name467 from "./../../assets/posts/467/0.jpg";
import post4671 from "./../../assets/posts/467/1.jpg";
import post4672 from "./../../assets/posts/467/2.jpg";
import post4673 from "./../../assets/posts/467/3.jpg";
import post4674 from "./../../assets/posts/467/4.jpg";
import post4675 from "./../../assets/posts/467/5.jpg";
import post4676 from "./../../assets/posts/467/6.jpg";
import post4677 from "./../../assets/posts/467/7.jpg";
import post4678 from "./../../assets/posts/467/8.jpg";

import name468 from "./../../assets/posts/468/0.jpg";
import post4681 from "./../../assets/posts/468/1.jpg";
import post4682 from "./../../assets/posts/468/2.jpg";
import post4683 from "./../../assets/posts/468/3.jpg";
import post4684 from "./../../assets/posts/468/4.jpg";
import post4685 from "./../../assets/posts/468/5.jpg";
import post4686 from "./../../assets/posts/468/6.jpg";
import post4687 from "./../../assets/posts/468/7.jpg";
import post4688 from "./../../assets/posts/468/8.jpg";
import post4689 from "./../../assets/posts/468/9.jpg";

import name469 from "./../../assets/posts/469/0.jpg";
import post4691 from "./../../assets/posts/469/1.jpg";
import post4692 from "./../../assets/posts/469/2.jpg";
import post4693 from "./../../assets/posts/469/3.jpg";
import post4694 from "./../../assets/posts/469/4.jpg";
import post4695 from "./../../assets/posts/469/5.jpg";
import post4696 from "./../../assets/posts/469/6.jpg";
import post4697 from "./../../assets/posts/469/7.jpg";

import name470 from "./../../assets/posts/470/0.jpg";
import post4701 from "./../../assets/posts/470/1.jpg";
import post4702 from "./../../assets/posts/470/2.jpg";
import post4703 from "./../../assets/posts/470/3.jpg";
import post4704 from "./../../assets/posts/470/4.jpg";
import post4705 from "./../../assets/posts/470/5.jpg";

import name471 from "./../../assets/posts/471/0.jpg";

import name472 from "./../../assets/posts/472/0.jpg";

import name473 from "./../../assets/posts/473/0.jpg";
import post4731 from "./../../assets/posts/473/1.jpg";
import post4732 from "./../../assets/posts/473/2.jpg";
import post4733 from "./../../assets/posts/473/3.jpg";
import post4734 from "./../../assets/posts/473/4.jpg";
import post4735 from "./../../assets/posts/473/5.jpg";

import name474 from "./../../assets/posts/474/0.jpg";
import post4741 from "./../../assets/posts/474/1.jpg";
import post4742 from "./../../assets/posts/474/2.jpg";

import name475 from "./../../assets/posts/475/0.jpg";
import post4751 from "./../../assets/posts/475/1.jpg";
import post4752 from "./../../assets/posts/475/2.jpg";
import post4753 from "./../../assets/posts/475/3.jpg";
import post4754 from "./../../assets/posts/475/4.jpg";
import post4755 from "./../../assets/posts/475/5.jpg";
import post4756 from "./../../assets/posts/475/6.jpg";
import post4757 from "./../../assets/posts/475/7.jpg";
import post4758 from "./../../assets/posts/475/8.jpg";
import post4759 from "./../../assets/posts/475/9.jpg";
import post47510 from "./../../assets/posts/475/10.jpg";

import name476 from "./../../assets/posts/476/0.jpg";
import post4761 from "./../../assets/posts/476/1.jpg";
import post4762 from "./../../assets/posts/476/2.jpg";
import post4763 from "./../../assets/posts/476/3.jpg";
import post4764 from "./../../assets/posts/476/4.jpg";
import post4765 from "./../../assets/posts/476/5.jpg";
import post4766 from "./../../assets/posts/476/6.jpg";
import post4767 from "./../../assets/posts/476/7.jpg";
import post4768 from "./../../assets/posts/476/8.jpg";
import post4769 from "./../../assets/posts/476/9.jpg";
import post47610 from "./../../assets/posts/476/10.jpg";
import post47611 from "./../../assets/posts/476/11.jpg";

import name477 from "./../../assets/posts/477/0.jpg";
import post4771 from "./../../assets/posts/477/1.jpg";

import name478 from "./../../assets/posts/478/0.jpg";
import post4781 from "./../../assets/posts/478/1.jpg";
import post4782 from "./../../assets/posts/478/2.jpg";

import name479 from "./../../assets/posts/479/0.jpg";
import post4791 from "./../../assets/posts/479/1.jpg";
import post4792 from "./../../assets/posts/479/2.jpg";
import post4793 from "./../../assets/posts/479/3.jpg";
import post4794 from "./../../assets/posts/479/4.jpg";
import post4795 from "./../../assets/posts/479/5.jpg";

import name480 from "./../../assets/posts/480/0.jpg";
import post4801 from "./../../assets/posts/480/1.jpg";
import post4802 from "./../../assets/posts/480/2.jpg";
import post4803 from "./../../assets/posts/480/3.jpg";
import post4804 from "./../../assets/posts/480/4.jpg";

import name481 from "./../../assets/posts/481/0.jpg";
import post4811 from "./../../assets/posts/481/1.jpg";
import post4812 from "./../../assets/posts/481/2.jpg";
import post4813 from "./../../assets/posts/481/3.jpg";
import post4814 from "./../../assets/posts/481/4.jpg";
import post4815 from "./../../assets/posts/481/5.jpg";
import post4816 from "./../../assets/posts/481/6.jpg";

import name482 from "./../../assets/posts/482/0.jpg";
import post4821 from "./../../assets/posts/482/1.jpg";
import post4822 from "./../../assets/posts/482/2.jpg";
import post4823 from "./../../assets/posts/482/3.jpg";
import post4824 from "./../../assets/posts/482/4.jpg";
import post4825 from "./../../assets/posts/482/5.jpg";

import name483 from "./../../assets/posts/483/0.jpg";
import post4831 from "./../../assets/posts/483/1.jpg";
import post4832 from "./../../assets/posts/483/2.jpg";
import post4833 from "./../../assets/posts/483/3.jpg";
import post4834 from "./../../assets/posts/483/4.jpg";
import post4835 from "./../../assets/posts/483/5.jpg";

import name484 from "./../../assets/posts/484/0.jpg";
import post4841 from "./../../assets/posts/484/1.jpg";

import name485 from "./../../assets/posts/485/0.jpg";
import post4851 from "./../../assets/posts/485/1.jpg";
import post4852 from "./../../assets/posts/485/2.jpg";
import post4853 from "./../../assets/posts/485/3.jpg";
import post4854 from "./../../assets/posts/485/4.jpg";
import post4855 from "./../../assets/posts/485/5.jpg";
import post4856 from "./../../assets/posts/485/6.jpg";

import name486 from "./../../assets/posts/486/0.jpg";
import post4861 from "./../../assets/posts/486/1.jpg";
import post4862 from "./../../assets/posts/486/2.jpg";
import post4863 from "./../../assets/posts/486/3.jpg";

import name487 from "./../../assets/posts/487/0.jpg";
import post4871 from "./../../assets/posts/487/1.jpg";
import post4872 from "./../../assets/posts/487/2.jpg";
import post4873 from "./../../assets/posts/487/3.jpg";
import post4874 from "./../../assets/posts/487/4.jpg";
import post4875 from "./../../assets/posts/487/5.jpg";
import post4876 from "./../../assets/posts/487/6.jpg";
import post4877 from "./../../assets/posts/487/7.jpg";

import name488 from "./../../assets/posts/488/0.jpg";
import post4881 from "./../../assets/posts/488/1.jpg";
import post4882 from "./../../assets/posts/488/2.jpg";
import post4883 from "./../../assets/posts/488/3.jpg";
import post4884 from "./../../assets/posts/488/4.jpg";
import post4885 from "./../../assets/posts/488/5.jpg";
import post4886 from "./../../assets/posts/488/6.jpg";
import post4887 from "./../../assets/posts/488/7.jpg";
import post4888 from "./../../assets/posts/488/8.jpg";

import name489 from "./../../assets/posts/489/0.jpg";
import post4891 from "./../../assets/posts/489/1.jpg";
import post4892 from "./../../assets/posts/489/2.jpg";
import post4893 from "./../../assets/posts/489/3.jpg";
import post4894 from "./../../assets/posts/489/4.jpg";
import post4895 from "./../../assets/posts/489/5.jpg";
import post4896 from "./../../assets/posts/489/6.jpg";
import post4897 from "./../../assets/posts/489/7.jpg";
import post4898 from "./../../assets/posts/489/8.jpg";

import name490 from "./../../assets/posts/490/0.jpg";
import post4901 from "./../../assets/posts/490/1.jpg";

import name491 from "./../../assets/posts/491/0.jpg";
import post4911 from "./../../assets/posts/491/1.jpg";

import name492 from "./../../assets/posts/492/0.jpg";
import post4921 from "./../../assets/posts/492/1.jpg";
import post4922 from "./../../assets/posts/492/2.jpg";
import post4923 from "./../../assets/posts/492/3.jpg";

import name493 from "./../../assets/posts/493/0.jpg";
import post4931 from "./../../assets/posts/493/1.jpg";
import post4932 from "./../../assets/posts/493/2.jpg";
import post4933 from "./../../assets/posts/493/3.jpg";
import post4934 from "./../../assets/posts/493/4.jpg";

import name494 from "./../../assets/posts/494/0.jpg";
import post4941 from "./../../assets/posts/494/1.jpg";
import post4942 from "./../../assets/posts/494/2.jpg";
import post4943 from "./../../assets/posts/494/3.jpg";
import post4944 from "./../../assets/posts/494/4.jpg";
import post4945 from "./../../assets/posts/494/5.jpg";

import name495 from "./../../assets/posts/495/0.jpg";
import post4951 from "./../../assets/posts/495/1.jpg";
import post4952 from "./../../assets/posts/495/2.jpg";
import post4953 from "./../../assets/posts/495/3.jpg";
import post4954 from "./../../assets/posts/495/4.jpg";

import name496 from "./../../assets/posts/496/0.jpg";
import post4961 from "./../../assets/posts/496/1.jpg";
import post4962 from "./../../assets/posts/496/2.jpg";
import post4963 from "./../../assets/posts/496/3.jpg";
import post4964 from "./../../assets/posts/496/4.jpg";
import post4965 from "./../../assets/posts/496/5.jpg";
import post4966 from "./../../assets/posts/496/6.jpg";
import post4967 from "./../../assets/posts/496/7.jpg";

import name497 from "./../../assets/posts/497/0.jpg";
import post4971 from "./../../assets/posts/497/1.jpg";
import post4972 from "./../../assets/posts/497/2.jpg";
import post4973 from "./../../assets/posts/497/3.jpg";
import post4974 from "./../../assets/posts/497/4.jpg";
import post4975 from "./../../assets/posts/497/5.jpg";
import post4976 from "./../../assets/posts/497/6.jpg";
import post4977 from "./../../assets/posts/497/7.jpg";

import name498 from "./../../assets/posts/498/0.jpg";

import name499 from "./../../assets/posts/499/0.jpg";
import post4991 from "./../../assets/posts/499/1.jpg";
import post4992 from "./../../assets/posts/499/2.jpg";
import post4993 from "./../../assets/posts/499/3.jpg";
import post4994 from "./../../assets/posts/499/4.jpg";
import post4995 from "./../../assets/posts/499/5.jpg";
import post4996 from "./../../assets/posts/499/6.jpg";
import post4997 from "./../../assets/posts/499/7.jpg";

import name500 from "./../../assets/posts/500/0.jpg";
import post5001 from "./../../assets/posts/500/1.jpg";
import post5002 from "./../../assets/posts/500/2.jpg";
import post5003 from "./../../assets/posts/500/3.jpg";
import post5004 from "./../../assets/posts/500/4.jpg";

import name501 from "./../../assets/posts/501/0.jpg";
import post5011 from "./../../assets/posts/501/1.jpg";
import post5012 from "./../../assets/posts/501/2.jpg";
import post5013 from "./../../assets/posts/501/3.jpg";
import post5014 from "./../../assets/posts/501/4.jpg";

import name502 from "./../../assets/posts/502/0.jpg";
import post5021 from "./../../assets/posts/502/1.jpg";
import post5022 from "./../../assets/posts/502/2.jpg";
import post5023 from "./../../assets/posts/502/3.jpg";
import post5024 from "./../../assets/posts/502/4.jpg";
import post5025 from "./../../assets/posts/502/5.jpg";

import name503 from "./../../assets/posts/503/0.jpg";
import post5031 from "./../../assets/posts/503/1.jpg";
import post5032 from "./../../assets/posts/503/2.jpg";
import post5033 from "./../../assets/posts/503/3.jpg";
import post5034 from "./../../assets/posts/503/4.jpg";
import post5035 from "./../../assets/posts/503/5.jpg";
import post5036 from "./../../assets/posts/503/6.jpg";

import name504 from "./../../assets/posts/504/0.jpg";
import post5041 from "./../../assets/posts/504/1.jpg";
import post5042 from "./../../assets/posts/504/2.jpg";
import post5043 from "./../../assets/posts/504/3.jpg";
import post5044 from "./../../assets/posts/504/4.jpg";

import name505 from "./../../assets/posts/505/0.jpg";
import post5051 from "./../../assets/posts/505/1.jpg";
import post5052 from "./../../assets/posts/505/2.jpg";
import post5053 from "./../../assets/posts/505/3.jpg";

import name506 from "./../../assets/posts/506/0.jpg";
import post5061 from "./../../assets/posts/506/1.jpg";
import post5062 from "./../../assets/posts/506/2.jpg";
import post5063 from "./../../assets/posts/506/3.jpg";
import post5064 from "./../../assets/posts/506/4.jpg";
import post5065 from "./../../assets/posts/506/5.jpg";
import post5066 from "./../../assets/posts/506/6.jpg";
import post5067 from "./../../assets/posts/506/7.jpg";
import post5068 from "./../../assets/posts/506/8.jpg";

import name507 from "./../../assets/posts/507/0.jpg";
import post5071 from "./../../assets/posts/507/1.jpg";
import post5072 from "./../../assets/posts/507/2.jpg";
import post5073 from "./../../assets/posts/507/3.jpg";
import post5074 from "./../../assets/posts/507/4.jpg";
import post5075 from "./../../assets/posts/507/5.jpg";
import post5076 from "./../../assets/posts/507/6.jpg";

import name508 from "./../../assets/posts/508/0.jpg";

import name509 from "./../../assets/posts/509/0.jpg";
import post5091 from "./../../assets/posts/509/1.jpg";
import post5092 from "./../../assets/posts/509/2.jpg";
import post5093 from "./../../assets/posts/509/3.jpg";
import post5094 from "./../../assets/posts/509/4.jpg";
import post5095 from "./../../assets/posts/509/5.jpg";
import post5096 from "./../../assets/posts/509/6.jpg";
import post5097 from "./../../assets/posts/509/7.jpg";

import name510 from "./../../assets/posts/510/0.jpg";
import post5101 from "./../../assets/posts/510/1.jpg";
import post5102 from "./../../assets/posts/510/2.jpg";
import post5103 from "./../../assets/posts/510/3.jpg";
import post5104 from "./../../assets/posts/510/4.jpg";
import post5105 from "./../../assets/posts/510/5.jpg";
import post5106 from "./../../assets/posts/510/6.jpg";

import name511 from "./../../assets/posts/511/0.jpg";
import post5111 from "./../../assets/posts/511/1.jpg";
import post5112 from "./../../assets/posts/511/2.jpg";
import post5113 from "./../../assets/posts/511/3.jpg";
import post5114 from "./../../assets/posts/511/4.jpg";
import post5115 from "./../../assets/posts/511/5.jpg";

import name512 from "./../../assets/posts/512/0.jpg";
import post5121 from "./../../assets/posts/512/1.jpg";
import post5122 from "./../../assets/posts/512/2.jpg";
import post5123 from "./../../assets/posts/512/3.jpg";
import post5124 from "./../../assets/posts/512/4.jpg";
import post5125 from "./../../assets/posts/512/5.jpg";
import post5126 from "./../../assets/posts/512/6.jpg";
import post5127 from "./../../assets/posts/512/7.jpg";

import name513 from "./../../assets/posts/513/0.jpg";
import post5131 from "./../../assets/posts/513/1.jpg";
import post5132 from "./../../assets/posts/513/2.jpg";
import post5133 from "./../../assets/posts/513/3.jpg";
import post5134 from "./../../assets/posts/513/4.jpg";
import post5135 from "./../../assets/posts/513/5.jpg";
import post5136 from "./../../assets/posts/513/6.jpg";
import post5137 from "./../../assets/posts/513/7.jpg";
import post5138 from "./../../assets/posts/513/8.jpg";

import name514 from "./../../assets/posts/514/0.jpg";
import post5141 from "./../../assets/posts/514/1.jpg";
import post5142 from "./../../assets/posts/514/2.jpg";
import post5143 from "./../../assets/posts/514/3.jpg";
import post5144 from "./../../assets/posts/514/4.jpg";
import post5145 from "./../../assets/posts/514/5.jpg";

import name515 from "./../../assets/posts/515/0.jpg";
import post5151 from "./../../assets/posts/515/1.jpg";

import name516 from "./../../assets/posts/516/0.jpg";
import post5161 from "./../../assets/posts/516/1.jpg";

import name517 from "./../../assets/posts/517/0.jpg";
import post5171 from "./../../assets/posts/517/1.jpg";

import name518 from "./../../assets/posts/518/1.jpg";
import post5181 from "./../../assets/posts/518/1.jpg";

import name519 from "./../../assets/posts/519/1.jpg";
import post5191 from "./../../assets/posts/519/1.jpg";

import name520 from "./../../assets/posts/520/1.jpg";
import post5201 from "./../../assets/posts/520/1.jpg";

import name521 from "./../../assets/posts/521/1.jpg";
import post5211 from "./../../assets/posts/521/1.jpg";
import post5212 from "./../../assets/posts/521/2.jpg";
import post5213 from "./../../assets/posts/521/3.jpg";
import post5214 from "./../../assets/posts/521/4.jpg";
import post5215 from "./../../assets/posts/521/5.jpg";
import post5216 from "./../../assets/posts/521/6.jpg";
import post5217 from "./../../assets/posts/521/7.jpg";
import post5218 from "./../../assets/posts/521/8.jpg";
import post5219 from "./../../assets/posts/521/9.jpg";
import post52110 from "./../../assets/posts/521/10.jpg";
import post52111 from "./../../assets/posts/521/11.jpg";

import name522 from "./../../assets/posts/522/1.jpg";
import post5221 from "./../../assets/posts/522/1.jpg";
import post5222 from "./../../assets/posts/522/2.jpg";
import post5223 from "./../../assets/posts/522/3.jpg";

import name523 from "./../../assets/posts/523/1.jpg";
import post5231 from "./../../assets/posts/523/1.jpg";
import post5232 from "./../../assets/posts/523/2.jpg";
import post5233 from "./../../assets/posts/523/3.jpg";

import name524 from "./../../assets/posts/524/1.jpg";
import post5241 from "./../../assets/posts/524/1.jpg";
import post5242 from "./../../assets/posts/524/2.jpg";
import post5243 from "./../../assets/posts/524/3.jpg";
import post5244 from "./../../assets/posts/524/4.jpg";
import post5245 from "./../../assets/posts/524/5.jpg";
import post5246 from "./../../assets/posts/524/6.jpg";

import name525 from "./../../assets/posts/525/1.jpg";
import post5251 from "./../../assets/posts/525/1.jpg";

import name526 from "./../../assets/posts/526/1.jpg";
import post5261 from "./../../assets/posts/526/1.jpg";
import post5262 from "./../../assets/posts/526/2.jpg";

import name527 from "./../../assets/posts/527/1.jpg";
import post5271 from "./../../assets/posts/527/1.jpg";
import post5272 from "./../../assets/posts/527/2.jpg";
import post5273 from "./../../assets/posts/527/3.jpg";
import post5274 from "./../../assets/posts/527/4.jpg";
import post5275 from "./../../assets/posts/527/5.jpg";
import post5276 from "./../../assets/posts/527/6.jpg";

import name528 from "./../../assets/posts/528/1.jpg";
import post5281 from "./../../assets/posts/528/1.jpg";
import post5282 from "./../../assets/posts/528/2.jpg";
import post5283 from "./../../assets/posts/528/3.jpg";
import post5284 from "./../../assets/posts/528/4.jpg";

import name529 from "./../../assets/posts/529/1.jpg";
import post5291 from "./../../assets/posts/529/1.jpg";
import post5292 from "./../../assets/posts/529/2.jpg";
import post5293 from "./../../assets/posts/529/3.jpg";

import name530 from "./../../assets/posts/530/1.jpg";
import post5301 from "./../../assets/posts/530/1.jpg";
import post5302 from "./../../assets/posts/530/2.jpg";

import name531 from "./../../assets/posts/531/1.jpg";
import post5311 from "./../../assets/posts/531/1.jpg";
import post5312 from "./../../assets/posts/531/2.jpg";
import post5313 from "./../../assets/posts/531/3.jpg";
import post5314 from "./../../assets/posts/531/4.jpg";
import post5315 from "./../../assets/posts/531/5.jpg";
import post5316 from "./../../assets/posts/531/6.jpg";

import name532 from "./../../assets/posts/532/1.jpg";
import post5321 from "./../../assets/posts/532/1.jpg";
import post5322 from "./../../assets/posts/532/2.jpg";

import name533 from "./../../assets/posts/533/1.jpg";
import post5331 from "./../../assets/posts/533/1.jpg";
import post5332 from "./../../assets/posts/533/2.jpg";

import name534 from "./../../assets/posts/534/1.jpg";
import post5341 from "./../../assets/posts/534/1.jpg";
import post5342 from "./../../assets/posts/534/2.jpg";
import post5343 from "./../../assets/posts/534/3.jpg";
import post5344 from "./../../assets/posts/534/4.jpg";
import post5345 from "./../../assets/posts/534/5.jpg";

import name535 from "./../../assets/posts/535/1.jpg";
import post5351 from "./../../assets/posts/535/1.jpg";
import post5352 from "./../../assets/posts/535/2.jpg";
import post5353 from "./../../assets/posts/535/3.jpg";
import post5354 from "./../../assets/posts/535/4.jpg";
import post5355 from "./../../assets/posts/535/5.jpg";

import name536 from "./../../assets/posts/536/1.jpg";
import post5361 from "./../../assets/posts/536/1.jpg";
import post5362 from "./../../assets/posts/536/2.jpg";

import name537 from "./../../assets/posts/537/1.jpg";
import post5371 from "./../../assets/posts/537/1.jpg";
import post5372 from "./../../assets/posts/537/2.jpg";
import post5373 from "./../../assets/posts/537/3.jpg";
import post5374 from "./../../assets/posts/537/4.jpg";
import post5375 from "./../../assets/posts/537/5.jpg";

import name538 from "./../../assets/posts/538/1.jpg";
import post5381 from "./../../assets/posts/538/1.jpg";
import post5382 from "./../../assets/posts/538/2.jpg";
import post5383 from "./../../assets/posts/538/3.jpg";

import name539 from "./../../assets/posts/539/1.jpg";
import post5391 from "./../../assets/posts/539/1.jpg";
import post5392 from "./../../assets/posts/539/2.jpg";
import post5393 from "./../../assets/posts/539/3.jpg";
import post5394 from "./../../assets/posts/539/4.jpg";

import name540 from "./../../assets/posts/540/1.jpg";
import post5401 from "./../../assets/posts/540/1.jpg";

import name541 from "./../../assets/posts/541/1.jpg";
import post5411 from "./../../assets/posts/541/1.jpg";
import post5412 from "./../../assets/posts/541/2.jpg";
import post5413 from "./../../assets/posts/541/3.jpg";

// 542
import name542 from "./../../assets/posts/542/1.jpg";
import post5421 from "./../../assets/posts/542/1.jpg";
import post5422 from "./../../assets/posts/542/2.jpg";
import post5423 from "./../../assets/posts/542/3.jpg";

// 543
import name543 from "./../../assets/posts/543/1.jpg";
import post5431 from "./../../assets/posts/543/1.jpg";
import post5432 from "./../../assets/posts/543/2.jpg";
import post5433 from "./../../assets/posts/543/3.jpg";

// 544
import name544 from "./../../assets/posts/544/1.jpg";
import post5441 from "./../../assets/posts/544/1.jpg";

// 545
import name545 from "./../../assets/posts/545/1.jpg";
import post5451 from "./../../assets/posts/545/1.jpg";
import post5452 from "./../../assets/posts/545/2.jpg";
import post5453 from "./../../assets/posts/545/3.jpg";

// 546
import name546 from "./../../assets/posts/546/1.jpg";
import post5461 from "./../../assets/posts/546/1.jpg";

// 547
import name547 from "./../../assets/posts/547/1.jpg";
import post5471 from "./../../assets/posts/547/1.jpg";
import post5472 from "./../../assets/posts/547/2.jpg";
import post5473 from "./../../assets/posts/547/3.jpg";

// 548
import name548 from "./../../assets/posts/548/1.jpg";
import post5481 from "./../../assets/posts/548/1.jpg";
import post5482 from "./../../assets/posts/548/2.jpg";
import post5483 from "./../../assets/posts/548/3.jpg";

// 549
import name549 from "./../../assets/posts/549/1.jpg";
import post5491 from "./../../assets/posts/549/1.jpg";

// 550
import name550 from "./../../assets/posts/550/1.jpg";
import post5501 from "./../../assets/posts/550/1.jpg";
import post5502 from "./../../assets/posts/550/2.jpg";
import post5503 from "./../../assets/posts/550/3.jpg";

// 551
import name551 from "./../../assets/posts/551/1.jpg";
import post5511 from "./../../assets/posts/551/1.jpg";
import post5512 from "./../../assets/posts/551/2.jpg";
import post5513 from "./../../assets/posts/551/3.jpg";

// 552
import name552 from "./../../assets/posts/552/1.jpg";
import post5521 from "./../../assets/posts/552/1.jpg";
import post5522 from "./../../assets/posts/552/2.jpg";
import post5523 from "./../../assets/posts/552/3.jpg";

// 553
import name553 from "./../../assets/posts/553/1.jpg";
import post5531 from "./../../assets/posts/553/1.jpg";
import post5532 from "./../../assets/posts/553/2.jpg";
import post5533 from "./../../assets/posts/553/3.jpg";

// 554
import name554 from "./../../assets/posts/554/1.jpg";
import post5541 from "./../../assets/posts/554/1.jpg";

// 555
import name555 from "./../../assets/posts/555/1.jpg";
import post5551 from "./../../assets/posts/555/1.jpg";
import post5552 from "./../../assets/posts/555/2.jpg";
import post5553 from "./../../assets/posts/555/3.jpg";

// 556
import name556 from "./../../assets/posts/556/1.jpg";
import post5561 from "./../../assets/posts/556/1.jpg";
import post5562 from "./../../assets/posts/556/2.jpg";
import post5563 from "./../../assets/posts/556/3.jpg";

// 557
import name557 from "./../../assets/posts/557/1.jpg";
import post5571 from "./../../assets/posts/557/1.jpg";
import post5572 from "./../../assets/posts/557/2.jpg";
import post5573 from "./../../assets/posts/557/3.jpg";

// 558
import name558 from "./../../assets/posts/558/1.jpg";
import post5581 from "./../../assets/posts/558/1.jpg";
import post5582 from "./../../assets/posts/558/2.jpg";
import post5583 from "./../../assets/posts/558/3.jpg";

// 559
import name559 from "./../../assets/posts/559/1.jpg";
import post5591 from "./../../assets/posts/559/1.jpg";
import post5592 from "./../../assets/posts/559/2.jpg";
import post5593 from "./../../assets/posts/559/3.jpg";

// 560
import name560 from "./../../assets/posts/560/1.jpg";
import post5601 from "./../../assets/posts/560/1.jpg";
import post5602 from "./../../assets/posts/560/2.jpg";
import post5603 from "./../../assets/posts/560/3.jpg";

// 561
import name561 from "./../../assets/posts/561/1.jpg";
import post5611 from "./../../assets/posts/561/1.jpg";
import post5612 from "./../../assets/posts/561/2.jpg";
import post5613 from "./../../assets/posts/561/3.jpg";

// 562
import name562 from "./../../assets/posts/562/1.jpg";
import post5621 from "./../../assets/posts/562/1.jpg";
import post5622 from "./../../assets/posts/562/2.jpg";
import post5623 from "./../../assets/posts/562/3.jpg";

// 563
import name563 from "./../../assets/posts/563/1.jpg";
import post5631 from "./../../assets/posts/563/1.jpg";
import post5632 from "./../../assets/posts/563/2.jpg";

// 564
import name564 from "./../../assets/posts/564/1.jpg";
import post5641 from "./../../assets/posts/564/1.jpg";
import post5642 from "./../../assets/posts/564/2.jpg";
import post5643 from "./../../assets/posts/564/3.jpg";

// 565
import name565 from "./../../assets/posts/565/1.jpg";
import post5651 from "./../../assets/posts/565/1.jpg";
import post5652 from "./../../assets/posts/565/2.jpg";

// 566
import name566 from "./../../assets/posts/566/1.jpg";
import post5661 from "./../../assets/posts/566/1.jpg";
import post5662 from "./../../assets/posts/566/2.jpg";
import post5663 from "./../../assets/posts/566/3.jpg";

// 567
import name567 from "./../../assets/posts/567/1.jpg";
import post5671 from "./../../assets/posts/567/1.jpg";
import post5672 from "./../../assets/posts/567/2.jpg";
import post5673 from "./../../assets/posts/567/3.jpg";

// 568
import name568 from "./../../assets/posts/568/1.jpg";
import post5681 from "./../../assets/posts/568/1.jpg";
import post5682 from "./../../assets/posts/568/2.jpg";

// 569
import name569 from "./../../assets/posts/569/1.jpg";
import post5691 from "./../../assets/posts/569/1.jpg";
import post5692 from "./../../assets/posts/569/2.jpg";
import post5693 from "./../../assets/posts/569/3.jpg";

// 570
import name570 from "./../../assets/posts/570/1.jpg";
import post5701 from "./../../assets/posts/570/1.jpg";
import post5702 from "./../../assets/posts/570/2.jpg";





const posts = [
  {
    imageGallery: [],
    image: name1,
    id: 1,
    title: "პირველკლასელთა გამოფენა 9 აპრილის თემაზე",
    briefText:
      "პირველკლასელთა გამოფენა 9 აპრილის თემაზე\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის I-3 კლასის მოსწავლეებმა ქართულის მასწავლებლის ნინო უგულავასაგან ბევრი რამ გაიგეს 9 აპრილის, როგორც ისტორიული თარიღის შესახებ!\nპატარები უკვე პლაკატის, პოსტერისა და სხვა ვიზუალური თვალსაჩინოების შექმნასაც სწავლობენ!\nთავიანთი პირველი ნამუშევრები მასწავლებლისა და მშობლების დახმარებით შექმნეს, გამოფენაც მოაწყვეს და გაკვეთილიც ჩაატარეს 9 აპრილის თემაზე.",
  },
  {
    imageGallery: [],
    image: name2,
    id: 2,
    title: "მესამე კლასელები აჭარის ხარიტონ ახვლედიანის სახელობის მუზეუმში",
    briefText:
      "მესამე კლასელები აჭარის ხარიტონ ახვლედიანის სახელობის მუზეუმში\n2021 წლის 12 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის III-1 კლასის მოსწავლეებს ხელოვნების გაკვეთილი მასწავლებელმა სოფო სანიკიძემ აჭარის ხარიტონ ახვლედიანის სახელობის მუზეუმში ჩაუტარა.\nპატარებმა დიდი ინტერესით დათვალიერეს მუზეუმის ექსპონატები, მოისმინეს მცირე ექსკურსი და ძალიან იხალისეს.",
  },
  {
    imageGallery: [],
    image: name3,
    id: 3,
    title: '"გიმნაზიელები გიმნაზიელებისთვის"!',
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში გრძელდება პროექტი "გიმნაზიელები გიმნაზიელებისთვის".\nპროექტის მიზანია, რომ თავისი ცოდნა და გამოცდილება უფროსი ასაკის ყოფილმა მოსწავლეებმა გაუზიარონ უმცროსებს!\n2021 წლის 13 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მეათე კლასის მოსწავლეები ონლაინ ფორმატში შეხვდნენ ყოფილ გიმნაზიელ გიორგი ახალაიას.\nგიორგი დასაქმებულია Invited Lecturer კავკასიის უნივერსიტეტში და Acting Head of Geodesy and Gravimetry Department დედამიწის შემსწავლელ მეცნიერებათა ინსტიტუტის სეისმური მონიტ. ეროვნული ცენტრი-ში. ინტერაქტიული ლექციის თემა იყო "დედამიწის შემსწავლელი მეცნიერებების მნიშვნელობა და როლი ქვეყნის მდგრად განვითარებაში".\nლექცია, რომელსაც გიორგი ახალაიას ყოფილი პედაგოგებიც ესწრებოდნენ, უაღრესად საინტერესოდ წარიმართა.\nბათუმის წმ. ანდრია პირველწოდებულის სკოლის ადმინისტრაციისა და მოსწავლეების სახელით დიდ მადლობას მოვახსენებთ გიორგის ამ შეხვედრისთვის!\n#გეოეკოლოგიისკლუბი #გიმნაზიელებიგიმნაზიელებისთვის #დედამიწისშემსწავლელიმეცნიერებებისმნიშვნელობა #მდგრადიგანვითარებისმიზნები',
  },
  {
    imageGallery: [],
    image: name4,
    id: 4,
    title: "2021 წლის 13 აპრილი",
    briefText:
      '2021 წლის 13 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VII-6 კლასში მასწავლებელმა ნინო ქავჟარაძემ ჩაატარა საინტერესო და სახალისო გაკვეთილი თემაზე "რუსი მწერლები და პოეტები საქართველოს შესახებ".',
  },
  {
    imageGallery: [],
    image: name5,
    id: 5,
    title: "14 აპრილი- ანბანის დღე!",
    briefText:
      "14 აპრილი- ანბანის დღე!\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის I-2 კლასის მოსწავლეებმა ქართული ენის მასწავლებლის მაია იმნაძის საშუალებით გაიგეს, რომ 14 აპრილი დედაენის დღეა, ისაუბრეს მეფე ფარნავაზის დამსახურებაზე ქართული ანბანის შექმნის საქმეში, ისიც თუ რატომ დაუდგეს ქართვებმა ძეგლი დედაენის.\nგაკვეთილი დატვირთული იყო შემოქმედებითი და სახალისო აქტივობებით!",
  },
  {
    imageGallery: [],
    image: name6,
    id: 6,
    title:
      "შეხვედრა ბრიტანული უნივერსიტეტის - University of Buckingham - რექტორთან",
    briefText:
      "2021 წლის 13 აპრილს უნივერსიტეტის რექტორი, ბატონი დავით აფრასიძე და აკადემიური პერსონალი შეხვდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებს.\nბრიტანული უნივერსიტეტი საქართველოში - University of Buckingham - ერთ-ერთი გამორჩეული სასწავლებელია.\nმისი შექმნა უკავშირდება ცნობილ პოლიტიკურ მოღვაწეს, მარგარეტ ტეტჩერს. 1973 წელს, განათლების მინისტრობის დროს, სწორედ ტეტჩერი ხელმძღვანელობდა ბუკინგემის საუნივერსიტეტო კოლეჯის შექმნას, ხოლო 1983 წელს, უკვე როგორც პრემიერ-მინისტრმა, დიდი წვლილი შეიტანა, რომ ბუკინგემს სამეფო ქარტიით უნივერსიტეტის სტატუსი მიენიჭა. 2020 წელს უნივერსიტეტი ზედიზედ მესამედ დასახელდა საუკეთესოდ 129 უნივერსიტეტს შორის სტუდენტების კმაყოფილების თვალსაზრისით. 2020 წელს ბუკინგემის უნივერსიტეტში მსოფლიოს 70-ზე მეტი ქვეყნიდან 3,300 სტუდენტი სწავლობდა. 2020 წელს ბუკინგემის უნივერსიტეტმა და ბრიტანულმა უნივერსიტეტმა საქართველოში ხელი მოაწერეს აფილირების აკადემიურ შეთანხმებას.",
  },
  {
    imageGallery: [],
    image: name7,
    id: 7,
    title: "14 აპრილი დედაენის დღეა!",
    briefText:
      "14 აპრილი დედაენის დღეა!\n2021 წლის 13 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის I-4 კლასის მოსწავლეებმა ქართულის მასწავლებელ მაია იმნაძესთან ერთად ნახეს ანიმაციური ფილმი “ფარნავაზ მეფე”, ისაუბრეს ანბანის შექმნის შესახებ, ააწყვეს ხმოვანი კროსვორდი, მხიარული მარცვლებით შეადგინეს სიტყვები.",
  },
  {
    imageGallery: [],
    image: name8,
    id: 8,
    title: "14 აპრილი დედაენის დღეა!",
    briefText:
      "ასე აღნიშნეს დედა ენის დღე ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის V-1 კლასის მოსწავლეებმა ქართულის მასწავლებელ ლუიზა სამსონიასთან ერთად",
  },
  {
    imageGallery: [],
    image: name9,
    id: 9,
    title: "14 აპრილი დედაენის დღეა!",
    briefText:
      'დედაენის დღე მიულოცეს ერთმანეთს და გაუზიარეს თავიანთი ცოდნა-გამოცდილება ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის IV-4 და V-3 კლასის მოსწავლეებმა.\nპატარებმა ქართული ენისა და ლიტერატურის მასწავლებლების რუსუდან თავხელიძისა და დალი ცეცხლაძის დახმარებით წარმოადგინეს ამ დღისათვის მომზადებული პლაკატები, მოიძიეს ინფორმაცია დედაენის დღის შესახებ, წაიკითხეს ლექსები, მოისმინეს კომპოზიტორ რევაზ ლაღიძის მიერ შექმნილი "ჰიმნი დედაენის".',
  },
  {
    imageGallery: [],
    image: name10,
    id: 10,
    title: "14 აპრილი- დედაენის დღე პირველად აღნიშნეს პირველკლასელებმა!",
    briefText:
      '14 აპრილი- დედაენის დღე პირველად აღნიშნეს პირველკლასელებმა!\nდედაენის დღე საინტერესოდ აღნიშნეს I-3 კლასის მოსწავლეებმა. ამჯერად პატარებმა უმასპინძლეს V კლასელებს. წაიკითხეს ლექსები და უფროს მეგობრებს აჩვენეს თავიანთი ნამუშევრები - "მხიარული" ასო-ბგერები.\nპირველი კლასის დამრიგებელი ანა კვიჭიძე, ხოლო ქართული ენისა და ლიტერატურის მასწავლებელი - ნინო უგულავა',
  },
  {
    imageGallery: [],
    image: name11,
    id: 11,
    title: "მესამეკლასელებმა აღნიშნეს დედა ენის დღე !",
    briefText:
      'მესამეკლასელებმა აღნიშნეს დედა ენის დღე !\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში დედა ენის დღესთან საინტერესო და შემეცნებითი გაკვეთილები ჩატარდა .\nIII-3 კლასის მოსწავლეებმა (მასწავლებელი მაია იმნაძე) ქართულის გაკვეთილზე ისაუბრეს ქართული ანბანის სამი სახეობის შესახებ, ნახეს ანიმაციური ფილმი, ესტუმრნენ სკოლის ულამაზეს ბიბლიოთეკას, ნახეს იაკობ გოგებაშვილის უძველესი სახელმძღვანელოები " დედა ენა" და "ბუნების კარი ", წავიკითხეს და განიხილეს ილია ჭავჭავაძის “დედა-ჩიტი.“',
  },
  {
    imageGallery: [],
    image: name12,
    id: 12,
    title: "ახალგაზრდები მდგრადი განვითარების მიზნების პოპულარიზაციისთვის!",
    briefText:
      'ახალგაზრდები მდგრადი განვითარების მიზნების პოპულარიზაციისთვის!\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში პროექტი " გიმნაზიელები გიმნაზიელებისთვის" გრძელდება!\nამჯერად XI-3 კლასის მოსწავლეთა ერთმა ჯგუფმა:\nლელა მახარაძე,\nმატასი კაპანაძე,\nნინი კოკობინაძე,\nსალომე ჩოგოვაძე,\nნინი ჩხეიძე,\nმარი კეშელავა,\nნინი არძენაძე,\nმარიამ იაშვილი - გეოგრაფიის მასწავლებლის სოფო ხუხუნაიშვილის დახმარებით მდგრადი განვითარების მიზნებისა და ამოცანების პოპულარიზაცია დაისახა მიზნად!\nშეხვედრას მერვე კლასელები ესწრებოდნენ.\nეს მიზნები ჩვენ წინაშე არსებულ თანამედროვე გლობალურ გამოწვევებს ეხება: სიღარიბის, უთანასწორობის, კეთილდღეობის, მშვიდობისა და სამართლიანობის საკითხებს, ასევე კლიმატურ და ეკოლოგიურ გამოწვევებს; მჭიდროდ უკავშირდება ერთმანეთს და იმისთვის, რომ არავინ დარჩეს მათ მიღმა, მნიშვნელოვანია, თითოეული ეს მიზანი და ინდიკატორი შესრულდეს.\nმდგრადი განვითარების მიზნების მისაღწევად აუცილებელია, ბავშვებს ცენტრალური ადგილი ეკავოთ სახელმწიფოს სტრატეგიასა და სამოქმედო გეგმაში.\nახალგაზრდებმა წარმატებით გაართვეს თავი საკმაოდ რთულ საქმეს და უაღრესად საინტერესო მასალა წარმოადგინეს.',
  },
  {
    imageGallery: [],
    image: name13,
    id: 13,
    title:
      "ანზორ ერქომაიშვილის სახელობის გალობის სკოლის (ხელმძღვანელი ეკა ბჟინავა) ნორჩი აღსაზრდელები.",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ანზორ ერქომაიშვილის სახელობის გალობის სკოლის (ხელმძღვანელი ეკა ბჟინავა) ნორჩი აღსაზრდელები.",
  },
  {
    imageGallery: [],
    image: name14,
    id: 14,
    title: "ღია გაკვეთილი V-4 კლასში",
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის V-5 კლასის აღსაზრდელებს რუსულ ენას ჩვენი გამორჩეული, ძვირფასი, ამაგდარი პედაგოგი ინეზა კანდელაკი ასწავლის.\n2021 წლის 12 აპრილს ჩატარდა ღია გაკვეთილი, რომელზეც მოსწავლეებმა მოისმინეს და წაიკითხეს ვლ. მაიაკოვსკის ლექსი "Что хорошо и что плохо " .\nმოსწავლეებმა შეძლეს ლექსის შინაარსის გადმოცემა, ისაუბრეს მეგობრობაზე, ამპარტავნებაზე, ჰიგიენაზე. მასწავლებლის დახმარებით გამოიტანეს სწორი დასკვნები. მოისმინეს პოეტის ბიოგრაფია.\nინეზა მასწავლებელმა ყურადღება გაამახვილა პოეტის დამოკიდებულებაზე საქართველოს მიმართ. დიდი ინტერესი გამოიწვია სურათებმა, რომელზეც აღბეჭდილი იყო პოეტის დაბადების ადგილი.\nგაკვეთილის დასარულს ბავშვებმა მუსიკის მასწავლებლის დახმარებით შეასრულეს რუსული სიმღერა.',
  },
  {
    imageGallery: [],
    image: name15,
    id: 15,
    title: "დედაენის დღისადმი მიძღვნილი კვირეული",
    briefText:
      '🌸📜 წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში დედაენის დღისადმი მიძღვნილი კვირეული დასრულდა.\n🌸📜 დაწყებითი საფეხურის მასწავლებლებმა ჩაატარეს თემატური გაკვეთილები.\n🌸📜 მოსწავლეებისთვის საინტერესო და სახალისო აღმოჩნდა დავალებების შესრულება: დახატეს "მხიარული" ასო-ბგერები,შეადგინეს რებუსები, შეარჩიეს და დახატეს გამორჩეული სიტყვები.\n🌸📜 ბიბლიოთეკაში მოეწყო სხვადასხვა წელს გამოცემული, იაკობ გოგებაშვილის მიერ შექმნილი დედა ენის სახელმძღვანელოების, უძველესი დამწერლობის ნიმუშების გამოფენა.\n🌸📜 მოსწავლეებმა დაათვალიერეს ჩვენი სკოლის მასწავლებლების მიერ შესრულებული ხელნაწერები.\n🌸📜 ჩატარდა გაკვეთილები სკოლის ბიბლიოთეკაში .\n🌸📜 მადლობას ვუხდით მოსწავლეებს და მასწავლებლებს კვირეულში მონაწილეობისთვის!',
  },
  {
    imageGallery: [],
    image: name16,
    id: 16,
    title: "ეროვნული ფესტივალის „SCIENCE ON STAGE“ საინფორმაციო შეხვედრა",
    briefText:
      " 2021 წლის 16 აპრილს შედგა „SCIENSE ON STAGE” ეროვნული ფესტივალის ორგანიზატორების შეხვედრა მასწავლებლებთან. ილიას სახელმწიფო უნივერსიტეტის საბუნებისმეტყველო განათლების კვლევითი ცენტრის SALIS-ის ოფიციალურმა წარმომადგენელმა საქართველოში, პროფესორმა მარიკა კაპანაძემ მასწავლებლებს გააცნო ეროვნული ფესტივალის მიმდინარეობის პირობები და ისაუბრა პროექტებზე, რომლებიც შესაძლებელია წარადგინონ ჟიურის წინაშე. გამარჯვებული 4 მასწავლებელი გაემგზავრება პრაღაში საერთაშორისო შეხვედრაზე!\nშეხვედრას ესწრებოდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მასწავლებლები ქეთევან ხარაბაძე და ქეთევან გოცირიძე.\nწარმატებებს ვუსურვებთ შეხვედრის ორგანიზატორებს და პედაგოგებს!",
  },
  {
    imageGallery: [],
    image: name17,
    id: 17,
    title: "სტუმრად არქეოლოგიის მუზეუმში",
    briefText:
      "2021 წლი 19 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის IX-1კლასის მოსწავლეები და ისტორიის მასწავლებელი ნატალია სირაბიძე სტუმრობდნენ ბათუმის არქეოლოგიის მუზეუმს.\nბავშვებმა დაათვალიერეს მუზეუმის კოლექციები, მოისმინეს საინტერესო ექსკურსი, ხოლო შემდეგ ნატალია მასწავლებელმა სამუზეუმო სივრცეში ჩაატარა ერთგვარი შემაჯამებელი გაკვეთილი თემებზე:\n1.ქვის ხანა; ენეოლითი.;\n2.ბრინჯაოს ხანა საქართველოში;\n3.კოლხა მითსა და სინამდვილეში;\n4.კოლხეთის სამეფო ძვ.წ.VI-I საუკუნეებში.",
  },
  {
    imageGallery: [],
    image: name18,
    id: 18,
    title:
      "სამუშაო შეხვედრა გაიმართა „ჯუნიორ ეჩივმენტი საქართველო“-ს წარმომადგენელთან",
    briefText:
      "2021 წლის 21 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის X კლასის მოსწავლეებს სამუშაო შეხვედრა გაიმართა „ჯუნიორ ეჩივმენტი საქართველო“-ს წარმომადგენელ ინგა გეგეშიძემ.\nშეხვედრის თემა იყო მოსწავლეების Entrepreneurship Skill Pass (ESP)-ის საერთაშორისო სამეწარმეო\nსერტიფიცირების პროცესში ჩართვა ევროპაში დამკვიდრებული სტანდარტებით 15-დან 25 წლამდე ასაკის ახალგაზრდებისთვის.\nსაქართველოში ამ სერტიფიცირების პროგრამაში ჩართვის უფლება აქვს მხოლოდ იმ მოსწავლეებს, რომლებიც „ჯუნიორ ეჩვმენტი საქართველოს“ „მოსწავლეთა კომპანიის“ მეთოდოლოგიით სწავლობენ „მეწარმეობას“.",
  },
  {
    imageGallery: [],
    image: name19,
    id: 19,
    title: '"ადამიანი ადამიანისთვის დღეა!"',
    briefText:
      '2021 წლის 22 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის სააქტო დარბაზში გაიმართა საქველმოქმედო კონცერტი, რომელშიც მონაწილეობდნენ გიმნაზიის პატარების გუნდი "მხიარული მელოდიები", ასევე, არც ისე დიდი ხნის წინ შექმნილი ანზორ ერქომაიშვილის სახელობის გალობის სკოლის აღსაზრდელები ( ხელმძღვანელი ეკა ბჟინავა).\nკონცერტის დროს შეგროვებული თანხა ჩაირიცხა პატარა დამიანე ნაცვლიშვილის მკურნალობის ფონდში.\nდამიანეს მშობლები გიორგი ნაცვლიშვილი და ნათია ჭელიძე ჩვენი სკოლის კურსდამთავრებულები არიან.\nჩვენ მათ გვერდით უნდა დავდგეთ!\n4 წლის დამიანეს დიაგნოზი არის ლეიკემია და თირკმლის მწვავე უკმარისობა.\nსკოლა, რომელსაც მსგავსი აქციების ორგანიზების დიდი გამოცდილება აქვს , მომავალშიც შემოგთავაზებთ არაერთ ღონისძიებას, რადგან ვიცით, რომ "ადამიანი ადამიანისთვის დღეა!"',
  },
  {
    imageGallery: [],
    image: name20,
    id: 20,
    title: "სახალისო არქეოლოგიის გაკვეთილი",
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში გრძელდება პროექტი "გიმნაზიელები გიმნაზიელებისთვის", რომლის მიზანია, რომ უფროსი თაობის გიმნაზიელებმა თავიანთი ცოდნა და გამოცდილება გაუზიარონ უმცროსებს.\n2021 წლის 22 აპრილს V-VI კლასის მოსწავლეებისთვის არქეოლოგიის სახალისო და საინტერსო გაკვეთილი ჩაატარა მარიამ კოხრეიძემ, რომელიც ივ. ჯავახიშვილის სახელობის თსუ-ის არქეოლოგიის ფაკულტეტის სტუდენტია.',
  },
  {
    imageGallery: [],
    image: name21,
    id: 21,
    title: "დედამიწის დღე",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში არაერთი ღონისძიება მიეძღვნა დედამიწის დღის აღნიშვნას. მოსწავლეებმა მოამზადეს პლაკატები, პოსტერები, ნახეს შემეცნებით-საგანმანათლებლო ფილმები, მოამზადეს სარეკლამო რგოლები, ისაუბრეს ეკოლოგიის პრობლემებზე.\nსაინტერსოდ დედამიწის დღე აღნიშნეს IV-5 კლასის მოსწავლეებმა მასწავლებელ მანანა გოგიბერიძესთან ერთად.\nმოსწავლეებმა დაამზადეს პლაკატები, მშობლების დახმარებით შეიძინეს ნერგები, ესტუმრნენ წმინდა დიდმოწამე ეკატერინეს სახელობის სათნოების სავანეს და გაალამაზეს ეზო.\nVI კლასის მოსწავლეებმა ბუნებისმეტყველების გაკვეთილზე (მასწავლებელი ნანა ჭელიძე) ნახეს დოკუმენტური ფილმი კლიმატის ცვლილების შესახებ, რომლის დასრულების შემდეგ ისაუბრეს გარემოს დაცვის მნიშვნელობაზე.",
  },
  {
    imageGallery: [],
    image: name22,
    id: 22,
    title: "სასწავლო- საგანმანათლებლო პროექტი ინგლისური ენის გაკვეთილზე",
    briefText:
      'საინტერესოდ და სახალისოდ წარიმართა სასწავლო- საგანმანათლებლო პროექტი "კოვიდ პანდემია" ინგლისური ენის გაკვეთილზე VII-2 და VII-6 კლასებში (მასწავლებელი ნათია არობელიძე) .',
  },
  {
    imageGallery: [],
    image: name23,
    id: 23,
    title: "23 აპრილი წიგნის საერთაშორისო დღეა!",
    briefText:
      "23 აპრილი წიგნის საერთაშორისო დღეა!\nწიგნის საერთაშორისო დღის აღსანიშნავად ხელოვნების გაკვეთილზე წიგნის სანიშნეები გააკეთეს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის II, III და IV კლასის მოსწავლეებმა ( მასწავლებელი ირმა კერძევაძე)",
  },
  {
    imageGallery: [],
    image: name24,
    id: 24,
    title: "მოსწავლეების სააღდგომოდ შექმნილი ნამუშევრების გამოფენა",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის III და IV კლასის მოსწავლეების სააღდგომოდ შექმნილი ნამუშევრების გამოფენა ; მასწავლებელი სოფო სანიკიძე.",
  },
  {
    imageGallery: [],
    image: name25,
    id: 25,
    title: '"ჰელადოს" გიმნაზიელთა მონაწილეობით',
    briefText:
      '2021 წლის 8-9 ივნისს ბათუმის ილია ჭავჭავაძის სახელობის პროფესიული სახელმწიფო დრამატული თეატრში - (ბათუმის ილია ჭავჭავაძის სახელობის დრამატული თეატრი ) - შედგა ნოდარ დუმბაძის "ჰელადოს" პრემიერა.\nსპექტაკლში მონაწილებდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები.\nლევან თედორაძე მთავარ, იანგულის როლს ასრულებს,\nგაბრიელ გოგუაძე პეტიას,\nმიქაელ გოგუაძე -პანჩოს.ახალგაზრდა მსახიობების დაძაბულმა შრომამ საუკეთესო შედეგი გამოიღო, ბავშვებმა საოცარი სახეები შექმნეს. იყო ბევრი ტაში, სიხარული, მილოცვები, ცრემლიც!\nმნიშვნელოვანი და აღსანიშნავია ისიც, რომ ლევანმა, მიქაელმა და გაბრიელმა თავიანთი პედაგოგები მიიწვიეს პრემიერაზე.\nგილოცავთ, ბიჭებო და გისურვებთ წარმატებებს!',
  },
  {
    imageGallery: [],
    image: name26,
    id: 26,
    title: "მათემატიკა - სამყაროს შექმნის იარაღი",
    briefText:
      'ნიკა აფხაზავა ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის XI-4 კლასის მოსწავლეა.\nსასწავლო წლის შემაჯამებელ გაკვეთილზე მან უაღრესად საინტერესო ნაშრომი წარმოადგინა მათემატიკის გაკვეთილზე : მათემატიკა - სამყაროს შექმნის იარაღი.\nნიკას მასწავლებელი არის გიული გელაშვილი.\nროგორც ნ. აფხაზავა აღნიშნავს, მისი მიზანი იყო, ეჩვენებინა თანატოლებისთვის მათემატიკური ცოდნის მნიშვნელობა, რომ "მათემატიკა მეტია, ვიდრე სასკოლო საგანი!"\nწარმატებები, ნიკა!\n',
  },
  {
    imageGallery: [],
    image: name27,
    id: 27,
    title: 'სასწავლო ექსკურსია შპს "ბათუმის წყალში"',
    briefText:
      '2021 წლის 7 ივნისს ბათუმის წმ.ანდრია პირველწოდებულის სახელობის სკოლის   VIII-3 და XI-2 კლასის მოსწავლეებისთვის მოეწყო სასწავლო   ექსკურსია-გაკვეთილი შპს "ბათუმის წყლის" ქიმიურ -ბაქტერიოლოგიურ ლაბორატორიაში   (პროექტის ავტორები პედაგოგები ნონა აბაშიძე და ნანა ჭელიძე).მასწავლებელთან ერთად "ბათუმის წყლის" ლაბორატორიის თანამშრომლებმა ძალიან საინტერესო და დასამახსოვრებელი ინფორმაცია მიაწოდეს ბავშვებს. მოსწავლეები ადგილზე გაეცნენ სასმელი წყლის კვლევებს, როგორც აპარატურულ, ასევე ტიტრაციის პროცესს.\nმადლობას მოვახსენებთ შპს ბათუმის წყალი • Batumis Tskali და ვიტოვებთ მომავალი თანამშრომლობის იმედს!\n#სასწავლოექსკურსია\n#ბათუმისწყალი\n',
  },
  {
    imageGallery: [],
    image: name28,
    id: 28,
    title: "გაკვეთილი ბავშვთა უფლებების დაცვის შესახებ",
    briefText:
      'ბავშვთა დაცვის საერთაშორისო დღე აღვნიშნეთ ანდრია პირველწოდებულის სახელობის სკოლაში.III-IV კლასების მოსწავლეებმა "მე და საზოგადოების" გაკვეთილზე (მასწავლებელი სალომე დანელია) მოისმინეს ინფორმაცია, იმის შესახებ თუ რა მიზანს ემსახურება ბავშვთა უფლებების დაცვის დღის აღნიშვნა. პატარებისთვის საინტერესო სანახავი იყო ბავშვის უფლებათა კონვენცია ანიმაციაში.მოსწავლეებმა იმსჯელეს , ისაუბრეს როდის ირღევა ბავშვთა უფლებები, მოიყვანეს მაგალითები, დაწერეს რაზე ოცნებობენ ბავშვები, შეასრულეს ნახატები.\n',
  },
  {
    imageGallery: [],
    image: name29,
    id: 29,
    title: "გაკვეთილი ბავშვთა უფლებების დაცვის შესახებ",
    briefText:
      'ბავშვთა დაცვის საერთაშორისო დღე აღვნიშნეთ ანდრია პირველწოდებულის სახელობის სკოლაში.III-IV კლასების მოსწავლეებმა "მე და საზოგადოების" გაკვეთილზე (მასწავლებელი სალომე დანელია) მოისმინეს ინფორმაცია, იმის შესახებ თუ რა მიზანს ემსახურება ბავშვთა უფლებების დაცვის დღის აღნიშვნა. პატარებისთვის საინტერესო სანახავი იყო ბავშვის უფლებათა კონვენცია ანიმაციაში.მოსწავლეებმა იმსჯელეს , ისაუბრეს როდის ირღევა ბავშვთა უფლებები, მოიყვანეს მაგალითები, დაწერეს რაზე ოცნებობენ ბავშვები, შეასრულეს ნახატები.\n',
  },
  {
    imageGallery: [],
    image: name30,
    id: 30,
    title: '"გიმნაზიელები გიმნაზიელებისთვის"- შეხვედრა უფლებადამცველებთან',
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში გრძელდება პროექტი "გიმნაზიელები გიმნაზიელებისთვის".\nპროექტის ფარგლებში 31 მაისს VII-2 კლასის მოსწავლეებს ბავშვთა დაცვის საერთაშორისო დღის, 1 ივნისისადმი მიძღვნილი გაკვეთილი ჩაუტარდათ თემაზე: "ბავშვთა უფლებები; ბავშვთა დაცვის დღის მნიშვნელობა და აუცილობლობა" (მოქალაქეობის მასწავლებელი- ნატალია სირაბიძე).\nბავშვებს შეხვდნენ ყოფილი გიმნაზიელები:\nმარიამ კვაჭაძე - ივანე ჯავახიშვილის სახელობის თბილისის სახელმწიფო უნივერსიტეტის სამართალმცოდნეობის სამაგისტრო პროგრამის სტუდენტი და\nნიკა ხაზარაძე - “ნიუ ვიჟენ უნივერსიტეტის” სამართლმოცდნეობის ფაკულტეტის კურსდამთავრებული.\nუაღრესად საინტერესო ინტერაქტიული ლექცია გაგრძელდა კითხვა-პასუხის რეჟიმში, შეხვედრა დასრულდა საინტერესო ვიქტორინით.  უღრმეს მადლობას მოვახსენებთ მარიამსა და ნიკას დღევანდელი გაკვეთილისთვის და ვიტოვებთ მომავალი თანამშრომლობის იმედს!\n',
  },
  {
    imageGallery: [],
    image: name31,
    id: 31,
    title: "სკოლის გეოეკოკლუბის მნიშვნელოვანი აქცია",
    briefText:
      "2021 წლის 10-11 ივნისს ბათუმის წმ, ანდრია პირველწოდებულის სახელობის სკოლის გეოეკოლოგიის კლუბის   წევრებმა, კლუბის ხელმძღვანელმა გეოგრაფიის მასწავლებელმა  სოფო ხუხუნაიშვილმა და ქიმიის მასწავლებელმა  ნონა აბაშიძემ მონაწილეობა მიიღეს  ევროკავშირის  დაფინანსებით მიმდინარე შავი ზღვის ეკოაკადემიის პროეტის\n„საზღვაო ნარჩენების“ ფარგლებში დაგეგმილი საზღვაო ნარჩენების მონიტორინგის, აღწერისა და დასუფთავების აქციაში.\n#გეოეკოლოგიისკლუბი\n#ჩვენვუფრთხილდებითბუნებას\n#იზრუნეგარემოზე #გარემოსდაცვა #ნარჩენებისმართვა\n",
  },
  {
    imageGallery: [],
    image: name32,
    id: 32,
    title: "ჯემალ ქარჩხაძის საღამო",
    briefText:
      "2021 წლის 14 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მკითხველთა კლუბმა (მასწავლებელი მარინა ტალახაძე) დიდი ქართველი მწერლის ჯემალ ქარჩხაძის დაბადებიდან 85 წლის იუბილე ბათუმის აკაკი წერეთლის სახელობის საჯარო ბიბლიოთეკაში აღნიშნა.\nმასწავლებელმა და კლუბის წევრებმა , IX-XII კლასის მოსწავლეებმა ისაუბრეს ჯემალ ქარჩხაძის პროზის შესახებ, დამსწრე საზოგადოებას გაუზიარეს ის ემოცია, რომელიც მწერლის განუმეორებელმა სიტყვამ გამოიწვია მათში.\n",
  },
  {
    imageGallery: [],
    image: name33,
    id: 33,
    title: "📣ჩვენო ძვირფასო ❤️გიმნაზიელებო!",
    briefText:
      "მოსწავლეებო, მასწავლებლებო, მშობლებო, კურსდამთავრებულებო!\nმადლობას მოგახსენებთ ყველას, ვინც თავს გიმნაზიელად მიიჩნევთ, ვინც ყოველი შეხმიანებისას გვიდგებით გვერდით და გვაძლიერებთ!\nამჯერადაც ასე მოხდა! სულ რაღაც ერთი კვირის მანძილზე თქვენი თანადგომით ორი მნიშვნელოვანი საქველმოქმედო აქციის ორგანიზება და ჩატარება შევძელით!\nეს ფოტო, ალბათ, ყველაზე კარგად, თან სიმბოლურად გამოხატავს ჩვენს სათქმელს; თანაბარი პასუხისმგებლობით ერთი იდეით გაერთიანებულნი გვერდიგვერდ იდგნენ პირველკლასელი თეკლა ბაზიაშვილი და მისი ბებია ჩვენი სკოლის პედაგოგი რუსუდან თავხელიძე. განა მარტო თეკლა და რუსუდან მასწავლებელი?\nასე, ოჯახებით, ახლობლებით, კლასებით შეგვიძლია ჩვენ თანადგომა, თანაგანცდა და ამით ვართ ძლიერები გიმნაზიელები!\nუღრმეს მადლობას მოგახსენებთ ყველა პედაგოგს, ვინც ჩართული იყო ამ აქციების ორგანიზების პროცესში!\nუღრმეს მადლობას მოგახსენებთ ყველა მოსწავლეს და მასწავლებელს, ვინც თავისი შემოქმედება წარმოგვიდგინა!\nუღრმეს მადლობას მოგახსენებთ ყველა მშობელს, ვინც სიკეთით ზრდით შვილებს!\nამ ერთი კვირის მანძილზე ჩვენ იმაზე ბევრად მეტი თანხა გავიღეთ საქველმოქმედო მიზნით, ვიდრე წარმოგვედგინა, რომ შევძლებდით!\nშეგნებულად არ ვასახელებთ ციფრს, რადგან ვთვლით, რომ სიკეთე, ჯანმრთელობა და სიცოცხლე ციფრებით არ იზომება!\nჩვენ გიმნაზიელები ვართ!\nჩვენ ერთად ნებისმიერ სირთულეს გადავლახავთ!\nჩვენ გვჯერა, რომ გამოჯანმრთელებული დამიანე ნაცვლიშვილიც სულ მალე გახდება გიმნაზიელი!\nგ მ ა დ ლ ო ბ თ !\n---------------------------------------------------\nპატივისცემით ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ადმინისტრაცია.\n",
  },
  {
    imageGallery: [],
    image: name34,
    id: 34,
    title: "ევროპის იმუნიზაციის კვირეული",
    briefText:
      "24-დან 30 აპრილამდე ევროპის იმუნიზაციის კვირეული აღინიშნება.\nამ მნიშვნელოვან თარიღთან დაკავშირებით ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის XI-3 კლასის მოსწავლეებმა ბიოლოგიის პედაგოგის ქეთევან ხარაბაძის ხელმძღვანელობით ჩაატარეს საინფორმაციო- საგანმანათლებლო შეხვედრა მეცხრე კლასის მოსწავლეებისთვის.\n",
  },
  {
    imageGallery: [],
    image: name35,
    id: 35,
    title: "გაკვეთილი კულტურული მემკვიდრეობის დაცვის მნიშვნელობის შესახებ",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VII კლასელებმა მოქალაქეობის გაკვეთილებზე იმსჯელეს კულტურული მემკვიდრეობის დაცვის მნიშვნელობის შესახებ.\nგაკვეთილის შემდეგ კი ბავშვებმა მასწავლებელ ზვიად ჩხენკელთან ერთად ბათუმში არსებული კულტურული მემკვიდრეობის ძეგლების ნაწილი დაათვალიერეს. გაეცნენ ძეგლების მდგომარეობას და ძველი ბათუმის მათთვის უცნობი დეტალები ფოტოზე აღბეჭდეს.\n",
  },
  {
    imageGallery: [],
    image: name36,
    id: 36,
    title: "დღე, რომელიც მხოლოდ თქვენ გეკუთვნით!",
    briefText:
      "20.05.2021 წელი.\nწელს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა 75 მოსწავლემ დაასრულა!\nმათგან 6 ოქროს, ხოლო 4 ვერცხლის მედალოსანია!\nტრადიციულად გადავიხადეთ პარაკლისი და დავულოცეთ გზა ჩვენს საამაყო გიმნაზიელებს!\nგილოცავთ!\n",
  },
  {
    imageGallery: [],
    image: name37,
    id: 37,
    title: "🎓📚 მედალოსანთა დაჯილდოება",
    briefText:
      "2021 წლის 12 ივლისს ბათუმის ღვთისმშობლის შობის სახელობის საკათედრო ტაძარში ბათუმისა და ლაზეთის მიტროპოლიტმა დიმიტრიმ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის წარჩინებული კურსდამთავრებულები ტრადიციულად დააჯილდოვა წმ. ანდრია პირველწოდებულის სახელობის სკოლის მედლებითა და ერთჯერადი სტიპენდიებით!\nწლევანდელი მედალოსნები არიან:\nანა ჩანჩიბაძე\nთამთა ჭავჭანიძე\nმარიამ ჯაყელი\nანა მარია ლეჟავა\nთინათინ ჯოჯუა\nმარიამ დობორჯგინიძე\nელენე ქარცივაძე\nნანუკა მიქაძე\nელენე დიასამიძე\nელენე გუდაძე\nგილოცავთ და გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name38,
    id: 38,
    title: "🎓 გიმნაზიის კურსდამთავრებულთა წარმატება ეროვნულ გამოცდებზე!",
    briefText:
      "2021 წელს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა 75 მოსწავლემ დაასრულა, მათგან 71 უკვე სტუდენტია. ვრცელია იმ უმაღლესი სასწავლებლების სია, სადაც ჩვენი აღზრდილები მნიშვნელოვან სიტყვას იტყვიან.\n18 კურსდამთავრებულმა 70% და 50 % -იანი გრანტი დაიმსახურა!\n100%-იანი სახელმწიფო გრანტის მფლობელები გახდნენ ჩვენი მედალოსნები:\nმარიამ ჯაყელი - თბილისის თავისუფალი უნივერსიტეტის სტუდენტი!\nანა ჩანჩიბაძე -თბილისის თავისუფალი უნივერსიტეტის სტუდენტი!\nელენე გუდაძე - კავკასიის უნივერსიტეტის სტუდენტი!\nგილოცავთ!\nვამაყობთ, გიმნაზიელებო, თქვენი წარმატებით!\nჩვენ გვჯერა თქვენი ღირსეული მომავლის!\n",
  },
  {
    imageGallery: [],
    image: name39,
    id: 39,
    title: "🎓🥇🏆 გამარჯვებული მოსწავლეების დაჯილდოება",
    briefText:
      "2021 წლის 10 სექტემბერს აჭარის განათლების, კულტურისა და სპორტის მინისტრმა მაია ხაჯიშვილმა, აჭარის უმაღლესი საბჭოს თავმჯდომარის მოადგილემ ტიტე აროშიძემ და განათლების კომიტეტის თავმჯდომარემ დავით ბაციკაძემ კონკურსებში გამარჯვებული მოსწავლეები დააჯილდოვეს.\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა ნაკრები გუნდი მათემატიკის ოლიმპიადის გამარჯვებული გახდა!\nგამარჯვებულ მოსწავლეებს დიპლომები და პლანშეტები გადაეცათ!\nმათემატიკის ოლიმპიადაში გამარჯვებული გუნდის შემადგენლობაში იყვნენ:\nნიკა ჩხაიძე\nლუკა უჩანეიშვილი\nთეკლა შერვაშიძე\nნათია დავითაძე\nიოანე ცეცხლაძევულოცავთ გიმნაზიელებს ამ გამარჯვებას და მომავალში დიდ წარმატებებს ვუსურვებთ!",
  },
  {
    imageGallery: [],
    image: name40,
    id: 40,
    title: "♟🏆სასკოლო საჭადრაკო ფესტივალი",
    briefText:
      "2021 წლის 14 ოქტომბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში გაიმართა სასკოლო საჭადრაკო ფესტივალი.\nსხვადასხვა ასაკობროვ კატეგორიაში ოცდაათამდე მოსწავლე შეხვდა ერთმანეთს.\nტურნირის გამარჯვებულები მონაწილეობას მიიღებენ რესპუბლიკურ საჭადრაკო ფესტივალში.",
  },
  {
    imageGallery: [],
    image: name41,
    id: 41,
    title: '🌏🖍🖼 გიმნაზიელები პროექტში "დახატე, რათა შეცვალო რეალობა"',
    briefText:
      'დღე პირველი!\n2021 წლის 13 სექტემბრიდან ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 12 მოსწავლე საქართველოს სახელით ჩაერთო პროექტში "YE Draw To Change Reality - Chapter II TEEN VERSION"- დახატე რათა შეცვალო რეალობა - ნაწილი II, ახალგაზრდული ვერსია;\nპროექტს ახორციელებს საერთაშორისო ორგანიზაცია Association of Small Business and Civil Development ASBCD- "მცირე ბიზნესისა და სამოქალაქო განვითარების ასოციაცია".\nპროექტში ჩვენი სკოლის მოსწავლეებთან ერთად მონაწილეობენ ევროპის რამდენიმე ქვეყნის ახალგაზრდები.\nპირველ დღეს მონაწილეებმა ისწავლეს თემატური კომიქსების ხატვა.\nორგანიზატორებმა ძალიან საინტერესო, უშუალო და თბილი გარემო შექმნეს.',
  },
  {
    imageGallery: [],
    image: name42,
    id: 42,
    title: '🌏🖍🖼 გიმნაზიელები პროექტში "დახატე, რათა შეცვალო რეალობა"',
    briefText:
      'დღე მეორე , მტირალას ეროვნული პარკი,\n16 ოქტომბერი\n2021 წლის 13 სექტემბრიდან ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 12 მოსწავლე საქართველოს სახელით ჩაერთო პროექტში "YE Draw To Change Reality - Chapter II TEEN VERSION"- დახატე რათა შეცვალო რეალობა - ნაწილი II, ახალგაზრდული ვერსია;\nპროექტს ახორციელებს საერთაშორისო ორგანიზაცია Association of Small Business and Civil Development ASBCD- "მცირე ბიზნესისა და სამოქალაქო განვითარების ასოციაცია".\nპროექტში ჩვენი სკოლის მოსწავლეებთან ერთად მონაწილეობენ ევროპის რამდენიმე ქვეყნის ახალგაზრდები.\nმეორე დღეს მონაწილეებმა და ორგანიზატორებმა დალაშქრეს მტირალას ეროვნული პარკი.',
  },
  {
    imageGallery: [],
    image: name43,
    id: 43,
    title:
      '🌏🖍🖼 კომიქსების გამოფენა\n🌏 გიმნაზიელები პროექტში "დახატე, რათა შეცვალო რეალობა"',
    briefText:
      '17.10.2021. დღე მესამე; დასკვნითი გამოფენა.\n2021 წლის 13 სექტემბრიდან ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 12 მოსწავლე საქართველოს სახელით ჩაერთო პროექტში "YE Draw To Change Reality - Chapter II TEEN VERSION"- დახატე რათა შეცვალო რეალობა - ნაწილი II, ახალგაზრდული ვერსია;\nპროექტს ახორციელებს საერთაშორისო ორგანიზაცია Association of Small Business and Civil Development ASBCD- "მცირე ბიზნესისა და სამოქალაქო განვითარების ასოციაცია".\nპროექტში ჩვენი სკოლის მოსწავლეებთან ერთად მონაწილეობენ ევროპის რამდენიმე ქვეყნის ახალგაზრდები.',
  },
  {
    imageGallery: [],
    image: name44,
    id: 44,
    title:
      "🏆🏅♟ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოჭადრაკეების წარმატება - III საპრიზო ადგილი სასკოლო საჭადრაკო ფესტივალსა და გუნდურ პირველობაზე 👏",
    briefText:
      '2021 წლის 24 ოქტომბერს ბათუმის სასპორტო სკოლისა და საჭადრაკო კლუბ "ნონას" ბაზაზე გაიმართა სასკოლო საჭადრაკო ფესტივალის მესამე დასკვნითი ეტაპი ფინალი-გუნდური პირველობა. მონაწილეობდა ბათუმის 13 სკოლა ( სულ 62 მოთამაშე). თითოეული სკოლა წარმოდგენილი იყო 5 მოჭადრაკით.\nპირველობა გაიმართა ფიდეს წესებით, გუნდური შვეიცარული სისტემით 7 ტურად.\nფესტივალში მონაწილეობდნენ დემეტრე გოგიაშვილი, გიორგი გოგიაშვილი, გიორგი დავლაშერიძე, ნუცა ნიკოლაიშვილი, სანდრო გორდელაძე, დათუნა ტუსკია.\nგუნდს ხელმძღვანელობდა სპორტის მასწავლებელი დავით ონიაშვილი.\n25 ოქტომბერს სასკოლო საჭადრაკო ფესტივალის საზეიმო დახურვა გაიმართა.\nდახურვას ესწრებოდნენ: აჭარის განათლების კულტურისა და სპორტის მინისტრის მოადგილე ბადრი ნაკაშიძე, მონაწილე სკოლების წარმომადგენლები და სხვა ოფიციალური პირები.\nვულოცავთ ჩვენს მოჭადრაკეებს ამ წარმატებას!',
  },
  {
    imageGallery: [],
    image: name45,
    id: 45,
    title: "📚პატარა გიმნაზიელების პირველი ნაბიჯები ,,ანბანეთში''",
    briefText:
      ",,გზად ია და ვარდი დააჰფინეთ, ანბანი მობრძანდებაო''\nქართული ენისა და ლიტერატურის გაკვეთილები 1/3 , 1/4 კლასი . მასწავლებელი თეა ქორჩილავა",
  },
  {
    imageGallery: [],
    image: name46,
    id: 46,
    title:
      '🌺🎓💐ქართული ენისა და ლიტერატურის საზეიმო გაკვეთილი 1/ 1 კლასში "აი ია, დედაენის გასაღები" - მასწავლებელი რუსუდან თოიძე.',
    briefText:
      'პატარებმა გაკვეთილზე ისაუბრეს ქართულ ანბანზე, იაკობ გოგებაშვილზე.\n⚘მოსწავლეები გაეცნენ "ა" და "ი" ასო-ბგერებს , იმუშავეს მოძრავი ანბანით ფრაზის "აი ია" -ს შედგენაზე. პლასტელინის გამოყენებით გამოძერწეს ასო-ბგერები.\nმესამე კლასელებმა პატარებს მიულოცეს ანბანის სტუმრობა და გადასცეს საკუთარი ხელით დამზადებული ნამუშევრები.',
  },
  {
    imageGallery: [],
    image: name47,
    id: 47,
    title:
      "📚🎓🌹🌸ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის 1/2 კლასის მოსწავლეებმა ქართული ენისა და ლიტერატურის მასწავლებელ ნინო უგულავასთან ერთად მხიარულად დაიწყეს ანბანის შესწავლა.",
    briefText:
      "ბავშვებმა გაკვეთილზე დახატეს თემატური სურათები, გამოძერწეს და გამოჭრეს ფერად- ფერადი ასო-ბგერები.",
  },
  {
    imageGallery: [],
    image: name48,
    id: 48,
    title: "📚📖 ილუსტრაცია წიგნის სამკაულია",
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მეოთხე კლასების მოსწავლეებმა აქტიური მონაწილეობა მიიღეს ხელოვნების კონკურსში\n"ილუსტრაცია წიგნის სამკაულია".\nკონკურსისთვის მოსწავლეები მოამზადა პედაგოგმა ირინა სევოსტიანოვამ.\nგაიმართა საკონკურსო ნამუშევრების გამოფენა.\nსაუკეთესო ილუსტრატორებს\nგადაეცა სამახსოვრო სიგელები. პატარებმა საჩუქრად მიიღეს წიგნებიც.',
  },
  {
    imageGallery: [],
    image: name49,
    id: 49,
    title:
      '🌏 ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეების და პედაგოგების დაჯილდოება სერთიფიკატებით პროექტში "დახატე, რათა შეცვალო რეალობა" მონაწილეობისთვის 🎓👏',
    briefText:
      '2021 წლის 13 სექტემბრიდან ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 12 მოსწავლე 4 პედაგოგთან ერთად საქართველოს სახელით ჩაერთო პროექტში "YE Draw To Change Reality - Chapter II TEEN VERSION"- დახატე რათა შეცვალო რეალობა - ნაწილი II, ახალგაზრდული ვერსია;\nპროექტს ახორციელებს საერთაშორისო ორგანიზაცია Association of Small Business and Civil Development ASBCD- "მცირე ბიზნესისა და სამოქალაქო განვითარების ასოციაცია".\nპროექტში ჩვენი სკოლის მოსწავლეებთან ერთად მონაწილეობენ ევროპის რამდენიმე ქვეყნის ახალგაზრდები.\n',
  },
  {
    imageGallery: [],
    image: name50,
    id: 50,
    title:
      "🌏🧭 ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის პედაგოგები საგარეო საქმეთა სამინისტროს საინფორმაციო ცენტრის მიერ ორგანიზებულ შეხვედრაზე\n",
    briefText:
      'საგარეო საქმეთა სამინისტროს საინფორმაციო ცენტრი ნატოსა და ევროკავშირის შესახებ ახორციელებს პროექტს „დასავლური ინტეგრაციის პროცესის შესახებ ინფორმირებულობისა და ჩართულობის გაზრდა საქართველოს რეგიონებში“.\nპროექტს ცენტრი ამერიკის შეერთებული შტატების საელჩოსთან ერთად, სახელმწიფო დეპარტამენტის მხარდაჭერით ახორციელებს.\nმიმდინარე წლის 29 ოქტომბერს საინფორმაციო ცენტრის ორგანიზებით ჩატარდა ონლაინ-შეხვედრა აჭარის რეგიონის საჯარო სკოლების დირექტორებისთვის და სამოქალაქო განათლების პედაგოგებისთვის (პლატფორმა ZOOM-ის საშუალებით) საქართველო\nევროატლანტიკური ინტეგრაციის მისწრაფებებსა და დასავლეთთან სტრატეგიული პარტნიორობის მნიშვნელოვან საკითხებზე შეხვედრას უძღვებოდა საინფორმაციო ცენტრის მიერ მოწვეული ექსპერტი, ყოფილი თავდაცვის მინისტრის მოადგილე ბატონი მიხეილ დარჩიაშვილი, რომელმაც წაიკითხა ლექციას თემაზე "ამერიკის შეერთებული შტატების საგარეო პოლიტიკა და საქართველო".',
  },
  {
    imageGallery: [],
    image: name51,
    id: 51,
    title: "🌏   პოლონელი სტუმარი სკოლაში",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახ. სკოლასა და პროფესიულ კოლეჯ „გოლდენ სი“-ს შორის ბოლო წლებში ნაყოფიერი თანამშრომლობა საგანმანათლებლო სფეროს სხვადასხვა ასპექტს მოიცავს.\nდღეს სკოლაში სტუმრად მობრძანდნენ პოლონეთის  რესპუბლიკის კავკასიის ფონდის პრეზიდენტი, ქალაქ ვროცლავის აგლომერაციის განვითარების სააგენტოს ხელმძღვანელი კაროლ ფშივარა და აჭარის ა.რ. უმაღლესი საბჭოს თავმჯდომარის კაბინეტის უფროსი ასლან ლორთქიფანიძე.\nპოლონელ სტუმარს, წმ. ანდრია პირველწოდებულის სახ. სკოლისა და კოლეჯ „გოლდენ სი“-ს ხელმძღვანელობას შორის შედგა სამმხრივი შეხვედრა, სადაც საუბარი ეხებოდა სამომავლოდ სხვადასხვა სახის სასწავლო-საგანმანათლებლო პროექტის განხორციელებას .\nამ ეტაპზე შეხვედრა ძირითადად გაცნობით ხასიათს ატარებდა.",
  },
  {
    imageGallery: [],
    image: name52,
    id: 52,
    title: "🌏🗺 გეოეკოლოგიის კლუბი",
    briefText:
      "🌲🌳🌻2021 წლის 9 ნოემბერს მუშაობა განაახლა ბათუმის წმ. ანდრია პირველწოდებულის სახ. სკოლის 🏕გეოეკოლოგიის კლუბმა (ხელმ. სოფო ხუხუნაიშვილი).🏞   კლუბი, რომელიც აერთიანებს სკოლის უფროსკლასელებს, უკვე რამდენიმე წელია საინტერესო და სასრგებლო პროექტებს ახორციელებს რეგიონის გეოლოგიური   და ეკოლოგიური ვითარების შესწავლის მიზნით.\nდღევანდელ შეხვედრაზე ახალგაზრდებმა პედაგოგთან ერთად ისაუბრეს ეკოლოგიურ პრობლემებზე,  დაგეგმეს განსახორციელებელი ღონისძიებები,   სამომავლო პროექტები და მოსალოდნელი შედეგები.\nსკოლაში მუშაობას შეუდგა, ასევე, ეკოლოგიური მიმართულების წრე\nდაწყებითი საფეხურის მოსწავლეებისთვის, რომელსაც ხელმძღვანელობს ნანა ჭელიძე.\nწინ საინტერესო და მრავალფეროვანი აქტივობებით დატვირთული წელია.\nწარმატებები!",
  },
  {
    imageGallery: [],
    image: name53,
    id: 53,
    title: "⚱⛪🏺ქართული კულტურის შემსწავლელთა კლუბი",
    briefText:
      '2021 წლის 10 ნოემბრიდან ბათუმის წმ. ანდრია პირველწოდებულის სახ. სკოლაში განახლდა ქართული კულტურის შემსწავლელთა კლუბის მუშაობა (ხელმ. პირიმზე რურუა).  კლუბში IX-XII კლასის მოსწავლეებისთვის ჩაინიშნა შეხვედრა თემაზე "კულინარია, როგორც ისტორიული და ეთნოკულტურული ფენომენი" .',
  },
  {
    imageGallery: [],
    image: name54,
    id: 54,
    title: "✏დებატ-კლუბი ⚖",
    briefText:
      '2021 წლის 11 ნოემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახ. სკოლაში მუშაობა დაიწყო დებატ კლუბმა (ხელმძღვანელი ზვიად ჩხენკელი ).\nკლუბის პირველ შეხვედრაზე მოსწავლეები გაეცნენ კარლ პოპერის სახელობის დებატების წესებს.\nგანისაზღვრა დებატების პირველი ტურნირის თემა "არასრულწლოვანთა მიერ ჩადენილი დანაშაული უნდა ისჯებოდეს".',
  },
  {
    imageGallery: [],
    image: name55,
    id: 55,
    title:
      "🎭🎭🎭 2021 წლის 30 ნოემბერი!\n\n🎭🎭🎭 13:00 საათი! წარმატებები ჩვენ უნიჭიერეს გიმნაზიელებს! 👏👏👏👏👏👏",
    briefText:
      "ნოემბერი\n13 საათი - გ.ჩოხელი „მართა“ | ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა | ბათუმის დრამატული თეატრი „დიდი სცენა“\nბათუმის ილია ჭავჭავაძის სახელობის პროფესიული სახელმწიფო დრამატული თეატრი „დიდი სცენა“ - შოთა რუსთაველის №1\nდასწრება თავისუფალია\nეპიდსიტუაციის გათვალისწინებით წარმოდგენებზე დაიშვება გარკვეული რაოდენობის მაყურებელი. სპექტაკლის გამართვის ადგილას კაპელდინერები და მოხალისეები, წარმოდგენის დაწყებამდე 30 წუთთ ადრე მაყურბელს გადასცემს სპეციალურ ბარათს, რისი საშუალებითაც მაყურებელს ექნება უფლება წარმოდგენაზე დასწრებისა. #დასწრებამოსწრებაზეა\nფესტივალის   თარიღები\nნოემბერი -   დეკემბერი 2021წ.\nფესტივალის ავტორი, დამფუძნებელი და ორგანიზატორი: აჭარის ა.რ. განათლების, კულტურისა და სპორტის სამინისტროს „ფესტივალების საგრანტო კონკურსში“ გამარჯვებული შემოქმედებითი ორგანიზაცია ა(ა)იპ „არტ პორტალი“.",
  },
  {
    imageGallery: [],
    image: name56,
    id: 56,
    title: "🎭📖 🎆🎇გიმნაზიელთა პირველი ავტოგრაფი დიდ სცენაზე",
    briefText:
      "საყმაწვილო-სასკოლო დასების თეატრალური ფესტივალი „პირველი ავტოგრაფი“\n\nგოდერძი ჩოხელი - „მართა“\nბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა",
  },
  {
    imageGallery: [],
    image: name57,
    id: 57,
    title: "🎭📖 🎆 🎇 გიმნაზიელთა პირველი ავტოგრაფი დიდ სცენაზე",
    briefText:
      "საყმაწვილო-სასკოლო დასების თეატრალური ფესტივალი „პირველი ავტოგრაფი“\n\nგოდერძი ჩოხელი - „მართა“\nბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა",
  },
  {
    imageGallery: [],
    image: name58,
    id: 58,
    title: "🖼🎨ნორჩი ხელოვანების გამოფენა",
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VI-4 კლასის მოსწავლეებმა ხელოვნების მასწავლებელ რუსუდან ეგუტიძესთან ერთად საოცარი ნამუშევრები გამოფინეს თემაზე: "არქიტექტურა და დიზაინი".\nგამოფენის მოწყობამდე ბავშვებმა შეისწავლეს არქიტექტურის მიმართულებები, ნაგებობათა სახეობები,\nდიზაინი, გაიგეს, როგორ იქმნება მაკეტი, ისაუბრეს ცნობილი არქიტექტორებისა და დიზაინერების შემოქმედებაზე. შესწავლილ მასალებზე დაყრდნობით ბავშვებმა შეასრულეს კომპლექსური დავალება\n,, მე - არქიტექტორი და ჩემი დაპროექტებული უბანი".',
  },
  {
    imageGallery: [],
    image: name59,
    id: 59,
    title: "ქიმიური ექსპერიმენტები და მეცნიერული წვრილმანები",
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები ნინო ბედინაძე და სანდრო კალანდაძე წარმატებით მონაწილეობდნენ ამერიკის ქიმიური საზოგადოების, სან დიეგოს სახელმწიფო უნივერსიტეტისა და ივანე ჯავახიშვილის სახელობის თბილისის სახელმწიფო უნივერსიტეტი ერთობლივ სამუშაო შეხვედაზე "ქიმიური ექსპერიმენტები და მეცნიერული წვრილმანები" , რომელიც გაიმართა ბათუმის ამერიკულ კუთხეში.  ',
  },
  {
    imageGallery: [],
    image: name60,
    id: 60,
    title: "📚🎓გიმნაზიელები გიმნაზიელებისთვის!",
    briefText:
      ' 2021 წლის 3 დეკემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში მოსწავლეებთან შესახვედრად და საკუთარი გამოცდილების გასაზიარებლად მობრძანდა ყოფილი გიმნაზიელი, ამჟამად თვალის ექიმი მარიამ ვარშანიძე.\nმარიამის უშუალო მასპინძელი იყო მისი ბიოლოგიის პედაგოგი ქეთევან ხარაბაძე.\nმარიამ ვარშამიძემ მეცხრე კლასელებს საინტერესო და დასამახსოვრებელი მასტერკლასი ჩაუტარა თემაზე : "თვალი", ესაუბრა იმ გზაზე, რომელიც დიდი შრომისმოყვარეობით განვლო გიმნაზიიდან დღემდე.\nმარიამმა დაასრულა თბილისის სახელმწიფო სამედიცინო უნივერსიტეტის მედიცინის ფაკულტეტი.\nშემდეგ ბელარუსის დიპლომის შემდგომი სამედიცინო აკადემია "ბელმაპო" რეზიდენტურა ოფთალმოლოგიაში.\nგაიარა მინსკის მეათე საავადმყოფოს ლაზერული მიკროქირურგიის განყოფილებაში 6 თვიანი სერთიფიცირებული სტაჟირება.\nამჟამად უკვე არის შემდგარი ოფთალმოლოგი, ლაზერული მიკროქირურგი, კლინიკა "ახალი მზერა"-ს ექიმი რეზიდენტი, 4 სტატიის და სამეცნიერი ნაშრომის ავტორი და თანაავტორი.\nეს შეხვედრა ნამდვილად დიდხანს დაამახსოვრდებათ მოსწავლეებს!\nდიდი მადლობა, მარიამ!\nგიმნაზიის კურსდამთავრებულებო, გელოდებით!\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები ნინო ბედინაძე და სანდრო კალანდაძე წარმატებით მონაწილეობდნენ ამერიკის ქიმიური საზოგადოების, სან დიეგოს სახელმწიფო უნივერსიტეტისა და ივანე ჯავახიშვილის სახელობის თბილისის სახელმწიფო უნივერსიტეტი ერთობლივ სამუშაო შეხვედაზე "ქიმიური ექსპერიმენტები და მეცნიერული წვრილმანები" , რომელიც გაიმართა ბათუმის ამერიკულ კუთხეში.',
  },
  {
    imageGallery: [],
    image: name61,
    id: 61,
    title:
      "🎭📖 🎆 🎇 თეკლა იაკობაძე -ფესტივალის საუკეთესო მსახიობი გოგონა!!!!",
    briefText:
      "გილოცავთ, თეკლა!\nგილოცავთ ყველა მონაწილეს!\nგილოცავთ პედაგოგებს!\nგიმნაზიელთა პირველი ავტოგრაფი დიდ სცენაზე\nსაყმაწვილო-სასკოლო დასების თეატრალური ფესტივალი „პირველი ავტოგრაფი“  გოდერძი ჩოხელი - „მართა“\nბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა",
  },
  {
    imageGallery: [],
    image: name62,
    id: 62,
    title: "🧑‍🔬 შემაჯამებელი გაკვეთილი ბიოლოგიაში",
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში X-1 და X-3 კლასებში ჩატარდა შემაჯამებელი გაკვეთილი თემაზე: "უჯრედი - სიცოცხლის აგებულებისა და განვითარების ძირითადი ერთეული" (პედაგოგი-ქეთევან ხარაბაძე).\nმოსწავლეებმა საკუთარი ხელით უაღრესად საინტერესო ნაშრომები -უჯრედის მაკეტები- წარმოადგინეს.',
  },
  {
    imageGallery: [],
    image: name63,
    id: 63,
    title: "📚🎓🏆მოსწავლეთა დაჯილდოება",
    briefText:
      '2021 წლის 7 დეკემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ადმინისტრაციის გადაწყვეტილებით სიგელებით და\nსაჩუქრებით (წიგნებით) დაჯილდოვდნენ VII, VIII და IX კლასების ის მოსწავლეები, რომლებმაც აჭარის ავტონომიური რესპუბლიკის განათლების, კულტურისა და სპორტის სამინისტროს ქვეპროგრამის "კონკურსები და ოლიმპიადების" ფარგლებში ჩატარებულ კონკურსში მიიღეს მონაწილეობა.\nჩვენი სკოლის გუნდმა "გიმნაზიელები" სხვადასხვა კონკურსის საპრიზო ადგილები დაიმსახურა.\n\nნათია დავითაძე\nბარბარე ბარამიძე\nგაბრიელ გოგუაძე\nლუკა ახალაძე\nნიკა ჩხაიძე\nგიორგი ცინცაძე\nელენე დუმბაძე\nალექსანდრე ჯელია\nგვანცა დევაძე\nნატალია თედორაძე\nდათა ურუშაძე\nანა გოგიჩაიშვილი\nგილოცავთ!\nმომავალშიც ველოდებით თქვენგან დიდ წარმატებებს!',
  },
  {
    imageGallery: [],
    image: name64,
    id: 64,
    title: "🖼🎨ნორჩი არქიტექტორების გამოფენა",
    briefText:
      '\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VI-2 კლასის მოსწავლეებმა ხელოვნების მასწავლებელ რუსუდან ეგუტიძესთან ერთად საოცარი ნამუშევრები გამოფინეს თემაზე: "არქიტექტურა და დიზაინი".\nგამოფენის მოწყობამდე შესწავლილ მასალებზე დაყრდნობით ბავშვებმა შეასრულეს კომპლექსური დავალება\n,, მე - არქიტექტორი და ჩემი დაპროექტებული უბანი".',
  },
  {
    imageGallery: [],
    image: name65,
    id: 65,
    title: "📖📚 გიმნაზიელები სტუმრად ბიბლიოთეკაში",
    briefText:
      '2021 წლის 17 დეკემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VI-3 კლასის მოსწავლეებს ქართული ენისა და ლიტერატურის მასწავლებელმა რუსუდან თავხელიძემ საინტერესო და დასამახსოვრებელი გაკვეთილი ჩაუტარა საბავშვო ბიბლიოთეკაში.\nგიმნაზიელებმა შეისწავლეს   ნუგზარ შატაიძის მოთხრობა "ჩემი სოფლის სამკითხველო". მოსწავლეებმა განიხილეს მოთხრობაში დასმული პრობლემები, ისაუბრეს გულახდილად, შეკითხვები დაუსვეს ბიბლიოთეკარებს, ერთად წაიკითხეს ლექსები, ფრაგმენტები მოთხრობებიდან, წარმოადგინეს ცალკეული მონაკვეთის ინსცენირება, იმღერეს.ახალგაზრდები ხელცარიელი არ წასულან სტუმრად; მათ ბიბლიოთეკას საჩუქრად ჩიჩილაკი, წიგნები, სანთლები, ხოლო უკეთილშობილ მასპინძლებს ტკბილეული მიართვეს.   შემდეგ ჩიჩილაკი თავად მორთეს მათივე დამზადებული სათამაშოებით. არც იმის აღნიშვნა დაავიწყდათ პატარებს,რომ 17 დეკემბერი ბარბარობაა.\nუღრმეს მადლობას მოვახსენებთ ქალბატონ ნანა კვაჭაძეს -საბავშვო ბიბლიოთეკის უაღრესად გულისხმიერ და ყურადღებიან მასპინძელს!\n',
  },
  {
    imageGallery: [],
    image: name66,
    id: 66,
    title: "👭👬 ჩვენ თქვენ გვერდით ვართ!",
    briefText:
      "ომი უბედურებაა!\nომი ყველაფერს ანადგურებს, მაგრამ ომით ყველაზე დიდ ტრამვას ბავშვები განიცდიან!\n\nომის ბავშვები კარგავენ მშობლებს, ახლობლებს, სახლს, მეგობრებს, მშვიდ ძილს, სილაღეს.....\nომის ბავშვები კარგავენ საყვარელ სათამაშოებს....\nჩვენ თქვენ გვერდით ვართ!   ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა სახელით ვიწყებთ საქველმოქმედო აქციას!\nვაგროვებთ სათამაშოებს ომის ბავშვებისთვის!\nმოგიწოდებთ ყველა მოსწავლეს, მშობელს, პედაგოგს, ყველა ბათუმელს და (არა მხოლოდ), რომ ჩვენამდე მოიტანოთ სათამაშო უკრაინაში ომის ბავშვებისთვის გასაგზავნად!\nსკოლაში (მისამართი: ბათუმი, დემეტრე თავდადებულის სახელობის ქუჩა N 49) ერთი კვირის განმავლობაში შევაგროვებთ საჩუქრებს, რომლის გაგზავნას უზრუნველყოფს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ადმინისტრაცია.",
  },
  {
    imageGallery: [],
    image: name67,
    id: 67,
    title: "🎨🖼🖌ხელოვნების გაკვეთილი მუზეუმში",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის III-4 კლასის მოსწავლეებს ხელოვნების მასწავლებელმა სოფო სანიკიძემ საინტერესო და დასამახსოვრებელი გაკვეთილი ჩაუტარა ხელოვნების მუზეუმში.\nპატარებმა დაათვალიერეს წარმოდგენილი ნამუშევრები, გადაიღეს ფოტოები, ისაუბრეს მხატვრობაზე, მხატვრებზე, შეხვდნენ და გაიცნეს ცნობილი ბათუმელი მხატვარი ბატონი ვახტანგ (ბესო) ბესელია.\nგიმნაზიელებმა დიდი შთაბეჭდილებით დატოვეს მუზეუმი.",
  },
  {
    imageGallery: [],
    image: name68,
    id: 68,
    title: "🌏 ⏳ ომი და კულტურა",
    briefText:
      '2022 წლის 2 მარტს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში შედგა ქართული კულტურის ისტორიის შემსწავლელთა კლუბის მორიგი შეხვედრა გაფართოებული ფორმატით.\nმოსწავლეებმა, პედაგოგებმა და სტუმრებმა ისაუბრეს\nთემაზე "ომი და კულტურა".\nკლუბის ხელმძღვანელი პირიმზე რურუა',
  },
  {
    imageGallery: [],
    image: name69,
    id: 69,
    title: "🏆💙სანდრო, გილოცავთ და გისურვებთ წარმატებებს!",
    briefText: "სანდრო, გილოცავთ და გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name70,
    id: 70,
    title:
      "🏆👏🤺 ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მეოთხე კლასის მოსწავლე ელენე ნაკაშიძე თბილისში, ოლიმპიური ჩემპიონის ნუგზარ ასათიანის სახელობის ფარიკაობის დარბაზში 28-31 მაისს გამართულ აფხაზეთის ღია პირველობაზე ხმლით ფარიკაობაში მესამე საპრიზო ადგილის მფლობელი გახდა! ",
    briefText:
      "ვულოცავთ ელენეს პირველ სერიოზულ გამარჯვებას და მომავალშიც ველოდებით დიდ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name71,
    id: 71,
    title: "🌲🌳🌴ტყის საერთაშორისო დღის კვირეული!",
    briefText:
      "23 მარტს ტყის საერთაშორისო დღისადმი მიძღვნილი კვირეულის ფარგლებში აჭარის გარემოს დაცვისა და ბუნებრივი რესურსების სამმართველოსა და სსიპ აჭარის სატყეო სააგენტოს ორგანიზებით მორიგი საგანმანათლებლო აქტივობა გაიმართა, რომელშიც მონაწილეობდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-9 კლასის მოსწავლეები.\nგამოცდილმა მეტყევეებმა მოზარდებს მცირე სემინარი ჩაუტარეს ტყეების განახლების მნიშვნელობის შესახებ და ბავშვებთან ერთად ნაძვის ნერგები დარგეს.\nაღნიშნული კვირეულის ფარგლებში თიკერის სატყეოში 300 ახალი ნერგი დაირგო.",
  },
  {
    imageGallery: [],
    image: name72,
    id: 72,
    title: "🌼🌎💫 დედამიწის საათი 2022!",
    briefText:
      "დედამიწის საათი მსოფლიოში უდიდესი გარემოსდაცვითი აქციაა, რომლის დროსაც მილიონობით ადამიანი ერთი საათით ელექტროენერგიის გამოყენებაზე უარს აცხადებს და ამით პლანეტის მწვანე და უსაფრთხო მომავლის მხარდაჭერას გამოხატავს.\nამ დღეს აჭარის გარემოს დაცვისა და ბუნებრივი რესურსების სამმართველო სასტუმრო „შერატონთან“ ერთად უკვე წლებია ტრადიციულად ერთობლივი ღონისძიებით აღნიშნავს.\nსწორედ ასეთი ღონისძიება შედგა , 26 მარტს სასტუმროს ფოიეში, რომელსაც ბათუმის წმ. ანდრია პირველწოდულის სახელობის სკოლის მოსწავლეები და პედაგოგები (სესილი გათენაძე და ეკატერინე ბჟინავა) ესწრებოდნენ.",
  },
  {
    imageGallery: [],
    image: name73,
    id: 73,
    title: "🏆🏐ფინალური მატჩი ფრენბურთში",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში დასრულდა ფრენბურთის ტურნირი უფროსკლასელთა შორის.\nტურნირის ორგანიზატორია სპორტის მასწავლებელი მიხეილ სალუქვაძე.\n2022 წლის 29 მარტს გაიმართა ფინალური შეხვედრა IX-1 და X-2 კლასის მოსწავლეთა შორის.\nფინალი მეცხრე კლასელთა გამარჯვებით დასრულდა (კაპიტანი ტატო მანველიძე)\nგილოცავთ!\nგისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name74,
    id: 74,
    title: "🌐📣 გიმნაზიელები ვერთიანდებით გიმნაზიელისთვის!",
    briefText:
      "2022 წლის 1 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში გაიმართა საქველმოქმედო კონცერტი, რომლითაც გამოვხატეთ ჩვენი თანადგომა ერთ-ერთ მოსწავლის მიმართ.\nხალხმრავლობა დარბაზში საოცარი ერთსულოვნება სუფევდა, კონცერტის ყველა მონაწილე პასუხისმგებლობითა და პროფესიონალიზმით მოეკიდა საქმეს!\nგვჯერა, ჩვენი პატარა მეგობარი მალე სრულად გამოჯანმრთელდება!",
  },
  {
    imageGallery: [],
    image: name75,
    id: 75,
    title: "ფლექსის პროგრამა",
    briefText:
      "თამარ ჩანჩიბაძე- ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-11 კლასის მოსწავლე, ფლექსის პროგრამის გამარჯვებული, მომავალი სასწავლო წლიდან სწავლას გააგრძელებს აშშ-ში!\nგილოცავთ, ჩვენო საამაყო თამარ! გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name76,
    id: 76,
    title:
      "💻 2022 წლის 8 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში საინფორმაციო შეხვედრა ჩაატარეს კიბერ აკადემიის ( Cyber Academy - კიბერ აკადემია ) წარმომადგენლებმა დემიდ ფასეიშვილმა და კახი კახიძემ.",
    briefText:
      "კიბერ აკადემიაში ახალგაზრდებს საშუალება აქვთ სკოლაში სწავლის პარალელურად დაეუფლონ მომავლის პროფესიებს.",
  },
  {
    imageGallery: [],
    image: name77,
    id: 77,
    title:
      "📚🎓💻ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებმა კვლავ მნიშვნელოვან წარმატებებს მიაღწიეს კინგსის ოლიმპიადაზე.",
    briefText:
      "სხვადასხვა საგანში მედლებით, დიპლომებით და სიგელებით დაჯილდოვდნენ:\nილია ჩხატარაშვილი,\nთეკლა დონდოლაძე,\nნიკოლოზ მესხი,\nნუცა ნიკოლაიშვილი,\nანდრო ხალვაში,\nრატი ვარშალომიძე,\nმარიამ ჩხატარაშვილი,\nნიკოლოზ აცინბა,\nნინია ჩავლეიშვილი,\nდალი დუმბაძე,\nანასტასია დუმბაძე,\nგიორგი ჩავლეიშვილი\nგილოცავთ! \nგისურვებთ წარმატებებს! ",
  },
  {
    imageGallery: [],
    image: name78,
    id: 78,
    title: "📚🎈🌞შეხვედა მწერალთან",
    briefText:
      "მწერალთან შეხვედრით აღნიშნეს დედა ენის დღე ბათუმის ანდრია პირველწოდებულის სახელობის სკოლის II-1 კლასის მოსწავლეებმა.\nქალბატონმა დალი თედორაძემ საკუთარი ზღაპრები წაუკითხა პატარებს.\nღონისძიების\nორგანიზატორი იყო ქართული ენისა და ლიტერატურის მასწავლებელი თეონა ლორთქიფანიძე.",
  },
  {
    imageGallery: [],
    image: name79,
    id: 79,
    title:
      "📒🖊💻📚ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აქტიურად მუშაობს ინტელექტკლუბი, რომელსაც ხელმძღვანელობს პედაგოგი ზვიად ჩხენკელი.",
    briefText:
      "2022 წლის 15 აპრილს გაიმართა ინტელექტუალური კლუბის ვიქტორინის რიგით მე-8 შეხვედრა. კლუბის შეხვედრებში მონაწილეობას იღებენ VIII-IX კლასის მოსწავლეები.",
  },
  {
    imageGallery: [],
    image: name80,
    id: 80,
    title:
      "📚🎓 📜2022 წლის 4 მაისს აკაკი წერეთლის სახელობის ქალაქ ბათუმის საჯარო ბიბლიოთეკის რამაზ სურმანიძის სამკითხველო დარბაზში აკადემიკოს მარიკა ლორთქიფანიძის დაბადებიდან 100 წლისთავთან დაკავშირებით ჩატარდა ბათუმის ანდრია პირველწოდებულის სახელობის სკოლის XII-4 კლასის ღია გაკვეთილი ბიბლიოთეკაში საქართველოს ისტორიაში - ,,ჩვენი დიდგორი“ ( პედაგოგი პირიმზე რურუა).",
    briefText:
      "გაკვეთილის დაწყებამდე მოსწავლეებმა დამსწრე საზოგადოებას წარუდგინეს დოკუმენტური ფილმი ქალბატონ მარიკა ლორთქიფანიძის შესახებ.\nბიბლიოთეკაში სტუმრად ბრძანდებოდნენ და აკადემიკოსი მარიამ ლორთქიფანიძე მოიგონეს ისტორიკოსებმა, პროფესორებმა ნანა ხახუტაიშვილმა და ნადიმ ვარშანიძემ.",
  },
  {
    imageGallery: [],
    image: name81,
    id: 81,
    title:
      '🎓📚 2022 წლის 11 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში XI-4 კლასში ჩატარდა ღია გაკვეთილი ისტორიაში თემაზე 🌐 "დიდი იმპერიების საგარეო-პოლიტიკიური კურსის გავლენა საქართველოს საშინაო პოლიტიკაზე" (მასწავლებელი პირიმზე რურუა).',
    briefText:
      "მოსწავლეებმა ისტორიული ფაქტების მოშველიებით, ანალიზითა და არგუმენტირებული მსჯელობით შეძლეს აუდიტორიისთვის ეჩვენებინათ ეპოქის მნიშვნელოვანი ასპექტები.",
  },
  {
    imageGallery: [],
    image: name82,
    id: 82,
    title: "📚⛪ 17 მაისი პოეტ ფრიდონ ხალვაშის დაბადების დღეა.",
    briefText:
      "ბატონი ფრიდონის საფლავთან ბათუმის საკათედრო ტაძრის ეზოში დღეს ტრადიციულად შეიკრიბნენ ოჯახის წევრები, მწერლები, საზოგადოებრიობის წარმომადგენლები.\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მეოთხე და მეხუთე კლასების მოსწავლეებმა ქართულის პედაგოგებთან ალექსანდრე მელიქაძესა და ლამარა გოგიბერიძესთან ერთად პატივი მიაგეს ბატონ ფრიდონ ხალვაშის ხსოვნას, წაიკითხეს ლექსები, ისაუბრეს პოეტის შემოქმედების შესახებ.",
  },
  {
    imageGallery: [],
    image: name83,
    id: 83,
    title:
      "⛪🎓🌞📚გიმნაზიელთა კიდევ ერთი, 23-ე გამოშვება გავაცილეთ დღეს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლიდან!",
    briefText:
      "გილოცავთ! \nვიცით, რომ გამორჩეული, გონიერი და ლამაზი, განათლებული ახალგაზრდები ხართ!\nმადლობელი ვართ იმ წრფელი სიტყვებისთვის, უდიდესი სითბოს, სიყვარულის, სიკეთისათვის, რაც დღეს გამოხატეთ გიმნაზიის მიმართ!\nჩვენც ვცადეთ, რომ მცირედი სამახსოვრო საჩუქარი მოგვემზადებინა თქვენთვის!",
  },
  {
    imageGallery: [],
    image: name84,
    id: 84,
    title: "⛪🎓🌞📚 ბოლო ზარი-2022!",
    briefText:
      "ტრადიციულად პარაკლისით, დალოცვით, კეთილი სურვილებით, სიყვარულით, სიხარულით, მცირედი სევდით გავაცილეთ დღეს გიმნაზიელთა კიდევ ერთი, 23-ე გამოშვება ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლიდან!\nგილოცავთ! წარმატებებს გისურვებთ!  \nგვიყვარხართ!",
  },
  {
    imageGallery: [],
    image: name85,
    id: 85,
    title: "წიგნიერის გამარჯვებულები დავაჯილდოვეთ და დავასაჩუქრეთ 😍😍😍",
    briefText:
      "ანანო წიკლაური, თამარ ჩანჩიბაძე, ეთუნა ასანიშვილი - ძალიან გვიხარია, რომ გაგიცანით! წარმატებებს გისურვებთ!",
  },
  {
    imageGallery: [],
    image: name86,
    id: 86,
    title:
      "⚽️🥇ეს საოცარი ბიჭი ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VI- 5 კლასის მოსწავლე ნიკოლოზ ჯიჯავაძეა.",
    briefText:
      "სულ ახლახან ის ლატვიაში გამართულ Kaunas Football Fest ტერნირზე საუკეთესო მეკარედ აღიარეს, ხოლო მისმა გუნდმა პირველი ადგილი მოიპოვა!\n \nგილოცავთ ნიკოლოზ და ვიცით, რომ მომავალშიც არაერთხელ გაგვახარებ!",
  },
  {
    imageGallery: [],
    image: name87,
    id: 87,
    title:
      '🌐🌏 ბათუმის ახალგაზრდული ფორუმის ორგანიზებით სასტუმრო "ჰილტონში" ჩატარდა მორიგი ღონისძიება პროექტის ,,თემის მობილიზაცია და თანამონაწილეობა" ფარგლებში, რომელსაც world vision საქართველო ახორციელებს საქართველოში გაეროს ლტოლვილთა უმაღლესი კომისრის წარმომადგენლობის UNHCR ფინანსური მხარდაჭერით.',
    briefText:
      "ამ მნიშვნელოვან ფორუმში დელეგატის სტატუსით მონაწილებდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები:\nმია მინაშვილი,\nანა ძნელაძე,\nთამარ ჩანჩიბაძე,\nოთო კახიძე,\nთორნიკე შალვაშვილი,\nელისაბედ რომანაძე .\nწარმატებებს გისურვებთ ახალგაზრდებო!",
  },
  {
    imageGallery: [],
    image: name88,
    id: 88,
    title: "კომიქსების ხატვა და საინტერესო და სახალისო ნამუშევრების გამოფენა",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის IV-3 კლასის მოსწავლეებმა ისწავლეს კომიქსების ხატვა და საინტერესო და სახალისო ნამუშევრების გამოფენაც მოაწყვეს (მასწავლებელი ირინე სევოსტიანოვა).  ",
  },
  {
    imageGallery: [],
    image: name89,
    id: 89,
    title: '"ტვინების ბრძოლა"',
    briefText:
      '2022 წლის 24 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში მოსწავლეთა აქტიური ჩართულობით ჩატარდა "ტვინების ბრძოლა" - დაძაბული და ხალისიანი ინტელექტუალური თამაში. მონაწილეობდნენ IV-XI კლასების მოსწავლეები.',
  },
  {
    imageGallery: [],
    image: name90,
    id: 90,
    title:
      "2022 წლის 31 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VI-1 კლასის მოსწავლეებმა ბუნების მასწავლებელ ნანა ჭელიძესთან ერთად ",
    briefText:
      '2022 წლის 31 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VI-1 კლასის მოსწავლეებმა ბუნების მასწავლებელ ნანა ჭელიძესთან ერთად ყვავილები დარგეს და გაალამაზეს ბათუმის საკათედრო ტაძრის ეზო. პატარებმა ბევრი იხალისეს და სამომავლოდაც დაგეგმეს "მწვანე გაკვეთილები',
  },
  {
    imageGallery: [],
    image: name91,
    id: 91,
    title:
      "2022 წლის 28 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის IX-3 კლასის მოსწავლეებმა, კლასის დამრიგებელმა ნანა ჭელიძემ და მოსწავლეთა მშობლებმა გასვლითი სასწავლო-შემეცნებითი ექსკურსია ",
    briefText:
      "2022 წლის 28 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის IX-3 კლასის მოსწავლეებმა, კლასის დამრიგებელმა ნანა ჭელიძემ და მოსწავლეთა მშობლებმა გასვლითი სასწავლო-შემეცნებითი ექსკურსია მოაწყვეს სამეგრელოში, დაათვალიერეს ნოქალაქევი, სტუმრობნენ ზუგდიდში დადიანების სასახლე.\nექსკურსია რეგულაციების სრული დაცვით განხორციელდა.",
  },
  {
    imageGallery: [],
    image: name92,
    id: 92,
    title: "🌏🌞💕1 ივნისი- ბავშვთა დაცვის საერთაშორისო დღე.",
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VII-1 კლასის მოსწავლეებმა სამოქალაქო განათლების მასწავლებლის ნატალია სირაბიძის\nდახმარებით შექმნეს  "საგანძურის სკივრები", მათში მოათავსეს საგნები, რომლებიც სიმბოლურად გამოხატავდნენ ბავშვთა უფლებებს.\nსახალისო და საინტერესო სამუშაო პროცესის დასრულების შემდეგ ბავშვებმა კრეატიული და ორიგინალური იდეებით შედგენილი საგანძურის სკივრების გამოფენაც მოაწყვეს ჩვენი სკოლის დერეფანში!',
  },
  {
    imageGallery: [],
    image: name93,
    id: 93,
    title:
      '🌏💒🕌🏰 2022 წლის 1 ივნისს VIII-6 კლასის მოსწავლეებს ისტორიის გაკვეთილი თემაზე " რატომ მოხდა რეფორმაცია დასავლურ ეკლესიაში?" ჩაუტარდათ არაფორმალურ გარემოში, გაკვეთილს უძღვებოდა ისტორიის მასწავლებელი ნატალია სირაბიძე.',
    briefText:
      "მოეწყო მინი-ექსკურსია ქალაქში არსებულ სხვადასხვა აღმსარებლობის პირთა სამლოცველოებში.\nმოსწავლეებმა დაათვალიერეს როგორც მართმადიდებლური, ასევე კათოლიკური, გრიგორიანული ეკლესიები, მეჩეთი და სინაგოგა, შეხვდნენ და ესაუბრნენ სხვადასხვა აღმსარებლობის სასულიერო პირებს.\nსასიამოვნო და შემეცნებითი ექსკურსიის შემდეგ მოსწავლეები მიიჩნევენ, რომ რელიგიური შემწყნარებლობა ერთ-ერთი მნიშვნელოვანი საფუძველია დემოკრატიული ღირებულებებისა და ფასეულობების მქონე საზოგადოების ჩამოსაყალიბებლად.\nმერვეკლასელებს გაუჩნდათ სურვილი ნახატებითა და ესსეებით გაუზიარონ შთაბეჭდილება თავიანთ თანატოლებს.",
  },
  {
    imageGallery: [],
    image: name94,
    id: 94,
    title: "🎈🌞🎭1 ივნისი ბავშვთა დაცვის საერთაშორისო დღეა.",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის II-2 კლასის მოსწავლეები და ქართული ენის მასწავლებელი მაია იმნაძე ბათუმის თოჯინების თეატრში ესწრებოდნენ სპექტაკლის “ალადინის თასი” პრემიერას.\nპატარებმა სპექტაკლის შემდეგ დაათვალიერეს თეატრის საინტერესო და იდუმალი სამყარო და ისაუბრეს სპექტაკლის შესახებ.",
  },
  {
    imageGallery: [],
    image: name95,
    id: 95,
    title: "🎓📚📖 საამაყო გიმნაზიელი - მარი ვერულაშვილი! ❤️",
    briefText:
      "იცნობდეთ!  \nმარიმ 2011 წელს დაასრულა ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა,\nშემდეგ კი ილიას სახელწიფო უნივერსიტეტის მეცნიერებათა და ხელოვნების ფაკულტეტი, საბაკალავრო პროგრამა - ჰუმანიტარული მეცნიერებები: ანგლისტიკა\n2014-2016 წ.წ. - ილიას სახელწიფო უნივერსიტეტის მეცნიერებათა და ხელოვნების ფაკულტეტის მაგისტრატურა სპეციალობით- პოლიტიკის მეცნიერება და საერთაშორისო ურთიერთობები;\n2015-2021 წ.წ. - საერთაშორისო რესპუბლიკური ინსტიტუტი - საქართველო (IRI Georgia), სპეც. პროგრამის ხელმძღვანელი;\n2021-2022 წ.წ. - ჯორჯთაუნის უნივერსიტეტის (ვაშინგტონი, აშშ) პოლიტიკის მართვის მაგისტრატურა;\n2022 წ. მაისიდან დღემდე მარი მუშაობს მსოფლიო ბანკში (ვაშინგტონი, აშშ).\nჯორჯთაუნის უნივერსიტეტის კურსდამთავრებულთა შორის არიან აშშ ყოფილი პრეზიდენტი ბილ კლინტონი, ესპანეთის ამჟამინდელი მეფე ფელიპე IV, იორდანიის მეფე აბდულა II, CIA-ს ყოფილი დირექტორი ჯორჯ ტენეტი, „სითიგრუფის“ თავმჯდომარე და CEO მაიკლ პრინცი, კინოკომპანია Warner Brothers-ის თავმჯდომარე და CEO ენნ სერნოფი, მრავალი სხვა ცნობილი პოლიტიკური და საზოგადო მოღვაწე და ჩვენი მარი!!!",
  },
  {
    imageGallery: [],
    image: name96,
    id: 96,
    title: "მედიის განვითარების ფონდი, MDF",
    briefText:
      'დღეს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში მედიაწიგნიერების ტრენინგზე გაეროს ბავშვთა ფონდის წარმომადგენელი, ღასან ხალილი გვეწვია და მოსწავლეებს მედიაწიგნიერების მნიშვნელობასა და პანდემიის დროს გავრცელებული ყალბი ინფორმაციის მავნე გავლენაზე ესაუბრა.\nტრენინგების სერიის "ნუ დაინფიცირდები დეზინფორმაციით" ფარგლებში სკოლის მოსწავლეებმა ინფორმაციის გადამოწმების ინსტრუმენტები და პირველწყაროს მოძიების ხერხები ისწავლეს და მიღებული ინფორმაციის კრიტიკულად გაანალიზებაზე იმუშავეს.\nტრენინგების სერია და საინფორმაციოა კამპანია UNICEF Georgia-სთან პარტნიორობითა და USAID/Georgia-ის ფინანსური მხარდაჭერით მიმდინარეობს.',
  },
  {
    imageGallery: [],
    image: name97,
    id: 97,
    title:
      "📚 2022 წლის 3 ივნისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა მედიაწიგნიერების ტრენინგი. ტრენინგს ესწრებოდა გაეროს ბავშვთა ფონდის წარმომადგენელი, ღასან ხალილი. მან მოსწავლეებს მედიაწიგნიერების მნიშვნელობასა და პანდემიის დროს გავრცელებული ყალბი ინფორმაციის მავნე გავლენაზე ესაუბრა.",
    briefText:
      'ტრენინგების სერიის "ნუ დაინფიცირდები დეზინფორმაციით" ფარგლებში სკოლის მოსწავლეებმა ინფორმაციის გადამოწმების ინსტრუმენტები და პირველწყაროს მოძიების ხერხები ისწავლეს და მიღებული ინფორმაციის კრიტიკულად გაანალიზებაზე იმუშავეს.\nტრენინგების სერია და საინფორმაციოა კამპანია UNICEF Georgia-სთან პარტნიორობითა და USAID/Georgia-ის ფინანსური მხარდაჭერით მიმდინარეობს.',
  },
  {
    imageGallery: [],
    image: name98,
    id: 98,
    title: "🎥03.06.2022. ჩვეთან, გიმნაზიაში! 📚📒💻📹😍🌞💚🎈",
    briefText: "🎥03.06.2022. ჩვეთან, გიმნაზიაში! 📚📒💻📹😍🌞💚🎈",
  },
  {
    imageGallery: [],
    image: name99,
    id: 99,
    title:
      '🏇🏇🧢 2022 წლის 3 ივნისს ბათუმის ანდრია პირველწოდებულის სახელობის სკოლის V-1 კლასის მოსწავლეები და მათი დამრიგებელი ალექსანდრე მელიქაძე ა(ა)იპ "ბათუმის საცხენოსნო კლუბს" ეწვივნენ. 🐎🐎🐎🐎',
    briefText:
      'მოსწავლეებს მასტერკლასი ჩაუტარა ტრენერმა გიორგი ძინძიბაძემ საქართველოს მრავალგზის ჩემპიონი, ინგლისურ-ამერიკული ჯიშის ფაშატით, სახელად - "ავანტაჟი". ბავშვებმა გაიცნეს , ასევე, "ქსანი" (ახალთექური, იშვიათი ჯიშის ულაყი) და "გალათეა" (გერმანული ჯიშის ულაყი);\nმოსწავლეებმა მოამზადეს პრეზენტაცია თემაზე: ისტორიაში ყველაზე ცნობილი ცხენების და მხედრებისშესახებ.\nაღნიშნულის წარდგენა მეტად უჩვეულო გარემოში - თავლაში მოხდა, რამაც ძალიან დიდი ხიბლი შემატა აღნიშნულ აქტივობას.\nრა თქმა უნდა, ფოტოები ვერ აღწერს სრულად ემოციებს და საჯინიბოში არსებულ სიცოცხლით სავსე გარემოს.',
  },
  {
    imageGallery: [],
    image: name100,
    id: 100,
    title:
      "📚🏫 ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში 4 დღის განმავლობაში მიმდინარეობდა დიაგნოსტიკური ტესტირება IV, VI, IX, X, XI კლასებში.",
    briefText:
      'ტესტირება აღნიშნულ კლასებში ჩატარდა ქართულ ენასა და ლიტერატურაში, მათემატიკასა და ცალკეულ საგნობრივ ბლოკში შემავალ საგნებში.\nდიგნოსტიკური ტესტირება მიზნად ისახავს განვლილი რთული პანდემიური სასწავლო წლების შედეგების შესწავლას.\nშედეგების ანალიზი ძალიან მნიშვნელოვანია მომავალი წლისთვის ეფექტური სასწავლო პროცესის დასაგეგმად.\nამ ეტაპზე მიმდინარეობს ნაშრომების გასწორება და შედეგების ანალიზი და კვლევა, რომელსაც სკოლის ადმინისტრაცია გააცნობს სასკოლო საზოგადოებას და მშობლებს განსახილველად.\nყველა მოსწავლეს და მათ პედაგოგს ვუსურვებთ წარმატებებს!"ულამაზესი და საინტერესო ნამუშევრები გამოფინეს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VIII-5 და VIII- 6 კლასის მოსწავლეებმა (ხელოვნების მასწავლებელი თამუნა წულაძე)- ცნობილი ფერწერული ტილოების მიხედვით შესრულებული 3 D სახის დიორამები ეპოქის დამახასიათებელი მხატვრული ნიშნებით.',
  },
  {
    imageGallery: [],
    image: name101,
    id: 101,
    title:
      '🎈🎼🌺💕🌸ტრადიციულად, "მხიარული მელოდიების"🎵🎵💚 შემაჯამებელი კონცერტით დასრულდა მიმდინარე სასწავლო წელი.',
    briefText:
      'პატარებმა და გუნდის ხელმძღვანელმა ეკა ბჟინავამ ფერადი, ლამაზი, ხალისიანი სანახაობა წარუდგინებს თანატოლებს, მშობლებს, ახლობლებს!\nკონცერტს საპატიო სტუმრის სტატუსით ესწრებოდა "მხიარული მელოდიების" დიდი მეგობარი პატარა დამიანე ნაცვლიშვილი.',
  },
  {
    imageGallery: [],
    image: name102,
    id: 102,
    title:
      "🌏🏕🧭🏞 რთული და აკრძალვებით დატვირთული სასწავლო წლის დასრულებისას შესაძლებელი გახდა თანაკლასელთა ქალაქგარეთ ექსკურსიაზე წასვლა, ბუნებაში დასვენება, გალაღება, ღირსშესანიშნაობების დათვალიერება.",
    briefText:
      "2022 წლის 16 ივნისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-6 კლასის მოსწავლეები დამრიგებელ მაია ახალაძესა და ისტორიის პედაგოგ ნატალია სირაბიძესთან ერთად იმერეთს სტუმრობდნენ.\nექსკურსია შესაბამისი რეგულაციებისა და წესების სრული დაცვით ჩატარდა.",
  },
  {
    imageGallery: [],
    image: name103,
    id: 103,
    title:
      '🎓🌼📚გუნდი "სალამურა" - "ტვინების ბრძოლი" ოლიმპიადის გამარჯვებული!',
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულისნ სახელობის სკოლის გუნდი "სალამურა" მონაწილეობდა "ტვინების ბრძოლის" რესპუბლიკური სასკოლო ოლიმპიადის U5 ასაკობრივ კატეგორიაში .\n"სალამურა" აჭარის რეგიონში წარმატებით და ღირსეულად წარსდგა სხვა გუნდებს შორის და პირველობა მოიპოვა, ხოლო საქართველოს მაშტაბით მეორე ადგილი დაიკავა და გამარჯვებულ გუნდს მხოლოდ ერთი ქულით ჩამორჩა!\nგუნდის წევრები არიან:\nდემეტრე გოგიაშვილი\nნარი თურმანიძე\nმიქაელ ალელიშვილი\nნიკოლოზ ფუტკარაძე\nგოგა გაგუა\nგუნდის ხელმძღვანელი - მათემატიკის მასწავლებელი ხატია ხალვაში.\n\nგილოცავთ!\nგისურვებთ წარმატებებს!',
  },
  {
    imageGallery: [],
    image: name104,
    id: 104,
    title: "🎓📚 მედალოსანთა დაჯილდოება",
    briefText:
      "2022 წლის 12 ივლისს ბათუმის ღვთისმშობლის შობის სახელობის საკათედრო ტაძარში ბათუმისა და ლაზეთის მიტროპოლიტმა დიმიტრიმ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 2021-2022 სასწავლო წლის წარჩინებული კურსდამთავრებულები ტრადიციულად დააჯილდოვა წმ. ანდრია პირველწოდებულის სახელობის სკოლის მედლებითა და ერთჯერადი სტიპენდიებით!\nწლევანდელი მედალოსნები არიან:\nელენე დოლიძე\nნუკა ნაკაშიძე\nლილე ტორონჯაძე\nმარი იაშვილი\nსალომე ჩოგოვაძე\nმარი კეშელავა\nნინი ჩხეიძე\nნინი არძენაძე\nგილოცავთ!\n\nგისურვებთ წარმატებებს! ",
  },
  {
    imageGallery: [],
    image: name105,
    id: 105,
    title:
      'სადისერტაციო თემა: "საზოგადოებრივ-პოლიტიკური ვითარება აჭარაში XX საუკუნის 30-იან წლებში".',
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ისტორიისა და სამოქალაქო განათლების პედაგოგს ლევან სამსონიას ვულოცავთ დოქტორის აკადემიური ხარისხის მინიჭებას! სადისერტაციო თემა: "საზოგადოებრივ-პოლიტიკური ვითარება აჭარაში XX საუკუნის 30-იან წლებში".\n დისერტაციის დაცვის თარიღი: 15 ივლისი 2022 წელი   ',
  },
  {
    imageGallery: [],
    image: name106,
    id: 106,
    title: ' "მოიპოვე გული გონიერი!"  ',
    briefText:
      ' ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა - 30 წლიანი ღირსეული და მდიდარი ისტორიით!\n  "მოიპოვე გული გონიერი!"',
  },
  {
    imageGallery: [],
    image: name107,
    id: 107,
    title: '🌎📚 "ჩვენ ყველანი თავისუფლებისთვის დავიბადეთ"',
    briefText:
      '   2022 წლის 25 ივლისს „შავი ზღვის ხელოვნების საერთშორისო ფესტივალის“ ფარგლებში ბათუმის ხელოვნების ცენტრში გამომცემლობა „ინტელექტმა“ წარადგინა წიგნი    “ჩვენ ყველანი თავისუფლებისთვის დავიბადეთ”- ადამიანის უფლებების საყოველთაო დეკლარაცია სურათებში.\n  წიგნის შესახებ ისაუბრეს გამომცემლობის წარმომადგენლებმა გვანცა ჯობავამ (Gvantsa Jobava ) და მაკა ლდოკონენმა . \n     პრეზენტაცია მიეძღვნა აშშ-ის და საქართველოს დიპლომატიური ურთიერთობების 30 წლისთავს.\n   ღონისძიებას ესწრებოდნენ ფესტივალის დამფუძნებელი, სახელოვანი პიანისტი ელისო ბოლქვაძე, აშშ-ის საელჩოს კულტურის ატაშე კრისტოფერ ანდერსონი, აჭარის განათლების, კულტურისა და სპორტის მინისტრი მაია ხაჯიშვილი და სხვები.\n   აღსანიშნავია, რომ გამომცემლობა „ინტელექტის“ მიერ საგანგებოდ მოწვეული ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის სხვადასხვა ასაკის მოსწავლეები აქტიურად მონაწილეობდნენ საღამოს მსვლელობაში.\n   უღრმეს მადლობას მოვახსენებთ გამომცემლობა "ინტელექტს" როგორც ამ მნიშვნელოვანი და საინტერესო გამოცემისთვის, ასევე, ჩვენი მოსწავლეების ჩართვისთვის პროგრამაში.',
  },
  {
    imageGallery: [],
    image: name108,
    id: 108,
    title: "🌎 მედიაწიგნიერების ტრენინგი",
    briefText:
      " 2022 წლის 6 აგვისტოს მედიის განვითარების ფონდმა MDF ნატოს სახალხო დიპლომატიის ოფისის მხარდაჭერითა და The Critical Mass LLC-თან თანამშრომლობით ბათუმში პედაგოგებისთვის მედია და ინფორმაციული წიგნიერების ტრენინგი ჩაატარა. შეხვედრა საქართველოში ნატოს სამეკავშირეო ოფისის ხელმძღვანელმა, ალექსანდრე ვინიკოვმა გახსნა.\n  ინტენსიური ტრენინგის მოდული სკოლებში მედია და ინფორმაციული წიგნიერების ისეთი კომპეტენციების განვითარებას ითვალისწინებს, როგორიცაა მედიაშინაარსის კრიტიკული ანალიზი, ყალბი ინფორმაციის, ვიზუალისა და ანგარიშების იდენტიფიცირება, ღია წყაროების გამოყენებით ინფორმაციის გადამოწმება. პროგრამა ასევე ითვალისწინებს კიბერუსაფრთხოების და კიბერბულინგის საკითხების სწავლებას.\n   შეხვედრა MDF-ის ახალი ინიციატივის “მედიაწიგნიერი სკოლები საზოგადოების მედეგობისთვის საქართველოში” ფარგლებში ჩატარდა.\n    ტრენინგის მუშაობაში აქტიურად მონაწილებდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის პედაგოგები ანა სლუსარევა, ნატალია ფრუიძე და ზვიად ჩხენკელი.",
  },
  {
    imageGallery: [],
    image: name109,
    id: 109,
    title: "გიორგი ნიგალიძე მუშაობას Amazon-ში დაიწყებს.",
    briefText:
      "თავისუფალი უნივერსიტეტის MACS[E]-ის სკოლის კომპიუტერული მეცნიერებებისა და მათემატიკის საბაკალავრო პროგრამის მეოთხე კურსის სტუდენტი, გიორგი ნიგალიძე მუშაობას Amazon-ში დაიწყებს.გიორგი სექტემბრიდან Amazon-ის გდანსკის (პოლონეთი) ოფისში იმუშავებს Software Development Engineer-ის პოზიციაზე Alexa AI-Natural Understanding-ის გუნდში.",
  },
  {
    imageGallery: [],
    image: name110,
    id: 110,
    title:
      "დაჩი გიორგი გარუჩავა ბერლინის ხელოვნების უნივერსიტეტის //University of the Arts in Berlin, Germany // სტუდენტი გახდა!",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის კურსდამთავრებული დაჩი გიორგი გარუჩავა ბერლინის ხელოვნების უნივერსიტეტის //University of the Arts in Berlin, Germany // სტუდენტი გახდა!\nდაჩი, გილოცავთ დიდი სიყვარულით და მომავალშიც გისურვებთ დიდ წარმატებას!\n              \n ჩვენ ვამაყობთ შენით! ",
  },
  {
    imageGallery: [],
    image: name111,
    id: 111,
    title: "    აბიტურენტთა მომზადების ცენტრი",
    briefText:
      "   აბიტურენტთა მომზადების ცენტრი\n   ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის აბიტურენტთა მომზადების ცენტრი აცხადებს მიღებას 2022-2023 სასწავლო წლის ერთიანი ეროვნული გამოცდებისათვის.\n   ამ ეტაპზე კომპლექტდება ჯგუფები ქართული ენასა და ლიტერატურაში და ისტორიაში . სხვა საგანიც დაემატება იმ შემთხვევაში, თუ მეცადინეობის მსურველი გამოჩნდება და ჯგუფი შედგება.\n  ჯგუფში იმუშავებს 4-5 მოსწავლე.\n   მეცადინეობა თითოეულ საგანში ჩატარდება კვირაში სამჯერ, 1,5-2 ასტრონომიული საათი.\n   მოსამზადებელ კურსებს უძღვებიან მარინე ტალახაძე (ქართული ენა) და პირიმზე რურუა (ისტორია).\n   სასწავლო წლის განმავლობაში ეტაპობრივად ჩატარდება იმიტირებულ (ერთიანი ეროვნული გამოცდის ტიპის)გამოცდები.\n    ყველა საჭირო სასწავლო და დამხმარე მასალით მოსწავლეებს უზრუნველყოფს სკოლა.\n    კურსის ღირებულება ერთი თვის განმავლობაში შეადგენს ჩვენი სკოლის მოსწავლეებისთვის თითოეულ საგანში 100 ლარს, ხოლო არაგიმნაზიელთათვის 120 ლარს.\n   მსურველთა მიღება წარმოებს მშობლის განცხადების საფუძველზე.\n  დაწვრილებით ინფორმაციას მიიღებთ სკოლის კანცელარიაში.",
  },
  {
    imageGallery: [],
    image: name112,
    id: 112,
    title:
      "    ძვირფასო გიმნაზიელებო და მშობლებო, ჩვენი სკოლის გულშემატკივრებო!",
    briefText:
      "   ძვირფასო გიმნაზიელებო და მშობლებო, ჩვენი სკოლის გულშემატკივრებო!\n   გადმოგცემთ რამდენიმე მშობლის ინიციატივას!\n    თუ თქვენ გაქვთ გასული წლებიდან დარჩენილი სახელმძღვანელოები, გიმნაზიის ფორმები (რომელსაც უკვე ვეღარ ირგებთ), მოიტანეთ სკოლაში!\n     სანაცვლოდ კი, იქნებ, თქვენც შეარჩიოთ სასურველი წიგნი ან ფორმა!\n    სკოლა უზრუნველყოფს ამ აქციის ორგანიზებას!\n წიგნების, ფორმებისა და სხვა სასწავლო ნივთების მოტანა სკოლაში შეგიძლიათ ორშაბათიდან, 5 სექტემბრიდან!\n   სკოლის ადმინისტრაციის სახელით მადლობას მოვახსენებთ ამ აქციის ინიციატორ მშობლებს!",
  },
  {
    imageGallery: [],
    image: name113,
    id: 113,
    title: "🏫📚🎈ღია კარის დღე",
    briefText:
      "  2022 წლის 7 სექტემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში მოეწყო ღია კარის დღეს პირველკლასელთა მშობლებისთვის.\n    მშობლებს შეხვდნენ აღმზრდელები, პედაგოგები, დაწყებითი სწავლების საფეხურის სასწავლო ნაწილი და სკოლის დირექტორის მოადგილე.\n     მათ გააცნეს სტუმრებს სკოლის ისტორია, მისია, შინაგანაწესი, სასწავლო პროცესის თავისებურებები, სახელმძღვანელოები, უპასუხეს მშობლების მიერ დასმულ შეკითხვებს, დაათვალიერებინეს სკოლა.\n    ორივე მხარემ გამოხატა ნაყოფიერი თანამშრომლობის სურვილი.",
  },
  {
    imageGallery: [],
    image: name114,
    id: 114,
    title: "    პირველკლასელთა მშობლების საყურადღებოდ!",
    briefText:
      "   ძვირფასო გიმნაზიელებო!\n    პატივცემულო მშობლებო!\n     გილოცავთ ახალი სასწავლო წლის დაწყებას!\n   გისურვებთ ჯანმრთელობას!\n    სიმხნევეს!\n    წარმატებებს!\n     15 სექტემბერს 9:00 საათზე, ვისაც გაქვთ სურვილი, მობრძანდით ღვთისმშობლის შობის სახელობის საკათედრო ტაძარში (მის. ბათუმი, დემეტრე თავდადებულის სახ. ქუჩა N51), სადაც სკოლის მოძღვრები გადაიხდიან პარაკლისს პირველკლასელთათვის, მათი ოჯახის წევრებისა და პედაგოგებისთვის!\n    9:20 სთ-დან უკვე სკოლის შენობაში დაიწყება პირველკლასელთა საზეიმო მიღება!\n    მოსწავლეთა განაწილება კლასებში, ინფორმაცია აღმზრდელებისა და პედაგოგების შესახებ შეგიძლიათ გაიგოთ სკოლაში.\n   პირადი მონაცემების დაცვის ფაქტორის გათვალისწინებით, ინფორმაციას მოსწავლეთა კლასებში განაწილების შესახებ არ ვასაჯაროებთ!\n   გ ე ლ ო დ ე ბ ი თ!   ",
  },
  {
    imageGallery: [],
    image: name115,
    id: 115,
    title: "🏫📖👨‍🎓👩‍🎓2022 წლის 15 სექტემბერი!",
    briefText:
      "   ახალი სასწავლო წლის დასაწყისი!\n    სკოლის კარი გიმნაზიელთა 31-ე თაობამ შემოაღო!   \n      როგორც ყოველთვის, დღესაც იყო ბევრი ღიმილი და სიხარული, პატარების მოლოდინით და ინტერესით აღსავსე თვალები, მცირე სიურპრიზებიც, ყვავილები, ფოტოები!\n           \n    წელსაც, ტრადიციულად, გადაიხადეს პარაკლისი სკოლის მოძღვრებმა, დალოცეს აღსაზრდელები, მათი მშობლები, პედაგოგები!\n             \n     ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ადმინისტრაცია ჩვენს მოსწავლეებს, განსაკუთრებით, პირველკლასელებს და სკოლის პედაგოგებს საუკეთესო სურვილებით გილოცავთ ახალი, 2022-2023 სასწავლო წლის დაწყებას!\n   გისურვებთ ჯანმრთელობას და წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name116,
    id: 116,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის 2022-2023 სასწავლო წლის აკადემიური კალენდარი (ანოტაციით)",
    briefText:
      " ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის 2022-2023 სასწავლო წლის აკადემიური კალენდარი (ანოტაციით)",
  },
  {
    imageGallery: [],
    image: name117,
    id: 117,
    title: "📢📢📢 პატივცემულო მშობლებო!",
    briefText:
      " როგორც მოგეხსენებათ, გასულ წლებში თქვენსა და სკოლას შორის გაფორმდა შეთანხმების ბარათი, რომლის ფარგლებშიც თქვენ გამოხატეთ პოზიცია იმასთან დაკავშირებით, რომ თქვენი შვილის გარკვეული სახის მაიდენტიფიცირებელი ინფორმაცია, კერძოდ, სასწავლო პროცესის ამსახველი ფოტო და ვიდეო გამოსახულება გამოქვეყნებულიყო (ან არ გამოქვეყნებულიყო) სოციალურ ქსელში (სკოლის ოფიციალურ ფეისბუქის და ვებ გვერდებზე) .\n გთხოვთ, თუ თქვენი დამოკიდებულება ამ საკითხზე შეიცვალა, განცხადებით მიმართეთ სკოლის ადმინისტრაციას .\n სხვა შემთხვევაში, ვიტოვებთ უფლებას გაგრძელდეს გასული წლის შეთანხმება, რადგან ვერიდებით პანდემიიდან გამომდინარე სკოლის ტერიტორიაზე უცხო პირთა შემოსვლას.\n ბათუმის წმ. ანდრია პირველწოდებულის სახ სკოლის ადმინისტრაცია.",
  },
  {
    imageGallery: [],
    image: name118,
    id: 118,
    title: "🏫📚🎓🌺 გიმნაზიელთა წარმატება!",
    briefText:
      "  ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა 2021-2022 სასწავლო წელს დაასრულა 78 მოსწავლემ.\n   მათგან წელს 75 გახდა სტუდენტი!\n   გრანტი მოიპოვა :\n  100% - 5 მოსწავლე,\n  70 % - 6 მოსწავლე,\n  50% - 9 მოსწავლე!\n     გილოცავთ ჩვენო საამაყო ახალგაზრდებო!    \n  გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name119,
    id: 119,
    title:
      "🏫📚👩‍🎓🌺ბსუ-ს ყველაზე მაღალქულიანი პირველკურსელი სტუდენტი გიმნაზიელია! 👏👏👏👏👏👏📖📖📖📖🎓🎓🎓🎓",
    briefText:
      "   ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის კურსდამთავრებულმა ლელა მახარაძემ პირველი დიდი ნაბიჯი გადადგა წარმატებისკენ!      \n  თამაზ ბექაიას საგანმანათლებლო ფონდის ხელმძღვანელმა ლევან ბექაიამ ბსუ-ში (ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U) ყველაზე მაღალქულიან პირველკურსელ სტუდენტს ლელა მახარაძეს პრემია გადასცა 1 500 ლარის ოდენობით.\n  გილოცავთ, ლელა!    \n   ",
  },
  {
    imageGallery: [],
    image: name120,
    id: 120,
    title: "ქართული გალობა",
    briefText:
      "   ძვირფასო მშობლებო!\n    ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლასთან არსებობს ანზორ ერქომაიშვილის სახელობის\n ქართული საეკლესიო გალობისა და ეთნომუსიკოლოგიის სკოლა!\n   სკოლაში სწავლება უფასოა!\n მსურველებს შაბათობით\n I-Vკლასების მოსწავლეებისთვის 14:00 სთ-ზე, ხოლო\n VI კლასის ზემოთ 17:00 საათიდან N 100 აუდიტორიაში გელოდებათ პედაგოგი ეკა ბჟინავა, რომელსაც დეტალების დაზუსტების მიზნით შეგიძლიათ დაუკავშირდით ტელ. 593284206!",
  },
  {
    imageGallery: [],
    image: name121,
    id: 121,
    title: "რობერტ კაპას ობიექტივში",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-10 კლასის მოსწავლეები 2022 წლის 4 ოქტომბერს ბათუმის ხელოვნების მუზეუმს სტუმრობდნენ.\n  პედაგოგი პირიმზე რურუა.\n   მოსწავლეებს ჩაუტარდათ საგანმანათლებლო პროგრამა ,,რობერტ კაპას ობიექტივში”.\n   პროგრამას უძღვებოდა ხელოვნების მუზეუმის გიდი თეონა ქინქლაძე.",
  },
  {
    imageGallery: [],
    image: name122,
    id: 122,
    title: "ინგლისური ენის სწავლება პედაგოგებისთვის",
    briefText:
      "   ინგლისური ენის სწავლება პედაგოგებისთვის\n   ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა ჩვენი სკოლის პედაგოგებს გთავაზობთ ინგლისური ენის შესწავლას.\n   მეცადინეობას წარმართავს პედაგოგი ზეინაბ კონცელიძე.\n   მეცადინეობები ჩატარდება ოთხშაბათს და პარასკევს 14:30 სთ-ზე.\n  სწავლება პედაგოგებისთვის არის უფასო.\n    გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name123,
    id: 123,
    title: "ნაპოლეონი - ეპოქის შემქმნელი და ეპოქის მსხვერპლი",
    briefText:
      '2022 წლის 19 ოქტომბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის XII-4 კლასის მოსწავლეებმა სანდრო კალანდაძემ, ნიკა მჟავანაძემ და თორნიკე სიხარულიძემ ისტორიის გაკვეთილზე წარმოადგინეს რეფერატი თემაზე:  "ნაპოლეონი - ეპოქის შემქმნელი და ეპოქის მსხვერპლი" (მასწავლებელი პირიმზე რურუა).\n   წარდგენის შემდეგ მსმენელებმა და მასწავლებელმა დასვეს შეკითხვები, გამოთქვეს მოსაზრებები და შეაფასეს თანაკლასელთა ნაშრომი.',
  },
  {
    imageGallery: [],
    image: name124,
    id: 124,
    title: "შეხვედრა თავისუფალი და აგრარულ უნივერსიტეტის წარმომადგენელთან",
    briefText:
      "  2022 წლის 17 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში თავისუფალი და აგრარულ უნივერსიტეტის წარმომადგენელმა აბიტურიენტებისთვის სასწავლო პროგრამების გაცნობითი შეხვედრა ჩაატარა.\n   აღსანიშნავია, რომ ჩვენს კურსდამთავრებულთა შორის მრავლად არიან თავისუფალი და აგრარული უნივერსიტეტების კურსდამთავრებულები და სტუდენტები.",
  },
  {
    imageGallery: [],
    image: name125,
    id: 125,
    title: "22 ოქტომბერი - ხის დარგვის საერთაშორისო დღე!",
    briefText:
      "  22 ოქტომბერი - ხის დარგვის საერთაშორისო დღე!\n   22 ოქტომბერს ხის დარგვის საერთაშორისო დღესთან დაკავშირებით აჭარის გარემოს დაცვისა და ბუნებრივი რესურსების სამმართველოს და სსიპ აჭარის სატყეო სააგენტოს ორგანიზებით გარემოსდაცვითი ცნობიერების ამაღლების ღონისძიება გაიმართა.\n     სატყეო სააგენტომ ბათუმის მოსწავლე-ახალგაზრდობის სასახლის ეკო-კლუბ „ცისნამი’’-სა და ბათუმის წმ. ანდრია პირველწოდებულის სკოლის აღსაზრდელებს ქობულეთში, თიკერის სანერგეში უმასპინძლა და ასამდე ფიჭვის ნერგის დარგვის შესაძლებლობა მისცა.\n      ",
  },
  {
    imageGallery: [],
    image: name126,
    id: 126,
    title: "ტვინების ბრძოლა",
    briefText:
      '   ტვინების ბრძოლა • Battle of Brains\n    2022 წლის 25 ოქტომბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში გუნდური ინტელექტუალური თამაშის "ტვინების ბრძოლა" პირველი ეტაპი ჩატარდა.\n   თამაშში სხვადასხვა ასაკობროვ კატეგორიაში რამდენიმე ათეული მოსწავლე მონაწილეობდა.\n   წარმატებებს ვუსურვებთ ჩვენს პატარა მოაზროვნეებს!',
  },
  {
    imageGallery: [],
    image: name127,
    id: 127,
    title: "NASA Space Apps Challenge 2022",
    briefText:
      "  ალექსანდრე ჯელია - NASA Space Apps Challenge 2022-ის წარმატებული მონაწილე!\n      ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მეათე კლასის მოსწავლე ალექსანდრე ჯელია დაჯილდოვდა Nasa Space Apps Challenge Apps 2022 პროგრამაში მონაწილეობისთვის!\n   1-2 ოქტომბერს ჩატარდა ყველაზე ფართომასშტაბიანი ჰაკათონი NASA Space Apps Challenge 2022 .\n   NASA Space Apps Challenge 2022 ორგანიზებულია ილიას სახელმწიფო უნივერსიტეტის და საქართველოს ინოვაციებისა და ტექნოლოგიების სააგენტოს GITA • Tech Park მიერ. ხოლო თანაორგანიზატორია ევროკავშირის დაფინანსებით მიმდინარე პროექტი „ახალგაზრდული ტექნოლოგიური კლუბების ქსელი”.",
  },
  {
    imageGallery: [],
    image: name128,
    id: 128,
    title: "შოთა რუსთაველის საქართველოს ეროვნული სამეცნიერო ფონდი",
    briefText:
      ' ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ქიმიის პედაგოგი ნონა აბაშიძე შოთა რუსთაველის საქართველოს ეროვნული სამეცნიერო ფონდის 2022 წლის დოქტორანტურის საგანმანათლებლო პროგრამების საგრანტო კონკურსის გრანტის მფლობელი გახდა თემისთვის "დასავლეთ საქართველოში მოწეული თაფლის ბოტანიკური წარმოშობის დასადგენად თაფლის მტვრიანების, ბიოაქტიური ნაერთებისა და ბიოლოგიური აქტიურობის კვლევა."\n    გილოცავთ, ნონა მასწავლებელო და გისურვებთ შემოქმედებით წარმატებებს!',
  },
  {
    imageGallery: [],
    image: name129,
    id: 129,
    title: "ჰუმანური პედაგოგიკა",
    briefText:
      ' 2022 წლის 26 ოქტომბერს თბილისის საკრებულოს თამარ მეფის დარბაზში შალვა ამონაშვილის საგანმანათლებლო პროექტის ,,ჰუმანური საქართველო""-ს პრეზენტაცია გაიმართა.\n   აკადემიკოსმა შალვა ამონაშვილმა დამსწრე აუდიტორიას პროექტის მიზნები და ხედვები გაუზიარა.\n   ღონისძიებაზე მიწვეული იყო ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაც, რომელსაც ამჯერად წარმოადგენდა ისტორიის და სამოქალაქო განათლების პედაგოგი ზვიად ჩხენკელი\n  სამომავლოდ ,,ჰუმანურ საქართველო""-სა და ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლას შორის მნიშვნელოვან და საინტერესო თანამშრომლობას ეყრება საფუძველი!',
  },
  {
    imageGallery: [],
    image: name130,
    id: 130,
    title: "პროექტული სწავლება სამოქალაქო განათლებაში",
    briefText:
      " პროექტული სწავლება სამოქალაქო განათლებაში\n   მიმდინარე სასწავლო წელს პირველად ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის X კლასებში სამოქალაქო განათლებაში დაინერგა პროექტული სწავლება, რომელსაც ასწავლის ახალგაზრდა პედაგოგი ანა ანუშიძე.\n    მოსწავლეების მიერ შერჩეული სასწავლო პროექტის მახასიათებლებით განისაზღვრა თემატიკა:\n  მდგრადი განვითარება\n  ციფრული მედეგობა\n  საკანონმდებლო აქტები მოსწავლეებისთვის\n   პუბლიცისტური წერილები\n  პოლიტიკა და პოლიტიკური იდეოლოგიები",
  },
  {
    imageGallery: [],
    image: name131,
    id: 131,
    title: '"წარმოსახვითი მოგზაურობა" და "აჭარული ნაჭრელი"',
    briefText:
      ' "წარმოსახვითი მოგზაურობა" და "აჭარული ნაჭრელი"\n    2022 წლის 29 ოქტომბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში ქართული კულტურის კლუბის მორიგი შეხვედრა შედგა (ხელმძღვანელმა პირიმზე რურუა).\n   შეხვედრის თემა: " კულტურული მრავალფეროვნება და წარმოსახვითი მოგზაურობა".\n    შემდეგ ახალგაზრდები სტუმრობდნენ აჭარის ხელოვნების მუზეუმს, სადაც დაათვალიერეს მუზეუმის ექსპოზიცია და გამოფენა "აჭარული ნაჭრელი".',
  },
  {
    imageGallery: [],
    image: name132,
    id: 132,
    title: "შავი ზღვის დაცვის დღე",
    briefText:
      ' შავი ზღვის დაცვის დღე\n   1996 წელს შავი ზღვის აუზის ქვეყნებმა: უკრაინამ, რუსეთმა, რუმინეთმა, თურქეთმა, ბულგარეთმა და საქართველომ სტამბულში ხელი მოაწერეს შავი ზღვის დაცვის სტრატეგიულ გეგმას.\n   31 ოქტომბერი შავი ზღვის დაცვის დღედ გამოცხადდა. ეს თარიღი აღინიშნება საქართველოშიც.\n   ამ დღესთან დაკავშირებით, მოსწავლეთა ცნობიერების ამაღლების მიზნით, ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის IX -2 კლასის მოსწავლეებმა და მასწავლებელმა ნატალია სირაბიძემ პარალელურ კლასების მოსწავლეებისთვის ჩაატარეს შემეცნებითი საუბრები თემებზე:\n „31 ოქტომბერი-შავი ზღვის დაცვის საერთაშორისო დღე";\n "შავი ზღვის გეოგრაფია და მისი მნიშვნელობა";\n „შავი ზღვის ქვეყნები და მოსახლეობა";\n "შავი ზღვის ფლორა და ფაუნა".',
  },
  {
    imageGallery: [],
    image: name133,
    id: 133,
    title:
      "ზღვის სანაპირო ზოლის დასუთავების აქცია შავი ზღვის დაცვის დღესთან დაკავშირებით",
    briefText:
      " ზღვის სანაპირო ზოლის დასუთავების აქცია შავი ზღვის დაცვის დღესთან დაკავშირებით\n    31 ოქტომბერს შავი ზღვის დაცვის საერთაშორისო დღესთან დაკავშირებით ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის გეოეკოლოგიის კლუბის წევრებმა (ხელმძღვანელი სოფო ხუხუნაიშვილი) და მოსწავლე-ახალგაზრდობის სასახლის აღსაზრდელებმა დაასუფთავეს შავი ზღვის სანაპირო ზოლი, ასევე, მოსახლეობის ცნობიერების ამაღლების მიზნით დაარიგეს მათ მიერ შექმნილი ბუკლეტები.",
  },
  {
    imageGallery: [],
    image: name134,
    id: 134,
    title: "წითელი ჯვრის ტრენინგი",
    briefText:
      "წითელი ჯვრის ტრენინგი\n  2022 წლის 4 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებისთვის გადაუდებელი პირველადი დახმარების სწავლების მიზნით IX-X კლასების მოსწავლეებისთვის ტრენინგი ჩაატარა წითელი ჯვრის რეგიონალურმა ორგანიზაციამ.\n  სწავლებას უძღვებოდა ბსუ-ს მედიცინის ფაკულტეტის სტუდენტი სალომე დოლიძე.",
  },
  {
    imageGallery: [],
    image: name135,
    id: 135,
    title: "შეხვედრა საბავშვო მწერალთან",
    briefText:
      ' შეხვედრა საბავშვო მწერალთან\n  2022 წლის 3 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-3 კლასის მოსწავლეებმა და ქართული ენის პედაგოგმა რუსუდან თოიძემ სტუმრად მოიწვიეს საბავშვო მწერალი დალი თედორაძე.\n  მოსწავლეებმა წაიკითხეს მისი ავტორობით გამოცემული ზღაპრების წიგნი -"როგორ გაჩნდნენ დევები".\n  იმსჯელეს წაკითხულის შესახებ, შექმნეს და წარმოადგინეს კომიქსები.\n  ავტორსა და მოსწავლეებს შორის გაიმართა საინტერესო და სახალისო საუბარი.\n  მწერალმა გულწრფელი პასუხები გასცა პატარების მიერ დასმულ შეკითხვებს .\n    ბავშვების სურვილის გათვალისწინებით დაიგეგმა მომავალი შეხვედრა.\n    IV-3 კლასის დამრიგებელი და ქართული ენის პედაგოგი რუსუდან თოიძე მადლობას უხდის ქალბატონ დალის გულისხმიერებისთვის!',
  },
  {
    imageGallery: [],
    image: name136,
    id: 136,
    title: "მეცნიერი-პედაგოგები",
    briefText:
      "   მეცნიერი-პედაგოგები\n   10 ნოემბერი მეცნიერების საერთაშორისო დღეა!     \n ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში ეს დღე რამდენიმე აქტივობით აღვნიშნეთ.\n  მასში ჩართული იყვნენ საბაზო და საშუალო საფეხურის მოსწავლეები.\n   ჩვენდა საამაყოდ გვსურს აღვნიშნოთ, რომ გიმნაზიაში არაერთი ახალგაზრდა მეცნიერი ასწავლის. სკოლაში მუშაობის პარალელურად ისინი ნაყოფიერ სამეცნიერო საქმიანობას ეწევიან.\n    ნაცნობი პედაგოგები დღეს ახალ - მეცნიერის ამპლუაში იხილეს მოსწავლეებმა.",
  },
  {
    imageGallery: [],
    image: name137,
    id: 137,
    title: "„ვაგროვებთ მაკულატურას ტყის გადასარჩენად“",
    briefText:
      "„ვაგროვებთ მაკულატურას ტყის გადასარჩენად“ \n   ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის გეო ეკოლოგიის კლუბის წევრებმა (კლუბის ხელმძღვანელი სოფიკო ხუხუნაიშვილი) მეოთხე კლასის მოსწავლეებისთვის საგანმანათლებლო აქცია ჩაატარეს თემაზე: „ვაგროვებთ მაკულატურას ტყის გადასარჩენად“    ",
  },
  {
    imageGallery: [],
    image: name138,
    id: 138,
    title: "ალექსანდრე ჯელია - წარმატებული გიმნაზიელი!",
    briefText:
      "  ალექსანდრე ჯელია - წარმატებული გიმნაზიელი!\n  31 ოქტომბერს ტექნოპარკში ჩატარდა HARDWARE StartUP ინკუბატორის Demo დღე, სადაც მონაწილეები წინასწარ დაკომპლექტებული ჟიურის წინაშე წარსდგნენ საკუთარი ბიზნეს იდეებითა და Hardware პროტოტიპებით.\n  საქართველოს მასშტაბით პროექტი 5 თვის განმავლობაში მიმდინარეობდა საქართველოს ტექნოპარკებში, სადაც მონაწილეებს უტარდებოდათ მიკროელექტრონიკისა (Arduino, Raspeberry PI with IOT) და ბიზნეს ტრენინგები/მენტორშიფები\n   პროექტის დასკვნით ეტაპზე Demo დღეზე წარმატებულად მონაწილეობდა ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე ალექსანდრე ჯელია. (აჭარის რეგიონიდან წარდგენილი პროექტი - SmartWall ) \n   ალექსანდრე, გისურვებთ წარმატებებს!   ",
  },
  {
    imageGallery: [],
    image: name139,
    id: 139,
    title: "ჭადრაკის ტურნირი",
    briefText:
      " 2022 წლის 13 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა სასკოლო საჭადრაკო ტურნირი V-XII კლასების მოსწავლეთა შორის (ღონისძიების ორგანიზატორები -მაია ჭანუყვაძე, დავით ონიაშვილი, კარლო ტრაპაიძე).\n   ტურნირში მონაწილეობდა 30-ზე მეტი მოსწავლე.\n   გამოვლინდნენ გამარჯვებულები - ძმები გიორგი და დემეტრე გოგიაშვილები და ანა ონიაშვილი.   ",
  },
  {
    imageGallery: [],
    image: name140,
    id: 140,
    title: "ლეგოზე დაფუძნებული დიზაინერული აზროვნება",
    briefText:
      "ლეგოზე დაფუძნებული დიზაინერული აზროვნება\n  2022 წლის 15 ნოემბერს საქართველოს უნივერსიტეტის ორგანიზებით ჩატარდა სემინარი უფროსკლასელთათვის თემაზე „ლეგოზე დაფუძნებული დიზაინერული აზროვნება“.\n  სემინარში მონაწილეობდა ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა გუნდი.",
  },
  {
    imageGallery: [],
    image: name141,
    id: 141,
    title: "წარმატებულ გიმნაზიელთა დაჯილდოება",
    briefText:
      "  წარმატებულ გიმნაზიელთა დაჯილდოება\n  2022 წლის 16 ნოემბერს აჭარის განათლების სამინისტრომ გასული წლის ოლიმპიადებსა და კონკურსებში გამარჯვებული მოსწავლეები დააჯილდოვა.",
  },
  {
    imageGallery: [],
    image: name142,
    id: 142,
    title: "ხელოვნების გაკვეთილი მუზეუმში",
    briefText:
      'ხელოვნების გაკვეთილი მუზეუმში\n   2022 წლის 18 ნოემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VIII-3 კლასის მოსწავლეებს ხელოვნების გაკვეთილი მასწავლებელმა ნინო როგავამ მუზეუმში ჩაუტარა. ხელოვნების მუზეუმში წარმოდგენილი იყო ჩვენი თანაქალაქელი მხატვრის ნათია-ფრიდა ბოლქვაძის პერსონალური გამოფენა "სიზმარი". \n  მოსწავლეებმა ყურადღებით დაათვალიერეს ნახატები, გაესაუბრნენ ავტორს, მოისმინეს ნამუშევრების შექმნის ისტორიები, ინსპირაციის წყაროები ბოლოს კი მიიღეს მიწვევა ფესტივალ,,განდაგანაზე".',
  },
  {
    imageGallery: [],
    image: name143,
    id: 143,
    title: "მოსწავლეთა საველე სასწავლო ტური სარფსა და გონიოში",
    briefText:
      "მოსწავლეთა საველე სასწავლო ტური სარფსა და გონიოში\n   2022 წლის 19 ნოემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ქართული კულტურის შემსწავლელთა კლუბის მოსწავლეებმა (კლუბის ხელმძღვანელი პირიმზე რურუა) მოაწყვეს საველე-სასწავლო ტური გონიოსა და სარფში.",
  },
  {
    imageGallery: [],
    image: name144,
    id: 144,
    title: "სასკოლო საჭადრაკო ფესტივალი",
    briefText:
      " სასკოლო საჭადრაკო ფესტივალი\n   2022 წლის 20 ნოემბერს გაიმართა აჭარის სასკოლო საჭადრაკო ფესტივალი, რომელშიც მონაწილეობდა ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის გუნდი, რომლის შემადგენლობაშიც შედიოდნენ ძმები გიორგი და დემეტრე გოგიაშვილები და ანა ონიაშვილი.",
  },
  {
    imageGallery: [],
    image: name145,
    id: 145,
    title: "მკითხველთა კლუბი",
    briefText:
      ' მკითხველთა კლუბი\n   2022 წლის 20 ნოემბერს ბათუმის წმ. ანდრია პირველწოდებულის სკოლაში შედგა მკითხველთა კლუბის შეხვედრა ( კლუბის ხელმძღვანელი მარინა ტალახაძე) .\n  შეხვედრის თემა: 1. ნიკო ლორთქიფანიძე "ტრაგედია უგმიროდ";\n  2. ბიბლიური სიუჟეტის ასახვა თანამედროვე ხელოვნებაში.',
  },
  {
    imageGallery: [],
    image: name146,
    id: 146,
    title: 'ეთნოგრაფიული მუზეუმი "ბორჯღალი".',
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის III-3 კლასი (დამრიგებელი თამუნა მექვაბიშვილი) სტუმრად ეთნოგრაფიულ მუზეუმში "ბორჯღალი".',
  },
  {
    imageGallery: [],
    image: name147,
    id: 147,
    title: "მოსწავლეთა სასწავლო შემოქმედებითი კონფერენცია",
    briefText:
      "  ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა სასწავლო შემოქმედებითი კონფერენცია\n   24-25 ნოემბერი, 2022-2023 სასწ. წელი\n მონაწილეები, მოხსენებები...",
  },
  {
    imageGallery: [],
    image: name148,
    id: 148,
    title: "ჩემპიონი ძმები",
    briefText:
      " დასრულდა საქართველოს თასი გოჯუ-რიუ კარატეში, სადაც გამარჯვება და ჩემპიონის სტატუსი მოიპოვეს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებმა ძმებმა დაჩი და სანდრო ბასილაძეებმა!\n   გილოცავთ!\n  დაჩი და სანდრო, გისურვებთ მომავალ დიდ სპორტულ წარმატებებს!   ",
  },
  {
    imageGallery: [],
    image: name149,
    id: 149,
    title:
      "მწერლის, პოეტისა და პუბლიცისტის ილია ჭავჭავაძის დაბადებიდან 185 წელი",
    briefText:
      "10 ნოემბერს, 14:00 საათზე ბათუმის საჯარო ბიბლიოთეკის საბავშვო-ახალგაზრდობის განყოფილებაში ჩატარდა საჯარო ლექცია ,,მწერლის, პოეტისა და პუბლიცისტის ილია ჭავჭავაძის დაბადებიდან 185 წელი.“",
  },
  {
    imageGallery: [],
    image: name150,
    id: 150,
    title:
      "გეო ეკოლოგიის კლუბის წევრები სტუმრად ბსუ-შიგეო ეკოლოგიის კლუბის წევრები სტუმრად ბსუ-ში",
    briefText:
      "გეო ეკოლოგიის კლუბის წევრები სტუმრად ბსუ-ში\n   2022 წლის 29 ნოემბერს წმ. ანდრია პირველწოდებულის სახელობის სკოლის გეო ეკოლოგიის კლუბის წევრები და მასწავლებელი სოფიკო ხუხუნაიშვილი ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტში ესწრებოდნენ ახალგაზრდა ნატურალისტთა საზოგადოების ინიციატივით ჩატარებულ ვორქშოპს",
  },
  {
    imageGallery: [],
    image: name151,
    id: 151,
    title:
      "ქ. ბათუმის, წმინდა ანდრია პირველწოდებულის სახელობის სკოლის, მე - 7 ბ კლასის მოსწავლეებმა, შექმნეს მრავალჯერადად გამოყენებადი სასწავლო რესურსი გეოგრაფიაში.",
    briefText:
      "მე - 7 ბ კლასის მოსწავლეებმა იმუშავეს მაღალი პასუხისმგებლობით რის შედეგადაც შემაჯამებელი გაკვეთილების თითოეულ ეტაპზე აჩვენეს წარმატებული შედეგი. შემაჯამებელი გაკვეთილების ფარგლებში მოსწავლეებმა:\n(ა) გაიმეორეს შესწავლილი და დამუშავებული მასალა გეოგრაფიაში.\n (ბ) თითოეული თემის დამუშავების შედეგად მოიფიქრეს „საკვანძო კითხვები“.\n (გ) „საკვანძო კითხვების“ გამოყენებით მოამზადეს სხვადასხვა დიზაინის კროსვორდები.\n (დ) მომზადებული კროსვერდები წარადგინეს კლასის წინაშე და მიიღეს რეფლექსია, როგოც მასწავლებლისგან ისე თანაკლასელებისგან.\n (ე) მოსწალეებს დაურიგდათ ერთმანეთის და პარალელური კლასელების მიერ მომზადებული კროსვორდები ორი მიზნით (1) შეევსოთ კროსორდები და (2) შეეფასებინათ კროსორდის შინაარსობრივი და ვიზუალური მხარე.\n (ვ) მოსწავლეებმა და მასწავლებელმა წარმოადგინეს ზემოთ ჩამოთვლილი და განხორციელებული აქტივობების შეფასება რის შემდეგაც მე - 7 კლასის მოსწავლეებმა, მიღებული გამოცდილების გაზიარების, გააზრების და დასკვნების გამოტანის შედეგად, ერთობლივად დაგეგმეს საერთო საკლასო კროსვორდის, როგორც მრავალჯერადად გამოსაყენებელი რესურსის, შექმნა.\n (ზ) მოსწალეებმა წარადგინეს საერთო საკლასო კროსვორდის პრეზენტაცია საკუთარ და პარალელურ კლასებში.\n წინსვლას და წარმატებებს ვუსურვებთ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლას და განსაკუთრებით ნიჭიერ და შრომისმოყვარე მე - 7 კლასის მოსწავლეებს.",
  },
  {
    imageGallery: [],
    image: name152,
    id: 152,
    title: "გეო ეკოლოგიის კლუბის წევრების პრაქტიკა ისპაანის ჭაობში.",
    briefText:
      "2022 წლის 22 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის გეო ეკოლოგიის კლუბის წევრები და კლუბის ხელმძღვანელი, გეოგრაფიის მასწავლებელი სოფიკო ხუხუნაიშვილი საგანმანათლებლო-შემეცნებითი მიზნით დაუკავშირდნენ კოლხეთის დაცული ტერიტორიების ადმინისტაციას და მოინახულეს ისპაანის ჭაობი.\n მოსწავლეებს ცენტრის თანამშრომელმა სოფო თხილაიშვილმა გააცნო ჭაობების მნიშვნელობა; შემდეგ ნორჩი ეკოლოგები გავიდნენ აღკვეთილისა და ნაკრძალის ტერიტორიაზე, სადაც ნახეს მსოფლიო მნიშვნელობის თეთრი ხავსი.\n გეო ეკოლოგების ვიზიტის შედეგები აისახა მოსწავლეთა საკონფერენციო ნაშრომში.",
  },
  {
    imageGallery: [],
    image: name153,
    id: 153,
    title:
      "ტვინების ბრძოლის 2022 წლის გაზაფხულის სეზონის რეგიონულ პირველობაზე წარმატებული ასპარეზობისთვის სერტიფიკატებით დაჯილდოვდნენ ჩვენი სკოლის მოსწავლეები:",
    briefText:
      "მარიამ ებრალიძე,\n თამარ ტაკიძე,\n ელენე გოგიჩაიშვილი,\n ლუკა დოლიძე,\n ნიკა ჩამბა ,\n ნიკოლოზ ფუტკარაძე,\n დემეტრე გოგიაშვილი,\n ნარი თურმანიძე,\n მიქაელ ალელიშვილი,\n გოგა გაგუა\n მასწავლებლები- ლამარა გოგიბერიძე და ხატია ხალვაში!\n გილოცავთ!",
  },
  {
    imageGallery: [],
    image: name154,
    id: 154,
    title:
      "ჭადრაკის გაკვეთილი ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველ კლასში და ყველასთვის საყვარელი ღვაწლმოსილი სპორტის მასწავლებელი კარლო ტრაპაიძე.",
    briefText: "წარმატებებს ვუსურვებთ ჩვენს პატარა მოჭადრაკეებს!",
  },
  {
    imageGallery: [],
    image: name155,
    id: 155,
    title: "ექსკურსია დენდროლოგიურ პარკში",
    briefText:
      '2022 წლის 29 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII - 4 კლასის მოსწავლეებს რუსული ენის მასწავლებელმა ევგენია ლომაძემ ჩაუტარა გასვლითი გაკვეთილი -ექსკურსია " ოქროსფერი შემოდგომა".\n მოსწავლეებმა მოინახულეს შეკვეთილის დენდროლოგიური პარკი.\n პარკში ვიზიტის მიზანი იყო - თეორიული ცოდნის გაღრმავება-განმტკიცება, კომუნიკაციური კომპეტენციის ფორმირება, შემოქმედებითობის და ფანტაზიის განვითარება.',
  },
  {
    imageGallery: [],
    image: name156,
    id: 156,
    title: "ღია გაკვეთილი ისტორიაში",
    briefText:
      '2022 წლის 2 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ისტორიის მასწავლებელმა პირიმზე რურუამ XII-4 კლასში ღია გაკვეთილი ჩაატარა თემაზე "ვენის კონგრესი და მსოფლიოს ახალი პოლიტიკური წესრიგი".',
  },
  {
    imageGallery: [],
    image: name157,
    id: 157,
    title:
      "2022 წლის 3 დეკემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში მობრძანდნენ ივანე ჯავახიშვილის თბილისის სახელმწიფო უნივერსიტეტის კულტურის კვლევების ინსტიტუტის თსუ კულტურის კვლევების ინსტიტუტი/ Institute of Cultural Studies, TSU მკვლევარები პროფესორები ნინო ჩიქოვანი, ქეთევან კაკიტელაშვილი და ვანო წერეთელი.",
    briefText:
      "მათ შეხვდნენ სკოლის ქართული კულტურის შემსწავლელთა კლუბის და მკითხველთა კლუბის მოსწავლეები და პედაგოგები მარინე ტალახაძე და პირიმზე რურუა.\n შეხვედრა უაღრესად ნაყოფიერად წარიმართა.\n სტუმრებმა სკოლას უსახსოვრეს კულტურის კვლევევათა ინსტიტუტის გამოცემები, საინტერესოდ ისაუბრეს კულტურის კვლევების აქტუალურ საკითხებსა და სამომავლო პერსპექტივებზე, ახალგაზრდების ჩართულობის მნიშვნელობაზე; მათ, ასევე, გამოხატეს ინტერესი ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის საგანმანათლებლო და საკლუბო მუშაობისადმი.\n შეხვედრა ძალიან მნიშვნელოვანი და დასამახსოვრებელი იყო მოსწავლეებისთვის.\n დავსახეთ სამომავლო გეგმები.",
  },
  {
    imageGallery: [],
    image: name158,
    id: 158,
    title:
      '2022 წლის 1 დეკემბერს ფილოლოგიის მეცნიერებათა დოქტორი გია მურღულია ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტის სტუდენტებს შეხვდა და საჯარო ლექცია წაიკითხა თემაზე: "ადამიანი - ემპათია - ლიტერატურა“.',
    briefText:
      'ბატონმა გიამ სტუდენტებს საკუთარი წიგნები - "საუბრები უფროსკლასელებთან” და "ცხრისნახევარზე” წარუდგინა .\n შეხვედრას ესწრებოდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პედაგოგები და მოსწავლეები.',
  },
  {
    imageGallery: [],
    image: name159,
    id: 159,
    title: "TOEFL ტესტის ოლიმპიადა ინგლისურ ენაში.",
    briefText:
      "2022 წლის 5 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში კომპანია English Book Education-მა ჩაატარა TOEFL ტესტის ოლიმპიადა ინგლისურ ენაში (პირველი ეტაპი).\n TOEFL ტესტის ოლიმპიადა განკუთვნილია სასკოლო ასაკის მოსწავლეებისთვის, მე-3 კლასიდან მე-12 კლასის ჩათვლით და ამოწმებს მათი ინგლისური ენის ცოდნის დონეს საყოველთაოდ ცნობილი საერთაშორისო გამოცდის TOEFL ტესტის საშუალებით.\n TOEFL ტესტის ოლიმპიადა შანსია მოსწავლეებისთვის, რომ ისინი სასკოლო ასაკშივე მიეჩვიონ საერთაშორისო საგამოცდო ფორმატით ტესტის წერას, ინსტრუქციების სწორად გაგებასა და პრობლემის დამოუკიდებლად გადაწყვეტას. ოლიმპიადა საშუალებას იძლევა მოსწავლეებმა არამხოლოდ შეამოწმონ თავიანთი ინგლისური ენის ცოდნის დონე, არამედ გაიღრმავონ კიდეც ცოდნა ამ კუთხით.\n ოლიმპიადაში მონაწილე თითოეულ მოსწავლეს გადაეცემა სერტიფიკატი კომპანია English Book Education-სგან.\n გამარჯვებული მოსწავლეები გამოვლინდება თითოეული საფეხურიდან (Primary-1; Junior-1; ITP-1) და ისინი მიიღებენ TOEFL ტესტის საერთაშორისო სერტიფიკატს, რომელსაც სხვადასხვა მიზნით (გაცვლითი პროგრამები, საზაფხულო სკოლები, დონის შემოწმება, პროგრესის მონიტორინგი და ა.შ.) გამოიყენებენ.\n რადგან TOEFL ტესტი არის ETS Global-ის პროდუქტი, ყველა ნამუშევარი იგზავნება საზღვარგარეთ და 10 დღეში მოსწავლეები იღებენ თავიან შედეგებს.\n რაც ყველაზე მნიშვნელოვანია, ეს არის ტესტი, რომელიც მსოფლიოში აღიარებულია, როგორც ხარისხის განმსაზღვრელი, ყველაზე სანდო და საიმედო შეფასების სისტემით. წარმატებებს ვუსურვებთ ჩვენს მოსწავლეებს!",
  },
  {
    imageGallery: [],
    image: name160,
    id: 160,
    title: '"კინო სკოლაში’’',
    briefText:
      '\n ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა ჩართულია საქართველოს კინემატოგრაფიის ცენტრის პროექტში -" კინო სკოლაში ".\n პროექტის ფარგლებში მოსწავლეები ონლაინპლატფორმის გამოყენებით, კინომცოდნესა და სკოლის პედაგოგთან ერთად, სწავლობენ კინოს ისტორიას სპეციალურად შექმნილი ვიდეო გაკვეთილების, საარქივო ფოტო-ვიდეო მასალისა და სავარჯიშოების გამოყენებით.\n პროექტი , ასევე, ითვალისწინებს მოსწავლეების შეხვედრას კინომცოდნესთან და ფილმების ჩვენებას სკოლაში.\n 2022 წლის 6 დეკემბერს სკოლას ეწვია კინომცოდნე სოფიკო თოქმაჯიშვილი.\n IX-X კლასის მოსწავლეებმა პედაგოგებთან (ინგა მართალიშვილი და ზვიად ჩხენკელი) ერთად ნახეს წინასწარ შერჩეული ფილმი "400 დარტყმა’’ .\n ფილმის გმირი 13 წლის ანტუანი ოჯახური და სოციალური უსამართლობის წნეხის ქვეშაა; უთანხმოება აქვს სკოლის მასწავლებელთან. ის მამინაცვალს საბეჭდ მანქანას პარავს და ოჯახის სურვილით ძნელად აღსაზრდელთა დაწესებულებაში ხვდება.\n ფილმის დასრულების შემდეგ გაიმართა ძალიან საინტერსო დისკუსია წარმოდგენილი ფილმის ირგვლივ.\n პროექტი მომავალშიც გაგრძელდება.',
  },
  {
    imageGallery: [],
    image: name161,
    id: 161,
    title:
      '2022 წლის 10 დეკემბერი! ინდივიდუალურ და საოჯახო შემსრულებელთა ფოლკლორულ-ეთნოგრაფიული VI ფესტივალი "ტრადიციების კვალდაკვალ".',
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ტრიოს ( დედა-შვილი ელენე ურუშაძე , დედამისი, ჩვენი მუსიკის პედაგოგი მაია ჭანუყვაძე და ლოლა ჯაფარიძე) და გოგონათა ანსამბლის წარმატებული გამოსვლა (ხელმძღვანელი ლოლა ჯაფარიძე).",
  },
  {
    imageGallery: [],
    image: name162,
    id: 162,
    title:
      '2022 წლის 14 დეკემბერს ბათუმის წმ. ანდრია პირველოდებულის სახელობის სკოლის მე-9 კლასის მოსწავლეები დამრიგებელ ზვიად ჩხენკელთან და გეოგრაფიის მასწავლებელ სოფო ხუხუნაიშვილთან ერთად იმყოფებოდნენ ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტში გამოფენაზე სახელწოდებით- "საქართველო XVI-XVIII საუკუნეების ნიდერლანდურ რუკებსა და გრავიურებზე".',
    briefText:
      "გამოფენა ნიდერლანდების სამეფოსა და საქართველოს შორის ორმხრივი დიპლომატიური ურთიერთობის დამყარების 30 წლისთავს ეძღვნება და საქართველოში ნიდერლანდების სამეფოს საელჩოს მხარდაჭერით, ღია სივრცე კავკასიის (COS) მიერ იმართება.",
  },
  {
    imageGallery: [],
    image: name163,
    id: 163,
    title:
      "3 დეკემბერს, შეზღუდული შესაძლებლობის მქონე პირთა საერთაშორისო დღეა. ამ თარიღთან დაკავშირებით ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ინკლუზიური განათლების კოორდინატორის ხათუნა ვარდიძის ორგანიზებითა და დაწყებითი საფეხურის პედაგოგების ჩართულობით დაიგეგმა საგანმანათლებლო კვირეული.",
    briefText:
      "მესამე-მეოთხე კლასების მოსწავლეებმა ნახეს თემატური ვიდეორგოლები, გასულ წლებში სკოლაში ჩატარებული აქტივობების ამსახველი მასალა;\n პატარებმა ისაუბრეს ნანახის შესახებ, გამოხატეს თავიანთი აზრი, დაწერეს მცირე ფორმატის ესსები, შეასრულეს ნახატები.\n მე-12 კლასის მოსწავლეებმა დამრიგებელ ლოლა ჯაფარიძესთან ერთად მცირე საახალწლო საჩუქრები გადასცეს ჩვენი სკოლის შშმ და სსსმ მოსწავლეებს.",
  },
  {
    imageGallery: [],
    image: name164,
    id: 164,
    title:
      "თარიღთან დაკავშირებით, ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში 2022-2023 სასწავლო წელს დაიგეგმა სასკოლო-საგანმანათლებლო პროექტი.",
    briefText:
      'პროექტის "საქართველოს რკინიგზა-150" ფარგლებში მე-10 კლასის მოსწავლეებმა 2022 წლის 18 დეკემბერს ისტორიის მასწავლებელ ზვიად ჩხენკელთან ერთად საგარეუბნო მატარებლით იმოგზაურეს ქუთაისის მიმართულებით.\n ეს შემეცნებითი ექსკურსია ერთგვარი უჩვეული თავგასავალიც იყო მოსწავლეებისთვის.\n ახალგაზრდებმა მატარებელშივე მოაწყვეს კოსტიუმირებული პერფორმანსი, გაითამაშეს წარმოდგენა "მოგზაურობა აღმოსავლეთის ექსპრესით".\n ქუთაისში მოსწავლეებმა დაათვალიერეს ქალაქის ღირსშესანიშნაობები.\n მასწავლებლების დავალებით ბავშვებმა გადაიღეს მოგზაურობის ამსახველი ფოტოები, ვიდეოები, დააგროვეს მასალები გამოფენის მოსაწყობად, შთაბეჭდილებები გადმოსცეს დღიურების სახით.\n #ბათუმის_წმინდა_ანდრია_პირველწოდებულის_სახელობის_სკოლა\n #ბათუმისგიმნაზია',
  },
  {
    imageGallery: [],
    image: name165,
    id: 165,
    title:
      "გიმნაზიელთა უჩვეულო სარკინიგზო თავგადასავალი ამბავი N 1. საქართველოს რკინიგზის საქართველოს რკინიგზა / Georgian Railway 150 წლის საიუბილეო",
    briefText:
      "გიმნაზიელთა უჩვეულო სარკინიგზო თავგადასავალი ამბავი N 1. საქართველოს რკინიგზის საქართველოს რკინიგზა / Georgian Railway 150 წლის საიუბილეო",
  },
  {
    imageGallery: [],
    image: name165,
    id: 165,
    title:
      "მთის საერთაშორისო დღე. 11 დეკემბერს აღინიშნება მთის საერთაშორისო დღე.",
    briefText:
      "ამ თარიღთან დაკავშირებით ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის გეო ეკოლოგიის კლუბის წევრებმა კლუბის ხელმძღვანელ სოფიკო ხუხუნაიშვილთან და მოქალაქეობის მასწავლებელ ზვიად ჩხენკელთან ერთად მოინახულეს ხელვაჩაურის მუნიციპალიტეტის მთის ფერდობებზე განფენილი სოფლები, მოსწავლეებმა, ასევე, დალაშქრეს გვარას ციხე და მირვეთის ჩანჩქერი.\n ახალგაზრდები შეხვდნენ ადგილობრივ მოსახლეობას, გაეცნენ მთებში არსებულ პრობლემებს , სამომავლოდ დაგეგმეს კვლევის ჩატარება აჭარის მთის სოფლების მდგომარეობის შესწავლის მიზნით.",
  },
  {
    imageGallery: [],
    image: name166,
    id: 166,
    title:
      'ქალები საქართველოდან. 2022 წლის 19-26 დეკემბერს ბათუმის წმ. ანდრია პირველწდებულის სახელობის სკოლაში მიმდინარეობდა საზოგადოებრივ მეცნიერებათა კათედრის მიერ ორგანიზებული სასწავლო-საგანმანათლებლო კვირეული "ქალები საქართველოდან". #ქალებისაქართველოდან',
    briefText:
      'კვირეულის ფარგლებში ჩატარდა არაერთი საინტერესო ღონისძიება:\n XI-XII კლასების მოსწავლეებისთვის ქართული ენისა და ლიტერატურის მასწავლებელმა მარინა ტალახაძემ წაიკითხა უაღრესად საინტერესო ლექცია თემაზე "ქართული ლიტერატურის ღირსსახსოვარი ქალები".\n X კლასების მოსწავლეებისთვის სამოქალაქო განათლებისა და ისტორიის მასწავლებლებმა ზვიად ჩხენკელმა და პირიმზე რურუამ ჩაატარეს გაკვეთილი თემაზე : "მეწარმე ქალები მე-19 საუკუნის გადმოსახედიდან მაგდანასა და ოთარაანთ ქვრივის მაგალითზე".\n სამოქალაქო განათლების მასწავლებლებმა ხათუნა ბერაძემ და ნატალია სირაბიძემ დაგეგმეს დისკუსია თემაზე "ქალი ტრადიციულ საზოგადოებაში". ამ მიზნით მათ IX-XI კლასების მოსწავლეებისთვის მოაწყვეს ყოფილი გიმნაზიელის თამუნა კოხრეიძის დოკუმენტური ფილმის "დედოფლობანა" ჩვენება და განხილვა.\n მე-12 კლასების მოსწავლეებისთვის ჩატარდა ინტერაქტიული ლექცია "1918-1921 წლების პარლამენტარი ქალები საქართველოდან". ლექციას უძღვებოდნენ სამოქალაქო განათლების და ისტორიის პედაგოგები ისტორიის აკადემიური დოქტორი ინგა მართალიშვილი და ქეთევან გოცირიძე.\n IX-XII კლასების მოსწავლეებისთვის ჩატარდა ინტერაქტიული ლექცია "აჭარა ჩადრიდან და ჩადრის გარეშე - მე-20 საუკუნის პირველი ნახევრის სოციალური პროცესები აჭარაში". ლექციას უძღვებოდა სამოქალაქო განათლებისა და ისტორიის პედაგოგი , ისტორიის აკადემიური დოქტორი ლევან სამსონია.\n X-XI კლასების მოსწავლეებისთვის უაღრესად საინტერესო ლექცია თემაზე "ქალი მსოფლიო პოლიტიკაში" ონლაინ ფორმატით ჩაატარა ყოფილმა გიმნაზიელმა, ამჟამად თბილისის საკრებულოს წევრმა ნინი წულაძემ.\n გეოგრაფიის მასწავლებელმა სოფიკო ხუხუნაიშვილმა IX კლასების მოსწავლეებისთვის ჩაატარა შემეცნებით-საგანმანათლებლო საუბარი თემაზე "მოგზაური ქალები".\n გეოგრაფიისა და მოქალაქეობის მასწავლებელმა საერთაშორისო ურთიერთობების აკადემიურმა დოქტორმა ანა ანუშიძემ X კლასების მოსწავლეებისთვის ჩაატარა გაკვეთილი თემაზე "ქართველი მეცნიერი ქალები".\n ქართული ენისა და ლიტერატურის მასწავლებელმა მზია ჯანელიძემ მოსწავლეებისთვის და პედაგოგებისთვის ჩაატარა საუბარი თემაზე "ლანა ღოღობერიძის ქალები".\n #ბათუმის_წმინდა_ანდრია_პირველწოდებულის_სახელობის_სკოლა\n #ბათუმისგიმნაზია',
  },
  {
    imageGallery: [],
    image: name167,
    id: 167,
    title: "ქართულ ლიტერატურის ღია გაკვეთილი",
    briefText:
      '2022 წლის 22 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ქართული ენისა და ლიტერატურის მასწავლებელმა მარინა ტალახაძემ ჩაატარა XII კლასში ღია გაკვეთილი თემაზე "ემპირიული რეალობა და მხატვრული სინამდვილე".\n #ბათუმის_წმინდა_ანდრია_პირველწოდებულის_სახელობის_სკოლა\n #ბათუმისგიმნაზია',
  },
  {
    imageGallery: [],
    image: name168,
    id: 168,
    title:
      "გიმნაზიელები სტუმრად ბსუ-ში.2022 წლის 22 დეკემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-10 კლასის მოსწავლეები, რომლებიც ეროვნული სასწავლო გეგმის ფარგლებში სწავლობენ მეწარმეობის საფუძვლებს ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტის ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U ეკონომიკისა და ბიზნესის ფაკულტეტს სტუმრობდნენ.",
    briefText:
      "ახალგაზრდებს მასპინძლობა გაუწია ამავე ფაკულტეტის დეკანმა, პროფესორმა ნათია წიკლაშვილმა და მისმა ასისტენტმა, ასისტენტ პროფესორმა თაკო ფოლადაშვილმა.\n შეხვედრას ესწრებოდნენ ამავე ფაკულტეტის სტუდენტებიც, რომელთაც ჩვენი სკოლის მოსწავლეებმა წარუდგინეს მეწარმეობის სასწავლო კურსის ფარგლებში მომზადებული აქტუალური და საინტერესო პრეზენტაციები თემებზე:\n საქართველოს ბუნებრივი რესურსები, როგორც წარმოების ფაქტორები;\n გამოჩენილი ქართველი მეწარმე-ბიზნესმენები;\n თანამედროვე ქართული ბიზნესი.",
  },
  {
    imageGallery: [],
    image: name169,
    id: 169,
    title:
      "გაკვეთილი მადლიერების შესახებ. 2022 წლის 23 დეკემბერს ბათუმის წმინდა ანდრია პირველწდებულის სახელობის სკოლის VI-3 კლასში ქართული ენისა და ლიტერატურის მასწავლებელმა თამარ ლომთაძემ ჩაატარა გაკვეთილი თემაზე „მადლიერებაზე დაფიქრება“.",
    briefText:
      "მოსწავლეებმა სასწავლო წლის დასაწყისში შექმნეს მადლიერების ყუთი.\n ყოველ პარასკევს ფერად ფურცლებზე წერდნენ, ვისი მადლიერნი იყვნენ განვლილი კვირის განმავლობაში.\n დღეს მოსწავლეებმა ერთმანეთს გაუზიარეს თავიანთი ემოციები, გრძნობები, გაუჭირდათ თუ არა იმ ადამიანის ვამორჩევა, ვის მიმართაც იგრძნეს მადლიერება. იფიქრეს, იმსჯელეს და დაასკვნეს, რომ მადლიერება ავსებს ადამიანს, აკეთილშობილებს, აქარწყლებს ბოროტებას, უმადურება კი ბადებს ბოროტებას.",
  },
  {
    imageGallery: [],
    image: name170,
    id: 170,
    title:
      'პატარა "ციფრული სამყაროს გენიოსები".2022 წლის 23 დეკემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VI-5 კლასში ღია გაკვეთილი ჩაატარა ისტ-ის ახალგაზრდა მასწავლებელმა კახი კახიძემ.',
    briefText:
      "\n გაკვეთილის თემა: ციფრული სამყაროს გენიოსები და კომპიუტერული სამყარო.\n გაკვეთილი წარიმართა მოსწავლეთა აქტიური ჩართულობითა და იმპროვიზაციით.\n ახალგაზრდებმა გაითავისეს ციფრული და მათემატიკური სამყაროს უდიდესი მეცნიერების-გენიოსების როლები, შეძლეს სხვადასხვა დროსა და სამყაროში ორიენტირება.\n მოსწავლეთა გააზრებულმა პასუხებმა კარგად წარმოაჩინა მასწავლებლის დიდი შრომა.",
  },
  {
    imageGallery: [],
    image: name171,
    id: 171,
    title:
      'მინი-სპექტაკლი რუსული ენის გაკვეთილზე.2022 წლის 24 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI - 4 კლასის მოსწავლეებმა (მასწავლებელი ევგენია ლომაძე) რუსული ენის გაკვეთილზე დადგეს მინი-სპექტაკლი რუსული ხალხური ზღაპარი "ტერემოკი".',
    briefText:
      "აქტივობა მიზნად ისახავდა, როგორც შემოქმედებითი, ასევე, რუსულ ენაში ზეპირმეტყველების, დიალოგისა და მონოლოგის უნარების განვითარებას, მოტივაციის ამაღლებას.",
  },
  {
    imageGallery: [],
    image: name172,
    id: 172,
    title: "საღვრთო სჯულის ღია გაკვეთილი.",
    briefText:
      '2022 წლის 27 დეკემბერს საღვრთო სჯულის მასწავლებელმა მარინა ტალახაძემ XI-XII კლასებში ჩაატარა ღია გაკვეთილი თემაზე: კლიპის "ერთ ცის ქვეშ" (Dimash - The story of one sky) საღვთისმეტყველო ანალიზი.',
  },
  {
    imageGallery: [],
    image: name173,
    id: 173,
    title: '"ზღაპარ იყო..."',
    briefText:
      "2022 წლის 28 დეკემბერს საახალწლო განწყობით გაჯერებული ზღაპრული სანახაობა წარმოადგინეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-2 კლასის პატარებმა ქართული ენის მასწავლებლის მაია იმნაძის დახმარებით.",
  },
  {
    imageGallery: [],
    image: name174,
    id: 174,
    title: "პირველკლასელთა საახალწლო ზეიმი.",
    briefText:
      "სიმღერა, ლექსი, მოლოცვა, სიკეთე, სითბო და სიყვარული იღვრებოდა 2022 წლის 29 დეკემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის სცენიდან პირველკლასელთა საახალწლო ზეიმზე (მასწავლებლები ანა კვიჭიძე და ეკა ბჟინავა).",
  },
  {
    imageGallery: [],
    image: name175,
    id: 175,
    title:
      'ბათუმის არქეოლოგიურ მუზეუმში წმ. ანდრია პირველწოდებულის სახელობის მე-10 კლასის მოსწავლეებს ჩაუტარდათ საგანმანათლებლო პროგრამა. "კერამიკა- ტრადიციული რეწვა". #მოდიმუზემში',
    briefText:
      'ბათუმის არქეოლოგიურ მუზეუმში წმ. ანდრია პირველწოდებულის სახელობის მე-10 კლასის მოსწავლეებს ჩაუტარდათ საგანმანათლებლო პროგრამა. "კერამიკა- ტრადიციული რეწვა". #მოდიმუზემში',
  },
  {
    imageGallery: [],
    image: name176,
    id: 176,
    title:
      "შინაარსიანი, საინტერესო და სასიამოვნო დღე გაატარეს VII- 2 კლასის მოსწავლეებმა ეთნოგრაფიულ მუზეუმში კლასის დამრიგებელ ნატალია კალანდაძესთან და ქართულის პედაგოგ რუსუდან თავხელიძესთან ერთად, ნანახსა და განცდილზე ისაუბრეს სკოლაში დაბრუნების შემდეგ.",
    briefText:
      "შინაარსიანი, საინტერესო და სასიამოვნო დღე გაატარეს VII- 2 კლასის მოსწავლეებმა ეთნოგრაფიულ მუზეუმში კლასის დამრიგებელ ნატალია კალანდაძესთან და ქართულის პედაგოგ რუსუდან თავხელიძესთან ერთად, ნანახსა და განცდილზე ისაუბრეს სკოლაში დაბრუნების შემდეგ.",
  },
  {
    imageGallery: [],
    image: name177,
    id: 177,
    title:
      "ქიმიის გაკვეთილი ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-9 კლასში. გაკვეთილის თემა: pHის განსაზღვრა ხსნარებში, მასწავლებელი ირინა ვიდულინა.",
    briefText:
      "ქიმიის გაკვეთილი ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-9 კლასში. გაკვეთილის თემა: pHის განსაზღვრა ხსნარებში, მასწავლებელი ირინა ვიდულინა.",
  },
  {
    imageGallery: [],
    image: name178,
    id: 178,
    title: "ჭარბტენიანი ტერიტორიების დაცვის საერთაშორისო დღე.",
    briefText:
      '2023 წლის 2 თებერვალს ჭარბტენიანი ტერიტორიების დაცის მსოფლიო საერთაშორისო დღის აღსანიშნავად ბათუმის წმ.ანდრია პირველწოდებულის სახელობის სკოლის მეათე კლასის მოსწავლებმა, გეო ეკოლოგიის კლუბის წევრებმა (მასწავლებელი სოფიკო ხუხუნაიშვილი) მეცხრე კლასელთათვის მოამზადეს და წარმოადგინეს თემა ამ დღის მნიშვნელობასა და საქართველოში არსებულ ჭაობებზე.\n ახალგაზრდებმა ისაუბრეს ისპაანის ჭაობის თავისებურებებსა და მისი დაცვის მნიშვნელობაზე.\n ღონისძიება შედგა სასკოლო პროექტის "გიმნაზიელები გიმნზაიელთათვის" ფარგლებში.\n #ბათუმის_წმინდა_ანდრია_პირველწოდებულის_სახელობის_სკოლა\n #ბათუმისგიმნაზია\n#გიმნაზიელებიგიმნაზიელთათვის',
  },
  {
    imageGallery: [],
    image: name179,
    id: 179,
    title:
      'აკაკი წერეთლის სახელობის ქალაქ ბათუმის საჯარო ბიბლიოთეკის საბავშვო-ახალგაზრდობის განყოფილებაში 8 თებერვალს, 14:00 საათზე ჩატარდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის XII – 4 კლასის ღია გაკვეთილი საქართველოს ისტორიაში : "ათასი წელი მეფე დავითთან ერთად." პედაგოგი: პირიმზე რურუა.',
    briefText:
      'აკაკი წერეთლის სახელობის ქალაქ ბათუმის საჯარო ბიბლიოთეკის საბავშვო-ახალგაზრდობის განყოფილებაში 8 თებერვალს, 14:00 საათზე ჩატარდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის XII – 4 კლასის ღია გაკვეთილი საქართველოს ისტორიაში : "ათასი წელი მეფე დავითთან ერთად." პედაგოგი: პირიმზე რურუა.',
  },
  {
    imageGallery: [],
    image: name180,
    id: 180,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში დასრულდა ხანგრძლივი, დაძაბული და ემოციებით დატვირთული საკალათბურთო ჩემპიონატი!",
    briefText:
      "ჩემპიონატის ორგანიზატორი იყო სპორტის პედაგოგი მიხეილ სალუქვაძე.\n ფინალში ერთმანეთს შეხვდნენ IX-2 და IX-4 კლასები!\n უკომპრომისო ბრძოლაში 2022-2023 სასწავლო წლის სკოლის ჩემპიონი გახდა IX-2 კლასის გუნდი!\n გილოცავთ!",
  },
  {
    imageGallery: [],
    image: name181,
    id: 181,
    title:
      "ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტის ღია კარის დღეები აბიტურიენტებისთვის გრძელდება.",
    briefText:
      "აბიტურიენტებისათვის ღია კარის დღე გაიმართა ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში, რომელსაც უძღვებოდნენ პროფესორი ჯემალ კარალიძე, ჰუმანიტარულ მეცნიერებათა ფაკულტეტის დეკანის მოადგილე შოთა ჯიჯეიშვილი და სტუდენტები.\n შეხვედრების დასრულების შემდეგ, აბიტურიენტებს სამახსოვრო საჩუქრები გადაეცათ.\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n #ბათუმისგიმნაზია\n #ბსუ #უნივერსიტეტი #აბიტურიენტები",
  },
  {
    imageGallery: [],
    image: name182,
    id: 182,
    title:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა ტოიოტას "საოცნებო ავტომობილის" ხატვის კონკურსზე წარდგენილი ნამუშევრები.',
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა ტოიოტას "საოცნებო ავტომობილის" ხატვის კონკურსზე წარდგენილი ნამუშევრები.',
  },
  {
    imageGallery: [],
    image: name183,
    id: 183,
    title:
      "17.02.2023 წელი აკადემიკოს შალვა ამონაშვილის სტუმრობა ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში!",
    briefText:
      "შეხვედრა მოსწავლეებთან, პედაგოგებთან, სასულიერო პირებთან, მშობლებთან.\n Humane Georgia-ჰუმანური საქართველო - უდიდესი პედაგოგის საჩუქარი საქართველოს!\n გამორჩეულად შინაარსიანი, დასამახსოვრებელი დღე ჩვენს სკოლაში!",
  },
  {
    imageGallery: [],
    image: name184,
    id: 184,
    title: "თეოლოგია - მეცნიერება, ისტორია, განვითარების პერსპექტივა.",
    briefText:
      '2023 წლის 22 თებერვალს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში უფროსკლასელთათვის საუბარი თემაზე "თეოლოგია- მეცნიერება, ისტორია, განვითარების პერსპექტივა" ჩაატარა ჩვენი სკოლის ყოფილმა მოსწავლემ გიორგი გაბუნიამ.\n შეხვედრა შედგა პროექტის "გიმნაზიელები გიმნაზიელთათვის" ფარგლებში.\n ამ პროექტის მიზანს წარმოადგენს ის, რომ კურსდამთავრებულები საკუთარ ცოდნასა და გამოცდილებას უზიარებენ მოსწავლეებს.\n გიორგი გაბუნიას ბევრი ჰქონდა სათქმელი.\n მან სკოლის დასრულების შემდეგ სწავლა გააგრძელა საზღვაო აკადემიაში, გახდა მეზღვაური, რამდენიმე წელი ამ პროფესიით იმუშავა, შემდეგ კი სწავლა გადაწყვიტა თეოლოგიური მიმართულებით. გიორგიმ დაასრულა სასულიერო სემინარია და სასულიერო აკადემია. ის დღეს თეოლოგია.\n შეხვედრა უაღრესად საინტერესოდ წარიმართა.',
  },
  {
    imageGallery: [],
    image: name185,
    id: 185,
    title: "გეო ეკოლოგიის კლუბი",
    briefText:
      "2023 წლის 23 თებერვალს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში გეო ეკოლოგიის კლუბის წევრებს (კლუბის ხელმძღვანელი სოფიკო ხუხუნაიშვილი) შეხვდა ბათუმის შოთა რუსთაველის სახელობის უნივერსიტეტის ბიოლოგიის ლექტორი დოქტორი იზოლდა მაჭუტაძე.\n შეხვედრის თემა იყო ბუნების მრავალფეროვნება და მისი სწორად დაცვის მნიშვნელობა.\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n #ბათუმისგიმნაზია",
  },
  {
    imageGallery: [],
    image: name186,
    id: 186,
    title: "#ღიაეთერი რადიო აჭარა",
    briefText:
      "#ღიაეთერი რადიო აჭარა\n #არაოკუპაციას\n #102წელისაბჭოთაოკუპაციიდან\n #ქართველიუნკერები\n #თებერვლისსისხლიანიქრონიკები\n #საქართველოსისტორიისსწავლებადამოზარდები\n #წარსულიდადღევანდელობა\n 24 თებერვალს- გადაცემაში \" ღია ეთერი''\n 13 საათსა და 10 წუთზე\n #თემა: 102 წელი საბჭოთა ოკუპაციიდან , უინკერთა ხსოვნის დღე , საქართველოს ისტორიის ქრონიკები და დღევანდელობა სკოლებში ...\n ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა\n #დღესგადაცემაში :\n 1921 წლის თებერვლის ტრაგიკული მოვლენები, მტკივნეული ფურცლები ჩვენი ქვეყნის უახლესი ისტორიიდან ...\n გაცოცხლებული წარსული აწმყოში , თებერვლის სისხლიანი ქრონიკები თანამედროვე გადასახედიდან -\n როგორ ისწავლება და რა იციან მოზარდებმა ამ ისტორიული თარიღის შესახებ - საქართველოს ისტორიის ქრონიკები სკოლებში....\n დეტალები გადაცემაში #ღიაეთერი\n #გადაცემისსტუმრები :\n - ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ისტორიის პედაგოგი ზვიად ჩხენკელი ....\n - წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-10 კლასის მოსწავლეები: ნილა ჯინჭარაძე , ანა დარჩიძე და კესარია გათენაძე ....",
  },
  {
    imageGallery: [],
    image: name187,
    id: 187,
    title:
      '2023 წლის 25-26 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის დირექტორის მოადგილე პირიმზე რურუა და უცხო ენების კათედრის ხელმძღვანელი ნატალია ფრუიძე სასწავლო-საგანმანათლებლო პროცესის თანამედროვე გამოწვევების გაცნობისა და სრულყოფის მიზნით მონაწილეობდნენ English Book Education- ის მიერ ორგანიზებულ საერთაშორისო სასწავლო კონფერენციის Annual Educational conference 2023 მუშაობაში, რომელიც გაიმართა კაჭრეთში, სასტუმრო "ამბასადორში".',
    briefText:
      "კონფერენციის მუშაობის ფარგლებში შედგა რამდენიმე მნიშვნელოვანი შეხვედრა ცალკეული საკითხის სრულყოფა// გადაწყვეტის მიზნით.\n 2023-2024 სასწავლო წელს არა ერთი სასიკეთო სიახლე იგეგმება ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის სასწავლო პროცესში.",
  },
  {
    imageGallery: [],
    image: name188,
    id: 188,
    title:
      'სლავური დღესასწაული "მასლენიცა" ყველიერში აღინიშნებოდა. სიმბოლურად ძველი სლავები ასე ეგებებოდნენ დიდმარხვის დაწყებას და გაზაფხულის შემობრძანებას.',
    briefText:
      'უჩვეულოდ ხალისიანი და ფერადი გაკვეთილი შემოგვთავაზეს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VII-4 კლასის მოსწავლეებმა და რუსული ენის პედაგოგმა ევგენია ლომაძემ მშობელთა ჩართულობით.\n ახალგაზრდებმა ისაუბრეს, ზოგადად, ხალხურ დღესასწაულებზე, ტრადიციებზე, ძველი სლავების ყოფა-ცხოვრებაზე და ყველიერის დღესასწაულ "მასლენიცაზე".\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n #ბათუმისგიმნაზია',
  },
  {
    imageGallery: [],
    image: name189,
    id: 189,
    title:
      "დაიწყო ტრადიციული ინტელექტუალური თამაშების რა? სად? როდის? ბათუმის რეგულარული სასკოლო ჩემპიონატი. პირველი თამაში გაიმართა 26 თებერვალს ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტის შენობაში.",
    briefText:
      "ჩემპიონატში ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 4 გუნდი იღებს მონაწილეობას!\n დიდი ინტერესით ვადევნებთ თვალს ჩემპიონატის მსვლელობას და წარმატებებს ვუსურვებთ გიმნაზიელებს!\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n #ბათუმისგიმნაზია",
  },
  {
    imageGallery: [],
    image: name190,
    id: 190,
    title:
      "კულტურა და კულტურული მემკვიდრეობა; თანამედროვე გამოწვევები - შეხვედრა მეცნიერთან.ბათუმის წმ. ანდრის პირველწოდებულის სახელობის სკოლაში უფროსკლასელთათვის შექმნილია კულტურის შემსწავლელთა კლუბი, რომელსაც ხელმძღვანელობს პირიმზე რურუა.",
    briefText:
      '2023 წლის 2 მარტს კულტურის კლუბის წევრებისთვის ონლაინ ფორმატით შედგა შეხვედრა თსუ-ს პროფესორ ქეთევან ხუციშვილთან თემაზე "კულტურა და კულტურული მემკვიდრეობა; თანამედროვე გამოწვევები ".\n ქალბატონი ქეთევანი არის თსუ პროფესორი, ეთნოლოგია-ანთროპოლოგიის ინსტიტუტის ხელმძღვანელი, თსუ სადისერტაციო საბჭოს თავმჯდომარე, თსუ აკადემიური საბჭოს წევრი, საქართველოს ანთროპოლოგთა ასოციაციის პრეზიდენტი, ისტორიის მეცნიერებათა დოქტორი, ეთნოლოგია-ანთროპოლოგიის სპეციალობით. არის ოთხი მონოგრაფისა და 80-ზე მეტი სამეცნიერო ნაშრომის ავტორი. მათ შორის აქვს საერთაშორისო პუბლიკაციები საქართველოს ანთროპოლოგიური კვლევის, ყოფისა და კულტურის ტრანსფორმაციული პროცესების, რელიგიური საკითხების და ეთნო-კულტურული იდენტობის შესახებ.\n საუბარი უაღრესად საინტერესოდ წარიმართა; მოსწავლეებმა დასვეს შეკითხვები, გამოთქვეს აზრი ცალკეულ საკითხზე.\n ქეთევან ხუციშვილის რანგის მეცნიერთან შეხვედრა ნამდვილად განსაკუთრებული მოვლენა იქნება ახალგაზრდების ცხოვრებაში.',
  },
  {
    imageGallery: [],
    image: name191,
    id: 191,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში 2023 წლის 2 მარტს ჩატარდა "ტვინების ბრძოლის" შიდასასკოლო ჩემპიონატი IV-V და VI კლასის მოსწავლეთა შორის.სკოლაში ჩემპიონატის ჩატარებას ხელმძღვანელობენ პედაგოგები ზვიად ჩხენკელი და კახი კახიძე.',
    briefText:
      'საერთო ჩათვლაში საუკეთესო სამეული ასე გამოიყურება:\n გუნდი "ხუთეული" (დამრიგებელი მაია ჭანუყვაძე),\n გუნდი "CR7" (დამრიგებელი ნონა აბაშიძე),\n გუნდი "საუკეთესო ხუთეული" (დამრიგებელი მანანა გოგიბერიძე).\n წარმატებებს ვუსურვებთ პატარებს!',
  },
  {
    imageGallery: [],
    image: name192,
    id: 192,
    title:
      '2023 წლის 10 მარტს - რადიო "აჭარის" საავტორო გადაცემაში " ღია ეთერი\'\' - 13 საათსა და 10 წუთზე!',
    briefText:
      '2023 წლის 10 მარტს - რადიო "აჭარის" საავტორო გადაცემაში " ღია ეთერი\'\' - 13 საათსა და 10 წუთზე!\n გადაცემაში მონაწილეობდნენ:\n --ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის დირექტორის მოადგილე , წმ. იოანე ღთისმეტყველის სახელობის სასულიერო სემინარიის ასოცირებული პროფესორი , აკადემიური დოქტორი , ისტორიის პედაგოგი პირიმზე რურუა ...\n - წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები -\n ანა ძნელაძე,\n ნიკა მჟავანაძე,\n თემო შარაბიძე...\n #თემა: საქართველოს ევროპული მომავალი - ჩვენ ვირჩევთ ევროპას! არა რუსეთს ! რუსეთი ოკუპანტია..\n -როგორ ესმით მოზარდებს ევროპული ღირებულებები?\n -რატომ მივილტვით ევროპისკენ ?\n -რატომ არის მნიშვნელოვანი ევროინტეგრაციის პროცესი საქართველოსთვის?\n -როგორ ისწავლება საქართველოს უახლესი ისტორიის ქრონიკები სკოლებში ?\n - როგორ დაგვაშორა 70- წლიანმა საბჭოთა ოკუპაციამ ევროპულ ოჯახს ?\n ჩანაწერი იხ. https://ajaratv.ge/video/13062...\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n #ბათუმისგიმნაზია\n #ერთადვიმსჯელოთდავიზრუნოთმომავალზე\n #ღიაეთერი\n #რუსეთიოკუპანტია\n #ჩვენვირჩევთევროპას!\n #საქართველოსევროპულიმომავალი',
  },
  {
    imageGallery: [],
    image: name193,
    id: 193,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მეცხრე კლასის მოსწავლეები ლუკა უჩანეიშვილი და გიორგი ცინცაძე 2023 წლის აგვისტოში გაემგზავრებიან თურქეთის სამეცნიერო ბანაკში. ღონისძიებას წარმართავს ორგანიზაცია "საერთაშორისო მეგობრობა სამეცნიერო განათლების გზით".',
    briefText:
      "აღსანიშნავია, რომ ახალგაზრდებმა სამეცნიერო ბანაკში გამგზავრება დიდი შრომის, სწავლის, მონდომების, რთულად გადასალახი გზის დაძლევის შედეგად დაიმსახურეს!\n წარმატებებს ვუსურვებთ ლუკას და გიორგის!\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა",
  },
  {
    imageGallery: [],
    image: name194,
    id: 194,
    title:
      '21 მარტი - დაუნის სინდრომის საერთაშორისო დღე! "მეგობრები ქრომოსომებს არ ითვლიან!"',
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის X-3 კლასის მოსწავლეებმა ბიოლოგიის მასწავლებელ ნანა ჭელიძესთან ერთად ძალიან საინტერესო შემეცნებითი სახალისო აქტივობა დაგეგმეს და ჩაატარეს მეხუთე კლასების მოსწავლეებისთვის.\n #გიმნაზიელებიგიმნაზიელთათვის\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n #ბათუმისგიმნაზია\n #მეგობრებიქრომოსომებსარითვკიან",
  },
  {
    imageGallery: [],
    image: name195,
    id: 195,
    title: '"შტრაუს-ჰოვის" თაობათა თეორია სასკოლო საგნების პერსპექტივიდან.',
    briefText:
      '2023 წლის 21 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ქართული ენისა და ლიტერატურის წამყვანმა მასწავლებელმა შორენა ბოლქვაძემ სამუშაო შეხვედრა ჩაატარა კოლეგებისა და უფროსკლასელი მოსწავლეებისთვის თემაზე:\n "შტრაუს-ჰოვის" თაობათა თეორია სასკოლო საგნების პერსპექტივიდან.\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n #ბათუმისგიმნაზია',
  },
  {
    imageGallery: [],
    image: name196,
    id: 196,
    title:
      'ქ. ბათუმის, წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-3 კლასის მოსწავლეებმა სამოქალაქო განათლების გაკვეთილზე "ჩვენ არ ვითვლით ქრომოსომებს" ჯგუფური მუშაობის ფორმატში, დაუნის სინდრომის თავისებურებების გაცნობის შემდეგ, იმსჯელეს თემაზე: როგორ შევქმნათ ინკლუზიური საგანმანათლებლო სერვისები?',
    briefText:
      "მოსწავლეებმა, მსჯელობის შედეგები წარმოადგინეს ჯგუფური პრეზენტაციის სახით.\n სამოქალაქო განათლების მასწავლებელი: ანა ანუშიძე\n #ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n #ბათუმისგიმნაზია",
  },
  {
    imageGallery: [],
    image: name197,
    id: 197,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-11 კლასის მოსწავლე ნიკა ბარამიძე ფლექსის პროგრამის გამარჯვებულია! მომავალ წელს ის სწავლას აშშ-ში გააგრძელებს!",
    briefText: "გილოცავთ, ნიკა!\n დიდ წარმატებას გისურვებთ!",
  },
  {
    imageGallery: [],
    image: name198,
    id: 198,
    title:
      "22 მარტი წყლის დაცვის მსოფლიო დღეა! ამ დღის აღნიშვნის მიზანი უსაფრთხო წყლის მნიშვნელობის ხაზგასმა და გლობალური წყლის კრიზისის შესახებ ცნობიერების ამაღლებაა. ეს არის დღე, რომელიც კიდევ ერთხელ გვახსენებს, რომ გლობალური წყლის კრიზისის დასაძლევად მოქმედება აუცილებელია.",
    briefText:
      '2023 წლის 22 მარტი ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში წყლის დღედ გამოცხადდა.\n ამ დღის აღსანიშნავად ჩატარდა VII-1 ინტეგრირებული გაკვეთილი თემაზე "წყალი სიცოცხლის საწყისი", რომელსაც უძღვებოდნენ ქიმიის მასწავლებელი ნონა აბაშიძე და ბიოლოგიის მასწავლებელი ნანა ჭელიძე.',
  },
  {
    imageGallery: [],
    image: name199,
    id: 199,
    title:
      "22 მარტი წყლის დაცვის მსოფლიო დღეა! ამ დღის აღნიშვნის მიზანი უსაფრთხო წყლის მნიშვნელობის ხაზგასმა და გლობალური წყლის კრიზისის შესახებ ცნობიერების ამაღლებაა.",
    briefText:
      'ბათუმის წმ. ანდრია პირველოდებულის სახელობის სკოლაში ამ დღის აღსანიშნავად X-1 კლასის მოსწავლეებმა შემეცნებით-საგანმანათლებლო აქტივობა ჩაატარეს VIII კლასის მოსწავლეებისთვის თემაზე: "საქართველოს მინერალური წყლები" პროექტის "გიმნაზიელები გიმნაზიელთათვის" ფარგლებში. ბიოლოგიის მასწავლებელი ქეთევან ხარაბაძე.',
  },
  {
    imageGallery: [],
    image: name200,
    id: 200,
    title:
      "22 მარტს აღინიშნება წყლის საერთაშორისო დღე! ქ. ბათუმის, წმინდა ანდრია პირველწოდებულის სახელობის სკოლის, VII-1, VII-2, VII-4 კლასების მოსწავლეებმა, გეოგრაფიის გაკვეთილებზე, მრავალფეროვანი აქტივობებით აღნიშნეს 22 მარტი, წყლის რესურსების დაცვის საერთაშორისო დღე!",
    briefText:
      'მოსწავლეები გაეცნენ:\n წყლის გაწმენდის ხერხებს, ჯგუფებში განიხილეს თითოეული ხერხის გამოყენებისთვის საჭირო მასალა, დადებითი და უარყოფითი მხარეები და შეაჯამეს ასევე ჯგუფური პრეზენტაციის წარდგენით.\n ვირტუალური წყლის ცნებას, რა არის, როგორ გამოითვლება და როგორ შეგვიძლია გამოვიყენოთ ყოველდღიურ ცხოვრებაში.\n ჯგუფებში მუშაობის გზით ააწყვეს ფაზლები, სადაც ერთმანეთს შეუსაბამეს პროდუქტები და მათი დამზადებისთვის საჭირო ვირტუალური წყლის ოდენობა ლიტრებში.\n ინდივიდუალური და წყვილებში მუშაობის გზით ამოხსნეს "მწვანე ამოცანები" წყლის რესურსების მდგრადი მოხმარების პრინციპების თემაზე.\n გეოგრაფიის მასწავლებელი: ანა ანუშიძე',
  },
  {
    imageGallery: [],
    image: name201,
    id: 201,
    title:
      "ბათუმის შოთა რუსთველის სახელმწიფო უნივერსიტეტის სტუდენტებმა და პროფესორ-მასწავლებლებმა ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U -ში სხვადასხვა მუნიციპალიტეტის სკოლების მოსწავლეებისთვის წყლის რესურსების დაცვის საერთაშორისო დღისადმი მიძღვნილი ღონისძიება გამართეს. 22 მარტს წყლის რესურსების დაცვის საერთაშორისო დღე გაერთიანებული ერების ორგანიზაციის გენერალური ასამბლეის გადაწყვეტილებით აღინიშნება. დღის დაწესებისა და აღნიშვნის მიზანია, მსოფლიო საზოგადოებას კიდევ ერთხელ შეახსენოს, როგორი მნიშვნელობა აქვს წყლის რესურსების მოფრთხილებასა და მის დაცვას.",
    briefText:
      'ღონისძიება ბათუმის შოთა რუსთველის სახელმწიფო უნივერსიტეტის საბუნებისმეტყველო მეცნიერებათა და ჯანდაცვის ფაკულტეტისა და "ბათუმის წყლის" ორგანიზებით გაიმართა.\n წყლის რესურსების დაცვის საერთაშორისო დღისადმი მიძღვნილ ღონისძიებაში მონაწილეობა მიიღეს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებმაც (ქიმიის მასწავლებელი ნონა აბაშიძე).\n სტუდენტებმა მოსწავლეებს გააცნეს წყლის არსი, მნიშვნელობა, დაბინძურების ფაქტორები, გასუფთავების ხერხები და ქიმიის როლი ამ პროცესში.\n ქიმიის საგანმანათლებლო პროგრამის სტუდენტებმა მოსწავლეებისათვის სახალისო ცდები ჩაატარეს და ვიქტორინა გამართეს წყლის თემაზე, რომელშიც გაიმარჯვა ჩვენი სკოლის გუნდმა!\n გამარჯვებულ გუნდს გადაეცა სამახსოვრო საჩუქრები, ხოლო ყველა მონაწილეს - სერტიფიკატი.',
  },
  {
    imageGallery: [],
    image: name202,
    id: 202,
    title:
      'მოსწავლეებმა ისაუბრეს შესწავლილ ტექსტზე -ლ. გოთუას "ჩემი უსტარაული"',
    briefText:
      "წარმოდგენილი იყო სამი მოხსენება:\n -ეკოსისტემა, როგორც ბუნებრივი კომპლექსი;\n -უსტარაულის გარშემო არსებული ეკოსისტემა;\n -ეკოსისტემის ცვლილების შედეგები.\n მოხსენებები წარმოადგინეს ნანა ჩხიკვაძემ, ნატია დავითაძემ და ლიზი ხალვაშმა.\n მოსწავლეებმა ისაუბრეს ლიტერატურის გაკვეთილებზე შესწავლილი ტექსტების შესახებ საბუნებისმეტყველო ჭრილში და გამოიტანეს დასკვნები.",
  },
  {
    imageGallery: [],
    image: name203,
    id: 203,
    title:
      '22 მარტი წყლის საერთაშორისო დღეა. \nბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII კლასში გეოგრაფიის გაკვეთილი თემაზე : "წყლის მნიშვნელობა სამყაროში"; მასწავლებელი სოფიკო ხუხუნაიშვილი.',
    briefText:
      'გაკვეთილზე მეათე კლასის მოსწავლეებმა უმცროსკლასელთათვის წარმოაგდინეს მოხსენება წყლის სასიცოცხლო ფუნქციის შესახებ პროექტის "გიმნაზიელები გიმნაზიელთათვის" ფარგლებში."',
  },
  {
    imageGallery: [],
    image: name204,
    id: 204,
    title:
      "2023 წლის 23 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მეცხრე კლასების მოსწავლეები ქართული ენისა და ლიტერატურის მასწავლებლებთან რუსუდან თოიძესა და ქეთევან ქაჯაიასთან ერთად ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U -ს სტუმრობდნენ, სადაც შეხვდნენ ცნობილ მეცნიერს უნივერსიტეტის პროფესორს ქალბატონ თინა შიოშვილს.",
    briefText:
      'ქალბატონმა თინამ ახალგაზრდებთან უაღრესად საინტერესოდ და დასამახსოვრებლად ისაუბრა თემაზე "წყლის კულტი ქართულ მითოლოგიასა და ფოლკლორში".',
  },
  {
    imageGallery: [],
    image: name205,
    id: 205,
    title:
      "წმინდა ანდრია პირველწოდებულის სკოლისა და კომპანია English Book Education-ის თანამშრომლობის ფარგლებში, ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში განხორციელდა ერთ-ერთი ყველაზე წარმატებული პროექტი: TOEFL ტესტის ოლიმპიადა.\nTOEFL მსოფლიოში ყველაზე აღიარებული ბრენდია ინგლისური ენის შეფასების კუთხით.",
    briefText:
      'აღსანიშნავია, რომ TOEFL ტესტის ოლიმპიადა აჭარაში მხოლოდ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა.\nოლიმპიადა სამ ტურად დაიგეგმა და განხორციელდა და კომპანია ,,English Book Education" -ის წარმომადგენელთა მიერ. ტესტი და შეფასება თანამედროვე საერთაშორისო სტანდარტის შესაბამისი იყო.\n 2023 წლის 24 მარტს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები დაჯილდოვდნენ TOEFL საერთაშორისო სერტიფიკატებით.\nოთხი უმაღლესი ქულის მქონე მოსწავლე მონაწილეობას მიიღებს ორკვირიან საზაფხულო სკოლაში, რომელსაც ბრიტანული უნივერსიტეტი საქართველოში მასპინძლობს.',
  },
  {
    imageGallery: [],
    image: name206,
    id: 206,
    title:
      "ბათუმი წიგნისა და უმაღლესი განათლების პირველ საერთაშორისო გამოფენას - “Batumi Book & Higher Education 2023” მასპინძლობს.\nგამოფენის მიზანია წიგნის კითხვის პოპულარიზაცია, საგამომცემლო სექტორის განვითარების ხელშეწყობა და თანამედროვე ტექნოლოგიების გაცნობა. გამოფენის ფარგლებში ჩატარდა საერთაშორისო კონფერენცია და სხვადასხვა შემეცნებით-გასართობი პროგრამები.",
    briefText:
      "გამოფენა კომპანია “Expo Batumi”-ის ორგანიზებით იმართება.\nჩვენთვის უაღრესად მნიშვნელოვანია, რომ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ინფორმაციული ტექნოლოგიების პედაგოგი კახი კახიძე და უფროსკლასელები აქტიურად არიან ჩართული ამ მნინელოვან და შემეცნებით ღონისძიებაში.",
  },
  {
    imageGallery: [],
    image: name207,
    id: 207,
    title:
      "ბათუმი წიგნისა და უმაღლესი განათლების პირველ საერთაშორისო გამოფენას - “Batumi Book & Higher Education 2023” მასპინძლობს.\nგამოფენის მიზანია წიგნის კითხვის პოპულარიზაცია, საგამომცემლო სექტორის განვითარების ხელშეწყობა და თანამედროვე ტექნოლოგიების გაცნობა.",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის უფროსკლასელები და პედაგოგები ნატალია ფრუიძე და კახი კახიძე ორი დღეს განმავლობაში იყვნენ ჩართული სხვადასხვა აქტივობებში.",
  },
  {
    imageGallery: [],
    image: name208,
    id: 208,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სკოლაში მიმდინარე წლიდან ნებისმიერ მსურველს შეუძლია დაეუფლოს ბერძნულ ენასა და კულტურას.კურსს უძღვება ბერძნული ენის პედაგოგი, აკადემიური დოქტორი ნინო ძნელაძე.",
    briefText:
      "2023 წლის 27 მარტს თბილისის საკრებულოში საბერძნეთის საელჩომ გამართა საბერძნეთის დამოუკიდებლობის 202-ე წლისთავისადმი მიძღვნილი საზეიმო მიღება, რომელსაც სკოლის სახელით ესწრებოდნენ ნინო ძნელაძე და პირიმზე რურუა.",
  },
  {
    imageGallery: [],
    image: name209,
    id: 209,
    title:
      '2023 წლის 29 მარტს ძმები ნობელების სახელობის ტექნოლოგიურ მუზეუმში, ,,სამუზეუმო საათის’’ ფარგლებში, ჩატარდა გრაფიკოს-დიზაინერის, ხელოვნების აკადემიური დოქტორის, ბათუმის-მუნიციპალიტეტის მერიის ისტორიული განაშენიანების ზონის განვითარების განყოფილების უფროსის, ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ხელოვნების პედაგოგის სოფო სანიკიძის საჯარო ლექცია თემაზე: ,,ბათუმის არქიტექტურული ძეგლები."\nმსმენელთათვის განსაკუთრებით საინტერესო აღმოჩნდა ბათუმის არქიტექტურული ძეგლების მხატვრულ-სტილისტური მახასიათებლები, კულტურული მემკვიდრეობის ღირებულება და მნიშვნელობა.',
    briefText:
      "შეხვედრას ესწრებოდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები.\nსაჯარო ლექციის პარალელურად ვიზიტორებს საშუალება ჰქონდათ დაეთვალიერებინათ საექსპოზიციო დარბაზში გამოფენილი ბათუმის ღირშესანიშნავი კულტურული მემკვიდრეობის ძეგლების ფოტოები.",
  },
  {
    imageGallery: [],
    image: name210,
    id: 210,
    title:
      "2023 წლის 30 მარტს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში შედგა პოეტ ტარიელ ხარხელაურის შემოქმედებითი საღამო.\nმოსწავლეებმა წაიკითხეს პოეტის ლექსები, შეასრულეს მის ლექსებზე შექმნილი სიმღერები; მოწვეულმა საპატიო სტუმრებმა, ბატონ ტარიელის შემოქმედების თაყვანისმცემლებმა, დიდი სითბო და სიყვარული გამოხატეს პოეტის მიმართ!",
    briefText:
      "ბატონ ტარიელთან ერთად ჩამობრძანდნენ მისი მეუღლე მარინა ხარხელაური, ფილოლოგი ლია თუშური და კავკასიის საერთაშიორისო უნივერსიტეტის რექტორის მრჩეველი გიორგი ფარეშიშვილი.\nდღე - პოეზიის ზეიმისა დიდხანს ემახსოვრება მრავალრიცხოვან აუდიტორიას!",
  },
  {
    imageGallery: [],
    image: name211,
    id: 211,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა სახვითი ხელოვნების კონკურსი  მეხუთე - მეცხრე კლასის მოსწავლეებს შორის.",
    briefText:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა სახვითი ხელოვნების კონკურსი მეხუთე - მეცხრე კლასის მოსწავლეებს შორის."',
  },
  {
    imageGallery: [],
    image: name212,
    id: 212,
    title:
      "2023 წლის 31 მარტს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში სტუმრად ბრძანდებოდა ნიკო ნიკოლაძის საზოგადოების თავმჯდომარე, კავკასიის საერთაშორისო უნივერსიტეტის რექტორის მრჩეველი გიორგი ფარეშიშვილი, რომელმაც უფროსკლასელებს ჩაუტარა უაღრესად საინტერესო და შთამბეჭდავი საუბარი დიდი ნიკო ნიკოლაძის ცხოვრებისა და მოღვაწეობის შესახებ.",
    briefText:
      "2023 წლის 31 მარტს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში სტუმრად ბრძანდებოდა ნიკო ნიკოლაძის საზოგადოების თავმჯდომარე, კავკასიის საერთაშორისო უნივერსიტეტის რექტორის მრჩეველი გიორგი ფარეშიშვილი, რომელმაც უფროსკლასელებს ჩაუტარა უაღრესად საინტერესო და შთამბეჭდავი საუბარი დიდი ნიკო ნიკოლაძის ცხოვრებისა და მოღვაწეობის შესახებ.",
  },
  {
    imageGallery: [],
    image: name213,
    id: 213,
    title:
      "1 აპრილი ფრინველთა დაცვის საერთაშორისო დღეა!\nამ დღის აღსანიშნავად ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-4 კლასის მოსწავლეები რუსული ენის პედაგოგმა ევგენია ლომაძემ და კლასის დამრიგებელმა ნონა აბაშიძემ ბათუმის ბულვარის ზოოკუთხეში წაიყვანეს.",
    briefText:
      "სახალისო და შემეცნებითი აქტივობებით დატვირთული რამდენიმე საათი პატარებმა სუფთა ჰაერზე გაატარეს , მოსწავლეებმა ნახეს ფრინველები, იქვე მოამზადეს მოამზადეს და წარადგინეს პოსტერები, ითამაშეს, გაერთნენ!",
  },
  {
    imageGallery: [],
    image: name214,
    id: 214,
    title:
      "2023 წლის 4 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის VII-1 კლასში რუსულ ენის შემოქმედებითი, სახალისო, საინტერესო გაკვეთილი ჩაატარა პედაგოგმა ევგენია ლომაძემ. . \nთემა: გარეგნობა",
    briefText:
      "მიზანი: საუბრისა და კითხვის უნარების გაუმჯობესება; ლექსიკური და გრამატიკული მასალის განმტკიცება თემის ფარგლებში; შემოქმედებითი აზროვნებისა და სამეტყველო უნარ- ჩვევების განვითარება.",
  },
  {
    imageGallery: [],
    image: name215,
    id: 215,
    title:
      'სასწავლო ექსკურსია შპს "ბათუმის წყალში".\n2023 წლის 5 აპრილს ბათუმის წმ.ანდრია პირველწოდებულის სახელობის სკოლის IX-6 კლასის მოსწავლეებისთვის მოეწყო სასწავლო ექსკურსია-გაკვეთილი შპს "ბათუმის წყლის" ქიმიურ -ბაქტერიოლოგიურ ლაბორატორიაში (ქიმიის პედაგოგი ირინა ვიდულინა).',
    briefText:
      'მასწავლებელთან ერთად "ბათუმის წყლის" ლაბორატორიის თანამშრომლებმა ძალიან საინტერესო და დასამახსოვრებელი ინფორმაცია მიაწოდეს ბავშვებს. მოსწავლეები ადგილზე გაეცნენ სასმელი წყლის კვლევებს.\nმადლობას მოვახსენებთ ბათუმის წყალი • Batumis Tskali და ვიტოვებთ მომავალი თანამშრომლობის იმედს!\n#ბათუმისწმინდაანდრიაპირველწოდებულისსახელობისსკოლა\n#სასწავლოექსკურსია\n#ბათუმისწყალი',
  },
  {
    imageGallery: [],
    image: name216,
    id: 216,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში პრაქტიკას გადიან შოთა რუსთაველის სახელობის ბსუ-ს ფსიქოლოგიის ფაკულტეტის სტუდენტები ელისაბედ მამულაძე და მარიამ თავბერიძე.",
    briefText:
      '2023 წლის 6 აპრილს სტუდენტებმა მე-9 კლასელთათვის ჩაატარეს უაღრესად საინტერესო ტრენინგი თემაზე: "მენტალური ჯანმრთელობის შენარჩუნებისთვის საჭირო უნარები".',
  },
  {
    imageGallery: [],
    image: name217,
    id: 217,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებმა:\nსანდრო კორძაძემ\nგიორგი გუჩმანიძემ\nბარბარე გუჩმანიძემ\nანა-მარია გოგიტიძემ\nელისაბედ ოქროპირიძემ\nმონაწილეობა მიიღეს ესეების კონკურსში „რატომ ვსწავლობ ბერძნულ ენას“, რომელიც საქართველოში საბერძნეთის საელჩოსა და თბილისის სახელმწიფო უნივერსიტეტის კლასიკური ფილოლოგიის, ბიზანტინისტიკისა და ნეოგრეცისტიკის ინსტიტუტის მხარდაჭერით გაიმართა ბერძნული ენის დღესთან დაკავშირებით.",
    briefText:
      "მოსწავლეები დაჯილდოვდნენ სერტიფიკატებით, მე-2 კლასის მოსწავლემ ელისაბედ ოქროპირიძემ კი აჭარის მასშტაბით ესეების კონკურსში დაიკავა მესამე ადგილი",
  },
  {
    imageGallery: [],
    image: name218,
    id: 218,
    title:
      "2023 წლის 8 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა მათემატიკის შიდა სასკოლო ოლიმპიადა დაწყებითი საფეხურის (II-VI კლასების) მოსწავლეებისთვის. ოლიმპიადის მიზანია მოსწავლეებში ლოგიკური აზროვნების, დამოუკიდებელი მუშაობის უნარ-ჩვევების განვითარება, საგნისადმი დადებითი დამოკიდებულების, ინტერესის გაღვივება, ასევე, ყოველდღიურ ცხოვრებაში მათემატიკის გამოყენების გააზრება.",
    briefText:
      "მოსწავლეები შეძლებენ, სასკოლო ოლიმპიადაში მიღებული გამოცდილება გამოიყენონ სკოლისგარეშე სხვადასხვა აქტივობაში მონაწილეობისას.",
  },
  {
    imageGallery: [],
    image: name219,
    id: 219,
    title:
      '2023 წლის 19 აპრილს ბათუმის ძმები ნობელების სახელობის ტექნოლოგიურ მუზეუმში გაიმართა ნორჩი კალიგრაფისტების საუკეთესო ნამუშევრების გამოფენა, სახელწოდებით: "ქართული ქართველთ რწმენაა".\n ექსპოზიციაში წარმოდგენილი იყო ბათუმის წმ.ანდრია პირველწოდებულის სახელობის სკოლის ნორჩ კალიგრაფისტთა ნამუშევრები.',
    briefText:
      "გამოფენის დასასრულს ნაჩვენები იყო ხელნაწერთა ეროვნული ცენტრის დოკუმენტური ფილმი: ,,ქართული კალიგრაფია.''",
  },
  {
    imageGallery: [],
    image: name220,
    id: 220,
    title: "გიმნაზიელები ვერთიანდებით იოანასთვის!",
    briefText:
      "მეგობრებო!\nმოგმართავთ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებს,\nპედაგოგებს,\nმშობლებს,\nყოფილ გიმნაზიელებს!\nკვლავ უნდა გავერთიანდეთ ერთი პატარა და მამაცი გოგონას დასახმარებლად!\nთიბისი:\n#GE71TB7009945063600061\nსაქართველო:\n#GE66BG0000000365875183\nთამარ ქათამაძე\n(პ/ნ 61004052484) \n#სიკეთე_გადამდებია!\n#გიმნაზიელებივერთიანდებითიოანასთვის!\nგარდა მითითებული ანგარიშებისა, შემოწირულობის გაღებას სკოლაშიც შეძლებთ ამ ერთი კვირის მანძილზე ( რამდენიმე ადგილას განვათავსებთ ყულაბებს), ასევე, კონცერტის მსვლელობისას!",
  },
  {
    imageGallery: [],
    image: name221,
    id: 221,
    title:
      '2023 წლის 23 აპრილს "ტვინების ბრძოლის" გაზაფხულის სეზონის ფინალური შეხვედრა გაიმართა. გუნდურად მოასპარეზე წარმატებული მოაზროვნეები ერთმანეთს საქართველოს ჩემპიონის ტიტულისთვის დაუპირისპირდნენ.',
    briefText:
      "ფინალურ თამაშში ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის გუნდიც მონაწილეობდა:\nმარიამ ჩიხლაძე\nანასტასია მოლაშხია\nანდრია კახიძე\nმარიამ გუგუშვილი\nსალომე ცინცაძე\nთამუნა ძაძამია\nმართა მოფინაძე\nმარიტა კოსტავა\nქეთო მორჩიაშვილი\nზურა გათენაძე",
  },
  {
    imageGallery: [],
    image: name222,
    id: 222,
    title:
      "კონფერენცია „თიხის წიგნებიდან აუდიო-წიგნებამდე“.წიგნისა და საავტორო უფლებების დაცვის დღეს, 23 აპრილს, სსიპ აჭარის მუზეუმის ბათუმის არქეოლოგიურ მუზეუმში ჩატარდა IV საბავშვო კონფერენცია „თიხის წიგნებიდან აუდიო-წიგნებამდე“.",
    briefText:
      'კონფერენციაში მონაწილეობდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები-მარიამ ნინიძე,\nმარიამ ბოლქვაძე,\nთეკლა შაშიკაძე,\nანა სარჯველაძე,\nნიკა ბარამიძე,\nმარიამ ჯანყარაშვილი,\nლილე კიკნაძე,\nქეთევან რუხაძე\nახალგაზრდებმა წარმოადგინეს მოხსენებები:\n"ვეფხისტყაოსნის" ილუსტრაციები;\nწიგნი "ქართლის ცხოვრება",\nალექსანდრიის ბიბლიოთეკა,\nბიბლიის ისტორია,\nლიტერატურულ მიმდინარეობათა ცვალებადობა ქართულ ლიტერატურაში.\nეს დღე, ასევე, წიგნის ჩუქების დღეცაა და აჭარის მუზეუმმა კონფერენციის ყველა მონაწილე დაასაჩუქრა წიგნებით.\nწიგნები და სერტიფიკატები მოსწავლეებს აჭარის მუზეუმის დირექტორმა თეონა ზოიძემ, დირექტორის მოადგილემ ინგა გოგიბერიძემ, არქეოლოგიური მუზეუმის მმართველმა ემზარ კახიძემ გადასცეს.\nკონფერენცია მოამზადა და უძღვებოდა ბათუმის არქეოლოგიის მეცნიერ-თანამშრომელი ნინო ძნელაძე.',
  },
  {
    imageGallery: [],
    image: name223,
    id: 223,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-4 კლასის მოსწავლეებმა მე და საზოგადოების გაკვეთილზე დაამზადეს და ერთმანეთს წარუდგინეს სხვადასხვა სახის დღესასწაულისადმი მიძღვნილი მისალოცი ბარათები ( მასწავლებელი ხათუნა მანჯგალაძე).",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-4 კლასის მოსწავლეებმა მე და საზოგადოების გაკვეთილზე დაამზადეს და ერთმანეთს წარუდგინეს სხვადასხვა სახის დღესასწაულისადმი მიძღვნილი მისალოცი ბარათები ( მასწავლებელი ხათუნა მანჯგალაძე).",
  },
  {
    imageGallery: [],
    image: name224,
    id: 224,
    title:
      "2023 წლის 14-21 აპრილს ქართული ენის კვირეული სკოლაში მრავალფეროვანი აქტივობით აღინიშნა.\nIV -3 კლასის მოსწავლეებმა წაიკითხეს ნაწყვეტები შოთა რუსთაველის „ვეფხისტყაოსნიდან“, დაისწავლეს აფორიზმები, ჩატარდა მხატვრული კითხვის და კალიგრაფიის კონკურსი (მასწავლებელი რუსუდან თოიძე);",
    briefText:
      'დედა ენის დღეს მიუძღვნეს საკლასო ღონისძიება IV-4 კლასის მოსწავლეებმა (მასწავლებელი ლამარა გოგიბერიძე);\nსკოლის ბიბლიოთეკაში ჩატარდა ამ დღისადმი მიძღვნილი გაკვეთილი ქართულ ენაში III-4 კლასში (მასწავლებელი მაია იმნაძე);\nსაინტერესო ცნობები მოიძიეს და პლაკატები შექმნეს ქართული ენის შესახებ IV-1 კლასის მოსწავლეებმა (მასწავლებელი თეონა ლორთქიფანიძე) ; \n"არა ბარბარიზმებს" -აქტივობა შემოგვთავაზეს II-2 კლასის მოსწავლეებმა ( მასწავლებელი ნინო უგულავა);\nთითქმის ყველა კლასში შეასრულეს კალიგრაფიის ნიმუშები, შექმნეს სიტყვების კედელი "სწორია-არასწორია" ფორმების გამოყენებით.',
  },
  {
    imageGallery: [],
    image: name225,
    id: 225,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებთან ევროინტეგრაციის საკითხებზე საინფორმაციო შეხვედრა გაიმართა.\n2023 წლის 25 აპრილს საგარეო საქმეთა სამინისტროს ნატოსა და ევროკავშირის შესახებ საინფორმაციო ცენტრის ორგანიზებით- საინფორმაციო ცენტრი ნატოსა და ევროკავშირის შესახებ • NATO & EU Info Center - ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ევროინტეგრაციის საკითხებზე საინფორმაციო შეხვედრა გაიმართა.",
    briefText:
      "შეხვედრაზე საინფორმაციო ცენტრის წარმომადგენელმა აჭარის რეგიონში ირმა გაბინაშვილმა საქართველოს ევროპული ინტეგრაციის ისტორიის, ევროკავშირთან თანამშრომლობის დინამიკის, ხელშესახები შედეგების და პერსპექტივების, აგრეთვე, ევროკავშირის სხვადასხვა პროგრამის ფარგლებში გახსნილი შესაძლებლობების და ვიზალიბერალიზაციის საკითხებზე ისაუბრა.\nყურადღება გამახვილდა ევროკავშირში გაწევრიანების თაობაზე საქართველოს მიერ გაკეთებულ განაცხადზე, ევროპული პერსპექტივის მნიშვნელობასა და მასთან დაკავშირებულ შემდგომ პროცედურებსა და ეტაპებზე.\nმომხსენებელმა, ასევე, ისაუბრა საინფორმაციო ცენტრის საქმიანობის მიმართულებებსა და მიზნებზე, ქვეყნის მთავარი საგარეო პრიორიტეტებისადმი საზოგადოების გაცნობიერებული მხარდაჭერის, ანტიდასავლური პროპაგანდის მიმართ მისი მედეგობის გაზრდის ხელშეწყობის მნიშვნელობაზე.\nშეხვედრაზე ყურადღება გამახვილდა ევროკავშირის მიერ დაფინანსებულ ERASMUS + გაცვლით პროგრამაში მონაწილეობის პირობებზე, შერჩევის კრიტერიუმებსა და პროგრამაში წარმატებით ჩართულობისთვის გასათვალისწინებელ ფაქტორებზე.\nშეხვედრის დასასრულს გაიმართა დისკუსია ახალგაზრდებისთვის საინტერესო საკითხებზე.\n#ბათუმის_წმინდა_ანდრია_პირველწოდებულის_სახელობის_სკოლა\n#ბათუმისგიმნაზია",
  },
  {
    imageGallery: [],
    image: name226,
    id: 226,
    title:
      "სტუმრად მხატვარ ნინო ნიჟარაძესთან.\nწლის 25 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის ქართული კულტურის შემსწავლელთა კლუბის წევრებმა (კლუბის ხელმძღვანელი პირიმზე რურუა) ბათუმის ხელოვნების მუზეუმის სამხატვრო გალერეაში დაათვალიერეს ქალბატონ ნინო ნიჟარაძის გამოფენა.",
    briefText:
      "ქალბატონმა ნინომ თავად უმასპინძლა მოსწავლეებს, ესაუბრა მათ საკუთარ შემოქმედებასა და, ზოგადად, მხატვრობის შესახებ, გაიხსენა თავისი ცხოვრების საინტერესო ისტორიები.\nშეხვედრა უაღრესად თბილ, უშუალო და ქალბატონ ნინოს შემოქმედებით გაჯერებულ გარემოში წარიმართა.",
  },
  {
    imageGallery: [],
    image: name227,
    id: 227,
    title:
      "2 აპრილი - მსოფლიო აუტიზმის ცნობადობის ამაღლების საერთაშორისო დღეა. აპრილის თვე აუტიზმის მსოფლიო თვედ არის აღიარებული და აუტიზმის შესახებ ცნობიერების ამაღლებას ეძღვნება.\nინკლუზიური საზოგადოების უფლებების განუხრელი დაცვა და მხარდაჭერის უკეთ გაცნობიერებისთვის ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 კლასის მოსწავლეებმა მოქალაქეობის გაკვეთილებზე იმუშავეს პროექტზე: ,,კი გამორჩეული, კი თავისებური, მაგრამ თქვენნაირი“. პედაგოგი - ინგა მართალიშვილი.",
    briefText:
      "მოსწავლეებმა მოიპოვებს ინფორმაცია აუტისტური სპექტრის შესახებ, ასევე, ჩაატარეს კვლევა თემში არსებული სტერეოტიპებისა და დამოკიდებულების გამოსავლენად.\nცნობადობის ამაღლებისა და საკითხში უკეთ გარკვევის მიზნით, სტუმრობდნენ ბათუმში არსებულ რეაბილიტაციის ცენტრს ,,ფანშეტი’’, რომელიც უზრუნველყოფილია ბავშვთა და მოზარდთა რეაბილიტაციისთვის საჭირო სერვისებითა და სპეციალისტებით.\nცენტრის ფსიქოლოგი ქალბატონი დარინა დუმბაძე მოსწავლეებს ძალიან საინტერესოდ და ინფორმაციულად ესაუბრა აუტიზის სპექტრის შესახებ, განიხილეს, რა სახის სტერეოტიპები არსებობს საზოგადოებაში და როგორ უშლის ხელს ბავშვთა სოციალიზაციას საზოგადოებაში დამკვირდებული სტიგმა. მან აღნიშნა:\n„მათ შეუძლიათ კომუნიკაცია, უბრალოდ, ჩვენ არ ვიცით, როგორ მოვეპყროთ მათ“.\nაუტიზმი - პაზლი, რომელიც ყველამ ერთად უნდა ავაწყოთ და ამის გასაღები, სიყვარულია!",
  },
  {
    imageGallery: [],
    image: name228,
    id: 228,
    title:
      "2023 წლის 8 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა მათემატიკის შიდა სასკოლო ოლიმპიადა დაწყებითი საფეხურის (II-VI კლასების) მოსწავლეებისთვის.",
    briefText:
      "ოლიმპიადამ დიდი ინტერესი და ჩართულობა გამოიწვია.\nწარმატებული მოსწავლეები დაჯილდოვდნენ სიგელებით!",
  },
  {
    imageGallery: [],
    image: name229,
    id: 229,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლასა და კიბერ აკადემიას ( Cyber Academy - კიბერ აკადემია ) შორის რამდენიმე წელია გრძელდება მრავალმხრივი და საქმიანი პარტნიორული ურთიერთობა.",
    briefText:
      "2023 წლის 3 მაისს უფროსკლასელთათვის ჩატარდა აკადემიის საინფორმაციო შეხვედრა, რომელსაც უძღვებოდა კიბერ აკადემიის წარმომადგენელი საბა ოკუჯავა.",
  },
  {
    imageGallery: [],
    image: name230,
    id: 230,
    title:
      '2023 წლის 5 მაისს ბათუმში, სასტუმრო "რედისონში" ორგანიზაცია საერთაშორისო გამჭვირვალობა-საქართველოს ინიციატივით გაიმართა შეხვედრა საჯარო და კერძო სკოლების მასწავლებლებთან, უნივერსიტეტის პროფესორებთან და სამოქალაქო საზოგადოების წარმომადგენლებთან ევროინტეგრაციის და დემოკრატიული პროცესების განვითარების მნიშვნელობაზე.\nსაინტერესო დისკუსიაში ჩართული იყვნენ ორგანიზაციის აღმასრულებელი დირექტორი ეკა გიგაური, ისტორიკოსი ლაშა ბაქრაძე და მასწავლებლის ეროვნული ჯილდოს გამარჯვებულები ლადო აფხაზავა, სოფო გოგოხია და როლანდ შავაძე.',
    briefText:
      'შეხვედრას ესწრებოდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის პედაგოგები პირიმზე რურუა და ზვიად ჩხენკელი.\nპედაგოგებმა ზოგადი განათლების კუთხით არსებულ გამოწვევებზე გაამახვილეს ყურადღება.\nლაშა ბაქრაძემ აუდიტორიას წარუდგინა და დამწრე საზოგადოების წარმომადგენლებს საჩუქრად გადასცა აკაკი ბაქრაძის წიგნის "მწერლობის მოთვინიერება" ახალი, შევსებული გამოცემა.',
  },
  {
    imageGallery: [],
    image: name231,
    id: 231,
    title:
      '2023 წლის 5 მაისს ბათუმის "თავისუფალ სივრცეში" საერთაშორისო გამჭვირვალობა-საქართველოს ორგანიზებით გაიმართა შეხვედრა უფროსკლასელებთან.\nსაუბარი წარიმართა საქართველოს ევროინტეგრაციასა და ევროკავშირის საკითხებზე.',
    briefText:
      "მოსწავლეებს ორგანიზაციის აღმასრულებელი დირექტორი ეკა გიგაური, პუბლიცისტი ლაშა ბაქრაძე, მასწავლებლის ეროვნული ჯილდოს გამარჯვებულები ლადო აფხაზავა და სოფო გოგოხია ინტერაქტიულ რეჟიმში ესაუბრნენ.\nშეხვედრას ესწრებოდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის უფროსკლასელები.",
  },
  {
    imageGallery: [],
    image: name232,
    id: 232,
    title:
      "შეხვედრა მწერალ თამარ გეგეშიძესთან.\n2023 წლის 8 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლას ესტუმრა მწერალი თამარ გეგეშიძე.",
    briefText:
      '"სული ჩიტი", "საშლელები", "ჩუმად უნდა იჯდე" - უკვე მოზარდების საყვარელ წიგნებად იქცა.\nჩვენთვის განსაკუთრებით მნიშვნელოვანია ის, რომ თამუნა ჩვენი სკოლის აღზრდილია, ხოლო დედამისი, მარინა მამალაძე დღესაც ქართული ენისა და ლიტერატურის პედაგოგია ჩვენთან.\nშეხვედრაზე საოცრად თბილი, უშუალო, ხალისიანი განწყობა სუფევდა. ახალგაზრდებმა შეკითხვები დაუსვეს საყვარელ ავტორს, თავი მოაწინეს მათ მიერ შესრულებული ილუსტრაციებით.\nემოციური იყო თამარის შეხვედრა ყოფილი პედაგოგებთან.\nღონისძიების ორგანიზატორები იყვნენ ქართული ენის პედაგოგები რუსუდან თოიძე და ქეთი ქაჯაია.\nმაშ ასე, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში "ჩვენი მწერლების" (ჩვენი სკოლადამთავრებულების) კვირეული დაიწყო!',
  },
  {
    imageGallery: [],
    image: name233,
    id: 233,
    title:
      "2023 წლის 10 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები შეხვდნენ ბათუმელ პოეტებს გენრი დოლიძეს და გიორგი გაბაიძეს.\nსტუმრებმა წაიკითხეს საკუთარი ლექსები, ახალგაზრდებს ესაუბრნენ თანამედროვე ქართული პოეზიის, ზოგადად, ლიტერატურის, ავტორების შესახებ.",
    briefText:
      "დასამახსოვრებელი შეხვედრა უაღრესად საინტერესო, უშუალო გარემოში წარიმართა.\nპოეტებმა სკოლის ბიბლიოთეკას წიგნები გადასცეს საჩუქრად.\nაღსანიშნავია, რომ გენრი დოლიძე ჩვენი სკოლის კურსდამთავრებულია.\nშეხვედრის ორგანიზატორები იყვნენ ქართული ენის პედაგოგები ქეთი ქაჯაია და რუსუდან თოიძე.",
  },
  {
    imageGallery: [],
    image: name234,
    id: 234,
    title:
      '2023 წლის 11 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები ფილოლოგს, საბავშვო მწერალს, ჩვენი სკოლის ყოფილ მოსწავლეს ნინო ლომიძეს შეხვდნენ.\n"უშბა და მეგობრები" უკვე იქცა ბავშვების საყვარელ წიგნად.',
    briefText:
      'ავტორმა თავად "გააცნო" პატარებს ძაღლი უშბა, წაუკითხა მონაკვეთები წიგნიდან, უპასუხა მათ შეკითხვებს.\nასეთი თბილი და უშუალო, კეთილგანწყობილი და მხიარული შეხვედრა მწერალთან დიდხანს დაამახსოვრდებათ ყმაწვილებს.',
  },
  {
    imageGallery: [],
    image: name235,
    id: 235,
    title:
      'ტყუპების ფესტივალი.\n2023 წლის 6 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა "ტყუპების ფესტივალი". ღონისძიების ორგანიზატორი იყო ბიოლოგიის მასწავლებელი, სამედიცინო ბიოლოგიის კლუბის ხელმძღვანელი ქეთევან ხარაბაძე.',
    briefText:
      "მოეწყო ბევრი ღიმილითა და სიყვარულით გაჯერებული, მხიარული, შემეცნებითი, საინტერესო შეხვედრა ჩვენი სკოლის ტყუპებთან და მათ მშობლებთან!\nმე-9 კლასის მოსწავლე მარიამ გოროზიამ დამსწრე საზოგადოებისთვის მოამზადა პრეზენტაცია ბუნების ამ ფენომენის შესახებ.\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის სამედიცინო ბიოლოგიის კლუბის წევრებმა ნილა ჯინჭარაძემ, კესარია გათენაძემ და ანა დარჩიძემ წარმართეს მხიარული თამაშები, გამოცნობანა, ტყუპებმა შეასრულეს სიმღერები, გაიხსენეს კურიოზები.",
  },
  {
    imageGallery: [],
    image: name236,
    id: 236,
    title: "საჯანმრთელო პარაკლისი 19 მაისი 12:10-12:50",
    briefText: "ბოლო ზარი 2023 წელი 19 მაისი 09:00-09:40",
  },
  {
    imageGallery: [],
    image: name237,
    id: 237,
    title:
      "გიმნაზიელთა დიდი წარმატება 76-ე სასწავლო-შემოქმედებით კონფერენციაზე.\n2023 წლის 20 მაისს თბილისში წმ. ანდრიას ქართული უნივერსიტეტში ჩატრდა ეროვნული სასახლის 76-ე სასწავლო-კვლევითი კონფერენციის ბოლო ტური.",
    briefText:
      'ტრადიციულად, ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებმა აქტიური მონაწილეობა მიიღეს კონფერენციის მუშაობაში, წარადგინეს და დაიცვეს ნაშრომები, უპასუხეს შეკითხვებს.\nკონფერენციაზე წარმოდგენილი იყო 11 მოსწავლის 9 ნაშრომი:\nლიკა ჯოხაძე, ნატალი თედორაძე - „გრამატიკული ნორმების დარღვევა თანამედროვე ქართული პრესის ენასა და ზეპირსიტყვიერებაში“, ხელმძღვანელი თამარ ლომთაძე (ქართული ენა და ლიტერატურა);\nანა გოგიჩაიშვილი, ალექსანდრე ჯელია - „მათემატიკური ალბათობა და გენეტიკა“, ხელმძღვანელი ნატალია კალანდაძე (მათემატიკის სექცია);\nანანო ფუტკარაძე - "ხელოვნური ინტელექტის გამოყენება კომპლექსური ამოცანების ამოხსნისას", ხელმძღვანელი კახი კახიძე (მათემატიკის სექცია);\nანა ონიაშვილი -" რა ვიცით შოკოლადის შესახებ", ხელმძღვანელი ირინა ვიდულინა (ქიმიის სექცია);\nნუცა ნიკოლაიშვილი- „თაფლი-ფალსიფიცირებული თუ ნატურალური“, ხელმძღვანელი ნონა აბაშიძე (ქიმიის სექცია);\nსანდრო კალანდაძე - „ბოროტება, რომელიც არასოდეს სრულდება!“ - ხელმძღვანელი პირიმზე რურუა (ისტორიის სექცია);\nნატალი თედორაძე - „არჩევნები, როგორც სახელმწიფოს დემოკრატიული განვითარების მაჩვენებელი“, ხელმძღვანელი ლევან სამსონია (სამოქალაქო განათლების სექცია);\nსალომე თანდილავა - " მდგრადი განვითარების მე-16 მიზანი - მშვიდობა, სამართლიანობა და ძლიერი ინატიტუციების მშენებლობა, როგორც ჩვენი ქვეყნის ეროვნული ინტერესების მიღწევის საფუძველი", ხელმძღვანელი ანა ანუშიძე (სამოქალაქო განათლების სექცია);\nდათა ურუშაძე, ნინი თურმანიძე-„ჭკვიანი სახლი და ენერგო ეფექტურობა“, ხელმძღვანელი ინგა მართალიშვილი (ეკოლოგიის სექცია) . \nსიამაყით და სიხარულით გვსურს გაცნობოთ, რომ ორი ნაშრომი დაჯილდოვდა პირველი ხარისხის დიპლომით (მათემატიკის სექციაში ანა გოგიჩაიშვილი და ალექსანდრე ჯელიას და ქიმიის სექციაში ნუცა ნიკოლაიშვილის თემები) , \nორი მეორე ხარისხის დიპლომით (სამოქალაქო განათლების სექციაში სალომე თანდილავასა და ისტორიის სექციაში სანდრო კალანდაძის თემები ), დიპლომი გადაეცა ყველა დანარჩენ მონაწილეს!\nვულოცავთ გიმნაზიელეებს და მათ ხელმძღვანელებს ამ დიდ წარმატებას!',
  },
  {
    imageGallery: [],
    image: name238,
    id: 238,
    title:
      "2023 წლის 20 მაისს ივანე ჯავახიშვილის სახელობის თბილისის სახელმწიფო უნივერსიტეტის კულტურის კვლევათა ინსტიტუტმა ( თსუ კულტურის კვლევების ინსტიტუტი/ Institute of Cultural Studies, TSU ) ჩაატარა X ყოველწლიური სტუდენტურ სამეცნიერო კონფერენცია „კულტურა, იდენტობა, პოლიტიკა”.\nწელს პირველად ამ ინტერდისციპლინურ კონფერენციაში მონაწილეობდნენ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები.",
    briefText:
      'გიმნაზიელებმა წარმოადგინეს ნაშრომები, უპასუხეს შეკითხვებს, მოისმინეს კომპეტენტური შეფასება.\nკონფერენციის მუშაობაში მონაწილებდნენ:\nგიორგი ჩხაიძე - "კულტურული კოქტეილი" ბათუმის მე-20 საუკუნის ლიტერატურული კაფედან", ხელმძღვანელი ალექსანდრე მელიქაძე;\nმარიამ გოროზია - "ნაადრევი ქორწინების საკითხი აჭარაში (XXI საუკუნის მასალების მიხედვით)", ხელმძღვანელი ზვიად ჩხენკელი;\nმარი ნინიძე -"რეალური და ციფრული ბათუმი", ხელმძღვანელი პირიმზე რურუა;\nსანდრო კალანდაძე - "XX საუკუნის 30-იან წლების რეპრესიების გამოძახილი აჭარაში" , ხელმძღვანელი პირიმზე რურუა.\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ადმინისტრაციის სახელით უღრმეს მადლობას მოვახსენებთ კონფერენციის ორგანიზატორებს ამ განსაკუთრებული შესაძლებლობისთვის!\nწარმატებებს ვუსურვებთ ჩვენს გიმნაზიელებს!',
  },
  {
    imageGallery: [],
    image: name239,
    id: 239,
    title:
      "1918 წლის 26 მაისს საქართველოს ეროვნულმა საბჭომ სახელმწიფოებრივი დამოუკიდებლობის აქტი მიიღო და ევროპული ტიპის ქართული სახელმწიფოებრიობა, დემოკრატიული სისტემა შექმნა.",
    briefText:
      'ამ მოვლენის აღსანიშნავად 2023 წლის 25 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის XI-1 კლასის მოსწავლეებმა წარუდგინეს მოხსენებები IX-2 კლასის მოსწავლეებს პროექტის "გიმნაზიელები გიმნაზიელთათვის" ფარგლებში თემებზე:\n1). გზა დამოუკიდებლობისკენ;\n2). რესპუბლიკა და ხალხი;\n3). საშინაო პოლიტიკა;\n4). პირველი რესპუბლიკის დასასრული.\nმოხსენებების დასრულების შემდეგ გაიმართა დებატები საქართველოს მთავრობის მიერ მიღებული საბოლოო გადაწყვეტილების-ემიგრაციაში გამგზავრების აუცილებლობის საკითხის შესახებ.\nღონისძიების ორგანიზატორი იყო ისტორიის პედაგოგი ნატალია სირაბიძე.',
  },
  {
    imageGallery: [],
    image: name240,
    id: 240,
    title: '"ათი მცნება-სიყვარულის კანონი".',
    briefText:
      '2023 წლის 24 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასში ჩატარდა ღონისძიება "ათი მცნება-სიყვარულის კანონი" ( ორგანიზატორები - საღმრთო სჯულის მასწავლებელი მარიამ ჭანტურია, კლასის დამრიგებელი მანანა გოგიბერიძე, მუსიკის მასწავლებელი ლოლა ჯაფარიძე).\nმოსწავლეებმა გამოავლინეს საღვრთო სჯულის გაკვეთილებზე შესწავლილი მასალის, მოსეს ცხოვრების და სინას სჯულდების ცოდნა, იგალობეს, ღონისძიება დატვირთული იყო მუსიკალური ნომრებით.',
  },
  {
    imageGallery: [],
    image: name241,
    id: 241,
    title:
      ',,პოეზიის დედოფალი -ანა კალანდაძე".\n2024 წლის 24 მაისს VII-1 კლასის მოსწავლეების მონაწილეობით გაიმართა პოეტ ანა კალანდაძისადმი მიძღვნილი ღონისძიება ,,პოეზიის დედოფალი -ანა კალანდაძე."',
    briefText:
      "აღნიშნული ღონისძიება მიზნად ისახავდა მოსწავლეთა დეკლამატორული უნარის, მხატვრული კითხვის ოსტატობის წარმოჩენას.\n1945 წლის 24 მაისის დღის პირველი საათი მნიშვნელოვანი თარიღია ანა კალანდაძის ცხოვრებაში. სწორედ ამ დღეს შედგა მისი პოეტური ნათლობა და სიმბოლურად სწორედ ამ თარიღსა და საათს დაამთხვიეს გიმნაზიელებმა ღონისძიება, რომლის კიდევ ერთი მიზანი დამსწრეთათვის, აუდიტორიისათვის, გენიალური პოეტის ცხოვრებისა და შემოქმედების მნიშვნელოვანი ასპექტების გაცნობაც გახლდათ.\nშემოქმედებითი საღამოს ორგანიზატორი იყო ქართული ენისა და ლიტერატურის მასწავლებელი, კლასის ხელმძღვანელი ლუიზა სამსონია.",
  },
  {
    imageGallery: [],
    image: name242,
    id: 242,
    title:
      '"კარგი რამ"- ხელნაწერი ჟურნალი.\n2023 წლის 23 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ბიბლიოთეკაში ჩატარდა VII კლასის მოსწავლეთა ხელნაწერი ლიტერატურული ჟურნალის "კარგი რამ" პრეზენტაცია; ქართული ენისა და ლიტერეტურის მასწავლებელი მარინა მამალაძე.',
    briefText:
      'ჟურნალი მიეძღვნა ილია ჭავჭავაძის მოთხრობას "კაცია-ადამიანი?!"\nმოსწავლეებმა წარმოადგინეს ჟურნალში მოთავსებული სტატიები, განიხილეს ილუსტრაციები, იმსჯელეს პერსონაჟთა ხასიათებსა და მათ ურთიერთობებზე, მწერლის მიერ წამოჭრილი საკითხების აქტუალურობაზე დღევანდელ სიტუაციაში.\nჟურნალზე მუშაობის პროცესი მოსწავლეებს დაეხმარა ნაწარმოების სათქმელის გაგება-გააზრებაში.\nგაწეული სამუშაო შეაფასეს მასწავლებლებმა, მშობლებმა, მერვეკლასელებმა.\nჟურნალი გადაეცა სკოლის ბიბლიოთეკას.',
  },
  {
    imageGallery: [],
    image: name243,
    id: 243,
    title:
      'გიმნაზიელი "მუზეუმის მოყვარულთა კლუბში".\nსსიპ "აჭარის მუზეუმმა" , მუზეუმის საერთაშორის დღე საზეიმოდ აღნიშნა.',
    briefText:
      'ჩატარდა მუზეუმის მოყვარულთა კლუბის პრეზენტაცია , რომელიც აჭარის მუზეუმის დირექტორმა თეონა ზოიძემ და მოადგილე ინგა გოგიბერიძემ წარადგინეს, ღონისძიებას აჭარის განათლების, კულტურისა და სპორტის მინისტრის მოადგილე აკაკი ძნელაძე დაესწრო.\n"მუზეუმის მოყვარულთა კლუბის" წევრები ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებიც არიან.\nწარმატებებს ვუსურვებთ გიმნაზიელებს!',
  },
  {
    imageGallery: [],
    image: name244,
    id: 244,
    title:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის III- 3 კლასში დამრიგებელმა თამარ მექვაბიშვილმა და ქართულის მასწავლებელმა ნინო უგულავამ განახორციელეს პროექტი"ჩემი თვალით დანახული ნოდარ დუმბაძე."',
    briefText:
      'პროექტის ფარგლებში მოსწავლეები\nგაეცნენ ნოდარ დუმბაძის ბიოგრაფიას და შემოქმედებას,\nწაიკითხეს ნაწარმოებები,\nდაესწრნენ სპექტაკლს" ჰელადოს",\nმოეწყო შეხვედრა სპექტაკლის მონაწილე პატარა მსახიობთან , ჩვენივე სკოლის მოსწავლე მიქაელ გოგუაძესთან,\nუყურეს ფილმებს,\nდაიგეგმა და განხორციელდა ექსკურსია ნ. დუმბაძის სახლ- მუზეუმში.\nმოსწავლეებმა იმსჯელეს, დაფიქრდნენ, შეაფასეს, გამოთქვეს მოსაზრებები, სიყვარულის , სიკეთის, ცხოვრებისეული სირთულეების ჟამს იუმორის მნიშვნელობაზე.',
  },
  {
    imageGallery: [],
    image: name245,
    id: 245,
    title: "1 ივნისს ნინოობას აღვნიშნავთ საქართველოში.",
    briefText:
      "სწორედ ამ დღესასწაულის მიეძღვნა დღევანდელი საღვთო სჯულის გაკვეთილი ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის V- 3 კლასში.\nწმ. ანდრია პირველწოდებულის სკოლის შენობაში არსებული ტაძარი წმინდა ნინოს სახელობისაა.\n საღვთო სჯულის მასწავლებელი მარიამ ქორიძე ესაუბრა მოსწავლეებს წმინდა ნინოს საქართველოში შემობრძანებაზე, მის მოციქულებრივ ღვაწლზე, გაიხსენეს, სად არის დაკრძალული წმინდანი, სად ინახება მისი ჯვარი. დაანთეს სანთლები და წმინდა ნინოს ხატთან წარმოთქვეს ტროპარი .",
  },
  {
    imageGallery: [],
    image: name246,
    id: 246,
    title:
      "მხიარულად და სხვადასხვა აქტივობით აღვნიშნეთ ბავშვთა დაცვის საერთაშორისო დღე ჩვენს სკოლაში.",
    briefText:
      "სკოლის ეზოში მოეწყო მოსწავლეთა ნახატების გამოფენა, პლენერზე ხატვა, ჩატარდა ბლიც ტურნირი ჭადრაკში, მთელი დღის განმავლობაში იყო საზეიმო განწყობა, მოსწავლეები იღებდნენ ფოტოებს, ცეკვავდნენ, ისმოდა საბავშვო მელოდიები.",
  },
  {
    imageGallery: [],
    image: name247,
    id: 247,
    title:
      "2023 წლის 2 ივნისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-1 და VI-2 კლასების მოსწავლეები სტუმრობდნენ ბათუმის სახელმწიფო მუსიკალური ცენტრი / Batumi State Music Centre-ის სიმფონიურ ორკესტრს (მუსიკის მასწავლებელი ეკატერინე ბჟინავა, დამრიგებელი მამა გაბრელ კაკაციძე).",
    briefText:
      "მოსწავლეები დაესწრნენ ორკესტრის რეპეტიციას (დირიჟორი მამუკა ალაფიშვილი), ხოლო ორკესტრის წევრებმა მათ გააცნეს საკრავები, მოასმენინეს მცირე მუსიკალური ფრაგმენტები.\nასეთი საინტერესო მუსიკალური გაკვეთილი დიდხანს დაამახსოვრდებათ პატარებს.",
  },
  {
    imageGallery: [],
    image: name248,
    id: 248,
    title:
      "2023 წლის 2 ივნისს ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის მეათე კლასის მოსწავლეებსა და სამოქალაქო განათლების პედაგოგ ანა ანუშიძეს აჭარის ავტონომიური რესპუბლიკის უმაღლესი საბჭო -ში უმასპინძლეს.\nსაგანმანათლებლო ვიზიტი განხორციელდა „კონსტიტუციის გაცნობისა და შესწავლის კვირეულის“ დასკვნითი ღონისძიების ფარგლებში, თემაზე: „საქართველოს, აჭარის ა/რ და აფხაზეთის ა/რ კონსტიტუციები“.",
    briefText:
      "გარდა იმ აქტივობებისა, რომელიც მოსწავლეებმა წარმოადგინეს, მათ უმაღლესი საბჭოს შენობაში ჩაუტარდათ გაცნობითი ხასიათის ექსკურსია, ინტერაქციული ლექციები.\nმე - 10 კლასელებმა აღნიშნეს ჩვენი ქვეყნის უახლესი ისტორიის უმნიშვნელოვანესი თარიღების მნიშვნელობა, წაიკითხეს საქართველოს, აჭარის ა/რ და აფხაზეთის ა/რ კონსტიტუციების პრეამბულები, თითოეული კონსტიტუციის, ზოგადი დებულების თავებიდან ამონარიდები, ისაუბრეს კონსტიტუციების აგებულებაზე და მათ ფუნდამენტურ მნიშვნელობაზე ჩვენი ქვეყნის სახელმწიფოებრიობისა და განვითარების საქმეში.\nმოსწავლეებზე განსაკუთრებული შთაბეჭდილება მოახდინა ინტერაქციულმა ლექციებმა, პრეზენტაციებმა თემებზე: აჭარის ა/რ უმაღლესი საბჭოს ისტორია, ქართული კონსტიტუციონალიზმის საფუძვლები, სახელმწიფო მოწყობის საკითხები, აჭარის ა/რ უმაღლესი საბჭოს ფორმირების წესი და ფუნქციები, აჭარის ა/რ უმაღლესი საბჭოს საერთაშორისო ურთიერთობები და ავტონომიური რესპუბლიკის როლი სახელმწიფოს პოლიტიკურ სისტემაში; კეთილგანწყობილმა გარემომ, ინკლუზიურმა სერვისებმა (წარმოადგინე ან/და შეუერთდი პეტიციას, გააკეთე კომენტარი კანონპროექტზე, მიმართე უმაღლეს საბჭოს, დაესწარი სხდომას, ჩანიშნე შეხვედრა დეპუტატთან, მოითხოვე ელექტრონული საშვი, გაეცანი აჭარის ბიუჯეტს, ჩაერთე საზედამხედველო საქმიანობაში, მიიღე მონაწილეობა საჯარო კონსულტაციებში) რომლებიც ყველა მოქალაქის ჩართულობას უზრუნველყოფს, და, რა თქმა უნდა, ისტორიული შენობის განუმეორებელმა ექსტერიერმა.\nმოსწავლეებმა საჩუქრად მიიღეს აჭარის ა/რ უმაღლესი საბჭოს მიერ მომზადებული მრავალფეროვანი ბუკლეტები და ბროშურები.\nკეთილგანწყობილი მასპინძლობისთვის, საინტერესო ლექციებისა და ინფორმაციული ინტერაქციისთვის განსაკუთრებულ მადლობას ვუხდით: აჭარის ა/რ უმაღლესი საბჭოს საკონსტიტუციო, იურიდიულ და საპროცედური საკითხთა კომიტეტის თავმჯდომარეს, ბატონ ვლადიმერ მგალობლიშვილს, აჭარია ა/რ უმაღლესი საბჭოს საფინანსო უზრუნველყოფისა და შესყიდვების განყოფილების უფროს, ბატონ დავით ბერიძეს, აჭარის ა/რ უმაღლესი საბჭოს, მოქალაქეთა ჩართულობის განყოფილების უფროსს, ქალბატონ ცირა ხაჯიშვილს.",
  },
  {
    imageGallery: [],
    image: name249,
    id: 249,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის სამედიცინო ბიოლოგიის კლუბის წევრებმა (კლუბის ხელმძღვანელი ბიოლოგიის პედაგოგი ქეთევან ხარაბაძე) განახორციელეს პროექტი „რევოლუცია სტომატოლოგიაში“.",
    briefText:
      "ამ მიზნით კლუბის წევრები, X-1 კლასის მოსწავლეები კესარია გათენაძე, ნილა ჯინჭარაძე, ლიკა დავითაძე და ანა დარჩიძე სტუმრობდნენ კლინიკა „სტომა დენტს“, სადაც შეხვდნენ ჩვენი სკოლის კურსდამთავრებულ სტომატოლოგ ანა ჩხენკელს, დაუსვეს მას შეკითხვები, დააკვირდნენ სტომატოლოგის მუშაობის სპეციფიკას, მიიღეს მისგან რჩევები აღნიშნულ თემასთან დაკავშირებით.\nუკვე დასრულებული ნაშრომი გოგონებმა წარუდგინეს მეათე კლასის მოსწავლეებს.\nასე შედგა კიდევ ერთი საინტერესო აქტივობა სასკოლო პროექტის „გიმნაზიელები გიმნაზიელთათვის“ ფარგლებში.",
  },
  {
    imageGallery: [],
    image: name250,
    id: 250,
    title:
      "2023 წლის 10 ივნისს ბათუმში ჩატარდა თამაშის „რა? სად? როდის?“ ევროპულ ტური, რომელშიც ერთმანეთს ეჯიბრებოდა აჭარის რეგიონის 100-ზე მეტი გუნდი.",
    briefText:
      'ძალიან მხიარულ და კონკურენტულ გარემოში ბათუმის წმ. ანდრია პირველწოდებულის სახელობის გუნდმა "გიმნაზიელები" წარმატებით იასპარეზა.\nგუნდის შემადგენლობაში იყვნენ:\nთეკლა შაშიკაძე,\nმარიამ ბოლქვაძე,\nთემო შარაბიძე,\nგიორგი ჩხაიძე,\nსანდრო კალანდაძე,\nაკა ბაკურიძე.\nგილოცავთ!\nგისურვებთ წარმატებებს!',
  },
  {
    imageGallery: [],
    image: name251,
    id: 251,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ბავშვთა უფლებების კვირეულის შემაჯამებელი ღონისძიება გაიმართა. მასწავლებელი - ანა ანუშიძე.",
    briefText:
      "შემაჯამებელი ღონისძიების ფარგლებში, სკოლას ეწვია ბავშვთა უფლებების სპეციალიზაციის და სამოქალაქო სამართლის ადვოკატი, იურისტი ბატონი ბაჩი გაბაიძე, რომელმაც წაიკითხა ინტერაქციული ლექცია ჩვენი მოსწავლეებისთვის, ამომწურავად უპასუხა თითოეული მოსწავლის შეკითხვას და მონაწილეობა მიიღო დაგეგმილ აქტივობებში თემებზე:\nადამიანის უფლებები;\nსამართლებრივი დოკუმენტები;\nადამიანის ღირსება;\nადამიანის მოთხოვნილებები და საჭიროებები;\nდემოკრატიის პრინციპები;\nკოლექტიური უფლებები;\nსამოქალაქო მონაწილეობის კიბე;\nრა არის სამართლებრივი კულტურა;\nსამართლის ძირითადი დარგები და სამართალდამცველები;\nარასრულწლოვანი და კანონი;\nმრავალფეროვანი აქტივობების ფარგლებში, პროექტის ავტორებმა\nგამოიყენეს მულტიმედია რესურსები,\nდილემური ამოცანები\nგააანალიზეს სხვადასხვა პრაქტიკული ქეისი.",
  },
  {
    imageGallery: [],
    image: name252,
    id: 252,
    title:
      "2023 წლის 3 და 4 ივნისს აჭარის მუზეუმი Ajara Museum ორგანიზებით მოსწავლეთა კონფერენცია გაიმართა.\nაჭარის მაშტაბით, მოსწავლეებმა 150 -ზე მეტი ნაშრომი წარადგინეს, რომლებიც თემატიკის მიხედვით, სექციებად განაწილდა.",
    briefText:
      "მოსწავლეთა კონფერენციის მიზანია, მოზარდთა შესაძლებლობების, ნიჭის, მეცნიერული კვლევისა და ანალიტიკის უნარის გამოვლენა.\nკონფერენციის დასასრულს , მონაწილეებსა და პედაგოგებს გადაეცათ სერტიფიკატები.\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები მონაწილებდნენ რამდენიმე სექციის მუშაობაში. მათ წარმატებით წარადგინეს თავიანთი ნაშრომები:\nნუცა ხუციშვილი, ლილე ღომიძე - ბიბლია და მათემატიკა - X კლასი ; \nნილა ჯინჭარაძე, კესარია გათენაძე - ისპანის ჭაობი - X კლასი;\nანანო ხინკილაძე - ზედაპირული და მიწისქვეშა წყლები - X კლასი;\nლუკა უჩანეიშვილი - ტოტალიტარიზმი და ტოტალიტარული მმართველი - IX კლასი;\nელენე ხუჯაძე, დათა ურუშაძე - მეოთხე ფიგურის პრობლემა არისტოტელესთან - X კლასი;\nალექსანდრე ჯელია - ბიბლიოთეკის ელექტრული სისტემა - X კლასი;\nმარიამ გოროზია - ტყუპები IX კლასი;\nმარიამ ბოლქვაძე - „მონა“ ირაკლი ქასრაშვილი -XI კლასი;\nმარიამ ბოლქვაძე - ფარდობითობის თეორია -XI კლასი . \nწარმატებებს ვუსურვებთ ახალგაზრდა მკვლევარებს!",
  },
  {
    imageGallery: [],
    image: name253,
    id: 253,
    title:
      "2023 წლის 21ივნისს საქართველოს უნივერსიტეტის აჭარის რეგიონულ ოფისში გაიმართა ტრენინგი “მედია და დეზინფორმაცია”.\nტრენინგი ჩაატარეს ბატონებმა დავით ქუტიძემ და რატი ახალაიამ.",
    briefText:
      "ტრენინგის მუშაობაში მონაწილეობდნენ ბათუმის წმ.ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები\nანანო ხინკილაძე,\nმართა დუმბაძე,\nელენე ხუჯაძე,\nალექსანდრე ჯელია,\nკესარია გათენაძე,\nნილა ჯინჭარაძე,\nმარიამ გოროზია.\nტრენინგის ბოლოს მოსწავლეებს გადაეცათ სერთიფიკატები.",
  },
  {
    imageGallery: [],
    image: name254,
    id: 254,
    title:
      'დიდი სიხარულით და სიამაყით გვსურს გაუწყოთ, რომ 2023 წლის 26 ივნისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ბიოლოგიის მასწავლებელმა ნანა ჭელიძემ ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U -ში წარმატებით დაიცვა სადოქტორო დისერტაცია თემაზე "D ვიტამინის რეცეპტორის (VDR) გენის as 2228570 პოლიმორფიზმის შესწავლა აუტოიმუნური თირეოიდიტის დროს აჭარის პოპულაციის მაგალითზე" და მიენიჭა ბიილოგიის აკადემიური დოქტორის ხარისხი!',
    briefText:
      'დიდი სიხარულით და სიამაყით გვსურს გაუწყოთ, რომ 2023 წლის 26 ივნისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის ბიოლოგიის მასწავლებელმა ნანა ჭელიძემ ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U -ში წარმატებით დაიცვა სადოქტორო დისერტაცია თემაზე "D ვიტამინის რეცეპტორის (VDR) გენის as 2228570 პოლიმორფიზმის შესწავლა აუტოიმუნური თირეოიდიტის დროს აჭარის პოპულაციის მაგალითზე" და მიენიჭა ბიილოგიის აკადემიური დოქტორის ხარისხი!\nგილოცავთ, ნანა და გისურვებთ წარმატებებს!',
  },
  {
    imageGallery: [],
    image: name255,
    id: 255,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები და-ძმა ელენე და საბა ხუჯაძეები წარმატებული მუსიკოსები არიან.",
    briefText:
      "2023 წლის 5-12 ივნისს ბათუმში გამართულ ახალგაზრდა მუსიკოს-შემსრულებელთა VII რეგიონალურ კონკურსზე საბამ პირველი ადგილი აიღო ფლეიტის, ხოლო ელენემ დიპლომი საოპერო ვოკალის და პირველი ადგილი საგუნდო მიმართულებით.\nსულ ახლახან ახალგაზრდა მუსიკოს-შემსრულებელთა კონკურს-ფესტივალზე „რონდო -კლასიკა“ საბამ პირველი პრემია დაიმსახურა.\nგილოცავთ!\nგისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name256,
    id: 256,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-10 კლასის მოსწავლეებმა 2023 წლის 24 ივნისს მონაწილეობა მიიღეს საქართველოს უნივერსიტეტის მიერ ორგანიზებულ დებატებში, რომელიც კარლ პოპერის წესებით ჩატარდა.\nდებატები დაიმართა ჩვენი სკოლისა და ბათუმის №16 საჯარო სკოლის ორ-ორ გუნდს შორის.",
    briefText:
      "მონაწილეებმა საინტერესო, ცხადე და დაძაბული თამაშის დროს განიხილეს შემდეგი რეზოლუციები:\n-საქართველოში 12 წლიანი სწავლება გამართლებულია;\n- ქალებს ნაკლებად აქვთ განვითარებული ტექნოლოგიური უნარები, ვიდრე კაცებს;\n- სიკვდილით დასჯა გამართლებულია.\nდებატებში მონაწილეობას იღებდნენ:\nნილა ჯინჭარაძე,\nმართა დუმბაძე,\nანანო ხინკილაძე,\nდათა ურუშაძე,\nქრისტინე ანთაძე,\nელენე ხუჯაძე.\nგაიმარჯვება მოიპოვა ჩვენი სკოლის გუნდმა ელენე ჯუხაძის, ქრისტინე ანთაძის და დათა ურუშაძის შემადგენლობით!\nგილოცავთ!\nწარმატებებს გისურვებთ!",
  },
  {
    imageGallery: [],
    image: name257,
    id: 257,
    title:
      'საბერძნეთში ( ერაკლიონში, კუნძული კრეტაზე) 2023 წლის 6-10 ივლისს დასრულდა მე-17 საერთაშორისო ტურნირი კრივში ,,MINOAS CUP" , რომელშიც მონაწილეობდნენ 7 ქვეყნის მოკრივეები.\nპირველი ადგილი 57 კგ წონით კატეგორიაში დაიკავა ჩვენი სკოლის მე-11 კლასის მოსწავლემ ანრი ყულეჯიშვილმა!',
    briefText:
      "ვულოცავთ ანრის ამ შედეგს და მომავალ ბრძოლებში წარმატებებს ვუსურვებთ!",
  },
  {
    imageGallery: [],
    image: name258,
    id: 258,
    title:
      "კვლავ გაგვახარეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებმა ელენე და საბა ხუჯაძეებმა.",
    briefText:
      "2023 წლის 1-7 ივლისს ბორჯომის გამართულ მე-12 საერთაშორისო ფესტივალ-კონკურსზე საბამ პირველი ადგილი აიღო, ხოლო ელენემ ვოკალისა და საგუნდო ფესტივალის საპატიო დიპლომები დაიმსახურა!\nვულოცავთ ნიჭიერ და-ძმას ამ წარმატებას!",
  },
  {
    imageGallery: [],
    image: name259,
    id: 259,
    title:
      "მედალოსანთა დაჯილდოება.\n 2023 წლის 12 ივლისს ბათუმის ღვთისმშობლის შობის სახელობის საკათედრო ტაძარში ბათუმისა და ლაზეთის მიტროპოლიტმა დიმიტრიმ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 2022-2023 სასწავლო წლის წარჩინებული კურსდამთავრებულები ტრადიციულად დააჯილდოვა წმ. ანდრია პირველწოდებულის სახელობის სკოლის მედლებითა და ერთჯერადი სტიპენდიებით!",
    briefText:
      "წლევანდელი მედალოსნები არიან:\nნინი ჭყონია\nთეკლა შაშიკაძე\nალექსანდრე გორდელაძე\nგაბრიელ მურვანიძე\nგიორგი ჩხაიძე\nნუციკო კეკელიძე\nგოგა ქათამაძე\nოთო კახიძე\nანა კვაჭაძე\nთამარ ჩანჩიბაძე\nმარიამ ჭაღალიძე\nლიზი ოგანეზოვა\nგილოცავთ!\nგისურვებთ წარმატებებს!\n#ბათუმისწმინდანდრიაპირველწოდებულისსახელობისსკოლა\n#გიმნაზიისმედალოსნები",
  },
  {
    imageGallery: [],
    image: name260,
    id: 260,
    title:
      "2023 წლის 15 სექტემბერს სასწავლო წლის პირველ დღეს, ბათუმის ღვთისმშობლის შობის სახელობის საკათედრო ტაძარში პირველკლასელთათვის ტრადიციულად ჩატარდა საჯანმრთელო პარაკლისი!",
    briefText:
      "2023 წლის 15 სექტემბერს სასწავლო წლის პირველ დღეს, ბათუმის ღვთისმშობლის შობის სახელობის საკათედრო ტაძარში პირველკლასელთათვის ტრადიციულად ჩატარდა საჯანმრთელო პარაკლისი!",
  },
  {
    imageGallery: [],
    image: name261,
    id: 261,
    title: "2023 წლის 15 სექტემბერი ... \nპირველკასელთა პირველი დღე სკოლაში-",
    briefText:
      "ემოციები,\nპირველი მასწავლებლები,\nახალი მეგობრები,\nსიხარული გამზიარებელი ოჯახის წევრები და ახლობლები,\nსაჩუქრები,\nსაყვარელი ზღაპრების პერსონაჟები,\nყვავილები...",
  },
  {
    imageGallery: [],
    image: name262,
    id: 262,
    title:
      "ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში IX და XI კლასის მოსწავლეებმა მენტორი მასწავლებლის ანა ანუშიძის დახმარებით აღნიშნეს მშვიდობის საერთაშორისო დღე!",
    briefText:
      'მოსწავლეებმა მოისმინეს ლექცია საერთაშორისო სამშვიდობო მისიების შესახებ.\nშექმნეს SWOT ანალიზი სხვადასხვა საერთაშორისო სამშვიდობო მისიაში ჩვენი ქვეყნის მონაწილეობის შესახებ.\nწარადგინეს პეზენტაციები თემაზე: "საქართველოს მონაწილეობა საერთაშორისო სამშვიდობო მისიებში"',
  },
  {
    imageGallery: [],
    image: name263,
    id: 263,
    title: "მხიარული სტარტები",
    briefText:
      "ფეხბურთი და კალათბურთი: VIII-2 და VIII-4 კლასები \nსპორტის მასწავლებელი - დავით ონიაშვილი\n მხიარული სტარტები და სხვა სპორტული აქტივობები: II-2 II-3 კლასები და IV-3 IV-4 კლასები\nსპორტის მასწავლებელი - კარლო ტრაპაიძე\n საბავშვო ფრენბურთი: III-1 vs III-3 კლასები\nსპორტის მასწავლებელი - გივი კერესელიძე\n ხელბურთი: V-3 vs V-4 კლასები\nსპორტის მასწავლებელი - დავით ონიაშვილი\n ხელბურთი: V-1 vs V-2 კლასები \nსპორტის მასწავლებელი - დავით ონიაშვილი\n მხიარული სტარტები: V-1 VS V-2 კლასები \nსპორტის მასწავლებელი - დავით ონიაშვილი",
  },
  {
    imageGallery: [],
    image: name264,
    id: 264,
    title:
      'X-3 კლასის მოსწავლეები ბათუმის დრამატულ თეატრში მიხეილ ჯავახიშვილის პიესის მიხედვით დადგმულ სპექტაკლს "სოფელსა შინა" დაესწრნენ.\nქართული ენისა და ლიტერატურის მასწავლებელი - რუსუდან თავხელიძე\nდამრიგებელი - ზვიად ჩხენკელი',
    briefText:
      'X-3 კლასის მოსწავლეები ბათუმის დრამატულ თეატრში მიხეილ ჯავახიშვილის პიესის მიხედვით დადგმულ სპექტაკლს "სოფელსა შინა" დაესწრნენ.',
  },
  {
    imageGallery: [],
    image: name265,
    id: 265,
    title:
      "1-ლ ოქტემბერს, ბათუმის წმ. ანდრია პირველწოდებულის სახ. სკოლის VIII კლასის მოსწავლეები სტუმრობდნენ სამეგრელოს.",
    briefText:
      "დადიანების მუზეუმში ინტერაქციულ ექსკურსიასთან ერთად მონაწილეობა მიიღეს ინტერგრირებულ აქტივობებში: ინფორმაციის გაანალიზება გუნდური მუშაობის გზით და ასოციაციური რუკების შექმნა და პეზენტაცია, რომლებშიც მათ, მუზეუმის სპეციალისტებთან ერთად, ხელმძღვანელობდნენ:\nგეოგრაფიის მასწავლებელი ანა ანუშიძე და კლასის ხელმძღვანელი - ნატალია ფრუიძე.",
  },
  {
    imageGallery: [],
    image: name266,
    id: 266,
    title:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში გრძელდება პროექტი "გიმნაზიელები გიმნაზიელთათვის".',
    briefText:
      'პროექტის მიზანია, რომ უფროსი ასაკის მოსწავლეებმა თავისი ცოდნა და გამოცდილება გაუზიარონ უმცროსებს!\nამჯერად, 2023 წლის 9 ოქტომბერს გვესტუმრა ჩვენი კურსდამთავრებული ივანე ჯავახიშვილის სახელობის თსუ-ს მაგისტრი, მედია-პლატფორმა "მაუწყებელი"-ს დამფუძნებელი რატი რატიანი.\nშეხვედრის თემა - პოლიტიკის მეცნიერება.\nინტერაქტიული ლექცია კითხვა-პასუხის რეჟიმში გაგრძელდა. რატიმ და მოსწავლეებმა არაერთი მნიშვნელოვანი პრობლემა განიხილეს და გააანალიზეს.\nუღრმეს მადლობას მოვახსენებთ რატის დიდ წარმატებებს ვუსურვებთ მას!',
  },
  {
    imageGallery: [],
    image: name267,
    id: 267,
    title:
      'ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში VII კლასის მოსწავლეებმა მენტორი მასწავლებლის ანა ანუშიძის დახმარებით ისაუბრეს დედამიწის ფორმისა და სიდიდის გეოგრაფიული მნიშვნელობის შესახებ. გაკვეთილზე გამოიყენეს საკუთარი ხელით დამზადებული გლობუსები და საკუთარი ხელით დაამზადეს "მოსწავლის წიგნები".',
    briefText:
      "ამ გზით შეაჯამეს საკითხები:\nდედამიწის ფორმა და სიდიდე;\nგრადუსთა ბადე და გეოგრაფიული კოორდინატები;\nდედამიწის ფორმა და სიდიდე;\nგრადუსთა ბადე და გეოგრაფიული კოორდინატები;\nწარმატებები პატარა გეოგრაფებს!",
  },
  {
    imageGallery: [],
    image: name268,
    id: 268,
    title: "ხელების დაბანის მსოფლიო დღე",
    briefText:
      "15 ოქტომბერი ხელების დაბანის საერთაშორისო დღეა, რომელიც ეძღვნება მოზარდებში ცნობიერების ამაღლებას და გააზრებას თუ რამდენად მნიშვნელოვანია ჰიგიენის დაცვა და ხელების საპნით დაბანა, რაც ეფექტური საშუალებაა დაავადებების თავიდან ასაცილებლად და სიცოცხლის გადასარჩენად.\n13 ოქტომბერს აჭარის საზოგადოებრივი ჯანდაცვის ცენტრის წარმომადგენლები ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-4 და მე-5 კლასის მოსწავლეებს შეხვდნენ და ესაუბრნენ ხელების საპნით დაბანის, როგორც დაავადებისგან თავდაცვის, ეფექტურ საშუალებაზე, თამაშებით წაახალისეს მოზარდები ჰიგიენის ამ მნიშვნელოვანი წესის დასაცავად.",
  },
  {
    imageGallery: [],
    image: name269,
    id: 269,
    title:
      "2023 წლის 24 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახ. სკოლაში, გაერთიანებული ერების ორგანიზაციის საერთაშორისო დღე აღინიშნა გაეროს უშიშროების საბჭოს სხდომის მოდელირებით.",
    briefText:
      "სასწავლო ღონისძიება ორი ნაწილისგან შედგებოდა:\nპირველი ნაწილის ფარგლებში მონაწილეებმა და დამსწრე საზოგადოებამ მოისმინეს ლექცია თემაზე „წმინდა ადგილების როლი საერთაშორისო ურთიერთობებში“.\nმეორე ნაწილის ფარგლებში მოდელირებული სხდომის მონაწილეებმა იმსჯელეს საკითხზე: ისრაელ - პალესტინის კონფლიქტი.\nმოდელირებული სხდომის მონაწილეთა ამოცანა გახლდათ: მშვიდობის დამყარება ახლო აღმოსავლეთში.\nსამუშაო ენა: ქართული ენა და ინგლისური ენა\nმოდელირების ფარგლებში, გაეროს უშიშროების საბჭოს თხუთმეტივე წევრი ქვეყნის წარმომადგენელმა წარადგინა პრეზენტაცია საკუთარი ქვეყნის საგარეო პოლიტიკის ძირითადი პოსტულატების და ქეისთან დაკავშირებული ოფიციალური პოზიციის შესახებ.\nპრეზენტაციებს შემდეგ გაიმართა მსჯელობისა და დისკუსიის პროცესი, რის შედეგადაც გამოკვეთილ რეზოლუციის პუნქტებს, პრეზიდენტი ქვეყნის, ბრაზილიის წარმომადგენლის ხელმძღვანელობით ეყარა კენჭი.\nმოდელირების ფარგლებში მიიღეს 11 პუნქტიანი რეზოლუცია, რაც პრეზიდენტმა ქვეყანამ გააცნო აუდიტორიას.\nგაეროს უშიშროების საბჭოს მოდელირების პროცესში მონაწილე X და XI კლასების მოსწავლეებს გადაეცათ შესაბამისი სერტიფიკატები.\nღონისძიება დაგეგმა და მოამზადა:\nგეოგრაფიის, სამოქალაქო განათლების, ინგლისური ენის მენტორმა მასწავლებელმა საერთაშორისო ურთიერთობების მეცნიერებათა დოქტორმა ანა ანუშიძემ და\nისტორიის უფროსმა მასწავლებელმა, საქართველოს ისტორიის მაგისტრმა ზვიად ჩხენკელმა",
  },
  {
    imageGallery: [],
    image: name270,
    id: 270,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის X-1 კლასის მოსწავლეებმა (ბიოლოგიის მასწავლებელი ქეთევან ხარაბაძე) იმუშავეს სასწავლო-საგანმანათლებლო პროექტზე „საქართველოს მინერალური წყლები“.",
    briefText:
      "ახალგაზრდებმა მოამზადეს მასალა, წარადგინეს აუდიტორიის წინაშე , იმსჯელეს წყლის რესურსების შენარჩუნებაზე, მინერალური წლების მრავალფეროვნებასა და შედგენილობაზე, თითოეულის მნიშვნელობაზე ადამიანის ჯანმრთელობისათვის, წაიკითხეს ეტიკეტები, სადაც მინიშნებულია სხვადასხვა მინერალური წყლის ქიმიური შედგენილობა, ბოლოს კი თავად შექმნეს მინერალური წყალი.",
  },
  {
    imageGallery: [],
    image: name271,
    id: 271,
    title:
      "24 ოქტომბერს მსოფლიო კლიმატის ცვლილების დღეს აღნიშნავს. ამ დღის აღნიშვნის მიზანია კლიმატის ცვლილების შესახებ საზოგადოების ცნობიერების ამაღლება, საფრთხეების გაანალიზება და პრევენციული ღონისძიებების დაგეგმვა ამ პროცესის შესაჩერებლად.",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაც შეუერთდა ამ მნიშვნელოვან ღონისძიებას!\nXI კლასის მოსწავლეებმა რუსუდან კეშელავამ და ალექსანდრე ჯელიამ მეექვსე კლასების მოსწავლეებისთვის ჩაატარეს შემეცნებითი აქტივობა კლიმატის ცვლილების, მისი მოსალოდნელი შედეგების და პრევენციული ღონისძიებების მნიშვნელობის შესახებ.\nპროექტის ავტორი - ბიოლოგიის მასწავლებელი მაია მშველიძე.",
  },
  {
    imageGallery: [],
    image: name272,
    id: 272,
    title:
      "2023 წლის 26 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-2 კლასის მოსწავლეებმა საღვრთო სჯულის მასწავლებელ თამარ ნინიძესთან ერთად შეაჯამეს შესწავლილი მასალა.",
    briefText:
      'მოსწავლეებმა წარმოადგინეს საკუთარი ხელით შექმნილი ესკიზები, ჩანახატები, ილუსტრაციები თემაზე უფლის მიერ ცისა და დედამიწის შექმნა, ქმნილებათა რიგი "შესაქმე" (დაბ.1-2 თ.) . \nპატარებმა საუკეთესოდ წარმოაჩინეს ცოდნა, სასწავლო და შემოქმედებითი უნარები.',
  },
  {
    imageGallery: [],
    image: name273,
    id: 273,
    title:
      "2023 წლის 28 ოქტომბერს აჭარის ავტონომიური რესპუბლიკის სპორტის დეპარტამენტისა და მძლეოსნობის ფედერაციის ორგანიზებით გაიმართა აჭარის პირველობა მძლეოსნობაში.",
    briefText:
      "სიხარულით გვსურს გაუწყოთ, რომ 60 მეტრ გარბენში ორივე საპრიზო ადგილი ჩვენმა საამაყო გოგონებმა მოიპოვეს- I ადგილი დაიკავა ელენე ურუშაძემ , ხოლო II ადგილი - მარიამ ჩხატარაშვილმა! (სპორტის მასწავლებელი დავით ონიაშვილი)\nგილოცავთ და გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name274,
    id: 274,
    title:
      "2023 წლის 29 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა შიდა სასკოლო პირველობს დასკვნითი ეტაპი ჭადრაკში.",
    briefText:
      "გამოვლინდნენ გამარჯვებული - ვაჟთა შორის ძმები დემეტრე და გიორგი გოგიაშვილები, ხოლო გოგონათა შორის - სალომე ბედინაძე. სწორედ ეს სამეული წარადგენს სკოლა 2023 წლის 12 ნოემბერს აჭარის სკოლებს შორის დაგეგმილ პირველობაზე.\nსასკოლო ტურნირის ორგანიზატორი იყო სპორტის მასწავლებელი დავით ონიაშვილი.\nწარმატებებს ვუსურვებთ ჩვენს ახალგაზრდა მოჭადრაკეებს!",
  },
  {
    imageGallery: [],
    image: name275,
    id: 275,
    title:
      "შოკოლადის დღე\n2023 წლის 30 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის ქიმიის მასწავლებლის ირინა ვიდულინას და ბიოლოგიის მასწავლებლის ნანა ჭელიძის ინიციატივით შოკოლადის დღე აღინიშნა!",
    briefText:
      'დღე დატვირთული იყო სხვადასხვა საინტერესო, სახალისო და შემეცნებითი ღონისძიებებით. მათ შორის:\nXI-3 კლასის მოსწავლეებმა თავად დაამზადეს და შეფუთეს შოკოლადები, შემდეგ კი თავიანთი ნახელავით უმცროსკლასელებს გაუმასპინძლდნენ;\nჩატარდა რამდენიმე ინტერაქტიული მინი-ლექცია სხვადასხვა კლასის მოსწავლეებისთვის.\nმომხსენებლები : \nნუცა ნიკოლაიშვილი,\nანანო ფიტკარაძე,\nანა ონიაშვილი,\nდავით ურუშაძე,\nქრისტინე ანთაძე,\nელენე ხუჯაძე,\nანანო ხინკილაძე,\nმართა დუმბაძე.\nახალგაზრდებმა ისაუბრეს შოკოლადის ბიო-ქიმიური შემადგენლობისა და თვისებების შესახებ, ასევე, კაკაოსა და შოკოლადზე მსოფლიო საისტორიო კონტექსტში, უპასუხეს აუდიტორიიდან დასმულ შეკითხვებს, ჩაატარეს ვიქტორინა, იხალისეს, დაარიგეს პრიზები!\nIX-2 კლასის მოსწავლებმა ქიმიის გაკვეთილზე მეხუთე კლასელებისთვის მოამზადეს შოკოლადი, ხოლო პედაგოგებმა ამ "ტკბილი ექსპერიმენტის" საშუალებით რამდენიმე მნიშვნელოვანი თეორიული საკითხი მიმოიხილეს!\nდაწყებითი საფეხურის მოსწავლეებმა მშობლების დახმარებით ტკბილეული მოამზადეს და თანატოლებს დააგემოვნებინეს, ხოლო მასწავლებლებისგან ბევრი სიახლე გაიგეს ტკბილეულის, მათი დამზადების წესის, ზოგადად, კვების კულტურის შესახებ (პედაგოგები რუსუდან თოიძე, რუსუდან ურუშაძე და თამუნა მექვაბიშვილი), შემდეგ კი მოაწყვეს გამოფენა თემაზე: "შოკოლადის სასახლე" (ხელოვნების მასწავლებლები ირინა სევოსტიანოვა და სოფო სანიკიძე).',
  },
  {
    imageGallery: [],
    image: name276,
    id: 276,
    title:
      'შოკოლადის დღის "შოკოლადის სასახლეების" გამოფენა\n2023 წლის 30 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში შოკოლადის დღე აღინიშნა!',
    briefText:
      'სხვა არაერთ ტკბილ და სახალისო ღონისძიებასთან ერთად დაწყებითი საფეხურის მოსწავლეებმა მოაწყვეს გამოფენა თემაზე: "შოკოლადის სასახლე" (ხელოვნების მასწავლებლები ირინა სევოსტიანოვა და სოფო სანიკიძე).',
  },
  {
    imageGallery: [],
    image: name277,
    id: 277,
    title:
      "იაკობ გოგებაშვილის დღეები\n2023 წლის 23-27 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში იაკობ გოგებაშვილის კვირეული აღინიშნა.",
    briefText:
      'მოსწავლეებმა ქართული ენის მასწავლებლების დახმარებით მოამზადეს პრეზენტაციები,\nგაეცნენ მწერლის ბიოგრაფიას,\nწაიკითხეს იაკობ გოგებაშვილის მოთხრობები, გადაიწერეს და ილუსტრაციები შექმნეს.\nუყურეს ფილმს იაკობის ცხოვრების შესახებ და მოისმინეს იაკობი გოგებაშვილის ხმა, ჩატარდა კითხვის და კალიგრაფიის კონკურსი,\nნახეს გოგებაშვილის მოთხრობების მიხედვით შექმნილი ანიმაციური ფილმები, იმსჯელეს,\nისაუბრეს.\nქართული ენის მასწავლებელმა რუსუდან თოიძემ აქტიურობისთვის მოსწავლეებს მადლობის ბარათები გადასცა.\n"იაკობ გოგებაშვილის დღეების" ორგანიზატორები იყვნენ ქართული ენისა და ლიტერატურის მასწავლებლები რუსუდან თოიძე, თეა ქორჩილავა, თეონა ლორთქიფანიძე, მაია იმნაძე, ნინო უგულავა.',
  },
  {
    imageGallery: [],
    image: name278,
    id: 278,
    title:
      "2023 წლის 5 ნოემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მე-11 კლასის მოსწავლეები იმყოფებოდნენ ბათუმის მერიის მიერ ორგანიზებულ ექსკურსიაზე იმერეთში.",
    briefText:
      "მოსწავლეებმა დაათვალიერეს ვანის არქეოლოგიური მუზეუმ-ნაკრძალი და გამოფენა „ოქრომრავალი კოლხეთი“, ბაგრატის ტაძარი, მოწამეთასა და გელათის სამონასტრო კომპლექსები.",
  },
  {
    imageGallery: [],
    image: name279,
    id: 279,
    title:
      "2023 წლის 6 ნოემბერს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის IV-3 კლასი მოსწავლეები ხელოვნების მასწავლებელ ირინა სევოსტიანოვასა და დამრიგებელ თამუნა მექვაბიშვილთან ერთად ეწვივნენ ხელოვნების მუზეუმს.",
    briefText:
      "მუზეუმის გიდმა თეონა ქინქლაძემ მოსწავლეებისთვის საგანმანათლებლო პროგრამა “პორტრეტი” წარმართა.\nბავშვებმა გადაიღეს სამახსოვრო ფოტოები; პროგრამის ბოლოს აჭარის მუზეუმის ადმინისტრაციისგან მასწავლებლებს გადაეცათ სერტიფიკატები.",
  },
  {
    imageGallery: [],
    image: name280,
    id: 280,
    title:
      "2023 წლის 12 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა გუნდი მონაწილეობდა ბათუმის სკოლათა შორის გამართულ საჭადრაკო ფესტივალში.",
    briefText:
      "სკოლა წარადგინეს შიდა სასკოლო ტურნირის გამარჯვებულმა ძმებმა დემეტრე და გიორგი გოგიაშვილებმა და ნუცა ნიკოლაიშვილმა.\nტურნირისთვის გუნდს ამზადებდა სპორტის მასწავლებელი დავით ონიაშვილი.\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის გუნდმა მეორე საპრიზო ადგილი დაიკავა!\nწარმატებებს ვუსურვებთ ჩვენს ახალგაზრდა მოჭადრაკეებს!",
  },
  {
    imageGallery: [],
    image: name281,
    id: 281,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის V კლასის მოსწავლეები დამრიგებელ ირინა ვიდულინასთან ერთად ესწრებოდნენ"მხიარული მეცნიერების ’’ მიერ ორგანიზებულ საბავშვო სამეცნიერო შოუს „დიდი კოსმოსური მოგზაურობა“.',
    briefText:
      "პატარებმა იმოგზაურეს კოსმიური სამყარო იდუმალებითაა მოცულ ლაბირინთებში!\nსამეცნიერო ექპერიმენტების მეშვეობით ისაუბრეს და ნახეს რა არის უწონადობა და ვაკუუმი?\nრისგან შედგება მზე და როგორია გეიზერები სხვადასხვა პლანეტებზე. თავისი ხელით გააკეთეს მეტეორიტებს, მოაწყვეს ვულკანის ამოფრქვევა ვენერაზე და შეხვდნენ მარსიანელებს!\nსაინტერესო და შემეცნებითი ყველა ექსპერიმენტი აბსოლუტურად უსაფრთხო იყო!",
  },
  {
    imageGallery: [],
    image: name282,
    id: 282,
    title: "14 ნოემბერი ასტრიდ ლინდგრენის დაბადების დღეა.",
    briefText:
      '"ჩემში ცხოვრობს ბავშვი, რომელსაც გაზრდა არ უნდა"-ხშირად ამბობდა მწერალი.\nამ დღის აღსანიშნავად II-4 კლასის მოსწავლეებმა სიხარულით მოირგეს პერსონაჟების კოსტიუმები.\nქართული ენისა და ლიტერატურის მასწავლებელ რუსუდან თოიძესთან ერთად წაიკითხეს ეპიზოდები ნაწარმოებებიდან, უყურეს მულტიპლიკაციურ ფილმებს.',
  },
  {
    imageGallery: [],
    image: name283,
    id: 283,
    title:
      '2023 წლის 16 ნოემბერს ბათუმის საჯარო ბიბლიოთეკის საბავშვო-ახალგაზრდობის განყოფილებაში ასტრიდ ლინდგრენის საიუბილეო დღეების ფარგლებში, კლუბ "საზღაპრეთში" შვედი მწერლის ნაწარმოებებიდან გადმოსული გმირები "გამოჩნდნენ": საოცარი კარლსონები, გოგონები პეპის გრძელი წინდებითა და კიკინებითა და საოცარი განწყობა შექმნეს.',
    briefText:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მესამე კლასის მოსწავლეებს, მათ მშობლებსა და პედაგოგებს (რუსუდან თოიძე და ლამარა გოგიბერიძე) განყოფილების ხელმძღვანელმა თინა ცენტერაძემ და მთავარმა ბიბლიოთეკარებმა ლელა სურმანიძემ და ნანა კვაჭაძემ უმასპინძლეს, მოზარდებს საყვარელი მწერლის იუბილე მიულოცეს, სკოლისა და ბიბლიოთეკის ურთიერთობაზე, წიგნის კითხვისა და ბიბლიოთეკაში სიარულის მნიშვნელობაზე ესაუბრეს.\nლელა სურმანიძემ მოსწავლეებს შვედი საბავშვო მწერლის უკეთ გასაცნობად კი მოკლემეტრაჟიანი ფილმი, ასტრიდ ლინდგრენი - "ბავშვი ჩემში" წარუდგინა.\nთავის მხრივ, მოსწავლეებმა ლინდგრენის ნაწამოებებიდან საყვარელი ამონარიდები წაიკითხეს, ზღაპრებიდან რამდენიმე ეპიზოდი დიდი ოსტატობით გააცოცხლეს.',
  },
  {
    imageGallery: [],
    image: name284,
    id: 284,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ასტრიდ ლინდგრენის საიუბილეო კვირეულის ფარგლებში არაერთი მხიარული და შემეცნებითი ღონისძიებით გაახარა პატარები დაწყებითი საფეხურის ქართული ენის მასწავლებელმა მაია იმნაძემ.",
    briefText:
      "I-3, II-1, IV-2, IV-4 კლასის მოსწავლეებმა ასტრიდ ლინდგრენის პერსონაჟები გააცოცხლეს, ნახეს ფრაგმენტები მწერალზე გადაღებული ფილმებიდან, წაიკითხეს ნაწარმოებები, მიწერეს წერილები პეპისა და კარლსონს.",
  },
  {
    imageGallery: [],
    image: name285,
    id: 285,
    title:
      "2023 წლის 24 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში საყმაწვილო, სასკოლო თეატრალური დასების ფესტივალ „პირველი ავტოგრაფი“-ს პროგრამის ფარგლებში სტუმრად მობრძანდნენ ჟიურის წევრები: თავჯდომარე გია კიტია - რეჟისორი, პოეტი ტარიელ ხარხელაური, მსახიობი ნანული სარაჯიშვილი, თანატოლი ჟიური მარიამ ხუჯაძე.",
    briefText:
      "ძვირფას სტუმრებს ფესტივალის გულშემატკივრებთან ერთად შეხვდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები და პედაგოგები.\nსაინტერესო შეხვედრა უაღრესად თბილ, უშუალო გარემოში კითხვა-პასუხის რეჟიმში წარიმართა. სტუმრებმა ჩვენი სკოლის სპექტაკლის აფიშაზე საკუთარი ავტოგრაფებიც დაგვიტოვეს.",
  },
  {
    imageGallery: [],
    image: name286,
    id: 286,
    title: 'ფესტივალი "პირველი ავტოგრაფი"!',
    briefText:
      '2023 წლის 27 ნოემბერი\nბათუმის წმ.ანდრია პირველწოდებულის სახელობის სკოლა\n"სპექტაკლის რეპეტიცია, ანუ ბოლო ზარი, იგივე ცისფერი ამბები" (ჯემალ ქარჩხაძის "მაღალი კაცი"-ს მიხედვით)\nინსცენირების ავტორი მარინა ტალახაძე',
  },
  {
    imageGallery: [],
    image: name287,
    id: 287,
    title:
      '2023 წლის 28 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში V-2 კლასის მოსწავლეებმა კლასის დამრიგებელ ირინა სევოსტიანოვას, პედაგოგების ეკა ბჟინავას და კახი კახიძის დახმარებით წარმოადგინეს საგანმანათლებლო, აკადემიური და საინტერესო მინი სპექტაკლი "ჩემი სამშობლო საქართველოა".',
    briefText:
      '2023 წლის 28 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში V-2 კლასის მოსწავლეებმა კლასის დამრიგებელ ირინა სევოსტიანოვას, პედაგოგების ეკა ბჟინავას და კახი კახიძის დახმარებით წარმოადგინეს საგანმანათლებლო, აკადემიური და საინტერესო მინი სპექტაკლი "ჩემი სამშობლო საქართველოა".',
  },
  {
    imageGallery: [],
    image: name288,
    id: 288,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე ტარიელ მანველიძე რამდენიმე წელია აქტიური სპორტული ცხოვრებით არის დაკავებული!",
    briefText:
      "დიდი შრომის შედეგიც სახეზეა- ჩვენი საამაყო მორკინალი პირველი ადგილის მფლობელი გახდა რესპუბლიკურ ტურნირზე!\nგილოცავთ, ტარიელ და გისურვებთ წარმატებებს! ",
  },
  {
    imageGallery: [],
    image: name289,
    id: 289,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე ანდრია ტუღუში ნოდარ ჭანუყვაძის ხსოვნის დღისადმი მიძღვნილ ტურნირზე ბერძნულ-რომაული ჭიდაობაში პირველი ადგილის მფლობელი გახდა.",
    briefText: "გილოცავთ ანდრია და გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name290,
    id: 290,
    title:
      "25 ნოემბერი გაერო-ს გენერალურ ასამბლეას ქალთა მიმართ ძალადობის წინააღმდეგ ბრძოლის საერთაშორისო დღედ აქვს გამოცხადებული.\nამ დღესთან დაკავშირებით, VIII-3 კლასის მოსწავლეებმა მოქალაქეობის გაკვეთილზე მასწავლებელ ინგა მართალიშვილის ხელმძღვანელობით წარმოადგინეს პრეზენტაცია ,,არ გაჩუმდე!’’.",
    briefText:
      "პროექტის მიზანი ცნობადობის ამაღლებაა იმ ფაქტის მიმართ, რომ ქალები მთელ მსოფლიოში ხდებიან ფიზიკური, ფსიქოლოგიური, ოჯახში ძალადობისა და სხვა სახის ძალადობის მსხვერპლინი.\nმოსწალეებმა განიხილეს პრობლებმის მასშტაბურობა და ის სინამდვილე, რომელიც ხშირად დამალული რჩება.\nრეგიონში არსებული თავისებურებების უკეთ გაცნობის მიზნით მოსწავლეები ეწვივნენ საქველმოქმედო ფონდ ,,იალქანს.’’ ფონდი 2015 წლიდან ფსიქოლოგიურ და იურიდიულ დახმარებას უწევს მარტოხელა დედებსა, ძალადობის მსხვერპლ ქალებსა და მათ შვილებს. კითხვაზე, თუ რამდენად ხშირია ოჯახში ძალადობის კუთხით მომართვიანობის ფაქტები, ქალბატონმა თიკა აბაშიძემ, რომელიც დღის ცენტრის დირექტორია, ბრძანა რომ კვირაში საშუალოდ 22 ფაქტი ფიქსირდება მათთან.\nმოსწავლეები გამოსავალს განათლებაში, ცნობიერების ამაღლებასა და საზოგადოების მხრიდან მეტ მხარდაჭერაში ხედავენ.",
  },
  {
    imageGallery: [],
    image: name291,
    id: 291,
    title:
      '2023 წლის 1 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-2 კლასში ჩატარდა ღია გაკვეთილი თემაზე "პროფესიები"; ქართული ენისა და ლიტერატურის მასწავლებელი ნინო უგულავა.',
    briefText:
      "პატარებმა სხვადასხვა პროფესიის წარმომადგენლებად წარადგინეს თავი, ისაუბრეს ამა თუ იმ სფეროს დიდ პროფესიონალებზე, ასევე, დღეს გამქრალ პროფესიებზე და სხვა.",
  },
  {
    imageGallery: [],
    image: name292,
    id: 292,
    title:
      "დიდი სიხარულით ვულოცავთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-4 კლასის მოსწავლესანასტასია მიქაბერიძეს აჭარის ჩემპიონატზე ტანვარჯიშში პირველი ადგილის დაკავებას და ვუსურვებთ მომავალ დიდ წარმატებებს!",
    briefText:
      "დიდი სიხარულით ვულოცავთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-4 კლასის მოსწავლესანასტასია მიქაბერიძეს აჭარის ჩემპიონატზე ტანვარჯიშში პირველი ადგილის დაკავებას და ვუსურვებთ მომავალ დიდ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name293,
    id: 293,
    title:
      'პირველი ავტოგრაფი • "The First Autograph" – "სპექტაკლის რეპეტიცია, იგივე ბოლო ზარი, ანუ ცისფერი ამბები".',
    briefText:
      'პირველი ავტოგრაფი • "The First Autograph" – "სპექტაკლის რეპეტიცია, იგივე ბოლო ზარი, ანუ ცისფერი ამბები".',
  },
  {
    imageGallery: [],
    image: name294,
    id: 294,
    title:
      "ძვირფასო მეგობრებო, მოსწავლეებო, მშობლებო, კოლეგებო!\nხვალ, 2023 წლის 7 დეკემბერს, 14:00 სთ-დან ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ტარდება ტრადიციული მოსწავლეთა სასწავლო-შემოქმედებითი კონფერენცია!",
    briefText:
      'გიზიარებთ თემატიკას:\nსაზოგადოებრივ მეცნიერებათა სექცია\nTrash to treasure, როგორ აქცია შვედეთმა ნარჩენები სიმდიდრედ - ნარჩენების მართვის საუკეთესო პრაქტიკა- ანანო ფუტკარაძე, ნუცა ნიკოლაიშვილი, XI კლასი, ხელმძღვანელი ანა ანუშიძე;\nდროის მენეჯმენტი - რუსუდან კეშელავა, სანდრო შაინიძე, XI კლასი, ხელმძღვანელი ანა ანუშიძე;\n1922 წელს საქართველოს დამოუკიდებლობის დღისადმი მიძღვნილი მანიფესტაცია ბათუმში - მოსწავლეები კესარია გათენაძე და ნუცა ხუციშვილი, XI კლასი, ხელმძღვანელი ზვიად ჩხენკელი;\nომი, ბავშვები და თანამედროვეობა მოსწავლე- ლუკა უჩანეიშვილი , Xკლასი, ხელმძღვანელი ხათუნა ბერაძე;\nჟურნალი "ტაიმი" და მეოცე საუკუნის რუსეთის და სსრკ-ს ისტორია 1917 წლიდან - ლიკა ჯოხაძე, XI კლასი, ხელმძღვანელი პირიმზე რურუა;\nმემკვიდრეობის სამართალი ძველ რომსა და თანამედროვე საქართველოში, ნინო თურმანიძე, ნიკოლოზ გოგოლაძე, XI კლასი, ხელმძღვანელი ლევან სამსონია.\nქალი ტრადიციული საზოგადოებაში (საქართველოს მაგალითზე) , მარიამ გოროზია, X კლასი, ხელმძღვანელი სალომე მიქაძე;\nეკოლოგიის და ქიმიის სექცია, მოდერატორი მაია მშველიძე\nენერგოეფექტურობა მდგრადი განვითარებისთვის, ნინო თურმანიძე, დათა ურუშაძე, XI კლასი, ხელმძღვანელი ინგა მართალიშვილი.\n"პური ჩვენი არსობისა", ანი ონიაშვილი, Xკლასი, ხელმძღვანელი ირინა ვიდულინა;\n"მედიკამენტების ალტერნატივა" , ბარბარე მიქავა, IXკლასი, ხელმძღვანელი ირინა ვიდულინა;\n"კბილის პასტების ხარისხი" , ბარბარე ბარამიძე, IXკლასი, ხელმძღვანელი ირინა ვიდულინა;\n"მიწისქვეშა წყლები", ეკატერინე მგალობლიშვილი, IXკლასი, ხელმძღვანელი ირინა ვიდულინა;\nმათემატიკის, ფიზიკის და ისტ-ის სექცია , მოდერატორი ანა სლუსარევა\nპითაგირას თეორემის საიდუმლოებანი, ანა ნაცვლიშვილი და ელენე ზანთარაია X კლასი, ხელმძღვანელი გიული გელაშვილი;\nალბათობის თეორია. შესაძლებელია თუ არა ეროვნული გამოცდების ჩაბარება პასუხის ამოცნობის მეთოდით ? - ლუკა უჩანეიშვილი , ანა ონიაშვილი X კლასი, ხელმძღვანელი ანა სლიუსარევა;\nმთვარე და ისტორია ; მარიამ გორიზია, ანანო ფუტკარაძე; X და XI კლასი, ხელმძღვანელი კახი კახიძე;\nვარსკვლავის წარმოქმნა; კესო გათენაძე, ნილა ჯინჭარაძე, XI კლასი, ხელმძღვანელი კახი კახიძე;\nნებულები, ალექსანდრე ჯელია, XI კლასი, ხელმძღვანელი კახი კახიძე;\nმაიონიზირებელი რადიაცია და მისი გამოყენება მედიცინაში, გვანცა ალელიშვილი, IX კლასი, ხელმძღვანელი მაიკო ბოლქვაძე.\nგელოდებით!',
  },
  {
    imageGallery: [],
    image: name295,
    id: 295,
    title:
      "2023 წლის 7 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა ტრადიციული მოსწავლეთა სასწავლო-შემოქმედებითი კონფერენცია!მოსწავლეებმა რამდენიმე სექციაში უაღრესად საინტერესო ნაშრომები წარმოადგინეს:",
    briefText:
      'საზოგადოებრივ მეცნიერებათა სექცია\nTrash to treasure, როგორ აქცია შვედეთმა ნარჩენები სიმდიდრედ - ნარჩენების მართვის საუკეთესო პრაქტიკა- ანანო ფუტკარაძე, ნუცა ნიკოლაიშვილი, XI კლასი, ხელმძღვანელი ანა ანუშიძე;\nდროის მენეჯმენტი - რუსუდან კეშელავა, სანდრო შაინიძე, XI კლასი, ხელმძღვანელი ანა ანუშიძე;\n1922 წელს საქართველოს დამოუკიდებლობის დღისადმი მიძღვნილი მანიფესტაცია ბათუმში - მოსწავლეები კესარია გათენაძე და ნუცა ხუციშვილი, XI კლასი, ხელმძღვანელი ზვიად ჩხენკელი;\nომი, ბავშვები და თანამედროვეობა მოსწავლე- ლუკა უჩანეიშვილი , Xკლასი, ხელმძღვანელი ხათუნა ბერაძე;\nჟურნალი "ტაიმი" და მეოცე საუკუნის რუსეთის და სსრკ-ს ისტორია 1917 წლიდან - ლიკა ჯოხაძე, XI კლასი, ხელმძღვანელი პირიმზე რურუა;\nმემკვიდრეობის სამართალი ძველ რომსა და თანამედროვე საქართველოში, ნინო თურმანიძე, ნიკოლოზ გოგოლაძე, XI კლასი, ხელმძღვანელი ლევან სამსონია.\nქალი ტრადიციული საზოგადოებაში (საქართველოს მაგალითზე) , მარიამ გოროზია, X კლასი, ხელმძღვანელი სალომე მიქაძე;\nეკოლოგიის და ქიმიის სექცია, მოდერატორი მაია მშველიძე\nენერგოეფექტურობა მდგრადი განვითარებისთვის, ნინო თურმანიძე, დათა ურუშაძე, XI კლასი, ხელმძღვანელი ინგა მართალიშვილი.\n"პური ჩვენი არსობისა", ანი ონიაშვილი, Xკლასი, ხელმძღვანელი ირინა ვიდულინა;\n"მედიკამენტების ალტერნატივა" , ბარბარე მიქავა, IXკლასი, ხელმძღვანელი ირინა ვიდულინა;\n"კბილის პასტების ხარისხი" , ბარბარე ბარამიძე, IXკლასი, ხელმძღვანელი ირინა ვიდულინა;\n"მიწისქვეშა წყლები", ეკატერინე მგალობლიშვილი, IXკლასი, ხელმძღვანელი ირინა ვიდულინა;\nმათემატიკის, ფიზიკის და ისტ-ის სექცია , მოდერატორი ანა სლუსარევა\nალბათობის თეორია. შესაძლებელია თუ არა ეროვნული გამოცდების ჩაბარება პასუხის ამოცნობის მეთოდით ? - ლუკა უჩანეიშვილი , ანა ონიაშვილი X კლასი, ხელმძღვანელი ანა სლიუსარევა;\n2.. მთვარე და ისტორია ; მარიამ გორიზია, ანანო ფუტკარაძე; X და XI კლასი, ხელმძღვანელი კახი კახიძე;\n3.. ვარსკვლავის წარმოქმნა; კესო გათენაძე, ნილა ჯინჭარაძე, XI კლასი, ხელმძღვანელი კახი კახიძე;\nნებულები, ალექსანდრე ჯელია, XI კლასი, ხელმძღვანელი კახი კახიძე;\nმაიონიზირებელი რადიაცია და მისი გამოყენება მედიცინაში, გვანცა ალელიშვილი, IX კლასი, ხელმძღვანელი მაიკო ბოლქვაძე.\nწარმატებებს ვუსურვებთ ჩვენს ახალგაზრდა მკვლევარებს!',
  },
  {
    imageGallery: [],
    image: name296,
    id: 296,
    title:
      '2023 წლის 9 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 კლასში რუსული ენის მასწავლებელმა ევგენია ლომაძემ განსხვავებული და დასამახსოვრებელი გაკვთილი თემაზე ა.ს. პუშკინის " ოქროს თევზი" არასასკოლო გარემოში ჩაატარა.\nგაკვეთილი უაღრესად საინტერესოდ წარიმართა.',
    briefText:
      "მოსწავლეები დაიყვნენ ორ ჯგუფად , წარადგინეს პრეზენტაციები თემის ფარგლებში, ნასწავლი ლექსიკური ერთეულების გამოყენებით დაახასიათეს მთავარი პერსონაჟები, მოსმენილი ტექსტის მიხედვით დანომრეს ილუსტრაციები ქრონოლოგიური თანმიმდევრობით. შემდეგ კი დაათვალიერეს ბათუმის აკვარიუმი (დამრიგებელი ნონა აბაშიძე).",
  },
  {
    imageGallery: [],
    image: name297,
    id: 297,
    title:
      '2023 წლის 10 დეკემბერს 14:00 საათზე ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ქართული კულტურის შემწავლელთა კლუბში შედგა შეხვედრა თემაზე "ზნენი სამამაცონი"- ქართული ტრადიციული საბრძოლო ხელოვნება.\nშეხვედრა წარმართა კლუბის ხელმძღვანელმა პირიმზე რურუამ.',
    briefText:
      'ამჯერად კლუბს სტუმრობდნენ ყველასათვის ცნობილი ქორეოგრაფი, აჭარის დამსახურებული არტისტი, ბათუმის ხელოვნების დამსახურებული მოღვაწე, ენვერ ხაბაძის სახელობის ქართული ნაციონალური ცეკვის სახელმწიფო აკადემიური ანსამბლ "ბათუმის" რეპეტიტორ- ქორეოგრაფი ქალბატონი მირანდა ბაღდადიშვილი, რომელმაც სიღრმისეულად ისაუბრა ქართულ ცეკვებში ასახულ სარაინდო-საგმირო თემატიკის შესახებ და ბატონი გივი კერესელიძე - აჭარის ა.რ.კრივის ფედერაციის გენერალური მდივანი,სერტიფიცირებული მწვრთნელი კრივში, კიკ-ბოქსინგსა და ჩინურ ორთაბრძოლა სან-დაში.\nბატონი გივის მეთვალყურეობით მოსწავლეებმა აღადგინეს ქართული ტრადიციული კრივის ილეთები.\nუაღრესად საინტერესო იყო ყოფილი გიმნაზიელის, ამჟამად საერთაშორისო სამართლის სპეციალისტის, ქართული ტრადიციული ორთაბრძოლების დიდი მოყვარულის გიორგი ლაზარიაშვილის ონლაინჩართვა. გიორგიმ საკუთარი ხედვა და გამოცდილება გაუზიარა მსმენელებს.',
  },
  {
    imageGallery: [],
    image: name298,
    id: 298,
    title:
      "2023 წლის 11-15 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში სასკოლო-სასწავლო გეგმის შესაბამისად VI-XI კლასებში მიმდინარეობს სადიაგნოსტიკო-რეიტინგული წერების კვირეული.",
    briefText:
      "კვირეული ტარდება ყოველი სასწავლო წლის დეკემბერში და ივნისში. წერის მიზანს წარმოადგენს აღნიშნულ კლასებში ცალკეულ საგანში სწავლა-სწავლების ხარისხის მონიტორინგი, შეფასება და სტრატეგიული დაგეგმვა.\nწარმატებებს ვუსურვებთ ჩვენს გიმნაზიელებს!",
  },
  {
    imageGallery: [],
    image: name299,
    id: 299,
    title:
      "ვულოცავთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-5 კლასის მოსწავლე ოთარ შაინიძეს პირველი ადგილის დაკავებას გოდერძი ბოლქვაძის ხსოვნის დღისადმი მიძღვნილ საჭიდაო ტურნირზე, რომელიც გაიმართა 2023 წლის 10 დეკემბერს ხულოში და მონაწილეობას იღებდნენ საქართველოს სხვადასხვა კუთხის წარმომადგენლები. ოთარ, გისურვებ წარმატებებს!",
    briefText:
      "ვულოცავთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-5 კლასის მოსწავლე ოთარ შაინიძეს პირველი ადგილის დაკავებას გოდერძი ბოლქვაძის ხსოვნის დღისადმი მიძღვნილ საჭიდაო ტურნირზე, რომელიც გაიმართა 2023 წლის 10 დეკემბერს ხულოში და მონაწილეობას იღებდნენ საქართველოს სხვადასხვა კუთხის წარმომადგენლები. ოთარ, გისურვებ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name300,
    id: 300,
    title:
      "კვლავ გაგვახარა მორიგი სპორტული წარმატებით ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე ტარიელ მანველიძემ, რომელიც კახაბერ ზარნაძის სახელობის ჩემპიონატზე ქართული საბრძოლო ხელოვნების სახეობა-შერეულ კრივში პირველი ადგილის მფლობელი გახდა და დაჯილდოვდა მედლითა და სიგელით!\n ვულოცავთ ტატოს და ვუსურვებთ მომავალ დიდ წარმატებებს!",
    briefText:
      "კვლავ გაგვახარა მორიგი სპორტული წარმატებით ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე ტარიელ მანველიძემ, რომელიც კახაბერ ზარნაძის სახელობის ჩემპიონატზე ქართული საბრძოლო ხელოვნების სახეობა-შერეულ კრივში პირველი ადგილის მფლობელი გახდა და დაჯილდოვდა მედლითა და სიგელით! ვულოცავთ ტატოს და ვუსურვებთ მომავალ დიდ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name301,
    id: 301,
    title:
      "ვულოცავთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეს ელენე ურუშაძეს და მის მასწავლებელს დავით ონიაშვილს მნიშვნელოვან წარმატებას ბათუმის მასობრივი სპორტის ფედერაციის მიერ ჩატარებულ შეჯიბრზე მძლეოსნობაში , სადაც ელენემ 100 მეტრიან დისტანციაზე გარბენში პირველი ადგილი, ხოლო 60 მეტრიან დისტანციაზე გარბენში - მეორე ადგილი დაიკავა!",
    briefText: "ელენე, გისურვებთ დიდ სპორტულ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name302,
    id: 302,
    title: "საახალწლო ვერნისაჟი",
    briefText:
      "მართლაც ზამთრის ზღაპარში გვამოგზაურეს ჩვენმა პატარებმა და საოცარი განწყობა შექმნეს საახალწლოდ (პედაგოგები ირინა სევოსტიანოვა და სოფო სანიკიძე)",
  },
  {
    imageGallery: [],
    image: name303,
    id: 303,
    title:
      "ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტის ზუსტ მეცნიერებათა და განათლების ფაკულტეტის ორგანიზებით, სკოლისა და უნივერსიტეტის თანამშრომლობის კლუბის „სკოლა-უნივერსიტეტი“ ფარგლებში, მეათე სამეცნიერო კონფერენცია გაიმართა თემაზე: „სასკოლო განათლება - თანამედროვე გამოწვევები და პერსპექტივები“.",
    briefText:
      'კონფერენციაზე ბათუმის შოთა რუსთაველის სახელობის სახელმწიფო უნივერსიტეტის სტუდენტებთან ერთად ნაშრომი წარმოადგინა ბათუმის წმ.ანდრია პირველწოდებულის სკოლის XI-3 კლასის მოსწავლე ანანო ხინკილაძემ თემაზე " ქართული თაფლი, როგორც ძლიერი ანტიოქსიდანტი" ; ხელმძღვანელი ქიმიის პედაგოგი ნონა აბაშიძე.',
  },
  {
    imageGallery: [],
    image: name304,
    id: 304,
    title:
      "დამდეგი ახალი წლის დღეებში ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV -4 კლასის მოსწავლეები თავიანთ პედაგოგებთან ნინო თალაკვაძესა და ეკატერინე ბჟინავასთან ერთად სტუმრად იყვნენ წმ. დიდმოწამე ეკატერინეს სახელობის სათნოების სავანეში.",
    briefText:
      "პატარებმა სითბო, სიყვარული, სიმღერა, ლექსი არ დაიშურეს სავანის მობინადრეებისთვის, მიულოცეს მათ დამდეგი შობა-ახალი წელი!",
  },
  {
    imageGallery: [],
    image: name305,
    id: 305,
    title:
      'უდიდესი სიხარულით გვსურს გაუწყოთ, რომ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის სპორტის მასწავლებელი დავით ონიაშვილი ბათუმის მერიის მიერ გამოცხადებულ კონკურსის შედეგად აღიარებულია, როგორც "წლის ფიზიკური აღზრდისა და სპორტის მასწავლებელი"!\n(წარმდგენი- ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა)',
    briefText: "გილოცავთ, დავით და გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name306,
    id: 306,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-2 კლასის მოსწავლემ ზაზა ცეცხლაძემ პირველი ადგილი დაიკავა რაზმიკ პეტროსიანის ხსოვნისადმი მიძღვნილ ღია პირველობაზე კრივში!გილოცავთ, ზაზა, სპორტულ მიღწევას და გისურვებთ წარმატებას !",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-2 კლასის მოსწავლემ ზაზა ცეცხლაძემ პირველი ადგილი დაიკავა რაზმიკ პეტროსიანის ხსოვნისადმი მიძღვნილ ღია პირველობაზე კრივში!გილოცავთ, ზაზა, სპორტულ მიღწევას და გისურვებთ წარმატებას !",
  },
  {
    imageGallery: [],
    image: name307,
    id: 307,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI კლასის მოსწავლე ელენე დავითაძემ მეორე საპრიზო ადგილი დაიკავა შიდა სპორტულ პირველობაზე მხატვრულ ტანვარჯიშში, რომელიც ჩატარდა მუხრან ვახტანგაძის სახელობის ბათუმის სპორტის სასახლეში!\nგილოცავთ, ელენე, სპორტულ მიღწევას და გისურვებთ წარმატებებს!",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI კლასის მოსწავლე ელენე დავითაძემ მეორე საპრიზო ადგილი დაიკავა შიდა სპორტულ პირველობაზე მხატვრულ ტანვარჯიშში, რომელიც ჩატარდა მუხრან ვახტანგაძის სახელობის ბათუმის სპორტის სასახლეში!\nგილოცავთ, ელენე, სპორტულ მიღწევას და გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name308,
    id: 308,
    title:
      "2023 წლის 21 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში შედგა გოგონათა ფოლკლორული ჯგუფის კონცერტი; ხელმძღვანელი- ლოლა ჯაფარიძე.",
    briefText:
      "ახალგაზრდებმა შეასრულეს სამხრეთ-დასავლეთ საქართველოს, კერძოდ, ლაზური, შავშური, იმერხეული ფოლკლორული მარგალიტები!\nსრულ ვიდეოჩანაწერს უახლოეს დღეებში შემოგთავაზებთ.",
  },
  {
    imageGallery: [],
    image: name309,
    id: 309,
    title:
      "უნიჭიერესი გიმნაზიელების არაჩვეულებრივი ოსტატობითა და გემოვნებით პლასტელინით შესრულებული ნამუშევრები.\nხელოვნების მასწავლებელი თამარ წულაძე",
    briefText:
      "უნიჭიერესი გიმნაზიელების არაჩვეულებრივი ოსტატობითა და გემოვნებით პლასტელინით შესრულებული ნამუშევრები.\nხელოვნების მასწავლებელი თამარ წულაძე",
  },
  {
    imageGallery: [],
    image: name310,
    id: 310,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლემქეთევან მახარაძემ 2023 წლის 22-23 დეკემბერს თბილისში გამართულ საქართველოს ჩემპიონატზე ფიგურულ ციგურაობაში მეორე საპრიზო ადგილი დაიკავა!\nგილოცავთ, ქეთევან და გისურვებთ დიდ წარმატებებს!",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლემქეთევან მახარაძემ 2023 წლის 22-23 დეკემბერს თბილისში გამართულ საქართველოს ჩემპიონატზე ფიგურულ ციგურაობაში მეორე საპრიზო ადგილი დაიკავა!\nგილოცავთ, ქეთევან და გისურვებთ დიდ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name311,
    id: 311,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III- 1 კლასის მოსწავლეები სტუმრად იმყოფებოდნენ არტ სტუდია "ანდამატში" ქალბატონ ლია კასპელაშვილთან .',
    briefText:
      'პატარებმა მონაწილეობა მიიღეს საგანმანათლებლო მასტერკლასში "კერამიკის ალქიმია".\nმათ თიხისგან საკუთარი ხელით დაამზადეს ნაძვის ხის სათამაშოები, რომლებიც შემდეგ საჩუქრად გადაეცათ. (მასწავლებელი რუსუდან თოიძე, კლასის დამრიგებელი ლამარა გოგიბერიძე).',
  },
  {
    imageGallery: [],
    image: name312,
    id: 312,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველკლასელთა საახალწლო ზეიმი (აღმზრდელი ანა კვიჭიძე).",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველკლასელთა საახალწლო ზეიმი (აღმზრდელი ანა კვიჭიძე).",
  },
  {
    imageGallery: [],
    image: name313,
    id: 313,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV- 2 კლასი დაესწრო ბათუმის ხელოვნების ცენტრში გამართულ საახალწლო კონცერტს "ახალი წლის ჯადოსნური ღამე". ( კლასის დამრიგებელი მაია იმნაძე)',
    briefText:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV- 2 კლასი დაესწრო ბათუმის ხელოვნების ცენტრში გამართულ საახალწლო კონცერტს "ახალი წლის ჯადოსნური ღამე". ( კლასის დამრიგებელი მაია იმნაძე)',
  },
  {
    imageGallery: [],
    image: name314,
    id: 314,
    title:
      "ბათუმში დასრულდა საქართველოს დამსახურებელი მწვრთნელის რაზმიკ პეტროსიანის ხსოვნისადმი მიძღვნილი რესპუბლიკური ტურნირი კრივში, რომელშიც წარმატებულად იასპარეზეს ბათუმოს წმინდა ანდრია პირველწოდებულის სახელობის მოსწავლეებმა.",
    briefText:
      "შეჯიბრების გამარჯვებულები გახდნენ ივერი ჯაყელი, ზაზა ცეცხლაძე და დაჩი ბასილაძე, ხოლო ანდრია მჟავანაძემ მეორე აპრიზო ადგილი დაიკავა.\n ვულოცავთ ჩვენ ნორჩ მოკრივეებს ამ დიდ წარმატებას და ვუსურვებთ მათ მომავალ გამარჯვებებს!",
  },
  {
    imageGallery: [],
    image: name315,
    id: 315,
    title:
      "საახალწლო ზეიმი ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-1 კლასში.",
    briefText:
      "მოსწავლეებმა რუსულის ენის გაკვეთილზე მასწავლებელ ნინო ქავჟარაძესა და დამრიგებელ მაია ჭანუყვაძესთან ერთად იმღერეს, იცეკვეს, წაიკითხეს ლექსები, გააცოცხლეს საყვარელი ზღაპრების გმირები. რაც მთავარია, დამსწრე საზოგადოებას მხიარული წინასაახალწლო განწყობა შეუქმნეს!",
  },
  {
    imageGallery: [],
    image: name316,
    id: 316,
    title: "პროექტული სწავლება მე-11 კლასში;\nსაგანი - ხელოვნება;",
    briefText:
      "პროექტი - ხელოვნება და ხელოვნური ინტელექტი, წარმდგენი ალექსანდრე ჯელია;\nპროექტი - ქართული ღვინო, როგორც კულტურული მემკვიდრეობის ძეგლი და ხელოვნება , წარმდგენი რუსკა კეშელავა;\nმასწავლებელი - ნინო როგავა.",
  },
  {
    imageGallery: [],
    image: name317,
    id: 317,
    title:
      "25.12. 2023. \nსაახალწლო ზეიმი ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის V-4 კლასში;\nქართული ენისა და ლიტერატურის პედაგოგი - ალექსანდრე მელიქაძე;\nდამრიგებელი - ირინა ვიდულინა.",
    briefText:
      "საახალწლო ზეიმი ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის V-4 კლასში;\nქართული ენისა და ლიტერატურის პედაგოგი - ალექსანდრე მელიქაძე;\nდამრიგებელი - ირინა ვიდულინა.",
  },
  {
    imageGallery: [],
    image: name318,
    id: 318,
    title:
      "გეოგრაფიის კვირეული (მასწავლებელი ანა ანუშიძე)\nთემა: „შექმენი და გამოიყენე გეოგრაფიული ხელსაწყო“ - (საბაზო საფეხურის მოსწავლეებისთვის)",
    briefText:
      "2023 წლის 19 – 26 დეკემბერს ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა გეოგრაფიის კვირეული, საბაზო საფეხურის (VII, VIII, IX კლასების) მოსწავლეებისთვის, რომლის ფარგლებშიც თითოეული კლასის მოსწავლეებისთვის, ეროვნული სასწავლო გეგმით განსაზღვრული და მიმდინარე სემესტრში დამუშავებული თემები შეჯამდა სხვადასხვა მასშტაბისა და თემატიკის გეოგრაფიული რუკების გამოყენებით.\nკვირეულის ფარგლებში მოსწავლეები:\nგაეცნენ გეოგრაფიული ხელსაწყოს, კურვიმეტრის ფუნქციებს, გამოყენების წესებს და აგებულებას.\nისწავლეს რუკის ლეგენდის კითხვა და გამოყენება სხვადასხვა თემატიკის რუკაზე მუშაობის პროცესში.\nისწავლეს რუკის მასშტაბის გამოყენებით სხვადასხვა გეოგრაფიულ ობიექტის რეალური სიგრძის და მათ შორის არსებული რეალური მანძილის დადგენა.\nისწავლეს მეთოდი, რომლის გამოყენებითაც შეძლეს გაეზომათ სხვადასხვა მდინარის, სახელმწიფოს საზღვრის, კონტინენტის გარშემოწერილობის, მერიდიანი, ეკვატორის და ა.შ. სიგრძე და მანძილი ორ გეოგრაფიულ ობიექტს შორის.\nკვირეულის ფარგლებში, მოსწავლეები მუშაობდნენ როგორც დამოუკიდებლად, ისე მცირე და საშუალო ჯგუფებში.",
  },
  {
    imageGallery: [],
    image: name319,
    id: 319,
    title:
      "ბოლო წლებში ეროვნული სასწავლო გეგმით X კლასში ახალი საგანი – „პროექტი სამოქალაქო განათლებაში“ დაინერგა.\nპროექტების განხორციელება მიზნად ისახავს მოსწავლეთა თვალსაწიერის გაფართოებას მათთვის საინტერესო მიმართულებით, კვლევითი უნარების ჩამომუშავებას და სხვ.",
    briefText:
      "დეკემბერს, ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის X კლასის მოსწავლეებმა პედაგოგ სალომე მიქაძის ხელმძღვანელობით წარმოადგინეს მათ მიერ ერთი სემესტრის განმავლობაში განხორციელებული მუშაობის შედეგები.\nთითოეული კლასის პროექტი ერთმანეთისაგან განსხვავებული იყო და გამოირჩეოდა ინფორმაციის მრავალფეროვნებითა და სიუხვით. წარმოდგენილი თემები გახლდათ:\nX1 - კიბერუსაფრთხოება და მედიაწიგნიერება\nX2- მიუსაფარი ცხოველები\nX3- ქალთა უფლებები და ფემიციდი\nX4-გენდერული უთანასწორობა\nX5 -ბულინგი და კიბერბულინგი",
  },
  {
    imageGallery: [],
    image: name320,
    id: 320,
    title:
      "2023 წლის 26 დეკემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-5 კლასში ქართული ენისა და ლიტერატურის მასწავლებელმა რუსუდან თავხელიძემ ჩაატარა ინტელექტუალურ-გასართობი გაკვეთილი.",
    briefText:
      "მოსწავლეებმა შეაჯამეს განვლილი სემესტრის მასალა, იმღერეს, იხალისეს, დამდეგი შობა-ახალი წელი მიულოცეს ერთმანეთს, დაასკვნეს, რომ ღონისძიების ყველა მონაწილე და გულშემატკივარი გამარჯვებული იყო და დასასრულს საქართველოს ჰიმნიც ერთად დააგუგუნეს!",
  },
  {
    imageGallery: [],
    image: name321,
    id: 321,
    title:
      '2023 წლის 26 დეკემბერს ბათუმის სპორტის სასახლეში გაიმართა საჭადრაკო კლუბ "ნონა"-ს ტრადიციული შემაჯამებელი ღონისძიება , რომელშიც მონაწილეობა მიიღო ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველი კლასის მოსწავლე ლაშა კახიძემ და U06 ასაკობრივ ჯგუფში აიღო პირველი ადგილი!\nვულოცავთ პატარა მოჭადრაკეს და დიდ წარმატებებს ვუსურვებთ!',
    briefText:
      '2023 წლის 26 დეკემბერს ბათუმის სპორტის სასახლეში გაიმართა საჭადრაკო კლუბ "ნონა"-ს ტრადიციული შემაჯამებელი ღონისძიება , რომელშიც მონაწილეობა მიიღო ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველი კლასის მოსწავლე ლაშა კახიძემ და U06 ასაკობრივ ჯგუფში აიღო პირველი ადგილი!ვულოცავთ პატარა მოჭადრაკეს და დიდ წარმატებებს ვუსურვებთ!',
  },
  {
    imageGallery: [],
    image: name322,
    id: 322,
    title:
      "28.12. 2023.საახალწლო ზეიმი ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-1 კლასში;\nდამრიგებელი - ლამარა გოგიბერიძე.",
    briefText:
      "28.12. 2023.საახალწლო ზეიმი ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-1 კლასში;\nდამრიგებელი - ლამარა გოგიბერიძე.",
  },
  {
    imageGallery: [],
    image: name323,
    id: 323,
    title:
      "ჩვენო ძვირფასო გიმნაზიელებო!\nპედაგოგებო!\nკურსდამთავრებულებო!\nმშობლებო!\nბებია-ბაბუებო!\nყველას!\nყველას!\nყველას!",
    briefText:
      'საუკეთესო სურვილებით გილოცავთ ახალ წელს!\n"ბუნების ძალავ, შემოქმედო ყოვლისა, შენ გაუთენე ჩემს ხალხს, ჩემს სამშობლოს ბედნიერი ახალი წელი.\nგანკურნე ყოველგვარი სენისაგან, მიეცი ჯანი მრთელი, ღონე შენი, ნიჭი შენი და უკვდავება შენი.\nგაავსე სახლი ყოველი მშრომელისა მზითა და სითბოთი, ბეღელი – პურით, მარანი – ღვინით, ახორი – საქონლით, კარია – ფრინველით და გული სათნოებით.\nააჟრიამულე ეზო-კარი ყოველი ქართველისა ბადიშებით, შვილთაშვილებითა და მათი შვილებით.\nდაუშრეტელ მდინარედ იდინე ბედნიერებავ ჩვენს ქვეყანაში, არ მოუშალო გონიერი ერისკაცი და მწყემსი საქართველოს.\nნატვრისთვალი დაუდე ამ ახალი წლის ღამით სასთუმალს რათა დილით ადგეს, ნახოს და სამშობლოს უკვდავება ინატროს!\nმიიღე, მამულო, ეს ლოცვა!" (ნოდარ დუმბაძე)',
  },
  {
    imageGallery: [],
    image: name324,
    id: 324,
    title:
      'წიგნის საჯაროდ კითხვის დღეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასის მოსწავლეებმა ინგლისური ენის გაკვეთილზე (მასწავლებელი ზეინაბ კონცელიძე) წაიკითხეს მოთხრობა " დამხმარე ხელები" , ისაუბრეს და იმსჯელეს მოთხრობის მთავარ სათქმელზე, სიკეთის კეთების მნიშვნელობაზე, მოიტანეს მაგალითები საკუთარი გამოცდილებიდან.',
    briefText:
      'წიგნის საჯაროდ კითხვის დღეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასის მოსწავლეებმა ინგლისური ენის გაკვეთილზე (მასწავლებელი ზეინაბ კონცელიძე) წაიკითხეს მოთხრობა " დამხმარე ხელები" , ისაუბრეს და იმსჯელეს მოთხრობის მთავარ სათქმელზე, სიკეთის კეთების მნიშვნელობაზე, მოიტანეს მაგალითები საკუთარი გამოცდილებიდან.',
  },
  {
    imageGallery: [],
    image: name325,
    id: 325,
    title:
      '2024 წლის 6 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-2 კლასში ჩატარდა ინტეგრირებული გაკვეთილი (ქართული ლიტერატურა და მუსიკა) თემაზე "ამღერებული ლექსი". გაკვეთილს უძღვებოდნენ ქართული ლიტერატურის პედაგოგი მარინა მამალაძე და მუსიკის პედაგოგი ეკატერინე ბჟინავა.',
    briefText:
      '2024 წლის 6 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-2 კლასში ჩატარდა ინტეგრირებული გაკვეთილი (ქართული ლიტერატურა და მუსიკა) თემაზე "ამღერებული ლექსი". გაკვეთილს უძღვებოდნენ ქართული ლიტერატურის პედაგოგი მარინა მამალაძე და მუსიკის პედაგოგი ეკატერინე ბჟინავა.',
  },
  {
    imageGallery: [],
    image: name326,
    id: 326,
    title:
      "2024 წლის 9 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-3 კლასში ჩატარდა უაღრესად საინტერესო ინტეგრირებული (ბუნება და ხელოვნება) გაკვეთილი თემაზე „ყვავილის აგებულება“.\nგაკვეთილს უძღვებოდნენ პედაგოგები სალომე დანელია და ირინა სევოსტიანოვა.",
    briefText:
      "2024 წლის 9 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-3 კლასში ჩატარდა უაღრესად საინტერესო ინტეგრირებული (ბუნება და ხელოვნება) გაკვეთილი თემაზე „ყვავილის აგებულება“.\n გაკვეთილს უძღვებოდნენ პედაგოგები სალომე დანელია და ირინა სევოსტიანოვა.",
  },
  {
    imageGallery: [],
    image: name327,
    id: 327,
    title:
      "2024 წლის 13 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-2 კლასში ჩატარდა ღია გაკვეთილი თემაზე „უცხო მოყმის ნახვა“ (შოთა რუსთაველის „ვეფხისტყაოსნის“ მიხედვით) - ტექსტის ანალიზი.\nგაკვეთილს უძღვებოდა ქართული ენისა და ლიტერატურის პედაგოგი მზია ჯანელიძე.",
    briefText:
      "2024 წლის 13 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-2 კლასში ჩატარდა ღია გაკვეთილი თემაზე „უცხო მოყმის ნახვა“ (შოთა რუსთაველის „ვეფხისტყაოსნის“ მიხედვით) - ტექსტის ანალიზი.\nგაკვეთილს უძღვებოდა ქართული ენისა და ლიტერატურის პედაგოგი მზია ჯანელიძე.",
  },
  {
    imageGallery: [],
    image: name328,
    id: 328,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველკლასელებმა საზეიმოდ დაასრულეს ანბანის შესწავლა.\nპატარებმა საკუთარი ხელით დაამზადეს ილუსტრირებული ანბანი და ნამუშევრები თანატოლებს გაუზიარეს.\nI-4 კლასის აღმზრდელი - თამარ კვერღელიძე , ქართული ენისა და ლიტერატურის მასწავლებელი - ნინო უგულავა.",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველკლასელებმა საზეიმოდ დაასრულეს ანბანის შესწავლა.\nპატარებმა საკუთარი ხელით დაამზადეს ილუსტრირებული ანბანი და ნამუშევრები თანატოლებს გაუზიარეს.\nI-4 კლასის აღმზრდელი - თამარ კვერღელიძე , ქართული ენისა და ლიტერატურის მასწავლებელი - ნინო უგულავა.",
  },
  {
    imageGallery: [],
    image: name329,
    id: 329,
    title:
      "10-11.02.2024; \nკაჭრეთი, ამბასადორი;\nAnnual Educational Conference - 2024; \nორგანიზატორი - English Book Education;",
    briefText:
      "საერთაშორისო საგანმანათლებლო კონფერენციას ესწრებოდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის უცხოური ენების კათედრის ხელმძღვანელი, ინგლისური ენის პედაგოგი ნინო კორძაძე და სკოლის დირექტორის მოადგილე პირიმზე რურუა.",
  },
  {
    imageGallery: [],
    image: name330,
    id: 330,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 კლასის მოსწავლეებმა რუსული ენის პედაგოგის ევგენია ლომაძის ხელმძღვანელობით მონაწილეობა მიიღეს მოლდოვის რესპუბლიკის მიერ ორგანიზებულ საერთაშორისო პროექტში “ჩვენ ვკითხულობთ ა. ს. პუშკინს“.\n პროქტის ფარგლებში კლასი გაეცნო ა.ს. პუშკინის ბიოგრაფიას და მისი ზღაპრების პერსონაჟებს, წაიკითხეს და თარგმნეს ტექსტები, გაიზიარეს ერთმანეთის აზრი, იმსჯელეს ისეთ საკითხბზე როგორიცაა სიკეთე და ბოროტება...",
    briefText:
      "მოსწავლეებმა ღირსეულად წარადგინეს მათ მიერ შექმნილი კოლაჟური ანიმაცია თემაზე „ ოქროს თევზი“. პროექტში მონაწილეობამ ბავშვებს საშუალება მისცა განევითარებინათ ზეპირმეტყველების და ტექსტთან დამოუკიდებლად მუშაობის უნარი, წარმოეჩინათ თავიანთი შემოქმეებითი შესაძლებლობები.\nპროექტის დასრულების შემდეგ დაიმსახურეს ორგანიზატორთა საუკეთესო შეფასება და დიპლომები.",
  },
  {
    imageGallery: [],
    image: name331,
    id: 331,
    title:
      "ტოიოტას “ოცნების ავტომობილის” ხატვის, ადგილობრივი კონკურსი დასრულდა! \nგამარჯვებულები სიმბოლურად დასაჩუქრდებიან ტოიოტა ცენტრი ბათუმის მიერ და ასპარეზს საერთაშორისო კონკურსზე გააგრძელებენ.",
    briefText:
      "გამარჯვებულთა შორის 8-11 წლის ასაკობრივი კატეგორიიდან არიან ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები\n 1 ადგილი - თეკლა ბაზიაშვილი\n2 ადგილი - ლილე ჯაიანი\n3 ადგილი - ანანო ანდღულაძე\n ვულოცავთ ჩვენს პატარა მხატვრებს და ვუსურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name332,
    id: 332,
    title:
      "ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტმა აბიტურიენტებისათვის ღია კარის დღეები დაიწყო. ",
    briefText:
      "ბსუ-ს პროფესორ-მასწავლებლებმა ჯემალ კარალიძემ და შოთა ჯიჯეიშვილმა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში გამართულ საინფორმაციო შეხვედრაზე მეთორმეტე კლასის მოსწავლეებს უნივერსიტეტის საბაკალავრო პროგრამები, საუნივერსიტეტო ცხოვრება, სოციალური პროგრამები, სტიპენდიები, გაცვლითი პროგრამები, სიახლეები და ინფრასტრუქტურა გააცნეს. საინფორმციო შეხვედრის დასრულების შემდეგ აბიტურიენტებს ბსუ-ს სამახსოვრო საჩუქრები გადაეცათ.",
  },
  {
    imageGallery: [],
    image: name333,
    id: 333,
    title: "შთაბეჭდილებით აღსავსე დღე",
    briefText:
      "2024 წლის 26 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებმა ხელოვნების პედაგოგებთან ირინა სევოსტიანოვასა და სოფო სანიკიძესთან ერთად მოინახულეს გონიოს ციხე და გონიოს ციხის კვლევითი ცენტრის სამუშაო სივრცეები - სარესტავრაციო ლაბორატორია და საცავი, გაეცნენ საცავში დაცულ იმ არქეოლოგიურ არტეფაქტებს, რომელთა ექსპონირება მუზეუმებში ჯერ არ განხორციელებულა, გაეცნენ არქეოლოგს, ხელოვნებათმცოდნეს და რესტავრატორს, ჩაუტარდათ შემეცნებითი 20 წუთიანი გაკვეთილი. შემდეგ საკუთარი ხელით შექმნეს კულტურულ მემკვიდრეობასთან დაკავშირებული ნამუშევრები, რომლებიც 1 ივნისს, ბავშვთა დაცვის საერთაშორისო დღეს, გამოიფინება.",
  },
  {
    imageGallery: [],
    image: name334,
    id: 334,
    title:
      "2024 წლის 28 თებერვალს ბათუმის წმინდა ანდრია პირველწდებულის სახელობის სკოლაში „სკოლის ელჩების“ პროექტის ფარგლებში წითელი ჯვრის მოხალისემ და ელჩმა, მე-11 კლასის მოსწავლემ ნუცა ნიკოლაიშვილმა მოსწავლეებისთვის ჩაატარა წითელი ჯვრის საინფორმაციო ტრენინგი. ",
    briefText:
      "2024 წლის 28 თებერვალს ბათუმის წმინდა ანდრია პირველწდებულის სახელობის სკოლაში „სკოლის ელჩების“ პროექტის ფარგლებში წითელი ჯვრის მოხალისემ და ელჩმა, მე-11 კლასის მოსწავლემ ნუცა ნიკოლაიშვილმა მოსწავლეებისთვის ჩაატარა წითელი ჯვრის საინფორმაციო ტრენინგი.",
  },
  {
    imageGallery: [],
    image: name335,
    id: 335,
    title:
      '2024 წლის 7 მარტს ბათუმის ანდრია პირველწოდებულის სკოლის X-3 კლასმა რუსული ენის გაკვეთილზე (მასწავლებელი ევგენია ლომაძე) წარადგინა კომპლექსური დავალება თემაზე "საქართველოს კუთხეები".\nმოსწავლეები დაიყვნენ ჯგუფებად, მოიძიეს სათანადო ინფორმაცია საქართველოს კუთხეების შესახებ. წარმოადგინეს ცალკეული კუთხის ტრადიციები, წეს - ჩვეულებანი, კულტურა, ღირშესანიშნავი ადგილები , სამზარეულო და ფოლკლორი',
    briefText:
      "დავალების და პრეზენტაციის მზადების პროცესი საინტერესო იყო ახალგაზრდებისთვის და დადებითად აისახა მოსწავლეთა განწყობაზე, ასევე, ხელი შეუწყო აუდიტორიის წინაშე გამომეტყველებითი კითხვის უნარ- ჩვევებისა და ტექსტთან დამოუკიდებლად მუშაობის უნარს.",
  },
  {
    imageGallery: [],
    image: name336,
    id: 336,
    title:
      "2024 წლის 1-7 მარტს გეოგრაფიის II კვირეული ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მიეძღვნა კლიმატური სარტყლებისა და ბუნებრივი ზონების საკითხს.\nკვირეულში მონაწილეობა მიიღეს მე - 7, მე - 10 და მე - 11 კლასების მოსწავლეებმა;",
    briefText:
      "კვირეულის ფარგლებში მოსწავლეება გაიგეს:\nრა არის კლიმატი და რომელია კლიმატწარმომქმნელი ფაქტორები?\nრა არის კიოპენის კლიმატის კლასიფიკაცია?\nრა განსხვავებაა ძირითად და გარდამავალ კლიმატურ სარტყლებს შორის?\nრა არის სიმაღლებრივი/ვერტიკალური ზონალობა და რისი შედეგია ის?\nრომელი ბუნებრივი ზონებია გავრცელებული დედამიწაზე?\nრა თავისებურებებით გამოირჩევა თითოეული მათგანი?\nრა არის ამ თავისებურებების გამომწვევი მიზეზები?\nროგორია საქართველოს კლიმატური დარაიონება კიოპენის კლასიფიკაციიის თანახმად?\nროგორია კლიმატური რაიონების ძირითადი კლიმატური მახასიათებლები და გავრცელების არეალები?\nკვირეულის ფარგლებში შეიქმნა სასწავლო რესურსი „ბუნებრივი ზონების ძირითადი მახასიათებლები“ და მოსწავლეების მიერ დამოუკიდებლად შექმნილი „გეოგრაფიული ამოცანების კრებული“.\nმასწავლებელი: ანა ანუშიძე",
  },
  {
    imageGallery: [],
    image: name337,
    id: 337,
    title:
      "სიხარულით გვსურს გაუწყოთ, რომ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-3 კლასის მოსწავლემ ელენე ნასყიდაშვილმა I ადგილი აიღო ღია საერთაშორისო ტურნირზე კიოკუშინკაი კარატეში!",
    briefText: "გილოცავთ, ელენე და გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name338,
    id: 338,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მეათე კლასის მოსწავლე გიორგი მოდინი ამჟამად იმყოფება ჰააგაში, სადაც ესწრება გაეროს მოდელირების საერთაშორისო კონფერენციას.",
    briefText:
      "გაეროს მოდელირება აკადემიური როლური კონფერენციაა, რომელიც გაეროს სხვადასხვა ორგანოს სიმულაციას ახდენს.\nმონაწილეები არიან დიპლომატები, ისინი წარადგენენ საკუთარ ქვეყანას, იცავენ მის პოზიციებს, მართავენ დებატებსა და მოლაპარაკებებს.\nწარმატებებს ვუსურვებთ ჩვენს გიოს ამ მნიშვნელოვან ღონისძიებაზე!",
  },
  {
    imageGallery: [],
    image: name339,
    id: 339,
    title:
      "2024 წლის 18 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში გაიმართა შეხვედრა ახალგაზრდა ევროპელი ელჩების ინიციატივის შესახებ, რომელსაც უძღვებოდნენ ამავე ინიციატივის წევრები: სალომე მიქაძე- ჩვენი სკოლის მოქალაქეობის პედაგოგი და თამარ შულგა.",
    briefText:
      "ახალგაზრდა ევროპელი ელჩების ინიციატივა წარმოადგენს არაპოლიტიკურ და ნებაყოფლობით საკომუნიკაციო ქსელს, რომელიც ხელს უწყობს კავშირების და მეგობრული ურთიერთობების დამყარებას აზერბაიჯანის, ბელარუსის, მოლდოვის რესპუბლიკის, საქართველოს, სომხეთის, უკრაინის წარმომადგენელ ახალგაზრდებსა და მათ თანატოლებს შორის ევროკავშირის წევრი სახელმწიფოებსა და გაერთიანებული სამეფოში.\nამ ქსელის მრავალ მიზანს შორის არის მოსახლეობის უკეთ ინფორმირება ევროკავშირის თანამშრომლობის შესახებ მის აღმოსავლეთ პარტნიორ ქვეყნებთან, სამოქალაქო აქტივიზმის გაძლიერების მხარდაჭერა და ერთობლივი საქმიანობა უკეთესი მომავლისათვის.\nშეხვედრის ფარგლებში ელჩებმა მოსწავლეებს გააცნეს ევროკავშირის შექმნის ისტორია, ორგანიზაციის ინსტიტუტების ფუნქციონირება, საქართველოსა და ევროკავშირის ხანგრძილივი ურთიერთობის ეტაპები. რაც მთავარია ისაუბრეს ინიციატივის, გაწევრიანების კრიტერიუმებისა და მის ფარგლებში განხორციელებული პროექტების შესახებ.\nასევე, განიხილეს ევროკავშირთან დაკავშირებით არსებული მითები.",
  },
  {
    imageGallery: [],
    image: name340,
    id: 340,
    title:
      "2024 წლის 20 მარტს ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში გაიმართა სკოლის ბავშვთა ომბუდსმენის ინსტიტუციის დანერგვის პრეზენტაცია.\n იდეა ეკუთვნის მოქალაქეობისა და გეოგრაფიის მენტორ მასწავლებელს ანა ანუშიძეს.",
    briefText:
      "პრეზენტაციის ფარგლებში ანამ სასკოლო საზოგადოებას წარუდგინა\n ბავშვთა ომბუდსმენის უფლება - მოვალეობები, ინსტიტუციის მიზნები, ამოცანები და სამომავლო გეგმები.\n ჩვენი სკოლა აგრძელებს საუკეთესო პრაქტიკის დანერგვას მოსწავლეთა ინტერესების მხარდასაჭერად, უსაფრთხო სასწავლო გარემოს და პოზიტიური სასკოლო კულტურის განვითარებისთვის.",
  },
  {
    imageGallery: [],
    image: name341,
    id: 341,
    title:
      "2024 წლის 22 მარტს აჭარის კულტურული მემკვიდრეობის დაცვის სააგენტოს მხარდაჭერით ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტში ახალგაზრდული კონფერენცია ,,ჩვენი მემკვიდრეობა’’გაიმართა.",
    briefText:
      'კონფერენციაში მონაწილეობა მიიღეს თბილისის და ბათუმის სკოლების უფროსკლასელებმა.\n კონფერენცია მიზნად ისახავდა ახალგაზრდებში კულტურული მემკვიდრეობისადმი ცნობიერების ამაღლებას.\n ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მეათე კლასის მოსწავლე ლუკა უჩანეიშვილმა კონფერენციაზე წარმოადგინა თემა "ბათუმის მერიის შენობა და ლაო ჯინ ჯაოს სახლი".',
  },
  {
    imageGallery: [],
    image: name342,
    id: 342,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე ალექსანდრე გუგუშვილი საფეხბურთო კლუბ ბათუმის "დინამოს" ძირითადი შემადგენლობის წევრია!',
    briefText: "სანდრო, გილოცავთ!\n გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name343,
    id: 343,
    title:
      "მიმდინარე წლის 25 მარტს ევროპის მასშტაბით ევროპელი ავტორების დღე აღინიშნა.",
    briefText:
      'დაიგეგმა სხვადასხვა ღონისძიებების ორგანიზება, წიგნების განხილვა, ლიტერატურულ საღამოები და სხვ.\nბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში დაიწყო ევროპელი ავტორების კვირეული.\n26 მარტს ქართული ენისა და ლიტერატურის მასწავლებელმა მარინა ტალახაძემ უფროსკლასელთათვის ჩაატარა ლექცია თემაზე : თომას მანი -"სიკვდილი ვენეციაში" და "ჯადოსნური მთა".',
  },
  {
    imageGallery: [],
    image: name344,
    id: 344,
    title:
      "2024 წლის 25 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში დაიწყო ევროპელი ავტორების კვირეული.",
    briefText:
      '27 მარტს პირველკასელებს განსხვავებული გაკვეთილი ჩაუტარდათ სკოლის ბიბლიოთეკაში. პატარებმა წაიკითხეს შარლ პეროს "წითელქუდა" , \n ზღაპრის ეპიზოდების მიხედვით შექმნეს ილუსტრაციები.\n გაკვეთილს უძღვებოდა წითელქუდად გარდასახული ქართული ენისა და ლიტერატურის მასწავლებელი მაია იმნაძე, კლასის აღმზრდელია ირინა ჩხაიძე.',
  },
  {
    imageGallery: [],
    image: name345,
    id: 345,
    title:
      "2024 წლის 25 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში დაიწყო ევროპელი ავტორების კვირეული.",
    briefText:
      '28 მარტს IX -3 კლასში ჩატარდა უაღრესად საინტერესო გაკვეთილი " ევროპული ლიტერატურა და ქართული კინო" (ლუიჯი პირანდელო და ფილმი "ქვევრი").\n გაკვეთილს უძღვებოდა ქართული ენისა და ლიტერატურის მასწავლებელი მარინა მამალაძე.',
  },
  {
    imageGallery: [],
    image: name346,
    id: 346,
    title:
      "2024 წლის 25 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში დაიწყო ევროპელი ავტორების კვირეული.",
    briefText:
      '28 მარტს X-4 კლასში ჩატარდა ლიტერატურული სემინარი რობერტ ბრენსის შემოქმედება; ერთი ლექსის ანალიზი- "Auld Lang Syne"ძველსა გზასა"\n სემინარს უძღვებოდა ინგლისური ენის მასწავლებელი ნატა ფრუიძე.',
  },

  {
    imageGallery: [],
    image: name347,
    id: 347,
    title:
      "2024 წლის 28 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-3 კლასის მოსწავლეებმა კლასის დამრიგებელ თამუნა მექვაბიშვილთან ერთად ულამაზესი საზეიმო სანახაობა შესთავაზეს მეგობრებს, მშობლებს, ბებია-ბაბუებს!",
    briefText:
      '"გაზაფხული შემოსულა ლენ!" - გვამცნეს პატარებმა, ბევრი ლექსი წაგვიკითხეს, სიმღერები გვიმღერეს! სკოლა კი გაზაფხულის და ყვავილების სურნელით აავსეს!',
  },
  {
    imageGallery: [],
    image: name348,
    id: 348,
    title:
      "2024 წლის 27 მარტს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-3 კლასის მოსწავლეებს ხელოვნების გაკვეთილი ჩაუტარდათ ბათუმის ღვთისმშობლის შობის სახელობის საკათედრო ტაძარში; ხელოვნების მასწავლებელი სოფო სანიკიძე. ",
    briefText:
      "პატარები გაეცნენ ხელოვნების ისეთ სახეობებს როგორიცაა: არქიტექტურა, ქანდაკება, ვიტრაჟი, ფრესკა, ხატი და ორნამენტი.\n პედაგოგმა ისაუბრა ხელოვნების ნიმუშების სპეციფიკასა და ესთეტიკურ მნიშვნელობაზე.\n გაკვეთილის მიზანი იყო ნასწავლი მასალის განმტკიცება ვიზუალური აღქმის საფუძველზე.",
  },
  {
    imageGallery: [],
    image: name349,
    id: 349,
    title:
      "2024 წლის 25 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში დაიწყო ევროპელი ავტორების კვირეული.",
    briefText:
      "28 მარტს III-2 კლასის მოსწავლეებმაც მიიღეს მონაწილეობა ევროპელი ავტორების კვირეულში.\nპატარებმა არასაგაკვეთილო გარემოში, სუფთა ჰაერზე, სკოლის მიმდებარე სკვერში წაიკითხეს ნაწყვეტები საყვარელი ევროპელი ავტორების ნაწარმოებებიდან.\n ქართული ენისა და ლიტერატურის მასწავლებელი ნინო უგულავა",
  },
  {
    imageGallery: [],
    image: name350,
    id: 350,
    title:
      "2024 წლის 25 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში დაიწყო ევროპელი ავტორების კვირეული.",
    briefText:
      "28 მარტს II- 4 კლასის მოსწავლეები ქართული ენისა და ლიტერატურის მასწავლებელ რუსუდან თოიძესთან ერთად ეწვივნენ სკოლის ბიბლიოთეკას, სადაც გულისხმიერი ბიბლიოთეკარი ქალბატონი ნუნუს გილი დახვდათ.\n პატარებმა უფროსებთან ერთად წაიკითხეს ნაწყვეტები ევროპელი მწერლების ნაწარმოებებიდან.",
  },
  {
    imageGallery: [],
    image: name351,
    id: 351,
    title:
      "2024 წლის 25 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში დაიწყო ევროპელი ავტორების კვირეული.",
    briefText:
      "29 მარტს ქართული ენისა და ლიტერატურის მასწავლებელმა შორენა ბოლქვაძემ VII კლასების მოსწავლეებს გააცნო ალფონს დოდეს შემოქმედება.",
  },
  {
    imageGallery: [],
    image: name352,
    id: 352,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში გრძელდება ევროპელი ავტორების კვირეული.",
    briefText:
      '2024 წლის 28 მარტს III-4 კლასის მოსწავლეებმა ქართული ენისა და ლიტერატურის მასწავლებელ თეა ქორჩილავასთან ერთად წაიკითხეს როალდ დალის "ჩარლი და შოკოლადის ქარხანა";\n პატარებმა გამოთქვეს აზრი, ისაუბრეს წაკითხული ნაწარმოების შესახებ, შექმნეს ილუსტრაციები.',
  },
  {
    imageGallery: [],
    image: name353,
    id: 353,
    title:
      "29.03.2024. \n ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა.განსაკუთრებული მნიშვნელობის დღე - სკოლაში ბავშვთა ომბუდსმენის ინსტიტუტის დაარსება!",
    briefText:
      "იდეის ავტორმა და სულისჩამდგმელმა გეოგრაფიისა და სამოქალაქო განათლების მენტორმა მასწავლებელმა ანა ანუშიძემ სასკოლო საზოგადოების და მოწვეული სტუმრების წინაშე წარადგინა სკოლაში ბავშვთა ომბუდსმენის უფლება - მოვალეობები, დებულება, მიზნები, ამოცანები და სამომავლო გეგმები.\n სკოლაში განხორციელებულ ფუნდამენტურ კვლევებზე და სკოლის მრავალწლიან გამოცდილებაზე ისაუბრა სკოლის პრორექტორმა პირიმზე რურუამ.\n ბოლო წლებში ჩვენს სკოლაში განხორციელებული საინტერესო აქტივობების შესახებ პრეზენტაცია წარადგინა ისტორიის მასწავლებელმა ზვიად ჩხენკელმა.\n მოხსენებებით გამოვიდნენ სასკოლო საზოგადოების წევრები, მშობლები და მოსწავლეები.\n განსაკუთრებული მადლობას მოვახსენებთ მობრძანებულ სტუმრებს:\n საქართველოს სახალხო დამცველის რეგიონულ რწმუნებულს აჭარაში ბ-ნ გიორგი ჩარკვიანს\n აჭარის ა/რ უმაღლესი საბჭოს ადამიანის უფლებათა დაცვის საკითხთა კომიტეტის თავმჯდომარეს ბ-ნ ცოტნე ანანიძეს\n აჭარის ა/რ უმაღლესი საბჭოს ადამიანის უფლებათა დაცვის საკითხთა კომიტეტის აპარატის უფროსს ბ-ნ ბაკურ ბოლქვაძეს\n აჭარის ა/რ უმაღლესი საბჭოს აპარატის საფინანსო უზრუნველყოფისა და შესყიდვების განყოფილების უფროსს ბ-ნ დავით ბერიძეს\n აჭარის ა/რ უმაღლესი საბჭოს განათლების, კულტურისა და სპორტის საკითხთა კომიტეტის აპარატის უფროსს ქ-ნ ნაირა აბულაძეს\n აჭარის ა/რ უმაღლესი საბჭოს განათლების, მეცნიერების, კულტურისა და სპორტის საკითხთა კომიტეტის აპარატის სპეციალისტს ქ-ნ ნონა ტაკიძეს\n აჭარის ა/რ უმაღლესი საბჭოს განათლების, მეცნიერების, კულტურისა და სპორტის საკითხთა კომიტეტის აპარატის სპეციალისტს ქ-ნ ნატო აბუსელიძეს.\n შეხვედრაზე დაიგეგმა არაერთი მნიშვნელოვანი სამომავლო პროექტი!",
  },
  {
    imageGallery: [],
    image: name354,
    id: 354,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში გრძელდება ევროპელი ავტორების კვირეული.",
    briefText:
      '2024 წლის 1 აპრილს XI კლასების მოსწავლეებს ქართული ენისა და ლიტერატურის მასწავლებელმა მზია ჯანელიძემ გააცნო ფრანც კაფკას შემოქმედება, კერძოდ , "მეტამორფოზა".',
  },
  {
    imageGallery: [],
    image: name355,
    id: 355,
    title:
      'ოლიმპიადა "ევერესტის " საშემოდგომო სეზონში მიღწეული წარმატებისთვის სიგელებით და საჩუქრებით დაჯილდოვდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები:',
    briefText:
      "- ალექსანდრე გაფრინდაშვილი-II კლასი,\n - დემეტრე შერვაშიძე-IV კლასი,\n -ემილი კაიტამბა-VI კლასი.\n- რევაზ გაფრინდაშვილი- VI კლასი, რეზიკოს განსაკუთრებული წარმატებისთვის პედაგოგმა და სკოლამ მადლობის წერილიც მიიღო!\n გილოცავთ!\n გისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name356,
    id: 356,
    title:
      "2024 წლის 2 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეების: თეკლა ხარაბაძის, მარიამ ჩხატარაშვილის, გვანცა ალელიშვილის და შოთიკო ბოლქვაძის ინიციატივითა და ორგანიზებით გაიმართა ინტელექტუალური ვიქტორინა, რომელშიც საბაზო საფეხურის სხვადასხვა კლასის მოსწავლეებისაგან დაკომპლექტებული გუნდები იღებდნენ მონაწილეობას.",
    briefText:
      "2024 წლის 2 აპრილს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეების: თეკლა ხარაბაძის, მარიამ ჩხატარაშვილის, გვანცა ალელიშვილის და შოთიკო ბოლქვაძის ინიციატივითა და ორგანიზებით გაიმართა ინტელექტუალური ვიქტორინა, რომელშიც საბაზო საფეხურის სხვადასხვა კლასის მოსწავლეებისაგან დაკომპლექტებული გუნდები იღებდნენ მონაწილეობას.",
  },
  {
    imageGallery: [],
    image: name357,
    id: 357,
    title:
      'გიმნაზიელთა წარმატება ქიმიის საერთაშორისო ტურნირზე\n2024 წლის 28-31 მარტს თბილისში ჩატარდა International Chemistry Competition "Golden Fleece 2024" ტურნირი "ოქროს საწმისი" საერთაშორისო გუნდური შეჯიბრი ქიმიაში.\nტურნირის მთავარი მიზანია საერთაშორისო ურთიერთობების ხელშეწყობა და ქიმიით დაინტერესებული მოსწავლეების წახალისება.',
    briefText:
      "ტურნირში მონაწილეობას იღებდნენ არა მხოლოდ საქართველოს, არამედ სხვა ქვეყნების მოსწავლეები.\nმათ, შორის ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის გუნდი, რომელიც დაკომპლექტებული იყო XI კლასის მოსწავლეებით. გუნდმა, რომელიც მოამზადა ქიმიის პედაგოგმა ნონა აბაშიძემ, საგნის არაჩვეულებრივი ცოდნა გამოავლინა და მოიპოვა ვერცხლის მედალი. აღსანიშნავია, რომ პირველი ადგილის მფლობელები გახდნენ რუმინელები, ანუ ჩვენმა მოსწავლეებმა საქართველოს მასშტაბით საუკეთესო შედეგი აჩვენეს!\nგუნდის შემადგენლობაში იყვნენ:\nანანო ხინკილაძე,\nნუცა ნიკოლაიშვილი,\nანა გოგიჩაიშვილი,\nლილე ღომიძე,\nდათა ურუშაძე . \nგილოცავთ!\nგისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name358,
    id: 358,
    title:
      "ქართული ენისა და ლიტერატურის გაკვეთილი I-4 კლასში.\nპატარებმა მოიწვიეს სტუმრებიც.\nთემა: ჩვენი სურვილები - სამომავლო პროფესიები;",
    briefText:
      'ტექსტში "ვინ რას აკეთებს?" წარმოდგენილი პროფესიებიდან რომელი მოგეწონა და რატომ?\nმოსწავლეებმა მოწვეულ სტუმრებთან ერთად ისაუბრეს რატომ არის საჭირო ამდენი პროფესია?\nრა გავიგე ახალი პროფესიების შესახებ?\nრა ვიცოდი აქამდე?\nრა არის მნიშვნელოვანი ადამიანთა საქმიანობისთვის?\nმხიარულ, დასამახსოვრებელ, საინტერესო გაკვეთილს უძღვებოდა ქართული ენისა და ლიტერატურის მასწავლებელი მაია იმნაძე.',
  },
  {
    imageGallery: [],
    image: name359,
    id: 359,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის X კლასის მოსწავლეები მეორე წელია აქტიურად მონაწილეობენ ბათუმის შოთა რუსთაველის სახ. უნივერსიტეტის ეკონომიკისა და ბიზნესის ფაკულტეტის ყოველწლიურ სტუდენტთა და მოსწავლეთა ერთობლივ კონფერენციაში თემაზე: „ქართული ბიზნესი - გამოწვევები და პერსპექტივები”.",
    briefText:
      "წლევანდელ კონფერენციაზე საინტერესო მოხსენებები წარადგინეს ორგანიზატორთა და მსმენელთა წინაშე\nანი ონიაშვილმა;\nნია დარჩიძემ;\nანასტასია ხარატმა;\nანა ძაგნიძემ;\nანა გიგაიამ;\nმარიამ ძნელაძემ;\n თეკლა ბაჯელიძემ;\nანანო ბეჟანიძემ;\nლიზი ტატურაშვილმა.\nასეთი ტიპის შეხვედრები სამომავლოდაც ხელს შეუწყობს სკოლისა და უნივერსიტეტის ურთიერთთანამშრომლობის გაღრმავებას.",
  },
  {
    imageGallery: [],
    image: name360,
    id: 360,
    title:
      "სპორტის საერთაშორისო დღესთან დაკავშირებით მძლეოსნობაში ჩატარებულ საქალაქო შეჯიბრზე 60 მ დისტანციაზე წარმატებულად გამოვიდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები; ხოლო VIII კლასის მოსწავლემ ელენე ურუშაძემ დაიკავა II საპრიზო ადგილი.",
    briefText: "სპორტის მასწავლებელი დავით ონიაშვილი. \n გილოცავთ!",
  },
  {
    imageGallery: [],
    image: name361,
    id: 361,
    title:
      "2024 წლის 4 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მოსწავლეთა მხრიდან გამოხატული დიდი ინტერესის გამო გაიმართა განმეორებითი შეხვედრა ახალგაზრდა ევროპელი ელჩების ინიციატივის შესახებ, რომელსაც უძღვებოდა ამავე ინიციატივის წევრი , სამოქალაქო განათლების პედაგოგი სალომე მიქაძე.",
    briefText:
      "ახალგაზრდა ევროპელი ელჩების ინიციატივა წარმოადგენს არაპოლიტიკურ და ნებაყოფლობით საკომუნიკაციო ქსელს, რომელიც ხელს უწყობს კავშირების და მეგობრული ურთიერთობების დამყარებას აზერბაიჯანის, ბელარუსის, მოლდოვის რესპუბლიკის, საქართველოს, სომხეთის, უკრაინის წარმომადგენელ ახალგაზრდებსა და მათ თანატოლებს შორის ევროკავშირის წევრი სახელმწიფოებსა და გაერთიანებული სამეფოში.\n ამ ქსელის მიზანებია: მოსახლეობის უკეთ ინფორმირება ევროკავშირის თანამშრომლობის შესახებ მის აღმოსავლეთ პარტნიორ ქვეყნებთან, სამოქალაქო აქტივიზმის გაძლიერების მხარდაჭერა და ერთობლივი საქმიანობა უკეთესი მომავლისათვის. შეხვედრის ფარგლებში ელჩებმა მოსწავლეებს გააცნეს ევროკავშირის შექმნის ისტორია, ორგანიზაციის ინსტიტუტების ფუნქციონირება, საქართველოსა და ევროკავშირის ხანგრძილივი ურთიერთობის ეტაპები, რაც მთავარია, ისაუბრეს ინიციატივის, გაწევრიანების კრიტერიუმებისა და მის ფარგლებში განხორციელებული პროექტების შესახებ, ყველაფერთან ერთად განიხილეს ევროკავშირთან დაკავშირებული მითები.",
  },
  {
    imageGallery: [],
    image: name362,
    id: 362,
    title:
      "2024 წლის 5-6-7 აპრილს სსიპ აჭარის მუზეუმი მოსწავლეთა II რეგიონალურ კონფერენციას - „მუზეუმის როლი განათლებაში“ მასპინძლობდა.\n კონფერენციაზე მოსწავლეებმა კვლევითი ნაშრომები და საინტერესო თემები წარმოადგინეს, რომლებმაც დამსწრე საზოგადოების დიდი მოწონება დაიმსახურა.",
    briefText:
      "კონფერენციის მუშაობაში აქტიურად იყვნენ ჩართული ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები.\nნუცა ხუციშვილი - ხელმძღვანელი ზვიად ჩხენკელი,\nლუკა უჩანეიშვილი -ხელმძღვანელი ხათუნა ბერაძე,\nდათა ურუშაძე- ხელმძღვანელი ინგა მართალიშვილი,\nლიკა ჯოხაძე- ხელმძღვანელი პირიმზე რურუა , \nანანო ფუტკარაძე- ხელმძღვანელი კახი კახიძე,\nალექსანდრე ჯელია- ხელმძღვანელი კახი კახიძე,\n რუსუდან კეშელავა -ხელმძღვანელი ანა ანუშიძე,\nმარიამ გოროზია- ხელმძღვანელი სალომე მიქაძე,გვანცა ალელიშვილი -ხელმძღვანელი-მაიკო ბოლქვაძე,\nანა ონიაშვილი -ხელმძღვანელი ირინა ვიდულინა,\nბარბარე ბარამიძე -ხელმძღვანელი ირინა ვიდულინა,\nბარბარე მიქავა- ხელმძღვანელი ირინა ვიდულინა , \nეკატერინე მგალობლიშვილი- ხელმძღვანელი ირინა ვიდულინა.\nკონფერენციის დასრულების შემდეგ მოსწავლეებსა და პედაგოგებს გადაეცათ სერტიფიკატები.\n ვულოცავთ ჩვენს მოსწავლეებსა და მათ პედაგოგებს ამ წარმატებას!",
  },
  {
    imageGallery: [],
    image: name363,
    id: 363,
    title:
      "გაზაფხულის შემობრძანება გვახარეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველკლასელებმა.",
    briefText:
      "პატარებმა დიდი მონდომებითა და სიყვარულით შეასრულეს მხატვრულ- მუსიკალური ნომრები, იცეკვეს, იმღერეს და ტკბილი სიტყვებით გული გაუთბეს დედიკოებს და მოწვეულ სტუმრებს.\n I-3 კლასის აღმზრდელი ირინა ჩხაიძე. მუსიკის მასწავლებელი ლოლა ჯაფარიძე.",
  },
  {
    imageGallery: [],
    image: name364,
    id: 364,
    title:
      '2024 წლის 10 აპრილს I-4 კლასის მოსწავლეები ქართული ენისა და ლიტერატურის მასწავლებელ ნინო უგულავასა და კლასის აღმზრდელ თამარ კვერღელიძესთან ერთად სტუმრობნენ სტუდია "ანდამატს" და ნამდვილ შემოქმედებად იქცნენ.',
    briefText:
      "თიხისაგან გამოძერწეს ფიგურები, მოისმინეს საინტერესო ინფორმაცია თიხასა და მის თვისებებზე, შეიძინეს ცოდნა და სასიამოვნოდ გაატარეს დღე.",
  },
  {
    imageGallery: [],
    image: name365,
    id: 365,
    title:
      "2024 წლის 10 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა აჭარის ავტონომიური რესპუბლიკის განათლების, კულტურისა და სპორტის სამინისტროს ქვეპროგრამის „კონკურსები და ოლიმპიადები“ ფარგლებში გათვალისწინებული სახვითი ხელოვნების კონკურსის პირველი ტური , რომელშიც მონაწილეობა მიიღეს V-IX კლასების მოსწავლეებმა .",
    briefText:
      "2024 წლის 10 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა აჭარის ავტონომიური რესპუბლიკის განათლების, კულტურისა და სპორტის სამინისტროს ქვეპროგრამის „კონკურსები და ოლიმპიადები“ ფარგლებში გათვალისწინებული სახვითი ხელოვნების კონკურსის პირველი ტური , რომელშიც მონაწილეობა მიიღეს V-IX კლასების მოსწავლეებმა .",
  },
  {
    imageGallery: [],
    image: name366,
    id: 366,
    title:
      '2024 წლის 12 აპრილს , ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასის მოსწავლეებისთვის ხარიტონ ახვლედიანის სახელობის მუზეუმში ჩატარდა საგანმანათლებლო პროგრამა "ფრინველთა სამყარო აჭარაში".',
    briefText:
      '2024 წლის 12 აპრილს , ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასის მოსწავლეებისთვის ხარიტონ ახვლედიანის სახელობის მუზეუმში ჩატარდა საგანმანათლებლო პროგრამა "ფრინველთა სამყარო აჭარაში".',
  },
  {
    imageGallery: [],
    image: name367,
    id: 367,
    title:
      '2024 წლის 12 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-2 და III-2 კლასის მოსწავლეებმა "დედა ენის" დღის აღსანიშნავად შეარჩიეს, დახატეს და გააფორმეს მათთვის გამორჩეული ქართული სიტყვები.ისაუბრეს სიტყვაქარგულ ქართულ ენაზე .',
    briefText:
      "გაკვეთილს უძღვებოდა ქართული ენისა და ლიტერატურის მასწავლებელი ნინო უგულავა.",
  },
  {
    imageGallery: [],
    image: name368,
    id: 368,
    title:
      "2024 წლის 10 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლისIX-1 კლასის მოსწავლეებს მოქალაქეობის გაკვეთილი (მასწავლებელი-ნატალია სირაბიძე) ჩაუტარდათ განსხვავებულ გარემოში - პროფესიულ სასწავლებელში, კოლეჯში “ბლექსი”.",
    briefText:
      "გაკვეთილის მიზანი იყო მოსწავლეებში ცნობიერების ამაღლება პროფესიული განათლების, სასწავლებლებისა და სამომავლო შესაძლებლობების შესახებ.",
  },
  {
    imageGallery: [],
    image: name369,
    id: 369,
    title:
      '2024 წლის 13 აპრილს სენაკის წმინდა ალექსი შუშანიას სახელობის სკოლა-გიმნაზიაში ჩატარდა მასწავლებელთა კონფერენცია თემაზე "ვეფხისტყაოსანი"- სიბრძნისა და სიმართლის დიდი წიგნი".',
    briefText:
      'კონფერენციის მუშაობაში მონაწილეობდნენ და მოხსენებებით წასრდგნენ ბათუმის წმინდა ანდრია პირველწიდებულის სახელობის სკოლის პედაგოგები მარინა ტალახაძე და პირიმზე რურუა:\nმარინა ტალახაძე - სათნოებათა კიბე "ვეფხისტყაოსანში";\n პირიმზე რურუა - ამბავი თამარ მეფისა - ის, რაზეც არ საუბრობენ ისტორიის მასწავლებლები.',
  },
  {
    imageGallery: [],
    image: name370,
    id: 370,
    title:
      "ქართული ენის დღესთან დაკავშირებით ასე ეფერებიან, აჩუქურთმებენ, აგვირისტებენ, ქარგავენ ქართულ ანბანს ჩვენი პატარები ხელოვნების მასწავლებლის ირინა სევოსტიანოვას დახმარებით.",
    briefText:
      "ქართული ენის დღესთან დაკავშირებით ასე ეფერებიან, აჩუქურთმებენ, აგვირისტებენ, ქარგავენ ქართულ ანბანს ჩვენი პატარები ხელოვნების მასწავლებლის ირინა სევოსტიანოვას დახმარებით.",
  },
  {
    imageGallery: [],
    image: name371,
    id: 371,
    title:
      "2024 წლის 15 აპრილს, ახალგაზრდა ევროპელი ელჩების ინიციატივის მხარდაჭერით ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა დედაენის დღისადმი მიძღვნილი ვიქტორინა; მასწავლებელი სალომე მიქაძე.",
    briefText:
      "10² კლასის მოსწავლეებმა უპასუხეს მრავალფეროვან კითხვებს, რომლებიც ეხებოდა ქართულ ანბანს, მხატვრულ ლიტერატურას, გრამატიკასა და ისტორიას.\n გამარჯვებულ ჯგუფებს გადაეცათ სიმბოლური საჩუქრები",
  },
  {
    imageGallery: [],
    image: name372,
    id: 372,
    title:
      "2024 წლის 17 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის წამყვანმა მასწავლებელმა შორენა ბოლქვაძემ VI-1 კლასში ჩაატარა ღია გაკვეთილი ქართულ ენაში თემაზე: რთული წინადადება.",
    briefText:
      "გაკვეთილს ესწრებოდნენ სკოლის ადმინისტრაციისა და ქართული ენის კათედრის წევრები.",
  },
  {
    imageGallery: [],
    image: name373,
    id: 373,
    title:
      '"DevOps და ხელოვნური ინტელექტი" - ამ სახელწოდებით ტრენინგი საქართველოს უნივერსიტეტის მეცნიერებისა და ტექნოლოგიების სკოლამ ბათუმში ჩაატარა.\n მოსწავლეებმა DevOps-ისა და ხელოვნური ინტელექტის შესახებ მიიღეს ინფორმაცია. ტრენინგი ღია კარის დღის ფარგლებში გაიმართა.',
    briefText:
      "ტრენინგს ესწრებოდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები, წარმატებული და აქტიური ჩართულობისთვის დაიმსახურეს სერთიფიკატები.",
  },
  {
    imageGallery: [],
    image: name374,
    id: 374,
    title:
      "2024 წლის 18 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის V-2 კლასის მოსწავლეებს ქართული ენისა და ლიტერატურის გაკვეთილი ბიბლიოთეკაში ჩაუტარდათ.",
    briefText:
      'ქართულის მასწავლებელმა შორენა ბოლქვაძემ პატარებს რევაზ ინანიშვილის "სასწაული ამბავი ტყეში". შემდეგ კი ისაუბრეს ადამიანისა და ბუნების ურთიერთობის შესახებ.',
  },
  {
    imageGallery: [],
    image: name375,
    id: 375,
    title:
      "22 აპრილი- დედამიწის დღე და ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასის მოსწავლეების თვალით დანახული დედამიწა (ხელოვნების მასწავლებელი ირინა სევოსტიანოვა)",
    briefText:
      "22 აპრილი- დედამიწის დღე და ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასის მოსწავლეების თვალით დანახული დედამიწა (ხელოვნების მასწავლებელი ირინა სევოსტიანოვა)",
  },
  {
    imageGallery: [],
    image: name376,
    id: 376,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მეათე კლასის მოსწავლეები გიორგი ცინცაძე და აჩი ბაკურიძე იმყოფებიან ევროპული საგანმანათლებლო ცენტრის მიერ ორგანიზებული ვიზიტით ბრიუსელსა და სტრასბურგში.",
    briefText:
      "მონაწილეებს ერთი კვირის განმავლობაში მნიშვნელოვან და საინტერესო შეხვედრები ჰქონდათ ევროკავშირის ინსტიტუციებში და ნატოში.\n აღსანიშნავია, რომ ახალგაზრდები ნატოს შტაბ-ბინაში ალიანსის წარმომადგენლებს შეხვდნენ; ისაუბრეს ნატო-საქართველოს ურთიერთობებსა და სამხრეთ კავკასიის თემაზე.\n წარმატებებს ვუსურვებს ჩვენს საამაყო მოსწავლეებს!",
  },
  {
    imageGallery: [],
    image: name377,
    id: 377,
    title:
      "მშვენიერი ვერნისაჟი შემოგვთავაზეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 და VII-5 კლასის მოსწავლეებმა.",
    briefText:
      "მათ ხელოვნების მასწავლებლის თამუნა წულაძის დახმარებით კუბისტურ სტილში, Პაბლო პიკასოს ნამუშევრების მიხედვით შესრულებული ნახატები და სამგანზომილებიანი პორტრეტები გამოფინეს.",
  },
  {
    imageGallery: [],
    image: name378,
    id: 378,
    title:
      "2024 წლის 23 აპრილს ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში წიგნის და საავტორო უფლებების დაცვის საერთაშორისო დღე აღინიშნა! პროექტის ორგანიზატორი არის მოქალაქეობისა და გეოგრაფიის მენტორი მასწავლებელი ანა ანუშიძე.",
    briefText:
      "VII - IX კლასის მოსწავლეები გაეცნენ საქართველოს კანონს საავტორო და მომიჯნავე უფლებების შესახებ.\n შეასრულეს პრაქტიკული სავარჯიშოები პატენტის, გამოგონების და სასარგებლო მოდელის თემატიკაზე.\n პროექტული სწავლების ფარგლებში XI კლასის მოსწავლეებმა დაამზადეს საინფორმაციო ბარათები, თემაზე „პლაგიატის გამოვლენის 10 შემთხვევა“.\n VII - IX კლასის მოსწავლეებმა შეასრულეს სახალისო ამოცანები სხვადასხვა სახის პლაგიატის ამოცნობასთან დაკავშირებით.",
  },
  {
    imageGallery: [],
    image: name379,
    id: 379,
    title:
      "პირველად აღნიშნეს დედამიწის დღე ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველკლასელებმა.",
    briefText:
      'მოამზადეს პლაკატები თემაზე:\n დედამიწა ჩვენი სახლია!\n ბუნებას უნდა მოვუაროთ!\n ხოლო ქართულის მასწავლებლის ნინო უგულავასაგან I-4 კლასის მოსწავლეებმა "პატარა ბუნებისდამცველების" ტიტულიც დაიმსახურეს !',
  },
  {
    imageGallery: [],
    image: name380,
    id: 380,
    title:
      "2024 წლის 23 აპრილს , ცნობილი ინგლისელი პოეტისა და დრამატურგის, უილიამ შექსპირის დაბადების დღესთან დაკავშირებით ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის V-3 კლასში ჩატარდა ინგლისური ენის საინტერესო გაკვეთილი. მოსწავლეებმა იმუშავეს წყვილებში, ჯგუფებში, ერთმანეთს გააცნეს შექსპირის ბიოგრაფია და საინტერესო ფაქტები მისი ცხოვრებიდან.",
    briefText:
      'ხალისით შეასრულეს აქტივობა: "ამოიკითხე გვირგვინიდან უილიამ შექსპირის ცნობილი ფრაზა".\n ინგლისური ენის მასწავლებელი- ზეინაბ კონცელიძე.',
  },
  {
    imageGallery: [],
    image: name381,
    id: 381,
    title:
      'საინტერესოდ დაგეგმა სასწავლო პროცესი ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის XI-3 კლასის ინგლისური ენის მასწავლებელმა ნატალია ფრუიძემ თემაზე "იყავი მუზეუმის კურატორი".',
    briefText:
      "განიხილეს ტექსტი, უპასუხეს შეკითხვებს: -გსურს თუ არა მსგავს პროგრამაში მონაწილეობის მიღება?-რატომ?-რატომ არა? -რა უნდა გააკეთო თუ კი დაინტერესებული ხარ ამ პროექტით?\n მომდევნო გაკვეთილი ჩატარდა ხელოვნების მუზეუმში. ახალგაზრდებმა უპასუხეს მასწავლებლის შემდეგ შეკითხვებს:\n 1. გიყვარს თუ არა მუზეუმში სიარული?\n 2. როგორი ტიპის მუზეუმს ანიჭებ უპირატესობას?\n 3. რომ შეგეძლოს მსოფლიოს რომელ მუზეუმს ეწვეოდი და რატომ?\n 4. ფიქრობ თუ არა რომ სკოლამ ხშირად უნდა გაუწიოს ორგანიზება მუზეუში ვიზიტს?\n 5. ოდესმე თუ ყოფილხარ უჩვეულო მუზეუმში? სად და როდის?\n 6. ვინმემ რომ გთხოვოთ გქონდეთ თქვენი პირადი მუზეუმი, რა ნივთებს განათავსებდით მასში?",
  },
  {
    imageGallery: [],
    image: name382,
    id: 382,
    title:
      '2024 წლის 23 აპრილს ბათუმის არქეოლოგიურ მუზეუმში წიგნისა და საავტორო უფლებების დღესთან დაკავშირებით გაიმართა მოსწავლეთა ნამუშევრების გამოფენა თემაზე "თიხის წიგნებიდან თანამედროვე წიგნებამდე".',
    briefText:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის XI-4 კლასის მოსწავლემ გვანცა დევაძემ წარმოადგინა ამავე კლასის მოსწავლეთა მიერ თანამედროვე კომიქსად ქცეული ჰაგიოგრაფიული ტექსტი გიორგი მერჩულეს "გრიგოლ ხანძთელის ცხოვრება" . ქართული ენისა და ლიტერატუტის მასწავლებელი თამარ ლომთაძე.',
  },
  {
    imageGallery: [],
    image: name383,
    id: 383,
    title:
      '2024 წლის 25 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-3 კლასში ჩატარდა ღია გაკვეთილი ქართულ ენასა და ლიტერატურაში თემაზე "ორი ძმა", რომელსაც უძღვებოდა პედაგოგი რუსუდან თოიძე.',
    briefText:
      '2024 წლის 25 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-3 კლასში ჩატარდა ღია გაკვეთილი ქართულ ენასა და ლიტერატურაში თემაზე "ორი ძმა", რომელსაც უძღვებოდა პედაგოგი რუსუდან თოიძე.',
  },
  {
    imageGallery: [],
    image: name384,
    id: 384,
    title:
      '2024 წლის 25 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 კლასში ჩატარდა ღია გაკვეთილი ხელოვნებაში თემაზე "ფოვიზმი, აბსტრაქციონიზმი, კუბიზმი", რომელსაც უძღვებოდა პედაგოგი თამუნა წულაძე.',
    briefText:
      '2024 წლის 25 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 კლასში ჩატარდა ღია გაკვეთილი ხელოვნებაში თემაზე "ფოვიზმი, აბსტრაქციონიზმი, კუბიზმი", რომელსაც უძღვებოდა პედაგოგი თამუნა წულაძე.',
  },
  {
    imageGallery: [],
    image: name385,
    id: 385,
    title:
      '2024 წლის 25 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 კლასში ჩატარდა ღია გაკვეთილი ხელოვნებაში თემაზე "ფოვიზმი, აბსტრაქციონიზმი, კუბიზმი", რომელსაც უძღვებოდა პედაგოგი თამუნა წულაძე.',
    briefText:
      'მოსწავლეებს ჩაუტარდათ თემატური ექსკურსია და საგანმანათლებლო პროგრამა: "სამყარო ცოცხალ ფერებში."\n პროგრამის დასასრულს კლასის პედაგოგს, თამარ წულაძეს - გადაეცა სსიპ ,,აჭარის მუზეუმის" სერტიფიკატი საგანმანათლებლო პროგრამაში მონაწილეობისათვის.',
  },
  {
    imageGallery: [],
    image: name386,
    id: 386,
    title:
      "ქალაქ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II კლასის მოსწავლეები სტუმრად ხელოვნების მუზეუმში.",
    briefText:
      "საგანმანათლებლო პროგრამა ,,პეიზაჟი“. \n პედაგოგები: ცისანა კლდიაშვილი, ირინე სევოსტიანოვა.",
  },
  {
    imageGallery: [],
    image: name387,
    id: 387,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-2 კლასის მოსწავლეებმა მონაწილეობა მიიღეს საგანმანათლებლო პროექტში, რომელიც ორგანიზებული იყო აჭარის კულტურული მემკვიდრეობის დაცვის სააგენტოს მიერ.",
    briefText:
      'პროგრამის ფარგლებში გონიოს ციხის ტერიტორიაზე ჩატარდა საგანმანათლებლო შემეცნებითი გაკვეთილი თემაზე: " პრეისტორია და პრეისტორიული ხანის ე.წ გამოქვაბულის მხატვრობა".\n ბავშვები გაეცნენ პირველყოფილი ადამიანის მიერ შექმნილ ნახატებს და შეეცადნენ პირველყოფილი მხატვრობიდან შერჩეული ნახატების ასლების დამზადებას.\n IV-2 კლასის დამრიგებელი - მაია იმნაძე, ხელოვნების მასწავლებელი- ირინა სევოსტიანოვა, ოროექტის ავტორი- სოფო სანიკიძე.',
  },
  {
    imageGallery: [],
    image: name388,
    id: 388,
    title:
      '"აჩუქე წიგნი! " ამ ტრადიციულად ქცეულ გამოწვევას შეუერთდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-4 კლასის მოსწვლეები და 23 აპრილს , წიგნის საერთაშორისო დღეს, სიხარულით აჩუქეს ერთმანეთს წიგნები. მასწავლებელი რუსუდან თოიძე.',
    briefText:
      '"აჩუქე წიგნი! " ამ ტრადიციულად ქცეულ გამოწვევას შეუერთდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-4 კლასის მოსწვლეები და 23 აპრილს , წიგნის საერთაშორისო დღეს, სიხარულით აჩუქეს ერთმანეთს წიგნები. მასწავლებელი რუსუდან თოიძე.',
  },
  {
    imageGallery: [],
    image: name389,
    id: 389,
    title:
      "2024 წლის 27 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის ხელოვნების პედაგოგის თამარ წულაძის მოსწავლეების გამოფენა მოეწყო ბათუმის ხელოვნების უნივერსიტეტში.",
    briefText: "პატარების ნამუშევრებმა დიდი მოწონება დაიმსახურა.",
  },
  {
    imageGallery: [],
    image: name390,
    id: 390,
    title:
      "2024 წლის 27 აპრილს თბილისში ეროვნული სასახლის ორგანიზებით და საქართველოს საპატრიარქოს წმ. ანდრია პირველწოდებულის სახელობის ქართული უნივერსიტეტის მხარდაჭერით მოსწავლეთა 77-ე სასწავლო -კვლევითი კონფერენცია ჩატარდა.",
    briefText:
      "მონაწილეები მთელი საქართველოდან კონფერენციის 9 სექციაში მეცნიერების სხვადასხვა სფეროში შექმნილ სამეცნიერო ნაშრომებს იცავდნენ.\n კონფერენციის მთავარი თემაა: ,,მდგრადი განვითარების მიზნების ხელშეწყობისა და თანამედროვე გლობალური პრობლემური საკითხების გადაჭრა.“\n კონფერენციის მუშაობაში წარმატებულად მონაწილეობდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები:\n ანა ონიაშვილი , ქიმიის სექცია, ხელმძღვანელი ირინა ვიდულინა- I ადგილი!\n დავით ურუშაძე, სამოქალაქო განათლების სექცია, ხელმძღვანელი ინგა მართალიშვილი- I ადგილი!\n ალექსანდრე ჯელია, ისტ-ის სექცია, ხელმძღვანელი კახი კახიძე -II ადგილი!\n კესარია გათენაძე, ისტორიის სექცია, ხელმძღვანელი ზვიად ჩხენკელი -II ადგილი!\n ნუცა ხუციშვილი, ისტორიის სექცია, ხელმძღვანელი ზვიად ჩხენკელი, დაჯილდოვდა სიგელით!\n ბარბარე ბარამიძე, ქიმიის სექცია, ხელმძღვანელი ირინა ვიდულინა, დაჯილდოვდა სიგელით!\n ბარბარე მიქავა, ქიმიის სექცია, ხელმძღვანელი ირინა ვიდულინა, დაჯილდოვდა სიგელით!\n ტრადიცია გრძელდება! ყველას გილოცავთ ამ დიდ წარმატებას!",
  },
  {
    imageGallery: [],
    image: name391,
    id: 391,
    title:
      '2024 წლის 27 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში შედგა შემეცნებით-ინტელექტუალური შეხვედრა "ჩვენ გვიყვარს ისტორია!"',
    briefText:
      'ერთმანეთს ისტორიის ცოდნაში ეჯიბრებოდნენ VIII-3 და VIII-4 კლასების გუნდები "გორგასლიანი" და "დავითფერული".\n ღონისძიების ორგანიზატორია ისტორიის პედაგოგი ხათუნა ბერაძე.',
  },
  {
    imageGallery: [],
    image: name392,
    id: 392,
    title:
      "2024 წლის 14 მაისს ბათუმის აკაკი წერეთლის სახელობის ბიბლიოთეკის ორგანიზებით ჩატარდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IX კლასის ღია გაკვეთილი საქართველოს ისტორიაში თემაზე: ,,საისტორიო წყაროები წმინდა ანდრია პირველწოდებულის საქართველოში მოღვაწეობის შესახებ“ , რომელსაც უძღვებოდნენისტორიის პედაგოგი პირიმზე რურუა და საღვრთო სჯულის პედაგოგი ალექსანდრე მელიქაძე.მოსწავლეები აქტიურად იყვნენ ჩართული საგაკვეთილო პროცესში.",
    briefText:
      "2024 წლის 14 მაისს ბათუმის აკაკი წერეთლის სახელობის ბიბლიოთეკის ორგანიზებით ჩატარდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IX კლასის ღია გაკვეთილი საქართველოს ისტორიაში თემაზე: ,,საისტორიო წყაროები წმინდა ანდრია პირველწოდებულის საქართველოში მოღვაწეობის შესახებ“ , რომელსაც უძღვებოდნენისტორიის პედაგოგი პირიმზე რურუა და საღვრთო სჯულის პედაგოგი ალექსანდრე მელიქაძე.მოსწავლეები აქტიურად იყვნენ ჩართული საგაკვეთილო პროცესში.",
  },
  {
    imageGallery: [],
    image: name393,
    id: 393,
    title:
      "2024 წლის 18 მაისს ბათუმის წმ.ანდრია პირველწოდებულის სახელობის სკოლაში გაიმართა საკალათბურთო ტურნირის ფინალური მატჩი IX-2 და XII-1 კლასებს შორის. მატჩი მეთორმეტე კლასის გამარჯვებით დასრულდა შედეგით 58:51.",
    briefText:
      "ვულოცავთ გამარჯვებულებს და ვუსურვებთ მომავალ წარმატებებს!\n აღსანიშნავია მეცხრე კლასის კალათბურთელთა გამორჩეული თამაშიც.\n გვსურს, მადლობა მოვახსენოთ იმ მოსწავლეებსა და მშობლებს, რომლებიც ესწრებოდნენ მატჩს! თქვენი გულშემატკივრობა ძალიან მნიშვნელოვანია!",
  },
  {
    imageGallery: [],
    image: name394,
    id: 394,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-3 კლასის მოსწავლეებმა ბუნებისმეტყველების გაკვეთილზე დაამზადეს დიორამები თემაზე - "გარემო და ცოცხალი არსებები".',
    briefText: "ბუნების მასწავლებელი - მანანა გოგიბერიძე.",
  },
  {
    imageGallery: [],
    image: name392,
    id: 392,
    title:
      "2024 წლის 14 მაისს ბათუმის აკაკი წერეთლის სახელობის ბიბლიოთეკის ორგანიზებით ჩატარდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IX კლასის ღია გაკვეთილი საქართველოს ისტორიაში თემაზე: ,,საისტორიო წყაროები წმინდა ანდრია პირველწოდებულის საქართველოში მოღვაწეობის შესახებ“ , რომელსაც უძღვებოდნენისტორიის პედაგოგი პირიმზე რურუა და საღვრთო სჯულის პედაგოგი ალექსანდრე მელიქაძე.მოსწავლეები აქტიურად იყვნენ ჩართული საგაკვეთილო პროცესში.",
    briefText:
      "2024 წლის 14 მაისს ბათუმის აკაკი წერეთლის სახელობის ბიბლიოთეკის ორგანიზებით ჩატარდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IX კლასის ღია გაკვეთილი საქართველოს ისტორიაში თემაზე: ,,საისტორიო წყაროები წმინდა ანდრია პირველწოდებულის საქართველოში მოღვაწეობის შესახებ“ , რომელსაც უძღვებოდნენისტორიის პედაგოგი პირიმზე რურუა და საღვრთო სჯულის პედაგოგი ალექსანდრე მელიქაძე.მოსწავლეები აქტიურად იყვნენ ჩართული საგაკვეთილო პროცესში.",
  },
  {
    imageGallery: [],
    image: name393,
    id: 393,
    title:
      "2024 წლის 18 მაისს ბათუმის წმ.ანდრია პირველწოდებულის სახელობის სკოლაში გაიმართა საკალათბურთო ტურნირის ფინალური მატჩი IX-2 და XII-1 კლასებს შორის. მატჩი მეთორმეტე კლასის გამარჯვებით დასრულდა შედეგით 58:51.",
    briefText:
      "ვულოცავთ გამარჯვებულებს და ვუსურვებთ მომავალ წარმატებებს!\n აღსანიშნავია მეცხრე კლასის კალათბურთელთა გამორჩეული თამაშიც.\n გვსურს, მადლობა მოვახსენოთ იმ მოსწავლეებსა და მშობლებს, რომლებიც ესწრებოდნენ მატჩს! თქვენი გულშემატკივრობა ძალიან მნიშვნელოვანია!",
  },
  {
    imageGallery: [],
    image: name394,
    id: 394,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-3 კლასის მოსწავლეებმა ბუნებისმეტყველების გაკვეთილზე დაამზადეს დიორამები თემაზე - "გარემო და ცოცხალი არსებები".',
    briefText: "ბუნების მასწავლებელი - მანანა გოგიბერიძე.",
  },
  {
    imageGallery: [],
    image: name395,
    id: 395,
    title:
      '2024 წლის 14 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში შედგა შემეცნებით-ინტელექტუალური შეხვედრა "ჩვენ გვიყვარს ისტორია!"',
    briefText:
      'ერთმანეთს ისტორიის ცოდნაში ეჯიბრებოდნენ VII-1 და VII-3კლასების გუნდები "ჯვაროსნები" და "ელიტა".\n ღონისძიების ორგანიზატორია ისტორიის პედაგოგი ხათუნა ბერაძე.',
  },
  {
    imageGallery: [],
    image: name396,
    id: 396,
    title:
      "პარაკლისი კურსდამთავრებულთათვის\n ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლას ერთი მშვენიერი ტრადიცია აქვს, სკოლის კურსდამთავრებულთათვის და მათი ოჯახის წევრებისთვის საჯანმრთელო პარაკლისის გადახდა, ახალგაზრდების დალოცვა და ასე გაცილება სკოლიდან.",
    briefText:
      "2024 წელს გიმნაზიას 25-ე თაობა ამთავრებს.\n პარაკლისი მეთორმეტე კლასელებისთვის გადაიხადა სკოლის მოძღვარმა, დეკანოზმა დიმიტრიმ (სარჯველაძე), მოსწავლეები დალოცა სკოლის რექტორმა, დეკანოზმა იაკობმა (ბენიძე).\n პარაკლისს ესწრებოდნენ დამრიგებლები ლალი ბოლქვაძე, მარინა ტალახაძე და თამარ ვაშაკიძე და მშობელები.\n კურსდამთავრებულებმა (კლასებმა) ტრადიციისამებრ ხატები შეწირეს წმ. ნინოს სახელობის ტაძარს.\n ვულოცავთ ჩვენს საამაყო გიმნაზიელებს!",
  },
  {
    imageGallery: [],
    image: name397,
    id: 397,
    title: "ქართულ ლიტერატურის ღია გაკვეთილი",
    briefText:
      '2024 წლის 24 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ქართული ენისა და ლიტერატურის მასწავლებელმა რუსუდან თავხელიძემ ჩაატარა X-3 კლასში ღია გაკვეთილი თემაზე "ავთანდილის ანდრძი".',
  },
  {
    imageGallery: [],
    image: name398,
    id: 398,
    title:
      "2024 წლის 17 მაისს ბათუმის წმ. ანდრია პირველწოდებულის სკოლის მოსწავლეებს მასპინძლობდა აგრარული და მემბრანული ტექნოლოგიების ინსტიტუტი.",
    briefText:
      "X-XI კლასის მოსწავლეებმა მონაწილეობა მიიღეს STEM საგანმანათლებლო სისტემაზე დაფუძნებულ უაღრესად საინტერესო სახალისო -შემეცნებით ქიმიურ ექსპერიმენტებში.\n ქიმიის მასწავლებლები ნონა აბაშიძე და ირინა ვიდულინა.",
  },
  {
    imageGallery: [],
    image: name399,
    id: 399,
    title:
      '2024 წლის 24 მაისს, ბათუმის ილია ჭავჭავაძის სახელობის დრამატულ თეატრში გაიმართა კონოფესტივალ "ცა-მეტის" დაჯილდოვება, რომელშიც მონაწილეობას იღებდნენ ჩვენი სკოლის მოსწავლეები მათ მიერ შექმნილი ფილმით "სინათლის ზემოთ"//“Above The Light”.\n გიმნაზიელთა ფილმმა გაიმარჯვა ნომინაციაში „მოზარდის ხმა“.',
    briefText:
      "ამავე ფილმში გოგოს როლის საუკეთესოდ შესრულებისთვის დაჯილდოვდა ქრისტინე ანთაძე.\n სცენარის ავტორი, რეჟისორი, პროდიუსერი, მონტაჟი - ქრისტინე ანთაძე\n როლებში: ქრისტინე ანთაძე, ანდრია კიკნაძე, ნიტა ანანიძე, ნიკოლოზ გოგოლაძე, თამარ ჩანტლაძე\n დამხმარე ჯგუფი (background/voice): ელენე ხუჯაძე, ანანო ხინკილაძე, ანდრია ანთაძე.\n გილოცავთ!\n ჩვენ გვჯერა, თქვენი მომავალი წარმატებებით კვლავ ვიამაყებთ!",
  },
  {
    imageGallery: [],
    image: name400,
    id: 400,
    title:
      "დიდი სიამაყით გვსურს გაუწყოთ, რომ 2024 წლის 25 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა ივანე ჯავახიშვილის სახელობის თბილისის სახელმწიფო უნივერსიტეტის კულტურის კვლევათა ინსტიტუტის (თსუ კულტურის კვლევების ინსტიტუტი/ Institute of Cultural Studies, TSU) ყოველწლიური სტუდენტთა XI სამეცნიერო კონფერენცია „კულტურა, იდენტობა, პოლიტიკა”.\n მიუხედავად იმისა, რომ სტუდენტურია, უკვე მეორე წელია კონფერენციაზე მოხსენებებს წარადგენენ ჩვენი მოსწავლეებიც.",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლისთვის დიდი პატივია, რომ სტუმრად ჩამობრძანდნენ ცნობილი ქართველი და უცხოელი პროფესორები -\n ნინო ჩიქოვანი,\n ირაკლი ჩხაიძე,\n ქეთი კაკიტელაშვილი,\n ივანე წერეთელი და\n ნორდის უნივერსიტეტის (ნორვეგია) პროფესორი ფრენკ ჯეიკობი,\n გვესტუმრა, ასევე, შოთა რუსთაველის სახელობის ბათუმის სახელმწიფო უნივერსიტეტის პროფესორი ჯემალ კარალიძე.\n კონფერენციის მუშაობაში მონაწილეობდნენ მოსწავლეები:\n კესარია გათენაძე - ხელმძღვანელი ზვიად ჩხენკელი,\n ნუცა ხუციშვილი - ხელმძღვანელი ზვიად ჩხენკელი,\n ლიკა ჯოხაძე- ხელმძღვანელი პირიმზე რურუა,\n მარიამ გოროზია-ხელმძღვანელი სალომე მიქაძე,\n გიორგი ცინცაძე-ხელმძღვანელი მარინა ტალახაძე,\n ლუკა უჩანეიშვილი-ხელმძღვანელი ხათუნა ბერაძე,\n რუსუდან კეშელავა-ხელმძღვანელი ანა ანუშიძე.\n ძვირფასმა სტუმრებმა სიტყვით მიმართეს მომხსენებლებს და დამსწრე საზოგადოებას, დასამახსოვრებელი და მნიშვნელოვანი რეპლიკებით შეაფასეს მოსწავლეთა მოკრძალებული ნამუშევრები, გამოთქვეს მომავალი თანამშრომლობის სურვილი.\n ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა ჩართვა საქართველოს უპირველესი უნივერსიტეტის კონფერენციაში, თბილისისა და ბათუმის აკადემიური წრეების პროფესორ-მასწავლებლებთან შეხვედრები თუ ლექციები ნამდვილად უნიკალური შესაძლებლობაა ახალგაზრდების განათლება-განვითარებისთვის.",
  },
  {
    imageGallery: [],
    image: name401,
    id: 401,
    title:
      "„კულტურა, იდენტობა, პოლიტიკა” - თსუ კულტურის კვლევების ინსტიტუტი/ Institute of Cultural Studies, TSU -ის ყოველწლიური სტუდენტთა მე-11 სამეცნიერო კონფერენცია და ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა -ის მოსწავლეთა მოხსენებები.",
    briefText:
      "გადაცემის სტუმრები\n- მარიამ გოროზია- წმ.ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე , მისი ხელმძღვანელი სამოქალაქო განათლების პედაგოგი სალომე მიქაძე . \n-ამავე სკოლის მოსწავლე ლუკა უჩანეიშვილი და მისი ხელმძღვანელი წმ.ანდრია პირველწოდებულის სახელობის სკოლის ისტორიის პედაგოგი ხათუნა ბერაძე,\n#ერთადვიმსჯელოთდავიზრუნოთმომავალზე\n-რა თემები შეარჩიეს მოსწვლეებმა ? როგორესმით კონფერენციის ძირითადი მიმართულებები ? \n-როგორ იკვეთება თანამედროვე მსოფლიოში მიმდინარე პროცესების კულტურული ასპექტები და სხვა მასთან დაკავშირებული საკითხები ?",
  },
  {
    imageGallery: [],
    image: name402,
    id: 402,
    title:
      "2024 წლის 28 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III- 3 კლასის მოსწავლეებს ინგლისური ენის გაკვეთილი ჩაუტარდათ განსხვავებულ გარემოში- სკოლის ბიბლიოთეკაში.",
    briefText:
      'პატარებმა ინგლისურის მასწავლებელ ზეკო კონცელიძესთან ერთად წაიკითხეს მოთხრობა "The lazy grasshopper" - ჭრიჭინა და ჭიანჭველა.\nისაუბრეს, იმსჯელეს მოთხრობის პერსონაჟებზე, გააკეთეს დასკვნა იმის შესახებ , რას გვასწავლის ეს მოთხრობა?',
  },
  {
    imageGallery: [],
    image: name403,
    id: 403,
    title:
      "25.05.2024- ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველკლასელთა მხიარული სტარტები ტრადიციულად დიდი ჟრიამულით და ემოციებით წარიმართა სპორტის მასწავლებლის გივი კერესელიძის ხელმძღვანელობით.",
    briefText:
      "25.05.2024- ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პირველკლასელთა მხიარული სტარტები ტრადიციულად დიდი ჟრიამულით და ემოციებით წარიმართა სპორტის მასწავლებლის გივი კერესელიძის ხელმძღვანელობით.",
  },
  {
    imageGallery: [],
    image: name404,
    id: 404,
    title:
      '2024 წლის 29 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა "ევროპული ვიქტორინა", რომელიც ჩაატარა სამოქალაქო განათლების მასწავლებელმა სალომე მიქაძემ "ახალგაზრდა ევროპელი ელჩების ინიციატივის" ხელშეწყობით.',
    briefText:
      "მონაწილეებმა უპასუხეს კითხვებს ევროკავშირის ისტორიის, მიმდინარე მოვლენებისა და მნიშვნელოვანი ფაქტების შესახებ.\nმოსწავლეებმა გაიგეს ბევრი ახალი და საინტერესო ინფორმაცია საქართველოსა და ევროკავაშირის ურთიერთობის შესახებ.\nგამარჯვებულ გუნდს სიმბოლური საჩუქრების სახით გადაეცა წიგნები.",
  },
  {
    imageGallery: [],
    image: name405,
    id: 405,
    title:
      '2024 წლის 30 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-7 კლასში გეოგრაფიის მენტორმა მასწავლებელმა ანა ანუშიძემ ინტეგრირებული სასწავლო პროექტის "ფინანასური და ეკონომიკური წიგნიერების" შემაჯამებელი ღონისძიება ჩაატარა ბავშვთა უფლებების დაცვის კვირეულის ფარგლებში .',
    briefText:
      "პროექტის მსვლელობისას მოსწავლეებმა პრაქტიკული აქტივობების გზით გაიცნეს ფინანსური და ეკონომიკური წიგნიერების საკვანძო საკითხები:\nფული და ბარტერი\nბაზარი (მოთხოვნა - მიწოდება) და ფასი\nკერძო და საჯარო საკუთრება\nდაზოგვა და ქველმოქმედება\nშემოსავალი, ხარჯვა და ბიუჯეტირება.\nპროექტის მუშაობაში ჩაერთო და მოსწავლეებს სტუმრობდა აჭარის ა/რ უმაღლესი საბჭოს აპარატის საფინანსო შესყიდვების და ტექნიკური უზრუნველყოფის დეპარტამენტის საფინანსო უზრუნველყოფის და შესყიდვების განყოფილების უფროსი დავით ბერიძე.",
  },
  {
    imageGallery: [],
    image: name406,
    id: 406,
    title:
      "2024 წლის 30 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში გაიმართა მოძრავი თამაშების შიგასასკოლო ფესტივალის პირველი ტური მესამე კლასების მონაწილეობით სახეობა მინი ფრენბურთში.",
    briefText:
      "ღონისძიების ორგანიზატორი- სპორტის მასწავლებელი გივი კერესელიძე.",
  },
  {
    imageGallery: [],
    image: name407,
    id: 407,
    title:
      "1 ივნისს, ბავშვთა დღეს, მიეძღვნა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის დაწყებითი საფეხურის მოსწავლეთა კონცერტი.",
    briefText:
      "პატარებმა შეასრულეს სიმღერები ქართული მულტფილმებიდან , გააცოცხლეს საყვარელი ანიმაციური გმირები.\nსცენა და დარბაზი გააერთიანა ნაცნობმა და მონატრებულმა მელოდიებმა, მომღერალთა და მოცეკვავეთა არტისტიზმმა და იმპროვიზაციამ!\nკონცერტი მოამზადეს მუსიკის პედაგოგებმა ეკა ბჟინავამ და ლოლა ჯაფარიძემ.",
  },
  {
    imageGallery: [],
    image: name408,
    id: 408,
    title:
      "პატარა მოჭადრაკეების დიდი გამარჯვება!\nაჭარის ჭადრაკის ფედერაციის მხარდაჭერით, 2 ივნისს, მუხრან ვახტანგაძის სახელობის ბათუმის სპორტის სასახლეში საქართველოს სასკოლო ოლიმპიადის ”ნონა გაფრინდაშვილის თასის” I ეტაპი – რაიონული პირველობა გაიმართა.",
    briefText:
      "ღონისძიებაში ჩართული იყო ბათუმის 16 სკოლა.\nთითოეული გუნდი შედგებოდა 4 მონაწილისგან, რომლებსაც წარმოადგენდნენ I-II კლასის მოსწავლეები.\nტურნირი ჩატარდა ოლიმპიური სისტემით.\nფინალურ მატჩში ერთმანეთს დაუპირისპირდნენ წმინდა ანდრია პირველწოდებულის სახელობის სკოლა და №18 საჯარო სკოლა, რომელიც 3-1 წმინდა ანდრია პირველწოდებულის სახელობის სკოლის გამარჯვებით დასრულდა!\nგუნდი შეჯიბრებისთვის მოამზადა სპორტის ღვაწლმოსილმა მასწავლებელმა კარლო ტრაპაიძემ!\nგამარჯვებული გუნდის შემადგენლობა:\nდათა იაკობაძე\nდაჩი ბალაძე\nალექსანდრე გაფრინდაშვილი\nვულოცავთ ჩვენს პატარა მოჭადრაკეებს ამ დიდ გამარჯვებას და ვუსურვებთ წარმატებებს",
  },
  {
    imageGallery: [],
    image: name409,
    id: 409,
    title:
      "ბავშვთა უფლებების კვირეულის შეჯამება აჭარის ა/რ უმაღლეს საბჭოში\nწლის 3 ივნისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები და მოქალაქეობის პედაგოგი ანა ანუშიძე, ბავშვთა უფლებების დაცვისადმი მიძღვნილი კვირეულის ფარგლებში იმყოფებოდნენ აჭარის ა/რ უმაღლეს საბჭოში, სადაც მათ უმასპინძლა",
    briefText:
      "აჭარის ა/რ უმაღლესი საბჭოს ადამიანის უფლებათა დაცვის საკითხთა კომიტეტის თავმჯდომარემ, ბატონმა ცოტნე ანანიძემ, რომელმაც მოსწავლეებთან ისაუბრა ბავშვთა უფლებათა დაცვის თანამედროვე გამოწვევებსა და მათი დაძლევის გზებზე.\nასევე, აჭარის ა/რ უმაღლესი საბჭოს მოქალაქეთა ჩართულობის განყოფილების უფროსმა, ქალბატონმა ცირა ხაჯიშვილმა მოსწავლეებს გააცნო გზები, რომელთა გამოყენებითაც შეძლებენ აქტიურად ადევნონ თვალი და ჩაერთონ საბჭოს მუშაობის, სხვადასხვა გადაწყვეტილების მიღების პროცესში.\nსკოლის მხრიდან ახალგაზრდებმა წარადგინეს სკოლის ბავშვთა ომბუდსმენის ინსტიტუტის მიერ კვირეულის ფარგლებში შექმნილი რესურსები:\nბავშვთა უფლებათა კონვენცია - ილუსტრირებული ბუკლეტი;\nმასწავლებლის პროფესიული ეთიკის კოდექსი - ილუსტრირებული ტრიპლექსი;\nსაგნობრივი სასწავლო რესურსები მათემატიკაში თემებზე:\nმონაცემთა ანალიზი და გეომეტრიის საფუძვლები.\nასევე, ისაუბრეთს ერთობლივი ინტეგრირებული სასწავლო პროექტის „ფინანსური და ეკონომიკური წიგნიერება“ - მნიშვნელობის შესახებ, რომელიც, ასევე, ბავშვთა უფლებების კვირეულის ფარგლებში განხორციელდა.\nაქვე მადლობა, აჭარის ა/რ უმაღლესი საბჭოს აპარატის საფინანსო უზრუნველყოფისა და შესყიდვების განყოფილების უფროსს, ბატონ დავით ბერიძეს, ვიზიტის ორგანიზებისა და კვირეულის ფარგლებში განხორციელებულ ერთ - ერთ სასწავლო პროექტში „ფინანსური და ეკონომიკური წიგნიერება“ - მონაწილეობისთვის.\nბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა\nაჭარის ავტონომიური რესპუბლიკის უმაღლესი საბჭო\n",
  },
  {
    imageGallery: [],
    image: name410,
    id: 410,
    title: "ჰაგიოგრაფია სკოლებში-ანაქრონიზმი თუ პანაცეა.",
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლა\nგაიგეთ მეტი გადაცემის სტუმრებისგან\n- წმინდა ანდრია პირველწოდებულის სახელობის სკოლის ქართული ენისა და ლიტერატურის პედაგოგი- მარინა ტალახაძე.\n- ამავე სკოლის მე-10 კლასის მოსწავლეები: ელენე დუმბაძე, გიორგი ცინცაძე,შოთა ბოლქვაძე.\n#ერთადვიმსჯელოთდავიზრუნოთმომავალზე\n- „უნდა ისწავლებოდეს თუ არა ჰაგიოგრაფია სკოლებში“?!\n- სწავლების მეთოდები, პერსპექტივები , მოსაზრებები , გზავნილები ... \nდეტალები გადაცემაში\n====\n#ერთადვიმსჯელოთდავიზრუნოთმომავალზე\nრადიო,,აჭარის'' საავტორო გადაცემები",
  },
  {
    imageGallery: [],
    image: name411,
    id: 411,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-2 კლასის მოსწავლეებმა ქართული ენისა და ლიტერატურის მასწავლებლის მარინა მამალაძის დახმარებით გამოსცეს ხელნაწერი ჟურნალი "ჰელადოს".',
    briefText:
      "მოსწავლეებმა პედაგოგთა და მშობელთა საზოგადოებას წარუდგინეს თავიანთი ნამუშევრები და სტატიები , ნახატები, ინტერვიუები პერსონაჟებთან, მასწავლებლებთან, გამვლელებთან, ჩატარებული კვლევის შედეგები, ვინ და როგორ კითხულობს ნოდარ დუმბაძის ნაწარმოებებს.\nხელნაწერი ჟურნალი იქვე აიკინძა და გადაეცა სკოლის ბიბლიოთეკას.\nღონისძიებას ესწრებოდნენ მასწავლებლები და მშობლები.",
  },
  {
    imageGallery: [],
    image: name412,
    id: 412,
    title:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში 2024 წლის 3-დან 7 ივნისამდე ჩატარდა სასკოლო სასწავლო გეგმით გათვალისწინებული დიაგნოსტიკურ//რეიტინგული წერები IV, VI, VII, VIII, IX, X, XI კლასებში.",
    briefText:
      "აღსანიშნავია, რომ ტესტირება აღნიშნულ კლასებში ჩატდება ქართულ ენასა და ლიტერატურაში, მათემატიკასა და ცალკეულ საგნობრივ ჯგუფში შემავალ საგნებში.\nდიგნოსტიკური ტესტირება მიზნად ისახავს განვლილი სასწავლო წლის შედეგების შესწავლას.\nშედეგების ანალიზი ძალიან მნიშვნელოვანია მომავალი წლისთვის ეფექტური სასწავლო პროცესის დასაგეგმად.\nამ ეტაპზე მიმდინარეობს ნაშრომების გასწორება და შედეგების ანალიზი და კვლევა.\nყველა მოსწავლეს და მათ პედაგოგს ვუსურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name413,
    id: 413,
    title:
      'ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-2 და IV-3 კლასებში მასწავლებლებმა ნინო უგულავამ და რუსუდან ურუშაძემ ჩაატარეს ინტეგრირებული გაკვეთილი ქართულ ენასა და საღმრთო სჯულში თემაზე ,, ძველი ქართული ხალხური და ქრისტიანული ტრადიციები".',
    briefText:
      "მეოთხეკლასელებმა წარმოადგინეს პრეზენტაციები სააღდგომო ტრადიციებთან დაკავშირებით,\nსტუმრებს და ერთმანეთს უმასპინძლეს ტკბილეულითა,\nშეასრულეს საკულტო ლექს- სიმღერებით,\nერთმანეთს გაუზიარეს ცოდნა და ემოციები.",
  },
  {
    imageGallery: [],
    image: name414,
    id: 414,
    title:
      'წარმოგიდგენთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-1 და VIII-2 კლასების მოსწავლეთა ქიმიის კომპლექსური დავალების "პერიოდული სისტემის ახალი ხედვა" ფარგლებში შესრულებულ საინტერესო და ორიგინალურ დავალებებს, რომელშიც კარგად გამოჩნდა ახალგაზრდების ცოდნა შემოქმედებითი მიდგომა საკითხისადმი.',
    briefText: "ქიმიის მასწავლებელი ირინა ვიდულინა.",
  },
  {
    imageGallery: [],
    image: name415,
    id: 415,
    title:
      'მშვენიერი სპექტაკლი წარმოადგინეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-2 კლასის მოსწავლეებმა 2024 წლის 7 ივნისს.\nსპექტაკლი "იყო ერთი მხატვარი..." ყმაწვილებს დაწყებითი საფეხურზე კლასის დამრიგებელმა და ქართული ენის მასწავლებელმა მაია იმნაძემ მოამზადებინა მუსიკის პედაგოგ ლოლა ჯაფარიძესთან ერთად.',
    briefText:
      "ასე ლამაზად აღნიშნეს მეოთხზე კლასის დასრულება და მაიკო მასწავლებელთან დამშვიდობება.\nაკადემიური, ფერადი, მუსიკალური წარმოდგენით უნიჭიერესმა პატარებმა გააცოცხლეს ძველი თბილისისა და ქართული ფილმებისა პერსონაჟები.\nმაიკო მასწავლებელი თბილი, ამაღელვებელი სიტყვით დაემშვიდობა ძვირფას მოსწავლეებს და სამახსოვრო ალბომები გადასცა მათ.\nმომავალი წლიდან დიდი და საინტერესო, სხვანაირი სასკოლო ცხოვრება იწყება!",
  },
  {
    imageGallery: [],
    image: name416,
    id: 416,
    title:
      "მშვენიერი სპექტაკლი წარმოადგინეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-2 კლასის მოსწავლეებმა 2024 წლის 7 ივნისს.",
    briefText:
      "მშვენიერი სპექტაკლი წარმოადგინეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-2 კლასის მოსწავლეებმა 2024 წლის 7 ივნისს.",
  },
  {
    imageGallery: [],
    image: name417,
    id: 417,
    title:
      'ოლიმპიადა "ევერესტის" ოქროს ტურში მონაწილე ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებს მიღწეული წარმატებისთვის გადაეცათ სიგელები და სამახსოვრო საჩუქრები:',
    briefText:
      "რევაზ გაფრინდაშვილი (VI კლასი)-ვერცხლის სიგელი ; \nდემეტრე შერვაშიძე (IV კლასი)- ბრინჯაოს სიგელი ; \nალექსანდრე გაფრინდაშვილი(II კლასი)- ვერცხლის სიგელი.\nგილოცავთ!\nგისურვებთ წარმატებებს!",
  },
  {
    imageGallery: [],
    image: name418,
    id: 418,
    title:
      "2024 წლის 13 ივნისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 და VII- 5 კლასის მოსწავლეები ბიოლოგიის პედაგოგ ქეთევან ხარაბაძესთან ერთად იმყოფებოდნენ ხარიტონ ახვლედიანის სახელობის მუზეუმში, სადაც გაეცნენ აჭარის მცენარეთა და ცხოველთა სამყაროს ამსახველ ექსპონატებს.",
    briefText:
      "2024 წლის 13 ივნისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-4 და VII- 5 კლასის მოსწავლეები ბიოლოგიის პედაგოგ ქეთევან ხარაბაძესთან ერთად იმყოფებოდნენ ხარიტონ ახვლედიანის სახელობის მუზეუმში, სადაც გაეცნენ აჭარის მცენარეთა და ცხოველთა სამყაროს ამსახველ ექსპონატებს.",
  },
  {
    imageGallery: [],
    image: name419,
    id: 419,
    title:
      "მხიარული ვიქტორინით დაასრულეთ სასწავლო წელი ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-4 კლასის მოსწავლეებმა და ცოდნითა და გამჭრიახობით თავი მოაწონეს პედაგოგებსა და მშობლებს.",
    briefText: "ღონისძიების ორგანიზატორი და კლასის ხელმძღვანელი რუსუდან თოიძე.",
  },
  {
    imageGallery: [],
    image: name420,
    id: 420,
    title: "გელოდებით!!!!!",
    briefText: "გელოდებით!!!!!",
  },
  {
    imageGallery: [],
    image: name421,
    id: 421,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სკოლაში ერთი თვის განმავლობაში სასწავლო პრაქტიკას გადიოდნენ შოთა რუსთაველის სახელობის ბათუმის სახელმწიფო უნივერსიტეტის ფსიქოლოგიის სპეციალობის დამამთავრებელი კურსის სტუდენტები მარიამ გამყრელიძე , ხატია მაჭუტაძე და რუსუდან პატარიძე.",
    briefText:
      "სტუდენტებმა სკოლის ფსიქოლოგის თეა ხინთიბიძის მენტორობით განახორციელეს სხვადასხვა აქტივობა, მათ შორის, IV-3 კლასის მოსწავლეებისთვის- თემაზე „ემოციები“.",
  },
  {
    imageGallery: [],
    image: name422,
    id: 422,
    title:
      "დიდი სიხარულით გვსურს გაუწყოთ, რომ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე ალექსანდრე ჯელია ათასწლეულის ინოვაციის კონკურსი - Millennium Innovations Award-ის 2024 წლის ფინალისტია!",
    briefText:
      "ვულოცავთ ფინალურ ეტაპზე გადასულ ალექსანდრეს გუნდს და წარმატებას ვუსურვებთ!",
  },
  {
    imageGallery: [],
    image: name423,
    id: 423,
    title:
      "2024 წლის წლის 29 ივნისს საპატრიარქოს განათლების ცენტრის თავმჯდომარის, ქუთათელ-გაენათელი მიტროპოლიტის იოანეს (გამრეკელი) ლოცვა-კურთხევით თბილისში შედგა საპატრიარქოს სკოლების ადმინისტრაციის წარმომადგენელთა 2023-24 სასწავლო წლის შემაჯამებელი ტრადიციული კონფერენცია, რომლის მუშაობაშიც ამჯერად მონაწილეობდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის სტრატეგიული განვითარების ჯგუფის ხელმძღვანელი ანა ანუშიძე.",
    briefText:
      'ანამ წარადგინა მოხსენება - "ზოგადსაგანმანათლებლო დაწესებულების ავტორიზაციის სტანდარტები, კრიტერიუმები და ინდიკატორები - მათი დაძლევის გზები და სტრატეგიები" . \nმომხსენებელმა თავის გამოსვლაში ჯეროვანი ყურადღება დაუთმო ჩვენი სკოლის - ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის საუკეთესო პრაქტიკასაც და გამოცდილება გაუზიარა კოლეგებს.\nდაიგეგმა სამომავლო თანამშრომლობის გზები.',
  },
  {
    imageGallery: [],
    image: name424,
    id: 424,
    title:
      "ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ბოლო ორი კვირის განმავლობაში პედაგოგთა აქტიური ჩართულობით მიმდინარეობდა სასკოლო ცხოვრებისთვის უაღრესად მნიშვნელოვანი სამუშაო პროცესი, რომელსაც წარმართავდა ჩვენი სკოლის სტრატეგიული განვითარების ჯგუფის ხელმძაღვანელი ანა ანუშიძე.",
    briefText:
      "სამუშაო პროცესში დამუშავდა შემდეგი დოკუმენტაცია/საკითხები\nეროვნული სასწავლო გეგმა, საგნობრივი სტანდარტები;\nარსებული სასწავლო პროგრამები და სკოლის მიერ უკვე არჩეული სახელმძღვანელოები, შესაბამისი ალტერნატივებით;\nმოსწავლეთა მიმდინარე და შემაჯამებელი დავალებების ანალიზის ამსახველი დოკუმენტაცია, ძლიერი და სუსტი მხარეები, განვითარების გზები;\nინდივიდუალური და ალტერნატიული სასწავლო გეგმების მიხედვით სათანადო სასწავლო რესურსების შექმნა - გამოყენების საკითხები;\nუნივერსალური დიზაინისა და დიფერენცირებული მიდგომის გამოყენების გზები სასკოლო პრაქტიკაში;\nშეიქმნა ახალი სასწავლო - მეთოდური რესურსები\nსაგნობრივი სტანდარტის, თემატიკის და სამიზნე ცნებების ამსახველი ინფოგრაფიკები, თითოეული საგნისთვის (კლასის/საფეხურის მიხედვით);\nშეფასების ჰოლისტური რუბრიკების და უნივერსალური დიზაინის მქონე აქტივობების ბარათები;\nკათედრის სამუშაო ელექტრონული ფორმები;\nშეიქმნა/გარდაიქმნა საგნობრივი სასწავლო გეგმები და შესაბამისი დანართები, თემატური მატრიცები და კომპლექსური დავალების ბარათები\nპედაგოგებმა შექმნეს/განაახლეს 170- ზე მეტი საგნობრივი სასწავლო გეგმა ( კლასების მიხედვით)\nმადლობა ყველა მასწავლებელს, ვინც კეთილსინდისიერად შრომობს!\nბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის ადმინისტრაცია განსაკუთრებულ მადლობას უხდის ანა ანუშიძეს ამ შრომატევადი საქმის კოორდინირებისა და ეფექტურად დასრულებისთვის!",
  },
  {
    imageGallery: [],
    image: name425,
    id: 425,
    title:
      "2024 წლის  20 ივლისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა მედიის განვითარების ფონდი, MDF -ის მიერ ორგანიზებული მედიაწიგნიერების ტრენინგი. ",
    briefText:
      "2024 წლის  20 ივლისს ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში ჩატარდა მედიის განვითარების ფონდი, MDF -ის მიერ ორგანიზებული მედიაწიგნიერების ტრენინგი.\n🔎 ახალგაზრდები წყაროების კრიტიკული ანალიზის, ვიზუალური მანიპულაციის იდენტიფიცირების და გადამოწმების, ყალბი ანგარიშების გამოვლენის პრაქტიკულ სავარჯიშოებში ჩაერთნენ. ბოლოს კი, ინფორმაციის გადამოწმების მიზნით, გეოლოკაციის ინსტრუმენტების მეშვეობით, საქართველოს ოკუპირებულ ტერიტორიებზე იმოგზაურეს.",
  },
  {
    imageGallery: [],
    image: name426,
    id: 426,
    title: "წარჩინებულ კურსდამთავრებულთა დაჯილდოება ",
    briefText:
      "📚🥇წარჩინებულ კურსდამთავრებულთა დაჯილდოება \n🏫 ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის  ერთ-ერთი მშვენიერი ტრადიციაა წარჩინებულ მოსწავლეთა, ოქროსა და ვერცხლის მედალოსანთა  წმ. ანდრია პირველწოდებულის სახელობის სკოლის მედლით და ერთჯერადი  სტიპენდიით დაჯილდოება. \n📚🏫ამ ტრადიციას გიმნაზიის დაარსების პირველივე წლებიდან საფუძველი ჩაუყარა ბათუმისა და ლაზეთის მიტროპოლიტმა  მეუფე დიმიტრიმ, რომელმაც, წელსაც,   2024 წლის 23 ივლისს    გადასცა მედლები გიმნაზიის  ფრიადოსან კურსდამთავრებულებს! \n📚🥇🏫ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის  2023-2024 სასწავლო წლის წარჩინებული მოსწავლეები არიან: \n🎓მარიამ ჩაგუნავა,\n🎓მარიამ ჯანყარაშვილი,\n🎓სალომე ფუტკარაძე,\n🎓ქეთევან რუხაძე,\n🎓ანა სარჯველაძე,\n🎓მარიამ ბოლქვაძე,\n🎓მარიამ დიასამიძე, \n🎓ანრი ვარშალომიძე,\n 🎓თედო ქავჯარაძე.\n📚🏫🎓გილოცავთ და დიდ წარმატებებს გისურვებთ,   ჩვენო საამაყო გიმნაზიელებო!",
  },
  {
    imageGallery: [],
    image: name427,
    id: 427,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მიმდინარეობს მზადება ახალი, 2024-2025 სასწავლო წლისთვის. ",
    briefText:
      "🏫ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მიმდინარეობს მზადება ახალი, 2024-2025 სასწავლო წლისთვის. \n🏫 ახალი სტანდარტის შესაბამისად  უკვე სრულად განახლდა, გარემონტდა,  უფრო მეტი სამედიცინო საშუალებით  და  ინვენტარით აღიჭურვა სამედიცინო კაბინეტი.",
  },
  {
    imageGallery: [],
    image: name428,
    id: 428,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში  დიდ ყურადღებას ვაქცევთ სასკოლო საზოგადოებისთვის უსაფრთხო და დაცული გარემოს შექმნას. ",
    briefText:
      "🏫ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში  დიდ ყურადღებას ვაქცევთ სასკოლო საზოგადოებისთვის უსაფრთხო და დაცული გარემოს შექმნას. \nამ მიმართულებით მუდმივად ტარდება პრევენციული ღონისძიებები. \nახალი სასწავლო წლის დაწყებამდე კიდევ ერთხელ მივმართეთ პარტნიორ ორგანიზაციას  ბათუმის წყალი • Batumis Tskali , რომელმაც სასმელი  წყლის სინჯების კვლევის შემდეგ მოგვაწოდა შესაბამისობის დასკვნა.",
  },
  {
    imageGallery: [],
    image: name429,
    id: 429,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მიმდინარეობს მუშაობა  სსიპ  განათლების ხარისხის განვითარების ეროვნულ ცენტრში 2024 წლის 1 სექტემბრამდე  წარსადგენ ",
    briefText:
      "🏫ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მიმდინარეობს მუშაობა  სსიპ  განათლების ხარისხის განვითარების ეროვნულ ცენტრში 2024 წლის 1 სექტემბრამდე  წარსადგენ\nზოგადსაგანმანათლებლო დაწესებულების ავტორიზაციის სტანდარტებთან შესაბამისობის ფორმაზე. \n🎓პასუხისმგებელ პირად განისაზღვრა სკოლის დირექტორის მოადგილე პირიმზე რურუა.\n📚ფოტოზე- სკოლის სტრატეგიული განვითარების ჯგუფის ხელმძღვანელი ანა ანუშიძე და საინფორმაციო ბაზის მენეჯერი  აღაზა გელაშვილი სამუშაო პროცესში.",
  },
  {
    imageGallery: [],
    image: name430,
    id: 430,
    title: "სკოლის მისია, ხედვა და ღირებულებები",
    briefText: "სკოლის მისია, ხედვა და ღირებულებები",
  },
  {
    imageGallery: [],
    image: name431,
    id: 431,
    title:
      "ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მიმდინარეობს მზადება ახალი სასწავლო წლისთვის. ",
    briefText:
      "🏫ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მიმდინარეობს მზადება ახალი სასწავლო წლისთვის. \n🧑‍🚒ამ ეტაპზე მთელს სკოლაში მონტაჟდება მაღალი დონის ხანძარსაწინააღმდეგო დაცვის სისტემა. სამუშაოებს ახორციელებს შპს „ელ+''. \n🏫სკოლის ადმინისტრაციამ პროექტი შესაფასებლად გადაუგზავნა შსს-ს სახელმწიფო საქვეუწყებო დაწესებულება-საგანგებო სიტუაციების მართვის სამსახურის სსიპ-სახელმწიფო რეზერვებისა და სამოქალაქო უსაფრთხოების სერვისების სააგენტოს, რომლის პასუხშიც ვკითხულობთ: \n„თქვენი, 2024 წლის 11 ივლისის N2098410 განხილვის შედეგად დადგინდა, რომ ქალაქ ბათუმში, დემეტრე თავდადებულის ქუჩა N49-ში არსებულ მიწის ნაკვეთზე (ს/კ 05.22.47.001) სკოლის შენობის ხანძარსაწინააღმდეგო დაცვის სისტემების მოწყობის პროექტები (ავტომატური სახანძრო სიგნალიზაცია და ხანძრის შესახებ მაუწყებლობის, ტექსტური გამოცხადების, ადამიანთა ევაკუაციის მართვის და ავარიული განათების სისტემები), შეესაბამება სამშენებლო ნორმების და წესების, ტექნიკური რეგულირების სხვა დოკუმენტებით დადგენილ სახანძრო უსაფრთხოების მოთხოვნებს“.",
  },
  {
    imageGallery: [],
    image: name432,
    id: 432,
    title:
      "ა(ა)იპ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 2024-2025 სასწავლო წლის I-XI კლასების სახელმძღვანელოების ჩამონათვალი",
    briefText:
      "ა(ა)იპ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 2024-2025 სასწავლო წლის I-XI კლასების სახელმძღვანელოების ჩამონათვალი",
  },
  {
    imageGallery: [],
    image: name433,
    id: 433,
    title:
      "    ბათუმის წმინდა ანდრია პირველწოდებულის  სახელობის სკოლის სწრაფი კვების ბლოკში  HACCP-ის სისტემა დაინერგა.",
    briefText:
      "ბათუმის წმინდა ანდრია პირველწოდებულის  სახელობის სკოლის სწრაფი კვების ბლოკში  HACCP-ის სისტემა დაინერგა.  \nHACCP-ის ჯგუფის მენეჯერი ლიანა გადახაბაძე განისაზღვრა, როგორც სისტემის გამართულ ფუნქციონირებაზე და სურსათის უვნებლობაზე პასუხისმგებელ პირი. \nHACCP- (Hazard Analysis and Critical Control Point -საფრთხის ანალიზი და კრიტიკული საკონტროლო წერტილები) - არის  სურსათის უვნებლობასთან დაკავშირებული რისკის იდენტიფიცირებისა და მართვის საერთაშორისოდ აღიარებული მეთოდი . \nHACCP არის მართვის სისტემა, რომელშიც სურსათის უვნებლობა უზრუნველყოფილია ბიოლოგიური, ქიმიური და ფიზიკური საფრთხის ანალიზისა და კონტროლის გზით ნედლეულის წარმოებიდან, შესყიდვა-დამუშავებიდან  მზა პროდუქტის წარმოებამდე, განაწილებამდე და მოხმარებამდე.\nშესაბამისად,  სწრაფი კვების ობიექტი შეამოწმა საქართველოს გარემოს დაცვისა და სოფლის მეურნეობის სამინისტროს სურსათის ეროვნულმა სააგენტომ. შესაბამისობის შეფასების აქტის მიხედვით არ გამოვლენილა  არც ერთი კრიტიკული შეუსაბამობა.",
  },
  {
    imageGallery: [],
    image: name434,
    id: 434,
    title:
      "ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის სტრუქტურა",
    briefText:
      "ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის სტრუქტურა",
  },
  {
    imageGallery: [post4351, post4352, post4353, post4354],
    image: name435,
    id: 435,
    title: "✨️🎆პატარების საახალწლო მეჯლისი",
    briefText:
      "👫🌞🌲საახალწლო დღეების საზეიმო განწყობას განსაკუთრებულ ხიბლს სძენდა მეჯლისისთვის მზადება ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-3 კლასის მოსწავლეებისთვის! \n👸🎅💥პირველად გამოსვლა დიდ სცენაზე, საყვარელი ზღაპრის გმირის კოსტიუმის მორგება, თანატოლების, მშობლების და ბებია-ბაბუების მქუხარე აპლოდისმენტები მართლაც საახალწლო ჯადოსნურ ზღაპარს ჰგავდა! \n👩‍🏫 ამ დღესასწაულის შემოქმედი იყო კლასის დამრიგებელი, ქართული ენისა და ლიტერატურის მასწავლებელი მაია იმნაძე.",
  },

  {
    imageGallery: [post4361, post4362, post4363, post4364],
    image: name436,
    id: 436,
    title: "🌲🎆საახალწლო ზღაპარი",
    briefText:
      "🎅👸💥ულამაზესი, მხიარული, მუსიკალური საახალწლო ზღაპარი წარუდგინეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-1 კლასის მოსწავლეებმა თანატოლებისა, მშობლების და სტუმრების მრავალრიცხოვან აუდიტორიას!🎇✨️🌲\n👩‍🏫💥პატარებთან ერთად წინასაახალწლო ამაღლებული განწყობის შექმნაზე  ზრუნავდნენ კლასის დამრიგებელი თამუნა მექვაბიშვილი და მუსიკის პედაგოგი მაია ჭანუყვაძე!",
  },

  {
    imageGallery: [
      post4371,
      post4372,
      post4373,
      post4374,
      post4375,
      post4376,
      post4377,
      post4378,
    ],
    image: name437,
    id: 437,
    title: "🌲🎅საახალწლო სპექტაკლი",
    briefText:
      "✨️🎅🌲ძალიან უყვართ ზღაპრების კითხვა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-4 კლასის მოსწავლეებს. 🎉\n👫🎆 წაკითხული ზღაპრებიდან საყვარელი გმირები გამოიხმეს, საახალწლო ჯადოსნური ამბებიც გაიხსენეს,  საქართველოს კუთხეებიც მოიარეს, ტრადიციებს გაეცნენ, დაკარგული თოვლის ბაბუაც იპოვეს, იმღერეს, იცეკვეს და მშვენიერი ზღაპარიც წარუდგინეს გულშემატკივრებს კლასის დამრიგებელ ირინა სევოსტიანოვასა და მუსიკის მასწავლებელ ლოლა ჯაფარიძესთან ერთად!💥🎅🌲🎆👫",
  },

  {
    imageGallery: [post4381, post4382],
    image: name438,
    id: 438,
    title: "🌞სტუმრად სათნოების სავანეში",
    briefText:
      "🌞🌲წინასაახალწლო დღეებში ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის I-3 კლასის მოსწავლეები აღმზრდელ ანა კვიჭიძესთან და მშობლებთან ერთად სტუმრობდნენ ბათუმის წმინდა ეკატერინეს სახელობის სათნოების სავანეს. \n👫 🌞გიმნაზიელებმა ლექსებით, სიმღერებით, მცირედი საჩუქრებით და დიდი სიყვარულით  გაახარეს სავანის ბებია-ბაბუები. მართლაც სადღესასწაულო განწყობა სუფევდა და ოვაციებიც დაიმსახურეს მასპინძლებიდან .\n🙏💕მადლობა სათნოების სავანის ბინადართ  თბილი და ტკბილი სიტყვებისთვის, დალოცვისთვის, რომელიც არ დაიშურეს პატარებისთვის!",
  },

  {
    imageGallery: [
      post4391,
      post4392,
      post4393,
      post4394,
      post4395,
      post4396,
      post4397,
      post4398,
      post4399,
    ],
    image: name439,
    id: 439,
    title: "🌲საახალწლო ზეიმი🎆",
    briefText:
      "🎉👫🌞ლექსებით, სიმღერებით, ცეკვებით, თეატრალიზებული წარმოდგენით  ლამაზად მიულოცეს ახალი წელი თანატოლებს, მშობლებს,   ბებია-ბაბუებს და მასწავლებლებს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასის მოსწავლეებმა კლასის დამრიგებელ ლამარა გოგიბერიძესთან ერთად, დიდი მოწონება და ოვაციებიც დაიმსახურეს!✨️🎉",
  },

  {
    imageGallery: [post4401],
    image: name440,
    id: 440,
    title: "🎓წარმატებები ჩვენს გონიერ გიმნაზიელებს!👏",
    briefText: "",
  },

  {
    imageGallery: [post4411],
    image: name441,
    id: 441,
    title: "📚კამპანიას ,,ეს ქვეყანა შენია''-ს გამარჯვებულთა დაჯილდოება",
    briefText:
      "🌐სამოქალაქო საზოგადოების ინსტიტუტი ( CSI) ყოველწლიურად ატარებს კამპანიას ,,ეს ქვეყანა შენია''. \n🌐📚 24 იანვარს ბათუმში, სასტუმრო რედისონში,  გაიმართა ახალგაზრდული კონკურსის „ეს ქვეყანა შენიას“ გამარჯვებულთა დაჯილოება.  \n📚გამარჯვებულები რეგიონების მიხედვით გამოვლინდნენ. \nაჭარის რეგიონში  გამარჯვებული  ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის გუნდია, რომელსაც შეადგენდნენ IX -3  კლასის მოსწავლეები:\n🎓1. ელენე ნასარაია\n🎓2. ანასტასია ოქროპირიძე\n🎓3. მარიამ ჩხატარაშვილი\n🎓4. კესარია ხაბურძანია\n🎓5. ანა თოიძე\n👩‍🏫 გუნდის კურატორი არის  მოქალაქეობისა და ისტორიის მასწავლებელი, ინგა მართალიშვილი.\n📚  დიპლომებთან ერთად  გამარჯვებულები დაჯილდოვდნენ  ლეპტოპებით.\n📚  დაჯილდოების ბოლოს გაიმართა შემეცნებითი აუდიო–ვიზუალური გამოფენა, სადაც მოსწავლეებმა ინტერაქციული თამაშების საშუალებით მიიღეს ინფორმაცია როგორც თანამედროვე, ისე მე–19 საუკუნისა და პირველი რესპუბლიკის ცხოვრებაში სამოქალაქო საზოგადოების როლის შესახებ.\n🌐📚შეგახსენებთ, 2024 წელს აღნიშული კამპანიის ფარგლებში გამოცხადდა კონკურსი ახალგაზრდებისთვის.\nკონკურსი თემა- აღიდგინე დაკარგული მეხსიერება,მოიძიე და გააცანი თემს დავიწყებული ისტორიები სამოქალაქო საზოგადოების შესახებ. \n🌐📚 ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის  გუნდმა წარადგინა პროექტი ნიკო (თეოფანე) ჯაყელის შესახებ. \nნიკო ჯაყელი (1862-1929) იყო პედაგოგი, განმანათლებელი, საზოგადო მოღვაწე, ქართველთა შორის წერა-კითხვის გამავრცელებელი საზოგადოების წარმომადგენელი, სოციალისტ-ფედერალისტი,  ქალაქ ბათუმის სათათბიროს ორი მოწვევის ხმოსანი წევრი,  წმინდა ანას და წმინდა სტანისლავის ორდენოსანი.\n🎓🌞ვულოცავთ ჩვენს გიმნაზიელებს ამ დიდ წარმატებას!👏",
  },

  {
    imageGallery: [
      post4421,
      post4422,
      post4423,
      post4424,
      post4425,
      post4426,
      post4427,
      post4428,
    ],
    image: name442,
    id: 442,
    title: "🏛 „შეეხე ისტორიას ხელებით“",
    briefText:
      "📜👫2025 წლის 28 იანვარს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობოის სკოლის  IV-3  კლასების მოსწავლეები კლასის დამრიგებელთან  სალომე დანელიასთან და ხელოვნების პედაგოგ ირინა სევოსტიანოვასთან  ერთად გონიოს ციხეს გონიო აფსაროსის ციხე-სიმაგრე / Gonio-Apsaros Fortress  სტუმრობდნენ, სადაც აჭარის კულტურული მემკვიდრეობის დაცვის სააგენტო  აჭარის კულტურული მემკვიდრეობის დაცვის სააგენტო    სკოლის მოსწავლეებისათვის  აგრძელებს შემეცნებით-საგანმანათლებლო პროგრამას  „შეეხე ისტორიას ხელებით“.\n📚ამ მეტად სასარგებლო პროგრამის მიზანია  მოსწავლეებისთვის ხელოვნების   სხვადასხვა   დარგის   სპეციფიკისა  და პროფესიული თავისებურებების გაცნობა და ანალიტიკური აზროვნებისა და შემოქმედებითი უნარ-ჩვევების გამომუშავება.\nგონიოს კვლევითი ცენტრის სამუშაო სივრცეში მოსწავლეებს ჩაუტარდათ პრეზენტაცია გონიოს ციხის ისტორიიდან. შემდეგ მათ საკუთარი ხელით შექმნეს თემატური ნამუშევრები - გრაფიკულ, ფერწერულ ნახატები, პანოები, მოხატეს კერამიკული ჭურჭელი და ქვები, დაამზადეს სამკაულები.",
  },

  {
    imageGallery: [
      post4431,
      post4432,
      post4433,
      post4434,
      post4435,
      post4436,
      post4437,
      post4438,
      post4439,
      post44310,
      post44311,
      post44312,
    ],
    image: name443,
    id: 443,
    title: "“გვიყვარს ოკეანე-  გვიყვარს შავი ზღვა“",
    briefText:
      "🌐🌿🌳2025 წლის 2 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-11 კლასის მოსწავლეები \n🎓ლიზი ხარაბაძე ,\n🎓ანანო ბეჟანიძე,\n🎓მარიამ აბულაძე,\n🎓მარიამ გოგიტიძე,\n🎓ლუციანა კუხალეიშვილი გეოგრაფიის პედაგოგ სესილი გათენაძესთან ერთად \nბათუმის შოთა რუსთაველის სახელობის  უნივერსიტეტში   ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U  ესწრებოდნენ ვორქშოპს, რომელიც მიეძღვნა  2 თებერვალს, როგორც   ჭარბტენიანი ტერიტორიების დაცვის დღეს. \n🌐🌿ღონისძიების ორგანიზატორი იყო  ორგანიზაცია- Doors Black Sea- შავი ზღვის რეგიონის განვითარების მხარდაჭერა ოპტიმალური და ღია კვლევებით.\nვორქშოფის  მუშაობას ხელმძღვანელობდნენ ნინო ჩხობაძე, იზოლდა მაჭუტაძე, მამუკა გვილავა, გუგული დუმბაძე.\n🌐🌿 ვორქშოფის განმავლობაში მოსწავლეებმა სტუდენტებთან ერთად  ისაუბრეს შავ ზღვაზე, მის პრობლემებზე,  გადაჭრის ხერხებზე, მიიღეს მონაწილეობა გამოკითხვაში,    ჯგუფურ აქტივობაში. \n📜შეხვედრის ბოლოს მონაწილეებს  გადაეცათ საერთაშორისო სერთიფიკატები. \n🌐დღის სლოგანი იყო- “გვიყვარს ოკეანე. გვიყვარს შავი ზღვა”",
  },

  {
    imageGallery: [
      post4441,
      post4442,
      post4443,
      post4444,
      post4445,
      post4446,
      post4447,
    ],
    image: name444,
    id: 444,
    title: "საგანმანათლებლო პროგრამა ,,პეიზაჟი”",
    briefText:
      "📚2025 წლის 3 თებერვალს, ხელოვნების მუზეუმს წმ. ანდრია პირველწოდებულის სკოლის I-3 კლასის  მოსწავლეები ხელოვნების პედაგოგ ირინა სევოსტიანოვასა და აღმზრდელ ანა კვიჭიძესთან ერთად  სტუმრობდნენ. \n👫🎨მოსწავლეებს საგანმანათლებლო პროგრამა ,,პეიზაჟი” ჩაუტარდათ.",
  },

  {
    imageGallery: [post4451, post4452, post4453, post4454, post4455],
    image: name445,
    id: 445,
    title:
      "ღია გაკვეთილი თემაზე: რევაზ ინანიშვილის 'ფრთხებიან ყვავები დამბაჩის ხმაზე?'",
    briefText:
      '2025 წლის 4 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-1 კლასში ქართული ენისა და ლიტერატურის პედაგოგმა მზია ჯანელიძემ ჩაატარა ღია გაკვეთილი თემაზე: რევაზ ინანიშვილის " ფრთხებიან ყვავები დამბაჩის ხმაზე?"\nგაკვეთილის მიზანს წარმოადგენდა მწერლის სათქმელის ამოცნობა, ასევე, თაობებს შორის (ტექსტში 4 თაობაა წარმოდგენილი) არსებული განსხვავებული ღირებულებების წარმოჩენა; მსჯელობა იმაზე, არის თუ არა ახალი თაობისთვის ვიტგენშტეინის საქციელი გასაგები, მისაღები, მოსაწონი (ან პირიქით), რომელმაც სიცოცხლეს ღირსების დაცვა ამჯობინა; ყვავების, როგორც ალეგორიულ-მეტაფორული სახის გააზრება.\nმოსწავლეებმა იმსჯელეს, რას ემსახურება მწერლის ჩანაფიქრი, რისი თქმა უნდა მკითხველისთვის.\nამ კითხვებზე პასუხები , ნაწარმოების ძირითადი  თემა აღმოჩნდა ახალგაზრდებისთვის საინტერესო, საკამათო და საორიენტაციო  იმისთვის, თუ რა უნდა შესთავაზოს მწერალმა მკითხველს, რომ ის გახდეს უკეთესი.',
  },

  {
    imageGallery: [post4461, post4462, post4463],
    image: name446,
    id: 446,
    title: "წიგნის საჯაროდ კითხვის დღე IX-3 კლასში",
    briefText:
      "📚📜5 თებერვალს წიგნის საჯაროდ კითხვის მსოფლიო დღე აღინიშნება, რომელსაც უკვე 8 წელია ავღნიშნავთ საქართველოშიც. \n📚წელსაც, როგორც ყოველ წელს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში არაერთი გაკვეთილი მიეძღვნა ამ მნიშვნელოვან თარიღს. \n📜📚IX-3 კლასის მოსწავლეებმა  ქართული ენისა და ლიტერატურის მასწავლებელ მარინა ტალახაძესთან ერთად წაიკითხეს უილიამ შექსპირის „რომეო და ჯულიეტა“. \n📚მოსწავლეებმა და პედაგოგმა ისაუბრეს პერსონაჟებზე, კლასიკურ ნაწარმოებებში გადმოცემულ მარადიულ ღირებულებებზე, ამ ღირებულებების ცვლილებებზე დროსთან ერთად, ზოგადად, ლიტერატურის როლსა და მნიშვნელობაზე.",
  },

  {
    imageGallery: [post4471, post4472, post4473, post4474],
    image: name447,
    id: 447,
    title: "წიგნის საჯაროდ კითხვის დღე X- 2 კლასში",
    briefText:
      "📜📚 ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში 2025 წლის 5 თებერვალს წიგნის საჯაროდ კითხვის მსოფლიო დღე აღინიშნა და  არაერთი გაკვეთილი მიეძღვნა ამ მნიშვნელოვან თარიღს. \n📚X-2 კლასში ქართული ენისა და ლიტერატურის მასწავლებელმა მზია ჯანელიძემ მოსწავლეებს წაუკითხა ედგარ პოს მოთხრობა „ამბავი ახელოვანი კაცისა“ . \n📜ედგარ პოს ნაწარმოების  შინაარსმა აქტიური დაინტერესება გამოიწვია აუდიტორიაში. ეს არის მოთხრობა კაცზე , რომელსაც სურს სახელი მოიხვეჭოს, მაგრამ არ იცის, რა გზით. მამამ ურჩია, გამოეყენებინა საკუთარი ცხვირი. შვილს რჩევა მოეწონა, მართლაც მიაღწია მიზანს- დაწერა ნარკვევები, სტატიები ცხვირზე, მხატვარსაც კი დაახატინა, შეხვედრისას ცხვირზე კოცნიდნენ, აიღო ჰონორარი, გაითქვა სახელი, ვიდრე ერთმა ნაცნობმა შეურაცხყოფა არ მოაყენა ცხვირს. „სახელოვანმა კაცმა“ დუელში გამოწვეულ მამხილებელს ცხვირში მოახვედრა ტყვია. ამის შემდეგ ყველა უცხვირო კაცზე ალაპარაკდა, ის იქცა გმირად. \n„სახელოვან კაცს“კი  ასეთი სიტყვები უთხრა მამამ „ცუდია, როდესაც ადამიანი სახელსა და დიდებაზე ცხვირის ზომის მიხედვით მსჯელობენ. ვინ შეედრება იმ სახელოვან კაცს, ვინც საერთოდ უხორთუმოდაა!“\n📚აღნიშნულ მოთხრობაზე საუბრის შემდეგ მოსწავლეებმა პარალელი გაავლეს შოთა რუსთაველის „ვეფხისტყაოსნის“ პერსონაჟებთან, იმსჯელეს იმაზე, თუ როგორ, რა გზითაა შესაძლებელი  დიდი საქმეების კეთება, ღირსეული სახელის მოხვეჭა.",
  },

  {
    imageGallery: [post4481],
    image: name448,
    id: 448,
    title:
      "🎓 გიმნაზიელი ალექსანდრე ჯელია- ათასწლეულის ინოვაციის კონკურსის - Millennium Innovations Award- გამარჯვებულია",
    briefText:
      '🎉 ვულოცავთ ათასწლეულის ინოვაციის კონკურსის 2024 წლის გამარჯვებულს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-12 კლასის მოსწავლეს ალექსანდრე ჯელიას, რომელმაც მეგობრებთან ერთად შექმნა ჭკვიანი, ეკომეგობრული თევზის ფერმა. \n🌱🐟ალექსანდრე GITA საქართველოს ინოვაციებისა და ტექნოლოგიების სააგენტოს დაფინანსებით სტენფორდის უნივერსიტეტის (აშშ) "iD Tech" ტექნოლოგიების ბანაკში მიიღებს მონაწილეობას! 💻\nთქვენი ინოვაციები ჩვენს მომავალს უფრო ნათელს ხდის! 🚀🌍👏',
  },

  {
    imageGallery: [post4491, post4492, post4493, post4494],
    image: name449,
    id: 449,
    title: "წიგნის საჯაროდ კითხვის დღე VI-3 კლასში",
    briefText:
      '\n📚📜5 თებერვალს წიგნის საჯაროდ კითხვის მსოფლიო დღე აღინიშნება.\n📚წელსაც, როგორც ყოველ წელს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში არაერთი გაკვეთილი მიეძღვნა ამ მნიშვნელოვან თარიღს. \n📜📚VI-3 კლასის მოსწავლეებმა  ქართული ენისა და ლიტერატურის მასწავლებელ რუსუდან თოიძესთან  ერთად წაიკითხეს ო\'ჰენრის მოთხრობა "უკანასკნელი ფოთოლი".',
  },

  {
    imageGallery: [post4501, post4502, post4503, post4504, post4505],
    image: name450,
    id: 450,
    title: "წიგნის საჯაროდ კითხვის დღე VII-4 კლასში",
    briefText:
      '📚📜5 თებერვალს წიგნის საჯაროდ კითხვის მსოფლიო დღე აღინიშნება.\n📚წელსაც, როგორც ყოველ წელს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში არაერთი გაკვეთილი მიეძღვნა ამ მნიშვნელოვან თარიღს. \n📜📚VII-4 კლასის მოსწავლეებმა  ქართული ენისა და ლიტერატურის მასწავლებელ ქეთი ქაჯაიასთან  ერთად წაიკითხეს გურამ პეტრიაშვილის "პატარა ქალაქის ზღაპრები".',
  },

  {
    imageGallery: [post4511, post4512, post4513, post4514, post4515],
    image: name451,
    id: 451,
    title: "წიგნის საჯაროდ კითხვის დღე III-3 კლასში",
    briefText:
      '📜📚წიგნის საჯაროდ კითხვის მსოფლიო დღესთან დაკავშირებით ინგლისური ენის გაკვეთილზე  III- 3 კლასის მოსწავლეებმა ინგლისურის პედაგოგ ზეინაბ კონცელიძესთან ერთად წაიკითხეს მოთხრობა\n "The Pinocchio" - " პინოქიო" .\n📜📚კითხვის დასრულების შემდეგ პატარებმა ისაუბრეს მოთხრობის მთავარ სათქმელსა და შინაარზე, მათთვის საინტერესო და დასამახსოვრებელ მონაკვეთებზე.',
  },

  {
    imageGallery: [
      post4521,
      post4522,
      post4523,
      post4524,
      post4525,
      post4526,
      post4527,
      post4528,
      post4529,
      post45210,
    ],
    image: name452,
    id: 452,
    title: "წიგნის საჯაროდ კითხვის დღე გიმნაზიაში",
    briefText:
      '📚📜5 თებერვალს წიგნის საჯაროდ კითხვის მსოფლიო დღე აღინიშნება.\n📚წელსაც, როგორც ყოველ წელს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში არაერთი გაკვეთილი მიეძღვნა ამ მნიშვნელოვან თარიღს. განსაკუთრებით იხალისეს დაწყებითი საფეხურის აღსაზრდელებმა. \n📚📜 III-4  და IV-2 კლასების მოსწავლეებმა თანაკლასელებს წარუდგინეს  საყვარელი წიგნები და წაიკითხეს  მათთვის საინტერესო ეპიზოდები ამ წიგნებიდან. მასწავლებლები  ნინო უგულავა და რუსუდან თოიძე. \n📚📜 II-1 კლასში პატარებმა ქართული ენისა და ლიტერატურის მასწავლებელ  ლამარა გოგიბერიძესთან ერთად წაიკითხეს საინტერესო და დასამახსოვრებელი ადგილები იტალიელი მწერლის ჯანი როდარის ნაწარმოებიდან "ჩიპოლინოს თავგადასავალი". \n📚📜 II-3 კლასის მოსწავლეები გაკვთილზე  გაეცნენ  ამონარიდს  რადიარდ კიპლინგის ნაწარმოებოდან "მაუგლი". შემდეგ კი სკოლის ბიბლიოთეკას ესტუმრნენ, სადაც წაიკითხეს ტექსტის სრული ვერსია. მეორეკლასელთა ქართული ენისა და ლიტერატურის მასწავლებელია  მაია იმნაძე.',
  },

  {
    imageGallery: [
      post4531,
      post4532,
      post4533,
      post4534,
      post4535,
      post4536,
      post4537,
    ],
    image: name453,
    id: 453,
    title:
      "დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული.",
    briefText:
      "🏫2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული.\n📚ისტორიის, მოქალაქეობის, ქართული ენისა და ლიტერატურის, საღვრთო სჯულის და სხვა საგნების  პედაგოგები მრავალფეროვან  გაკვეთილებს ატარებენ დავით აღმაშენებლის და მისის ეპოქის  შესახებ.\n📜📚👩‍🏫 2025 წლის 11 თებერვალს ისტორიის მასწავლებელმა ქეთევან გოცირიძემ თემატური გაკვეთილი ჩაატარდა V-1 კლასში.",
  },

  {
    imageGallery: [
      post4541,
      post4542,
      post4543,
      post4544,
      post4545,
      post4546,
      post4547,
      post4548,
    ],
    image: name454,
    id: 454,
    title: " „საქართველოს გაერთიანება და დავით აღმაშენებელი“. ",
    briefText:
      "2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული.\n11 თებერვალს სკოლაში სტუმრად მობრძანდა შოთა რუსთაველის სახელობის ბსუ-ს პროფესორი, ისტორიკოსი ჯემალ კარალიძე, რომელიც შეხვდა უფროსკლასელებს, პედაგოგებს და ესაუბრა მათ თემაზე „საქართველოს გაერთიანება და დავით აღმაშენებელი“. \nუღრმეს მადლობას მოვახსენებთ ბატონ ჯემალს ყურადღებისთვის და თანამშრომლობისთვის!",
  },

  {
    imageGallery: [
      post4551,
      post4552,
      post4553,
      post4554,
      post4555,
      post4556,
      post4557,
    ],
    image: name455,
    id: 455,
    title: "დიდგორის ბრძოლა",
    briefText:
      '🏫📚2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული.\n📽📖11 თებერვალს IV, V, VI კლასების მოსწავლეებმა  პედაგოგებთან ერთად სკოლის სააქტო დარბაზში ნახეს სასწავლო-დოკუმენტური ფილმი "დიდგორის ბრძოლა". \n🎞👫ფილმმა დიდი დაინტერესება გამოიწვია პატარებში. ფილმის ყურების შემდეგ მსჯელობა და განხილვა საკლასო ოთახებში გაგრძელდა.',
  },

  {
    imageGallery: [post4561, post4562, post4563, post4564],
    image: name456,
    id: 456,
    title: 'მეფის სახე კონსტანტინე გამსახურდიას რომანში "დავით აღმაშენებელი".',
    briefText:
      '🏫📚2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული.\n📜12 თებერვალს XI-1 კლასში ქართული ენისა და ლიტერატუტის მასწავლებელმა ქეთევან ქაჯაიამ ჩაატარა თემატური გაკვეთილი:  მეფის სახე კონსტანტინე გამსახურდიას რომანში "დავით აღმაშენებელი".',
  },

  {
    imageGallery: [
      post4571,
      post4572,
      post4573,
      post4574,
      post4575,
      post4576,
      post4577,
      post4578,
    ],
    image: name457,
    id: 457,
    title: "“დიდი სახელითა და უდიდესი საქმითა”- დავით აღმაშენებელი.",
    briefText:
      "🏫📚დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიღვნილი კვირეულის ფარგლებში ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში 2025 წლის 12 თებერვალს XI-2 და XI- 3 კლასებში \nმოქალაქეობის პედაგოგმა ნატალია სირაბიძემ ჩაატარა თემატური გაკვეთილი ' პიროვნების როლი სახელმწიფოში- “დიდი სახელითა და უდიდესი საქმითა”-დავით აღმაშენებელი.'",
  },

  {
    imageGallery: [
      post4581,
      post4582,
      post4583,
      post4584,
      post4585,
      post4586,
      post4587,
      post4588,
      post4589,
    ],
    image: name458,
    id: 458,
    title: "გალობანი სინანულისანი",
    briefText:
      '📚🏫2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული.\n📜12 თებერვალს   ქართული ენისა და ლიტერატურის მასწავლებელმა მარინა ტალახაძემ  წაიკითხა ლექცია თემაზე დავით აღმაშენებლის "გალობანი სინანულისანი". \n📚ლექციას ესწრებოდნენ უფროსკლასელები , პედაგოგები და სასკოლო საზოგადოების წარმომადგენლები.',
  },

  {
    imageGallery: [
      post4591,
      post4592,
      post4593,
      post4594,
      post4595,
      post4596,
      post4597,
      post4598,
      post4599,
      post45910,
    ],
    image: name459,
    id: 459,
    title:
      "ვიქტორინის შეკითხვები ეხებოდა დავით აღმაშენებლის ეპოქას და მასთან დაკავშირებულ მოვლენებს.",
    briefText:
      "📚🏫2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული.\n📜12 თებერვალს ისტორიის მასწავლებელმა ზვიად ჩხენკელმა  ჩაატარა თემატური  ვიქტორინა-კონკურსი მე-8 კლასის მოსწავლეთა შორის.\n📚ვიქტორინის შეკითხვები ეხებოდა დავით აღმაშენებლის ეპოქას და მასთან დაკავშირებულ მოვლენებს.\nღონისძიებას ესწრებოდნენ ისტორიის პედაგოგები.",
  },

  {
    imageGallery: [post4601, post4602, post4603, post4604, post4605, post4606],
    image: name460,
    id: 460,
    title:
      "რუის-ურბნისის კრება; სახელმწიფოსა და ეკლესიის ურთიერთობა დავით IV-ის დროს",
    briefText:
      '📚🏫2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული. \n📜13 თებერვალს ისტორიის მასწავლებელმა პირიმზე რურუამ წაიკითხა ლექცია თემაზე "რუის-ურბნისის კრება; სახელმწიფოსა და ეკლესიის ურთიერთობა დავით IV-ის დროს" \nღონისძიებას ესწრებოდნენ უფროკლასელი მოსწავლეები და   პედაგოგები.',
  },

  {
    imageGallery: [
      post4611,
      post4612,
      post4613,
      post4614,
      post4615,
      post4616,
      post4617,
    ],
    image: name461,
    id: 461,
    title: "პარაკლისი წმიდისა  კეთილმსახურისა მეფისა დავით აღმაშენებლისა. ",
    briefText:
      "დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიღვნილი კვირეულის ფარგლებში ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში 2025 წლის 13 თებერვალს წმ. ნინოს სახელობის ტაძარში სკოლის მოძღვრებმა გადაიხადეს პარაკლისი წმიდისა  კეთილმსახურისა მეფისა დავით აღმაშენებლისა. \nპარაკლისს ესწრებოდნენ სკოლის პედაგოგები და მოსწავლეები.",
  },

  {
    imageGallery: [post4621, post4622],
    image: name462,
    id: 462,
    title: "დავით აღმაშენებელი",
    briefText:
      "დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიღვნილი კვირეულის ფარგლებში ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში 2025 წლის 13 თებერვალს  ქართული ენისა და ლიტერატურის პედაგოგ რუსუდან თოიძესთან ერთად III-4 კლასის მოსწავლეებმა ისაუბრეს დავით აღმაშენებლის შესახებ, წარმოადგინეს თავიანთი საპრეზენტაციო ნამუშევრები, წაიკითხეს მონაკვეთები საბავშვო ისტორიიდან.",
  },

  {
    imageGallery: [
      post4631,
      post4632,
      post4633,
      post4634,
      post4635,
      post4636,
      post4637,
      post4638,
    ],
    image: name463,
    id: 463,
    title: "წმინდა კეთილმსახური მეფე დავით აღმაშენებლის ღვაწლი",
    briefText:
      "📚🏫2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული. ჩატარდა არაერთი თემატური გაკვეთილი. \nსაღმრთო სჯულის გაკვეთილებზე V,VI,VII კლასებში (მასწავლებლები მარიამ ქორიძე და რუსუდან ურუშაძე) ისაუბრეს წმინდა კეთილმსახური მეფე დავით აღმაშენებლის ღვაწლზე, გელათის მონასტრისა და აკადემიის მნიშვნელობაზე. მოსწავლეებმა წარმოადგინეს მათ მიერ შექმნილი კედლის გაზეთები.",
  },

  {
    imageGallery: [
      post4641,
      post4642,
      post4643,
      post4644,
      post4645,
      post4646,
      post4647,
      post4648,
      post4649,
    ],
    image: name464,
    id: 464,
    title: "საქართველოს საგარეო-პოლიტიკური ვითარება დიდგორის ომის წინ",
    briefText:
      '📚🏫2025 წლის 10-14 თებერვალს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში აღინიშნება დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილი კვირეული. \n📜14 თებერვალს ისტორიის მასწავლებელმა ლევან სამსონიამ  წაიკითხა ლექცია თემაზე "საქართველოს საგარეო-პოლიტიკური ვითარება დიდგორის ომის წინ". \nღონისძიებას ესწრებოდნენ უფროკლასელი მოსწავლეები და  პედაგოგები.',
  },

  {
    imageGallery: [post4651, post4652, post4653, post4654],
    image: name465,
    id: 465,
    title: "დავით აღმაშენებელი",
    briefText:
      "📖📚 დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიღვნილი კვირეულის ფარგლებში ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში 2025 წლის 14 თებერვალს  ქართული ენისა და ლიტერატურის პედაგოგ ლამარა გოგიბერიძესთან  ერთად II-1 კლასის მოსწავლეებმა  ისაუბრეს დავით აღმაშენებლის შესახებ, წარმოადგინეს თავიანთი საპრეზენტაციო ნამუშევრები.",
  },

  {
    imageGallery: [post4661, post4662, post4663, post4664],
    image: name466,
    id: 466,
    title: "დავით აღმაშენებელი ქართულ პოეზიაში",
    briefText:
      '📖📚 დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიღვნილი კვირეულის ფარგლებში ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში 2025 წლის 14 თებერვალს  ქართული ენისა და ლიტერატურის პედაგოგმა რუსუდან თოიძემ VII-3 კლასში ჩაატარა თემატური გაკვეთილი \n"დავით აღმაშენებელი ქართულ პოეზიაში".',
  },

  {
    imageGallery: [
      post4671,
      post4672,
      post4673,
      post4674,
      post4675,
      post4676,
      post4677,
      post4678,
    ],
    image: name467,
    id: 467,
    title: "დავით IV აღმაშენებელი",
    briefText:
      '📖📚 დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიღვნილი კვირეულის ფარგლებში ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში 2025 წლის 14 თებერვალს  ისტორიის  პედაგოგმა ქეთევან გოცირიძემ  VI-3 კლასში ჩაატარა თემატური ღია გაკვეთილი\n "დავით IV აღმაშენებელი".',
  },

  {
    imageGallery: [
      post4681,
      post4682,
      post4683,
      post4684,
      post4685,
      post4686,
      post4687,
      post4688,
      post4689,
      post4691,
      post4692,
      post4693,
      post4694,
      post4695,
      post4696,
      post4697,
    ],
    image: name468,
    id: 468,
    title: " „და იდექ სვეტად საქართველოსა“ ",
    briefText:
      '📚🏫2025 წლის 11-14 თებერვალს,      ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI -1 კლასში, ,, ჩვენი საქართველოს’’  გაკვეთილები  დაეთმო დავით აღმაშენებლის გარდაცვალების 900 წლისთავისადმი მიძღვნილ კვირეულს.\n👩‍🏫მასწავლებელი ინგა მართალიშვილი\n📖 11  თებერვალს  გაკვეთილზე „და იდექ სვეტად საქართველოსა“ - მოსწავლეებმა ისაუბრეს ერთიანი საქართველოს შექმნისთვის გადადგმულ პირველ ნაბიჯებზე, მეფე მწიგნობარზე, გელათის აკადემიის შექმნასა და მის მნიშვნელობაზე.\n📖14 თებერვალი დაეთმო  მეფის სამხედრო რეფორმებსა    და  "ძლევაი საკვირველს".\n📜მოსწავლეებმა ისაუბრეს დიდგორის ბრძოლის დროს დავით მეფის სტრატეგიულ და ტაქტიკურ  ნაბიჯებზე, მტერთა  სიმრავლის მიუხედავად  ბრძოლაში გამარჯვებაზე.',
  },

  {
    imageGallery: [],
    image: name469,
    id: 469,
    title:
      "🏛ვორქშოფი თემაზე: 📜ისტორიული წყაროების კონტენტ ანალიზი გრაფიკული ორგანიზატორების გამოყენებით",
    briefText:
      '🏫ა(ა)იპ ქ. ბათუმის წმ. ანდრია პირველწოდებულის სახელობის  სკოლაში დავით აღმაშენებლის გარდაცვალებიდან 900 წლისადმი მიძღვნილი კვირეულის ფარგლებში\nVIII-1 და VIII-4  კლასების მოსწავლეებმა გეოგრაფიის პედაგოგის ანა ანუშიძის  შესაბამისი ინსტრუქციების და  მაგალითების გამოყენებით შეძლეს  დავით აღმაშენებლის ისტორიკოსის თხზულებიდან "ცხოვრება მეფეთ-მეფისა დავითისი" 10 ფრაგმენტის კონტენტ ანალიზი. \n🔖💡 როგორც კონტენტ ანალიზის პროცესში, ისე კონტენტ ანალიზის შედეგების დემონსტრირების მიზნით მომზადებულ პრეზენტაციის ფურცელებში გამოიყენეს 🔎📑გრაფიკული ორგანიზატორები: კონცეპტუალური რუკა, მიმდევრობითი დიაგრამა, ვენის დიაგრამა, ყვავილის გვირგვინი, სვეტოვანი დიაგრამა, ტაქსონომია.',
  },

  {
    imageGallery: [],
    image: name470,
    id: 470,
    title: "რუსული სამზარეულო",
    briefText:
      '🏫📜2025 წლის 12 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში რუსული ენის (მეორე უცხოური ენა) მასწავლებელმა ლალი ლომთათიძემ VIII-1 კლასში  ჩაატარა ღია გაკვეთილი "რუსული სამზარეულო". \nსამიზნე ცნება - ზეპირი კომუნიკაცია\nდავალების პირობა: მოსწავლეებს უნდა აერჩიათ  რუსული სამზარეულოს კერძი და წარედგინათ აუდიტორიისთვის; უნდა   მოეთხროთ მისი მომზადების პროცესის შესახებ, უნდა წარმოეჩინათ:\nსაკუთარი დამოკიდებულები და ემოციები,  კერძის შემადგენელი ინგრედიენტები, მათი რაოდენობა და კერძის მომზადების ეტაპების თანმიმდევრობა.\n🥞🥐მოსწავლეებმა სახლში მოამზადეს და მოიტანეს რუსული სამზარეულოს შემდეგი კერძები: მოსკოვური სალათი, ვინეგრეტი, სალათი - „შუბა“, კარტოფილიანი ღვეზელები, "ოლადები", "ბლინები", „ჩებურეკი“, ვაშლის ნამცხვარი, კრემიანი ფუნთუშები, ყველიანი ბლითები.',
  },

  {
    imageGallery: [post4701, post4702, post4703, post4704, post4705],
    image: name471,
    id: 471,
    title: "კონფერენცია ჩატარდა ბათუმში, სასტუმრო ქორთიარდ მერიოტში",
    briefText:
      "📚📖 2025 წლის 15 თებერვალს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის დირექტორის მოადგილე პირიმზე რურუა და უცხო ენებისა და მათემატიკის კათედრის ხელმძღვანელები ნინო კორძაძე და ხატია ხალვაში ესწრებოდნენ საერთაშორისო საგანმანათლებლო კონფერენციას - Annual Educational Conference 2025-  organised by English Book Education .\nკონფერენცია ჩატარდა ბათუმში, სასტუმრო ქორთიარდ მერიოტში.",
  },

  {
    imageGallery: [],
    image: name472,
    id: 472,
    title: "📣📣 პირველკლასელთა  რეგისტრაცია 2025-2026 სასწავლო წლისთვის ! ",
    briefText:
      "📣📣 პირველკლასელთა  რეგისტრაცია 2025-2026 სასწავლო წლისთვის ! \n🏫📚ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა აცხადებს პირველკლასელთა რეგისტრაციას მომავალი, 2025-2026 სასწავლო წლისთვის! \n📋 რეგისტრაცია წარიმართება ეტაპობრივად:\n📌15 თებერვლიდან 15 \nაპრილამდე  დავარეგისტრირებთ ჩვენი მოსწავლეების  დედმამიშვილებსა  და საპატრიარქოს საბავშვო ბაღის აღსაზრდელებს, \n📌15 აპრილიდან  შეუძლია მოგვმართოს ნებისმიერმა მსურველმა. \n👫 შეგახსენებთ, რომ მომავალ წელს პირველ კლასებში მიიღებიან   ის მოსწავლეები, რომელთაც 6 წელი უსრულდებად 2025 წლის 31 დეკემბრის ჩათვლით! \n📌მშობლებმა მიმართეთ სკოლის კანცელარიას 9:00 საათიდან 14:00 საათამდე!",
  },

  {
    imageGallery: [post4731, post4732, post4733, post4734, post4735],
    image: name473,
    id: 473,
    title:
      "გასული სეზონის „კინგსის“ ოლიმპიადის გამარჯვებული ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები  დაჯილოვდნენ სერტიფიკატებითა და დიპლომებით . ",
    briefText:
      "👩‍🎓🧑‍🎓🏆გასული სეზონის „კინგსის“ ოლიმპიადის გამარჯვებული ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები  დაჯილოვდნენ სერტიფიკატებითა და დიპლომებით . \n🎓ალექსანდრე აბაშიძე- VIკლასი, ინგლისური  ენის ოლიმპიადაში ოქროს მედალი დაიმსახურა;\n🎓ნიცა ჯორბენაძე- VIკლასი.\n🎓გიორგი გუჩმანიძე- V კლასი, \n🎓დემეტრე შერვაშიძე- V კლასი, ქართული ენის ოლიმპიადის შემოდგომის სეზონის გამარჯვებული მოსწავლეა\n🎓ანასტასია გაგუა- V კლასი, \n🎓ლუკა კომახიძე- IV კლასი, \n🎓ანიტა აბგარიანი- IV კლასი,\n🎓მარიამ მამულაშვილი- IV კლასი,\n🎓ნია დიასამიძე- IV კლასი, \n🎓სესილია მოლაშხია- III კლასი,\n🎓ნინა ნაკაშიძე- III კლასი,\n🎓ინგა ქოქოლაძე- III კლასი. \n🎓სიდონია ბოლქვაძე- II კლასი,\n🎓ერეკლე შერვაშიძე- II კლასი,\n🎓ტაისია კახიძე- II კლასი. \n🏆გილოცავთ და გისურვებთ წარმატებებს!  👏👏",
  },

  {
    imageGallery: [post4741, post4742],
    image: name474,
    id: 474,
    title:
      "🏆♟აჭარის ჭადრაკის ფედერაციის ორგანიზებით 2025 წლის  9 მარტს მუხრან ვახტანგაძის სახელობის ბათუმის სპორტის სასახლეში აჭარის ჩემპიონატის დაჯილდოების ცერემონია გაიმართა.",
    briefText:
      "🏆♟აჭარის ჭადრაკის ფედერაციის ორგანიზებით 2025 წლის  9 მარტს მუხრან ვახტანგაძის სახელობის ბათუმის სპორტის სასახლეში აჭარის ჩემპიონატის დაჯილდოების ცერემონია გაიმართა.    \n🏆♟ტურნირი ჩატარდა ფიდეს წესებით, შვეიცარული სისტემით 7 ტურად. ღონისძიების ექვსივე ასაკობრივ კატეგორიაში პირველობისთვის 173 სპორტსმენი იბრძოდა.    \n🏆♟კიდევ ერთხელ გაგვახარეს ჩვენმა მოჭადრაკე ძმებმა.     \nბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-10 კლასის მოსწავლე  გიორგი გოგიაშვილმა 18 წლამდე ჭაბუკთა შორის  პირველი ადგილი მოიპოვა (7-დან 7 ქულა), ხოლო მე-8 კლასის მოსწავლე დემეტრე გოგიაშვილმა  16 წლიანებში აიღო მეორე ადგილი. \nსამომავლო გამარჯვების  სურვილებით ვულოცავთ ჩვენს  საამაყო ბიჭებს მორიგ წარმატებას! 👏👏",
  },

  {
    imageGallery: [
      post4751,
      post4752,
      post4753,
      post4754,
      post4755,
      post4756,
      post4757,
      post4758,
      post4759,
      post47510,
    ],
    image: name475,
    id: 475,
    title:
      " პლასტმასით დაბინძურების მიზეზები, გამოწვევები და შემცირების გზები.",
    briefText:
      "📚🏫 2025 წლის 10 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები და გეოგრაფიის პედაგოგი სესილი გათენაძე ბათუმის შოთა რუსთაველის სახელობის უნივერსიტეტში (  ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U ) ესწრებოდნენ  სამუშაო შეხვედრას  მოსწავლეებთან  თემაზე: პლასტმასით დაბინძურების მიზეზები, გამოწვევები და შემცირების გზები.\n📋 შეხვედრის  ხელმძღვანელი -  ასოცირებული პროფესორი გუგული დუმბაძე;\n📋მიზანი: მოსწავლეების გარემოსდაცვითი ცნობიერების ამაღლება, პლასტმასის შემცირების გზების ძიება და აქტიური ჩართულობის ხელშეწყობა; \n📋 შეხვედრის მხარდამჭერი: საერთაშორისო პროექტი CARE SEA: “თანამშრომლობა და ცნობიერების ამაღლება, დაბინძურებისგან თავისუფალი და ეკოლოგიურად მდგრადი შავი ზღვისთვის” (ხელ-ლი: უვადო მეცნიერი იზოლდა მაჭუტაძე).\n📋ვორქშოფს ესწრებოდნენ:\n📚ლუკა ჯანგირაშვილი,\n📚მარიამ ჩიხლაძე,\n📚მარიტა კოსტავა,\n📚თამუნა ძაძამია,\n📚სალომე ცინცაძე,\n📚ნინი ბუსხრიკიძე.\n📋 ლექციის,დისკუსიის და პრაქტიკული ხასიათის სამუშაოს შესრულების  შემდეგ  მონაწილეებს გადაეცათ სერთიფიკატები.",
  },

  {
    imageGallery: [
      post4761,
      post4762,
      post4763,
      post4764,
      post4765,
      post4766,
      post4767,
      post4768,
      post4769,
      post47610,
      post47611,
    ],
    image: name476,
    id: 476,
    title:
      " საინტერესო და დასამახსოვრებელი  იყო ყოფილ გიმნაზიელთან , უნივერსიტეტის ლექტორ, კაპიტნის პირველ თანაშემწე ნიკოლოზ ჯანელიძესთან შეხვედრა.",
    briefText:
      "📚2025 წლის 7 მარტს, ბათუმის ნავიგაციის სასწავლო უნივერსიტეტში ( ბათუმის ნავიგაციის სასწავლო უნივერსიტეტი - B N T U )ღია კარის დღე გაიმართა, რომლის ფარგლებშიც უნივერსიტეტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები და პედაგოგი ზურაბ კალანდაძე სტუმრობდნენ.  \n🚢მოსწავლეები გაეცნენ უნივერსიტეტის უმაღლეს და პროფესიულ საგანმანათლებლო პროგრამებს, დაათვალიერეს მატერიალურ-ტექნიკური ბაზა, თავად გამოცადეს გემის მართვის ტექნოლოგიები და ჩაერთნენ ტრენინგ ცენტრის საჩვენებელ სწავლებაში⚓️\nსაინტერესო და დასამახსოვრებელი  იყო ყოფილ გიმნაზიელთან , უნივერსიტეტის ლექტორ, კაპიტნის პირველ თანაშემწე ნიკოლოზ ჯანელიძესთან შეხვედრა.",
  },

  {
    imageGallery: [post4771],
    image: name477,
    id: 477,
    briefText:
      "🏃‍♀‍🏆კვლავ წარმატებულად იასპარეზეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის  მოსწავლეებმა აჭარის ჩემპიონატზე მძლეოსნობაში. \nშეჯიბრისთვის სპორტის მასწავლებლის დავით ონიაშვილის მომზადებულმა მძლეოსნებმა  ბარბერე სიხარულიძემ 50 მეტრ დისტანციაში დაიკავა II   ადგილი,  ელენე ურუშაძემ - 60 მეტრსა და  100 მეტრ დინსტანციაზე, ასევე,  II ადგილი.",
  },

  {
    imageGallery: [post4781, post4782],
    image: name478,
    id: 478,
    briefText:
      "საქართველოს ეკლესიის ავტოკეფალიის აღდგენის დღესთან დაკავშირებით, 2025 წლის 25 მარტს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები იმყოფებოდნენ  რელიგიის მუზეუმში,  სადაც ამ დღისადმი მიძღვნილი საჯარო ლექცია გამართა ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტის პროფესორმა ჯემალ კარალიძემ.",
  },

  {
    imageGallery: [post4791, post4792, post4793, post4794, post4795],
    image: name479,
    id: 479,
    briefText:
      " 2025 წლის 27 მარტს  ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის II-1 კლასის მოსწავლეები პედაგოგებთან ირინა სევასტიანოვასა  და თამარ მექვაბიშვილთან ერთად სტუმრად იყვნენ  აჭარის ხარიტონ ახვლედიანის ხელობის მუზეუმში , სადაც ჩატარდა საგანმანათლებლო პროგრამა 'ფრინველთა სამყარო'. ",
  },

  {
    imageGallery: [post4801, post4802, post4803, post4804],
    image: name480,
    id: 480,
    briefText:
      '☀️ 👩‍🎓🧑‍🎓წარმატებას ვულოცავთ და იცნობდეთ ოლიმპიადა "ევერესტის" გამარჯვებულ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებს: \n🎓ერეკლე შერვაშიძე, II კლასი;\n🎓გიორგი კვარაცხელია, II კლასი\n🎓საბა ჩიბურდანიძე, II კლასი;\n🎓ტაისია კახიძე, II კლასი;\n🎓ტასო მხეიძე, II კლასი;\n🎓სიდონია ბოლქვაძე ,  II კლასი;\n🎓მარი კიღურაძე, II კლასი;\n🎓ლაშა კახიძე, II კლასი;\n🎓ნია ხორავა,  II კლასი;\n🎓დემეტრე კახაძე, II კლასი;\n🎓დავით მიქელაძე, II კლასი;\n🎓ილია წულუკიძე, III კლასი;\n🎓ელისაბედ ესაძე, III კლასი;\n🎓ეკატერინე გოგიტიძე, III კლასი;\n🎓ელენე ტარიელაძე, III კლასი;\n🎓ინგა ქოქოლაძე, III კლასი;\n🎓იოანა გოგიტიძე,   IV კლასი;\n🎓ნუცა მიქელაძე,  V კლასი;\n🎓დემეტრე შერვაშიძე,  IV კლასი;\n🎓ნინი ესაძე, VI კლასი.',
  },

  {
    imageGallery: [post4811, post4812, post4813, post4814, post4815, post4816],
    image: name481,
    id: 481,
    briefText:
      "📚🌏ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები ანა ნაცვლიშვილი, ელენე ზანთარაია, გიორგი მოდინი, ანდრია ჯაფარიძე, მარიამ ჩხატარაშვილი, ლიზი ტყეშელაშვილი და  ნინია ჩავლეიშვილი იმყოფებოდნენ მადრიდში, ესპანეთში სადაც მონაწილეობდნენ SEKMUN-ის კონფერენციაში.\n SEK საგანმანათლებლო ჯგუფი არის ესპანეთში არსებული საგანმანათლებლო დაწესებულება, რომელიც 1892 წლიდან ინარჩუნებს ერთ-ერთი ყველაზე პრესტიჟული საგანმანათლებლო სივრცის სტატუსს. იგი აერთიანებს რამდენიმე საერთაშორისო სკოლას და სთავაზობს მოსწავლეებს მრავალფეროვან სასწავლო პროგრამებს, რაც ხელს უწყობს მათი ინტელექტუალური, ემოციური და სოციალური უნარების განვითარებას ჰოლისტური განათლების სისტემის ფარგლებში.\n🔹 SEK აქტიურად არის ჩართული საგანმანათლებლო ინიციატივებში, მათ შორის Model United Nations (MUN) კონფერენციების ორგანიზებაში. MUN კონფერენციები ეხმარება მოსწავლეებს გლობალურ საკითხებზე ცოდნის გაღრმავებაში და საერთაშორისო პოლიტიკის უკეთესად გაგებაში.\nSEKMUN კონფერენცია სამდღიან რეჟიმში მიმდინარეობდა, სადაც ბათუმელი მოსწავლეები აქტიურად მონაწილეობდნენ სხვადასხვა კომიტეტების მუშაობაში. მათ ჰქონდათ შესაძლებლობა, გაეღრმავებინათ ცოდნა საერთაშორისო ურთიერთობებში, ემუშავათ დელეგატებთან სხვადასხვა ქვეყნებიდან და განევითარებინათ საჯარო გამოსვლის, დებატებისა და გუნდური მუშაობის უნარები.\n🏛 კონფერენციის გახსნის ცერემონია ესპანეთის სენატში გაიმართა, რამაც ღონისძიებას კიდევ უფრო შთამბეჭდავი და მნიშვნელობით დატვირთული ხასიათი მისცა.\n✅ ბათუმელი მოსწავლეების მონაწილეობა SEKMUN-ში მნიშვნელოვანი ნაბიჯი იყო მათი აკადემიური და პიროვნული განვითარებისკენ, რაც შესაძლებელი გახდა Delegate Development Center-ის  მხარდაჭერის შედეგად.",
  },

  {
    imageGallery: [post4821, post4822, post4823, post4824, post4825],
    image: name482,
    id: 482,
    briefText:
      '📚🌞ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII  კლასების მოსწავლეებმა ქიმიის პედაგოგ ირინა ვიდულინასთან ერთად იმუშავეს ეკოლოგიურ პრობლემებზე თემაზე "გარემო და დაბინძურება".\n🌏კერძოდ, მათი ინტერესის საგანი გახდა გლობალური დათბობა, \nოზონი და ოზონის ხვრელი, მჟავური წვიმები. \n🌏📚პროექტის დასრულების შემდეგ გიმნაზიელებმა ერთმანეთს წარუდგინეს თავიანთი ნამუშევრები.',
  },

  {
    imageGallery: [post4831, post4832, post4833, post4834, post4835],
    image: name483,
    id: 483,
    briefText:
      '2025 წლის 2 აპრილს, ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის IV-1 კლასის მოსწავლეები იმყოფებოდნენ გონიო-აფსაროსის მუზეუმ-ნაკრძალში.  საგანმანათლებლო  პროგრამის "შეეხე ისტორიას ხელებით"  ფარგლებში, იმყოფებოდნენ გონიოს კვლევით  ცენტრში, სადაც ჩატარდა სასწავლო-შემეცნებითი აქტივობა. ბავშვებმა მოინახულეს  გონიოს  კვლევითი  ცენტრის  ლაბორატორია, ფონდები და გონიოს  ციხე-ნაკრძალი.\nპედაგოგები: სოფიო სანიკიძე და ლამარა გოგიბერიძე.',
  },

  {
    imageGallery: [post4841],
    image: name484,
    id: 484,
    briefText:
      "2025 წლის 6 აპრილს  სპორტის საერთაშორისო დღესთან დაკავშირებით ჩატარებულ მძლეოსნობის ტურნირზე ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე მართა იაკობაძემ 60 მეტრ დისტანციაზე მე-2 საპრიზო ადგილი დაიკავა, ხოლო ელენე ურუშაძემ - 100 მეტრ დისტანციაზე  მოიპოვა მე-2 საპრიზო ადგილი.  სპორტის მასწავლებელი - დავით ონიაშვილი.",
  },

  {
    imageGallery: [post4851, post4852, post4853, post4854, post4855, post4856],
    image: name485,
    id: 485,
    briefText:
      '📚2025 წლის 5-6 აპრილს სსიპ აჭარის მუზეუმის ორგანიზებით გაიმართა მოსწავლეთა III რეგიონული კონფერენცია - ,,მუზეუმის როლი განათლებაში”.\n✅ძმები ნობელების სახელობის ბათუმის ტექნოლოგიურმა მუზეუმმა ქიმიის, ფიზიკისა და მათემატიკის სექციებს უმასპინძლა.\n🔹  ქიმიის სექციის მუშაობაში მონაწილეობას იღებდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის  IX-3 კლასის მოსწავლეები გიორგი ჟღენტი, ანა თოიძე და ელენე ნასარაია.  \nგიმნაზიელებმა ქიმიის მასწავლებლის ნონა აბაშიძის ხელმძღვანელობის მოამზადეს და წარმატებით წარადგინეს შემდეგი მოხსენებები:\n📜გიორგი ჟღენტი- "წყლის უნიკალური თვისებები და მისი მნიშვნელობა სიცოცხლისთვის";\n📜ანა თოიძე, ელენე ნასარაია - სხვადასხვა სახის მარილები, მათი წარმოქმნა და გამოყენება". \n📚მოსწავლეებს კონფერენციის ბოლოს გადაეცათ სერტიფიკატები.',
  },

  {
    imageGallery: [post4861, post4862, post4863],
    image: name486,
    id: 486,
    briefText:
      "📚2025 წლის 12 მარტს  სკოლის მოსწავლეებს  შორის ჩატარდა ბუნებრივი და ტექნოლოგიური საფრთხეების, მოწყვლადობის თემებისა და მასთან დაკავშირებული პრევენციული ღონისძიებების შესახებ ცოდნის ხელშეწყობის ოლიმპიადა.\n🌏ოლიმპიადა ჩატარდა ევროპისა და ხმელთაშუა ზღვის დიდი საფრთხის შესახებ შეთანხმების ეგიდით (EUR-OPA)  და  ემსახურება ევროპისა და სამხრეთ ხმელთაშუა ზღვის ქვეყნებს შორის თანამშრომლობის პლატფორმას.\n🌏Besafenet -ის საერთაშორისო ოლიმპიადაში მონაწილეობდნენ   ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის  მეცხრე და მერვე  კლასის მოსწავლეები  გიორგი ჟღენტი და ანა თოიძე.  \nგუნდი მოამზადა ქიმიის მასწავლებელმა ნონა აბაშიძემ. \n📚 გიმნაზიელებმა 60 წუთში  სტიქიურ უბედურებებთან და ტექნოლოგიურ საფრთხეებთან დაკავშირებულ 50 კითხვას  სწორად გასცეს პასუხი. \n📚ოლიმპიადაში მონაწილე მოსწავლეებს გადაეცათ სერთიფიკატები.",
  },

  {
    imageGallery: [
      post4871,
      post4872,
      post4873,
      post4874,
      post4875,
      post4876,
      post4877,
    ],
    image: name487,
    id: 487,
    briefText:
      'ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში დედაენის დღესთან დაკავშირებით II-4  კლასში ჩატარდა დედა ენისადმი მიძღვნილი გაკვეთილი.\nგაკვეთილზე მოსწავლეებმა მასწავლებელთან ერთად ისაუბრეს იაკობ გოგებაშვილის "დედა ენის" შესახებ, ასევე მოეწყო კალიგრაფიის კონკურსი. \nხელოვნების გაკვეთილზე ბავშვებმა მოაჩუქურთმეს და გააფორმეს თავიანთი სახელები, მოეწყო მოსწავლეთა ნამუშევრების გამოფენა საკლასო ოთახში.\nქართულის მასწავლებელი- ნინო უგულავა\nხელოვნების მასწავლებელი- ირინე სევოსტიანოვა',
  },

  {
    imageGallery: [
      post4881,
      post4882,
      post4883,
      post4884,
      post4885,
      post4886,
      post4887,
      post4888,
    ],
    image: name488,
    id: 488,
    briefText:
      "🏫ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის V-1 და V-4 კლასებში წინასააღდგომო სამზადისთან დაკავშირებით  ინგლისურ ენაში ჩატარდა გაკვეთილი თემაზე :  How to celebrate Easter in different countries - როგორ აღნიშნავენ აღდგომის დღესასწაულს სხვადასხვა ქვეყნებში. ინგლისური ენის მასწავლებელი ზეინაბ კონცელიძე\n🌎ჯგუფებად დაყოფილმა მოსწავლეებმა  მოამზადეს საპრეზენტაციო მასალა, წარუდგინეს თანატოლებს,  გაეცნენ და შეადარეს ერთმანეთს სხვადასხვა ქვეყნის ტრადიციები და კულტურა,  იმსჯელეს, რა მსგავსება-განსხვავებაა საქარტველოსა  და სხვა ქვეყნებს შორის. გაკვეთილის მიზანი იყო ლექსიკური მარაგის გამდიდრება სამიზნე თემაზე.",
  },

  {
    imageGallery: [
      post4891,
      post4892,
      post4893,
      post4894,
      post4895,
      post4896,
      post4897,
      post4898,
    ],
    image: name489,
    id: 489,
    briefText:
      "🏫2025 წლის 24 აპრილს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-3 კლასში ჩატარდა ღია გაკვეთილი ქართული ენაში; მასწავლებელი თეა ქორჩილავა.",
  },

  {
    imageGallery: [post4901],
    image: name490,
    id: 490,
    briefText:
      '🏆♟დიდი სიხარულით ვულოცავთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მეორე კლასის მოსწავლე ლაშა კახიძეს 8 წლამდე ჭაბუკთა შორის ვერცხლის მედლისა და მეორე ადგილის მოპოვებას  საერთაშორისო საჭადრაკო ტურნირზე "ნოე ჟორდანიას თასი", რომელიც ჩატარდა ლანჩხუთის მუნიციპალიტეტის მერიის, განათლების, კულტურის, სპორტისა და ახალგაზრდულ საქმეთა სამსახურის, საჭადრაკო კლუბი ლანჩხუთის და სპორტული ცენტრის ორგანიზებით. 👏👏👏',
  },

  {
    imageGallery: [post4911],
    image: name491,
    id: 491,
    briefText:
      "🌿 ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის II-1, II-4, IV-2 და IV-3 კლასის მოსწავლეებმა აღნიშნეს 🌍დედამიწის საერთაშორისო დღე. მოსწავლეებმა მასწავლებელთა ერთად გამართეს დისკუსია, იმსჯელეს და ისაუბრეს ეკოლოგიის შესახებ. \n🏞 შემდეგ კი შექმნეს თემატური ჩანახატები\nმასწავლებელი- ირინე სევოსტიანოვა",
  },

  {
    imageGallery: [post4921, post4922, post4923],
    image: name492,
    id: 492,
    briefText:
      '📜📚2025 წლის 25 აპრილს სენაკის წმინდა ალექსი შუშანიას სახელობის სკოლა-გიმნაზიაში ჩატარდა  მასწავლებელთა კონფერენცია  თემაზე  "კონფლიქტი და კონტრასტები ლიტერატურის, პროზისა და პოეზიის გზაზე".\n📜📚კონფერენციაზე საპატრიარქოს სკოლების პედაგოგებმა წარმოადგინეს თემები, რომლებშიც განიხილეს სწავლა-სწავლების ახლებური მიდგომები, ხედვები და დამოკიდებულებები. შეხვედრის მიზანი იყო გამოცდილების გაზიარება  და სამომავლო თანამშრომლობა.\n📜📚კონფერენციის მუშაობაში მონაწილეობდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის ქართული ენისა და ლიტერატურის პედაგოგი მარინა ტალახაძე და სკოლის დაწყებითი საფეხური სასწავლო ნაწილი ნაირა ზოიძე. \nმარინა ტალახაძემ წარადგინა მოხსენება თემაზე "ეპოქების კონფლიქტი ქართულ ლიტერატურაში".',
  },

  {
    imageGallery: [post4931, post4932, post4933, post4934],
    image: name493,
    id: 493,
    briefText:
      "30 აპრილს, ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლას ეწვია აჭარის მუზეუმის საგანმანათლებლო და შემეცნებითი პროგრამების ხელმძღვანელი ნათია იმნაძე, აჭარის ხარიტონ ახვლედიანის სახელობის მუზეუმის მმართველ ოთარ გოგოლიშვილთან ერთად.  სტუმრებმა ჩვენი სკოლის უფროსკლასელებს და პედაგოგებს გააცნეს აჭარის მუზეუმის საგანმანათლებლო პროგრამები.",
  },

  {
    imageGallery: [post4941, post4942, post4943, post4944, post4945],
    image: name494,
    id: 494,
    briefText:
      "👫🌞 2025 წლის 1  მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის IV-3 კლასის მოსწავლეები კლასის ხელმძღვანელ  რუსუდან თოიძესა და მუსიკის მასწავლებელ ეკა ბჟინავასთან ერთად  ეწვივნენ წმინდა ეკატერინეს სახელობის სათნოების სავანეს.  \n👫პატარებმა მასპინძლებს  წარუდგინეს  თავიანთი შემოქმედება და სამახსოვროდ საკუთარი ხელით დამზადებული სამაჯურები და ტკბილეული მიართვეს.\nმოხუცები კმაყოფილნი დარჩნენ პატარების სითბოთი და ყურადღებით და დალოცეს ისინი.",
  },

  {
    imageGallery: [post4951, post4952, post4953, post4954],
    image: name495,
    id: 495,
    briefText:
      "🔶  2025 წლის 1 მაისს კავკასიის საერთაშორისო უნივერსიტეტსა და საპატრიარქოს განათლების ცენტრს შორის ურთიერთთანამშრომლობის მემორანდუმი გაფორმდა. \n🔶  დოკუმენტის მიხედვით, კავკასიის საერთაშორისო უნივერსიტეტი საპატრიარქოს განათლების ცენტრის შემადგენლობაში შემავალი სკოლების კურსდამთავრებულებს, რომლებიც CIU-ში ჩაირიცხებიან, 40%-იან შიდა გრანტს გამოუყოფს. თანამშრომლობა ასევე მოიცავს დამამთავრებელი კლასის მოსწავლეებისთვის პროფესიული ორიენტაციის ტრენინგებს, ეროვნული გამოცდებისთვის მოსამზადებელ აქტივობებსა და შემეცნებით-საგანმანათლებლო პროექტებს. გარდა მოსწავლეებისა, კავკასიის საერთაშორისო უნივერსიტეტი განათლების ცენტრის დირექტორებისა და პედაგოგებისთვის განახორციელებს გადამზადების პროგრამებს. \n🔶ურთიერთთანამშრომლობის მემორანდუმს ხელს კავკასიის საერთაშორისო უნივერსიტეტის რექტორი კახაბერ კორძაია და საპატრიარქოს განათლების ცენტრის თავმჯდომარე, მიტროპოლიტი იოანე გამრეკელი აწერენ. \n🔶  ღონისძიების დასასრულს კავკასიის საერთაშორისო უნივერსიტეტის სემინარის „კარიერული ორიენტაცია და აკადემიური მზაობა“ - გავლისთვის მსმენელები შესაბამისი სერტიფიკატებით დაჯილდოვდნენ. \n🔶  შეხვედრას ესწრებოდნენ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პედაგოგები ზვიად ჩხენკელი და კახი კახიძე.",
  },

  {
    imageGallery: [
      post4961,
      post4962,
      post4963,
      post4964,
      post4965,
      post4966,
      post4967,
    ],
    image: name496,
    id: 496,
    briefText:
      "🏛️2025 წლის 1 მაისს აჭარის ხარიტონ ახვლედიანის სახელობის მუზეუმს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-2 კლასი ეწვია.\n🔷ჩატარდა საგანმანათლებლო პროგრამა “ფრინველთა სამყარო”.\n🔷კლასის დამრიგებელს  ირინე სევასტიანოვას პროგრამაში მონაწილეობისთვის გადაეცა სერტიფიკატი.",
  },

  {
    imageGallery: [
      post4971,
      post4972,
      post4973,
      post4974,
      post4975,
      post4976,
      post4977,
    ],
    image: name497,
    id: 497,
    briefText:
      '🏨 2025 წლის 3 მაისს ახალგაზრდობის ეროვნული სასახლის ორგანიზებით ჩატარდა რიგით 78-ე სასწავლო-კვლევითი კონფერენცია, რომელშიც მონაწილეობას იღებდნენ ჩვენი სკოლის მოსწავლეები. \n🥇პირველი ადგილი ისტორიის სექციაში: ელენე დუმბაძე - "ბათუმის ჭაობის მენშევიკური ორგანიზაცია" ხელმძღვანელი ზვიად ჩხენკელი. \n🥈მეორე ადგილი გეოგრაფიის სექციაში: მარიამ გოროზია - "ჭკვიანი სახლების გეოგრაფია" ხელმძღვანელი - კახი კახიძე.',
  },

  {
    imageGallery: [],
    image: name498,
    id: 498,
    briefText:
      "🏆🥇⛸️დიდი სიხარულით ვულოცავთ მორიგ წარმატებას ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-10  კლასის მოსწავლე  ქეთევან მახარაძეს, რომელმაც   ერევანში გამართულ საერთაშორისო ტურნირზე ფიგურულ ციგურაობაში, Advanced Novice Girls კატეგორიაში, ოქროს მედალი მოიპოვა! \n👏👏👏👏",
  },

  {
    imageGallery: [
      post4991,
      post4992,
      post4993,
      post4994,
      post4995,
      post4996,
      post4997,
    ],
    image: name499,
    id: 499,
    briefText:
      "🏤 2025 წლის 7 და 8 მაისს IX-1 და IX-2 კლასის მოსწავლეები ძმები ნობელების სახელობის ბათუმის ტექნოლოგიურ მუზეუმს ეწვივნენ. \n⚙️🔬მოსწავლეებს მუზეუმში ჩაუტარდათ ექსკურსია, სადაც ისინი გაეცნენ XIX-XX საუკუნეში საქართველოში მიმდინარე ინდუსტრიალიზაციას. მოსწავლეებმა დაათვალიერეს ნობელების, როტშილდის, მანთაშევის, სხვა ნავთობმაგნატების, ჩაის ინდუსტრიის, ღვინის წარმოების და სხვა საწარმოების შესახებ მუზეუმში დაცული მასალები.\n👨‍🏫 ისტორიის მასწავლებელი-  ზვიად ჩხენკელი",
  },

  {
    imageGallery: [post5001, post5002, post5003, post5004],
    image: name500,
    id: 500,
    briefText:
      "📚 გეოგრაფიის კვირეული\n🏫🌏 2025 წლის 6 მაისს ბათუმის წმინდა  ანდრია პირველწოდებულის სახელობის  სკოლაში დასრულდა გეოგრაფიის კვირეული VIII კლასებში. 👩‍🏫 მასწავლებელი ანა ანუშიძე. \n🌏კვირეულის თემატიკა:\n✅️ კლიმატური სარტყლები და ბუნებრივი ზონები;\n✅️ რელიეფის ფორმები;\n🔹️გეოგრაფიული ტექსტის ანალიზი:\n🔹️სხვადასხვა თემატური რუკის გამოყენება;\n🔹️გეოგრაფიული სტატიების გაცნობა - განხილვა;",
  },

  {
    imageGallery: [post5011, post5012, post5013, post5014],
    image: name501,
    id: 501,
    briefText:
      "🏆🏸2025 წლის 2-4 მაისს ქ.თბილისში ჩატარდა საქართველოს პირველობა ბადმინტონში.\n🏸წმინდა ანდრია პირველწოდებულის სახელობის სკოლის V-4 კლასის მოსწავლე ანასტასია კუტუბიძემ   U13 ერთეულთა კატეგორიაში დაიკავა მესამე ადგილი, ხოლო U15 წყვილთა კატეგორიაში პირველი ადგილი რაფაელ ოვანესიანთან ერთად.\n🏆ვულოცავთ ანასტასიას და ვუსურვებთ წარმატებებს მომავალში!👏👏",
  },

  {
    imageGallery: [post5021, post5022, post5023, post5024, post5025],
    image: name502,
    id: 502,
    briefText:
      "🌞👫 2025 წლის 8 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მეორე კლასის მოსწავლეები კლასის დამრიგებელ ირინა სევოსტიანოვასთან ერთად იყვნენ  ეთნოგრაფიული მუზეუმში  “ბორჯღალო” .\n🌞ეთნოგრაფიულ მუზეუმში წარმოდგენილია აჭარის რეგიონისათვის დამახასიათებელი საცხოვრებელი და სამეურნეო ნაგებობათა მაკეტები, ხალხური რეწვის დარგები, აგრარული მეურნეობა, ყოფითი ცხოვრება და სხვა, ამ ყველაფერს კი ფოლკლორული მუსიკა ერთვის.  აქ ვნახავთ ადამიანთა ფიგურებს სხვადასხვა საქმიანობისას. \n🌞პატარები შეხვდნენ “ბორჯღალოს” დამფუძნებლს, ბატონ  ქემალ თურმანიძეს. \n🌞 ეთნოგრაფიული მუზეუმში  სასიამოვნო გარემოში გატარებული დრო ინფორმაციით დატვირთული,  შემეცნებითი იყო.",
  },

  {
    imageGallery: [post5031, post5032, post5033, post5034, post5035, post5036],
    image: name503,
    id: 503,
    briefText:
      "ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლაში 2025 წლის 3-8 მაისს, საღვთო სჯულის პედაგოგებმა კვირეული მიუძღვნეს ორ დიდ დღესასწაულს: გიორგობასა და ანდრიაობას. \nმასწავლებლებმა I-VII კლასებში  გაკვეთილებზე   ისაუბრეს: \n1. წმინდა საკვირველთმოქმედი და ძლევაშემოსილი გიორგის შესახებ, რომელიც  ქართველი ერის მფარველად მიიჩნევა,  მართლმადიდებელი ეკლესია 6 მაისს მისი აღსრულების დღეს აღნიშნავს.\n2. ღვთისმშობლისადმი საქართველოს წილხვდომილობის დღესთან და ამავდროულად, საქართველოს ეკლესიის, როგორც სამოციქულო საყდრის დამაარსებლის, წმინდა ანდრია პირველწოდებულის საქართველოში შემოსვლის დღესთან დაკავშირებით, რომელიც ეროვნულ დღესასწაულად იქცა და 12 მაისს ვდღესასწაულობთ.\nამ თემებთან დაკავშირებით, მოსწავლეებმა მრავალმხრივ საინტერესო პრეზენტაციები წარმოადგინეს გაკვეთილებზე.\nპედაგოგები: რუსუდან ურუშაძე, თამარ ნინიძე, მარიამ ქორიძე, მარიამ ჭანტურია.",
  },

  {
    imageGallery: [post5041, post5042, post5043, post5044],
    image: name504,
    id: 504,
    briefText:
      "#საბიბლიოთეკოგაკვეთილი\n📚📚ბათუმის საჯარო ბიბლიოთეკის საბავშვო-ახალგაზრდობის განყოფილების მთავარმა ბიბლიოთეკარმა ნანა კვაჭაძემ, ბათუმის ანდრიაპირველწოდებულისსახელობის საჯარო  სკოლის IV/2 კლასის მოსწავლეებისთვის, საბიბლიოთეკო გაკვეთილი ჩაატარა თემაზე: „იაკობის სიცოცხლე ლეგენდას ჰგავს, მაგრამ ის ლეგენდაზე მეტია“. \n📚📚მთავრმა ბიბლიოთეკარმა, თავდაპირველად, მოსწავლეებს ვლადიმერ ალფენიძის “ოცდაცამეტი მზისსახოვანი ბრძენი იაკობი”  და  იაკობ გოგებაშვილის “დედაენა” წარადგინა. ესაუბრა ქართული ანბანის შექმნის ისტორიებსა და ლეგენდებზე, იაკობ გოგებაშვილის ბიოგრაფიასა და შემოქმედებაზე. ასევე ხაზი გაესვა “დედაენისა” და იაკობის როლს საქართველოში წერა-კითხვის გავრცელებაში.  \n📚📚საბიბლიოთეკო გაკვეთილი ინტერაქტიულად წარიმართა. მასში აქიტურად ჩაერთნენ მოსწავლეები და პედაგოგი  ნინო უგულავა.",
  },

  {
    imageGallery: [post5051, post5052, post5053],
    image: name505,
    id: 505,
    briefText:
      '🏫 ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის U5 კატეგორიაში მოასპარეზე დებიუტანტმა გუნდმა "მეოთხე ლეგიონმა"  "ტვინების ბრძოლის" საქართველოს პირველობაზე მოიპოვა მეოთხე და აჭარის მასშტაბით 🥇 პირველი ადგილი.',
  },

  {
    imageGallery: [
      post5061,
      post5062,
      post5063,
      post5064,
      post5065,
      post5066,
      post5067,
      post5068,
    ],
    image: name506,
    id: 506,
    briefText:
      "🔹2025 წლის 16 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის XI კლასის მოსწავლეები დაესწრნენ მოქანდაკე ბაჩო ჭამელაშვილის  გამოფენის გახსნას, რომელიც  ხელოვნების მუზეუმში შედგა. \nდამსწრე საზოგადოებას მიეცა შესაძლებლობა, რომ თავად   ავტორისგან მოესმინა  გამოფენილი ნამუშევრების შესახებ და  თავადაც დაესვა შეკითხვები. \nმასწავლებელი - ზვიად ჩხენკელი",
  },

  {
    imageGallery: [post5071, post5072, post5073, post5074, post5075, post5076],
    image: name507,
    id: 507,
    briefText:
      "2025 წლის 9-12 მაისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მასწავლებელი ანა ანუშიძე მიწვეული იყო The Global Education Summit-ზე, რომელიც გაიმართა აზერბაიჯანის დედაქალაქ ბაქოში. \nმონაწილეებმა გაიზიარეს საუკეთესო პრაქტიკა და ინოვაციური მიდგომები სწავლა - სწავლების პროცესის ეფექტიანად წარმართვისა და პოზიტიური სასკოლო კულტურის ჩამოყალლიბების მიმართულებით. \nანა ანუშიძე ჩაერთო პანელურ დისკუსიაში თემებზე :\nა) ინოვაციები და ტრადიციები: სწორი ბალანსი გლობალურ სწავლებაში, \nბ) საკლასო ოთახის ახლებური გააზრება: როგორ ცვლის თანამედროვე ტექნოლოგიები საგანმანათლებლო სივრცეებს მთელს მსოფლიოში. \nდასრულებისას ანას გადაეცა შესაბამისი დიპლომები.",
  },

  {
    imageGallery: [],
    image: name508,
    id: 508,
    briefText:
      "„ეს საამაყო და გამორჩეული ახალგაზრდები ქვეყნის მომავალს განსაზღვრავთ!“- ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლიდან 26-ე თაობა გააცილეს",
  },

  {
    imageGallery: [
      post5091,
      post5092,
      post5093,
      post5094,
      post5095,
      post5096,
      post5097,
    ],
    image: name509,
    id: 509,
    briefText:
      '🏫 დიდი ხანია  საუკეთესო გამოცდილებად იქცა  ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლასა და შოთა რუსთაველის სახელობის ბსუ-ს( ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტი / B S U ) შორის მჭიდრო თანამშრომლობა სხვადასხვა მიმართულებით . \n📚ბოლო კვირეების განმავლობაში ჩვენს სკოლაში პრაქტიკას გადიოდნენ ფსიქოლოგიის მიმართულების სტუდენტები  მილენა თავდგირიძე, დეა დარჩია, მარიამ სალუქვაძე, ნიკოლოზ ნაკაშიძე, სულხან ბერიძე.\nსტუდენტებს მენტორობას უწევდა სკოლის ფსიქოლოგი თეა ხინთიბიძე. \n👩‍🏫 ახალგაზრდებმა თავიანთი პრაქტიკა შეაჯამეს პრეზენტაციებით III (დამრიგებელი ხათუნა მანჯგალაძე) და   VI ( დამრიგებელი   ზეინაბ კონცელიძე) კლასებში \nთემებზე : "საკუთარი და სხვისი ემოციების იდენტიფიცირება, ემოციების ექსპრესია და მართვა" და "არაძალადობრივი კომუნიკაციის მეთოდები".',
  },

  {
    imageGallery: [post5101, post5102, post5103, post5104, post5105, post5106],
    image: name510,
    id: 510,
    briefText:
      '🌞ბათუმის წმინდა ანდრია პირველწოდებულის სკოლის XI-3 კლასის მოსწავლეებმა წარმოადგინეს თეატრალიზებული პერფორმანსი თემაზე "სილამაზისა და მოდის სტანდარტები".\n🎩🥻👒🪭\nმოსწავლეები დაიყვნენ ჯგუფებად, 👫 მოიძიეს  სათანადო ინფორმაცია . შეისწავლეს სხვადასხვა ეპოქის თავისებურებები და სათანადოთ გააცოცხლეს ისინი თეატრალიზებული სცენებით, ცოცხალი მონოლოგებით, კოსტიუმებითა და მუსიკალური გაფორმებით, სადაც თითოეული ეპიზოდი იყო ვიზუალური მოგზაურობა დროისა და მოდის ლაბირინთში.\n🪭👒✨️🥻🎩\nპროექტის რუსულის მასწავლებელი - ევგენია ლომაძე',
  },

  {
    imageGallery: [post5111, post5112, post5113, post5114, post5115],
    image: name511,
    id: 511,
    briefText:
      "✨️🌐 ეროვნული სამოსის დღესთან დაკავშირებით ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის  III- 4 კლასის მოსწავლეებმა ხელოვნების პედაგოგ ირინა სევოსტიანოვასთან ერთად   საინტერესო  პროექტი დაგეგმეს და განახორციელეს. \n👫🌞პატარებმა მოიძიეს ინფორმაცია და  წარადგინეს მასალა საქართველოს კუთხეების ტრადიციების შესახებ.\n🎨შემდეგ დახატეს  სხვადასხვა  კუთხის სამოსი. \n🏛ბოლოს კი ეწვივნენ   აჭარის სახელმწიფო მუზეუმს, სადაც გაიმდიდრეს ცოდნა  აჭარაში  სამოსის ფორმებისა და  მისი ტარების შესახებ.",
  },

  {
    imageGallery: [
      post5121,
      post5122,
      post5123,
      post5124,
      post5125,
      post5126,
      post5127,
    ],
    image: name512,
    id: 512,
    briefText:
      '🏫ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეთა გუნდმა მონაწილეობა მიიღო საფეხბურთო ტურნირში  "თავისუფლების თამაშები". \nბათუმის საჯარო და კერძო სკოლების მოსწავლეთა შორის წარმატებით იასპარეზეს და დაიკავეს 🥉III ადგილი.',
  },

  {
    imageGallery: [
      post5131,
      post5132,
      post5133,
      post5134,
      post5135,
      post5136,
      post5137,
      post5138,
    ],
    image: name513,
    id: 513,
    briefText:
      "🌞👫🌼2025 წლის 2 ივნისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში გაიმართა ხალხური შემოქმედების  კონცერტი, რომელშიც მონაწილეობდნენ დაწყებითი საფეხურის მოსწავლეები. \n🌞👩‍🏫კონცერტის ორგანიზატორი- მუსიკის მასწავლებელი ეკატერინე ბჟინავა. \n🌐👫🌼 კონცერტი მიეძღვნა ბავშვთა დაცვის საერთაშორისო დღეს.",
  },

  {
    imageGallery: [post5141, post5142, post5143, post5144, post5145],
    image: name514,
    id: 514,
    briefText:
      "2025 წლის 3 ივნისს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-4 კლასში ჩატარდა ღია გაკვეთილი  საღვრთო სჯულში თემაზე:  წმინდა ანდრია პირველწოდებულის მოღვაწეობა საქართველოში. \nსაღვრთო სჯულის პედაგოგი თამარ ნინიძე.",
  },

  {
    imageGallery: [post5151],
    image: name515,
    id: 515,
    briefText:
      "2025 წლის 17 მაისს ბათუმის შოთა რუსთაველის სახელმწიფო უნივერსიტეტში , სკოლისა და უნივერსიტეტის თანამშრომლობის კლუბის „სკოლა-უნივერსიტეტი“ ფარგლებში, გაიმართა მე-11 სამეცნიერო კონფერენცია თემაზე: „სასკოლო განათლება - თანამედროვე გამოწვევები და პერსპექტივები“.\nქიმიის სექტორში კონფერენციაში მონაწილეობა მიიღეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-2 კლასის მოსწავლეებმა ანდრია რუხაძემ და ოთო ბაღდავაძემ.",
  },

  {
    imageGallery: [post5161],
    image: name516,
    id: 516,
    briefText:
      "🏆🏃‍♀‍მორიგ წარმატებას ვულოცავთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებს და სპორტის პედაგოგს დავით ონიაშვილს შიდა სპორტულ სასკოლო პირველობაზე მძლეოსნობაში 60 მეტრიან გარბენში, სადაც მართა იაკობაძემ პირველი ადგილი, ხოლო ბარბარე სიხარულიძემ  მესამე ადგილი მოიპოვეს!",
  },

  {
    imageGallery: [post5171],
    image: name517,
    id: 517,
    briefText:
      '🏆უდიდესი სიხარულით გვსურს გამცნოთ, რომ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე შიო გენჯაძე მსოფლიო ჩემპიონია!   \n🏆გილოცავთ  შიო! \nმსოფლიო ჩემპიონი - შიო გენჯაძე🇬🇪🏅\nშერეული საბრძოლო ხელოვნებების ახალგაზრდულ მსოფლიო ჩემპიონატზე ქალაქ აბუ დაბიში ქართული სპორტის ისტორია დაიწერა ამ ახალგაზრდა მებრძოლის მიერ💥\nგილოცავთ ქართველებო და გილოცავთ შიო!" - ვკიტხულობთ GMMAF - Georgian Mixed Martial Arts National Federation-ის ოფიციალურ გვერდზე.',
  },
  {
    imageGallery: [post5181],
    image: name518,
    id: 518,
    title: "",
    briefText:
      " ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლის ფორმა.",
  },
  {
    imageGallery: [post5191],
    image: name519,
    id: 519,
    title: "",
    briefText:
      ' 🏛👨🎓👩🎓გიზიარებთ და გიწვევთ "მშობელთა საზაფხულო სკოლის" დასკვნით ვორქშოფებზე 1, 2 და 3 სექტემბერს.\n🏛  ვოქშოფის მასპინძელი და მხარდამჭერია ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა.  \n📮მისამართი: დემეტრე თავდადებულის ქ. №49\n✅️ ვორქშოფებში მონაწილე მშობლებს გადაეცემათ\n💡📚 სხვადასხვა ფორმატის, მატერიალური და ელექტრონული  რესურსები თითოეულ თემაზე და\n📜 სამახსოვრო სერტიფიკატები.\n📝რეგისტრაციის ბმული\n📎 https://docs.google.com/…/1FAIpQLScl0O91HfRZ0Bnj2B…/viewform  \n⏰️ რეგისტრაციის გავლა შესაძლებელია 2️⃣7️⃣ აგვისტოს ჩათვლით.\n📬  ვორქშოფებში მონაწილეობის მოწვევის შეტყობინებას მიიღებთ 3️⃣0️⃣ აგვისტომდე.\nგისურვებთ წარმატებებს! 📚♥️ \n🏛👨🎓👩🎓 We’re excited to invite you to the final workshops of our “Parents’ Summer School” taking place on September 1, 2, and 3 🏛 Our host and supporter is the N(N)LE St. Andrew the First-Called School of Batumi. 📮Address: 49 Demetre Tavdadebuli Street\n✅️ As a participant, you will receive:\n💡📚 A variety of valuable materials and resources for each topic (both printed and digital)\n📜 A special certificate to remember the experience\n📝 Register here:\n📎 https://docs.google.com/…/1FAIpQLScl0O91HfRZ0Bnj2B…/viewform\n⏰ Registration is open until August 27.\n📬 Confirmation of participation will be sent by August 30.\nWe can’t wait to welcome you — and wish you every success! 📚♥️',
  },
  {
    imageGallery: [post5201],
    image: name520,
    id: 520,
    title: "",
    briefText:
      " 🏫👩🎓🧑🎓სიხარულითა და სიამაყით გვსურს გაცნობოთ, რომ 2024-2025 სასწავლო წლის ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის 76 კურსდამთავრებულიდან 71 უკვე სტუდენტია, მათ შორის 16 - სახელმწიფო გრანტის მფლობელი!  \n📚სტუდენტობას გილოცავთ, ძვირფასო გიმნაზიელებო!\n📚გისურვებთ წარმატებებს! \n🏫 ჩვენ მუდამ ვიამაყებთ ჩვენი ღირსეული მოსწავლეებით!",
  },
  {
    imageGallery: [
      post5211,
      post5212,
      post5213,
      post5214,
      post5215,
      post5216,
      post5217,
      post5218,
      post5219,
      post52110,
      post52111,
    ],
    image: name521,
    id: 521,
    title: "",
    briefText:
      " ა(ა)იპ ბათუმის წმ. ანდრია პირველწოდებულის სახელობის სკოლის 2025-2026 სასწავლო წლის \nI-XI კლასების სახელმძღვანელოების ჩამონათვალი",
  },
  {
    imageGallery: [post5221, post5222, post5223],
    image: name522,
    id: 522,
    title: "",
    briefText:
      " ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის I, II, III-XII კლასების გაკვეთილების დაწყება-დასრულების  გრაფიკი.",
  },
  {
    imageGallery: [post5231, post5232, post5233],
    image: name523,
    id: 523,
    title: "",
    briefText:
      " 🖥⌨️ახალი სასწავლო წლისთვის ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში მთლიანად განახლდა კომპიუტერული ლაბორატორია, სადაც პედაგოგისა და მოსწავლეებისთვის დამონტაჟდა ახალი კომპიუტერები და პროექტორი.",
  },
  {
    imageGallery: [post5241, post5242, post5243, post5244, post5245, post5246],
    image: name524,
    id: 524,
    title: "",
    briefText:
      " 🎯📝2025 წლის 8-11 სექტემბერს  🏣 ა(ა)იპ ქ. ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში ახალი სასწავლი წლის დაწყებამდე  პედაგოგთა და კათედრების ხელმძღვანელთა ჩართულობით უმნიშვნელოვანესი  სამუშაო პროცესი წარიმართა. \n✅შეხვედრები დაგეგმა და წარმართა სკოლის სტრატეგიული განვითარების ჯგუფის ხელმძღვანელმა ანა ანუშიძემ. \n✅ დამუშავდა შემდეგი დოკუმენტაცია/საკითხები 📑➡️\n🔸ეროვნული სასწავლო გეგმა, საგნობრივი სტანდარტები;\n🔸არსებული სასწავლო პროგრამები და სკოლის მიერ უკვე არჩეული სახელმძღვანელოები, შესაბამისი ალტერნატივებით;\n🔸მოსწავლეთა მიმდინარე და შემაჯამებელი დავალებების ანალიზის ამსახველი დოკუმენტაცია, ძლიერი და სუსტი მხარეები, განვითარების გზები;\n🔸ინდივიდუალური და ალტერნატიული სასწავლო გეგმების მიხედვით სათანადო სასწავლო რესურსების შექმნა - გამოყენების საკითხები;\n🔸უნივერსალური დიზაინისა და დიფერენცირებული მიდგომის გამოყენების გზები სასკოლო პრაქტიკაში;\n✅განახლდა სასწავლო - მეთოდური რესურსები 📑➡️\n🔸საგნობრივი სტანდარტის, თემატიკის და სამიზნე ცნებების ამსახველი ინფოგრაფიკები, თითოეული საგნისთვის (კლასის/საფეხურის მიხედვით);\n🔸შეფასების ჰოლისტური რუბრიკების და უნივერსალური დიზაინის მქონე აქტივობების ბარათები;\n🔸კათედრის სამუშაო ელექტრონული ფორმები;\n✅გარდაიქმნა/განახლდა საგნობრივი სასწავლო გეგმები და შესაბამისი დანართები თემატური მატრიცები და კომპლექსური დავალების ბარათები 📑➡️\n🔸განახლდა და თავიდან შეიქმნა 173 საგნობრივი სასწავლო გეგმა.\nბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა მადლობას მოახსენებს  ყველა მასწავლებელს,  ვინც კეთილსინდისიერად შრომობს! ❤️",
  },
  {
    imageGallery: [post5251],
    image: name525,
    id: 525,
    title: "",
    briefText:
      " 🏫ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის 2025-2026 სასწავლო წლის პირველკლასელთათვის და მათი ოჯახის წევრებისთვის 15 სექტემბერს 9:00  საათზე ბათუმის ღვთისმშობლის შობის სახელობის ტაძარში ჩატარდება საჯანმრთელო პარაკლისი ! \nგელოდებით!",
  },
  {
    imageGallery: [post5261, post5262],
    image: name526,
    id: 526,
    title: "",
    briefText:
      " ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის 2025-2026 სასწავლო წლის კალენდარი",
  },
  {
    imageGallery: [post5271, post5272, post5273, post5274, post5275, post5276],
    image: name527,
    id: 527,
    title: "",
    briefText:
      " 👩🎓🧑🎓🏫2025 სასწავლო წელს ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა გიმნაზიელთა 35-ე თაობას შეეგება სიხარულით და სიყვარულით! \nტრადიციულად 100-მდე პირველკლასელისთვის, მათი პედაგოგებისა და ოჯახის წევრებისთვის ღვთისმშობლის შობის სახელობის ტაძარში სკოლის მოძღვარმა მამა დიმიტრი სარჯველაძემ აღავლინა პარაკლისი, დალოცა და სასწავლო წლის დაწყება მიულოცა პატარებს და მათ აღმზრდელებს.",
  },
  {
    imageGallery: [post5281, post5282, post5283, post5284],
    image: name528,
    id: 528,
    title: "",
    briefText:
      ' 🏫🇬🇪ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში "საქართველოს სახელმწიფო სიმბოლოების გამოყენების წესის" თანახმად,  ისევე, როგორც საქართველოს სხვა საგანმანათლებლო დაწესებულებებში სასწავლო წლის დაწყებისას სახელმწიფო ჰიმნის აჟღერდა.',
  },
  {
    imageGallery: [post5291, post5292, post5293],
    image: name529,
    id: 529,
    title: "",
    briefText:
      " 15 სექტემბრის ქრონიკები- პირველკლასელთა ემოციები, ბედნიერი მშობლები, ახალი მასწავლებლები, გასამხნევებლად მოსული საყვარელი ზღაპრების გმირები, საჩუქრები,  ყვავილები.....😄👩🎓🧑🎓🌺🌸🌞",
  },
  {
    imageGallery: [post5301, post5302],
    image: name530,
    id: 530,
    title: "",
    briefText:
      " 🏫 დიდი მადლიერებით და პატივისცემით გაცნობთ ჩვენს ძვირფას, საიმედო  ქალბატონებსა და ბატონებს-\n📌ინგა მიქავას,\n📌ნინო შარაძეს,\n📌ლალი ჩახვაძეს,\n📌ელენა მეფარიშვილს,\n📌გულიკო კეშელავას,\n📌ნათია სვანიძეს ,\n📌გელა დარცმელიძეს,\n📌გია დარცმელიძეს!\nსწორედ მათი დამსახურებით შევხვდით ასე ლამაზად ახალ სასწავლო წელს!\nმათი დაუღავალი და ერთგული შრომის შედეგია მოწესრიგებული, გაპრიალებული საკლასო ოთახები, დერეფნები, დარბაზები, სკოლის ეზო! \nუღრმესი მადლობა თქვენ! 💕💕",
  },
  {
    imageGallery: [post5311, post5312, post5313, post5314, post5315, post5316],
    image: name531,
    id: 531,
    title: "",
    briefText:
      " 🏫🌞 ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა არაერთი ლამაზი ტრადიციის მატარებელია!\n🏫 ერთ-ერთი გამორჩეული დღე ჩვენი სკოლის ცხოვრებაში ყოველწლიურად არის წარჩინებულ კურსდამთავრებულთა დაჯილდოება წმინდა ანდრია პირველწოდებულის მედლით, დიპლომითა და ერთჯერადი სტიპენდიით! \n🏫 ამ დიდებულ ტრადიციას საფუძველი ჩაუყარა გიმნაზიის დამფუძნებელმა მაღალყოვლადუსამღვდელოესმა ბათუმისა და ლაზეთის მიტროპოლიტმა დიმიტრიმ. \n🏫 2025 წლის 21 სექტემბერს ბათუმის ღვთისმშობლის შობის სახელობის ტაძარში მეუფე დიმიტრიმ დალოცა ჩვენი მოსწავლეები, მიულოცა მათ  ცხოვრების უმნიშვნელოვანესი  დღე, გადასცა მედლები, დიპლომები და სტიპენდიები! \n🏫👩🎓👨🎓2024-2025 სასწავლო წელს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის წარჩინებული, წმ. ანდრია პირველწოდებულის სახელობის მედალოსნები არიან:\n🎓ნუცა ხუციშვილი\n🎓ალექსანდრე ჯელია\n🎓ანა გოგიჩაიშვილი\n🎓ანა დარჩიძე\n🎓ლიკა ჯოხაძე\n🎓რატი ნემსაია\n🎓ნატალი თედორაძე\n🎓ელენე ხუჯაძე\n🎓დათა ურუშაძე\n🎓ანანო ხინკილაძე\n🎓ნუცა ნიკოლაიშვილი\n🏫🌞დიდი სიხარულით ვულოცავთ ახალგაზრდებს- დღეს უკვე სტუდენტებს  და ვუსურვებთ  ჯანმრთელობას და წარმატებებს!",
  },
  {
    imageGallery: [post5321, post5322],
    image: name532,
    id: 532,
    title: "",
    briefText:
      " ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VII-2 კლასის მოსწავლეს ალექსანდრე აბაშიძეს 2024 წლის გაზაფხულის სეზონზე კინგსის საერთაშორისო ინგლისური ენის ოლიმპიადაში მონაწილეობისა და ეროვნული გამარჯვებულის ტიტულის მოპოვებისთვის გადაეცა ოქროს მედალი და ფულადი ჯილდო.",
  },
  {
    imageGallery: [post5331, post5332],
    image: name533,
    id: 533,
    title: "",
    briefText:
      ' ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეებმა მონაწილეობა მიიღეს "ეტალონის" საგნობრივ ოლიმპიადებში. \nVII-1 კლასის მოსწავლე ილო იკოშვილი ქართული ენისა და ლიტერატურის ონლაინ ოლიმპიადის ათეულში მოხვდა და ამის დასტურად გადაეცა დიპლომი.\nIX-2 კლასის მოსწავლე ანასტასია შაშიკაძე ლოგიკური აზროვნებისა და ზოგადი განათლების ონლაინ ოლიმპიადაში მიღწეული წარმატებისთვის დაჯილდოვდა სიგელით.',
  },
  {
    imageGallery: [post5341, post5342, post5343, post5344, post5345],
    image: name534,
    id: 534,
    title: "",
    briefText:
      " ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-10 კლასის მოსწავლეებს სსიპ აჭარის სატყეო სააგენტომ უმასპინძლა. \nშეხვედრის ფარგლებში სააგენტოს სპეციალისტებმა ახალგაზრდებისთვის ჩაატარეს ლექცია-სემინარი მდგრადი განვითარების თემაზე. მთავარი მიზანი იყო მოზარდებში გარემოსდაცვითი ცნობიერების ამაღლება და პასუხისმგებლიანი დამოკიდებულების ჩამოყალიბება ბუნებრივი რესურსების მიმართ. \nმდგრადი განვითარება გულისხმობს ეკონომიკური, სოციალური და გარემოსდაცვითი მიმართულებების ურთიერთშეთავსებას. რომლის მიზანია არსებული რესურსების რაციონალურად გამოყენება და მათი დაცვა მომავალი თაობებისთვის. \nსწორედ ამიტომ, ახალგაზრდების განათლება და მათი ჩართულობა ამ პროცესში მნიშვნელოვან საფუძველს ქმნის უფრო მდგრადი მომავლისთვის.\nშეხვედრას უძღვებოდა ჩვენი სკოლის გეოგრაფიის მასწავლებელი, გარემოს დაცვისა და სოციალური რისკების მართვის სპეციალისტი - სესილი გათენაძე.",
  },
  {
    imageGallery: [post5351, post5352, post5353, post5354, post5355],
    image: name535,
    id: 535,
    title: "",
    briefText:
      " 🏢📚 2025 წლის 27 სექტემბერს  ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის ყველა კათედრის მასწავლებელი შეიკრიბა, რათა  შეეჯამებინა წინა სასწავლო წლის მიღწევები, გამოწვევები და გაეზიარებინათ  ერთმანეთისთვის:\n🔹️ კათედრების მიერ განახლებული 2️⃣0️⃣2️⃣5️⃣ - 2️⃣0️⃣2️⃣6️⃣ სასწავლო წლის კურიკულუმები და მათ განხორციელებასთან დაკავშირებული ყველა საჭირო მასალა; \n🔹️ ️სპეციალური საჭიროების და სხვადახვა ინტერესების მქონე მოსწავლეთა მხარდაჭერის განახლებული ხედვა.\n🔹️ურთიერთთანამშრომლობის და სწავლა-სწავლების ხარისხის განვითარებაზე დაკვირვება - გაუმჯობესების განახლებული ხედვა.\n🔹️მშობლების სასკოლო ცხოვრებაში ჩართულობის განახლებული ხედვა.\n🏢📚ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის  სკოლა მუდამ ორიენტირებულია სწავლა-სწავლების პროცესის ხარისხის გაუმჯობესებაზე და ყველა მოსწავლის მხარდაჭერაზე.\n🏢 შეხვედრა წარმართა ბათუმის წმ. ანდრია პირველწოდებულის სახ. სკოლის სტრატეგიული განვითარების ჯგუფის ხელმძღვანელმა ანა ანუშიძემ. \nწარმატებები!❤️🙏",
  },

  {
    imageGallery: [post5361, post5362],
    image: name536,
    id: 536,
    title: "",
    briefText:
      "  ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის 2025-2026 სასწავლო წლის პირველი სემესტრის  კლუბებისა და წრეების მუშაობის გრაფიკი",
  },
  {
    imageGallery: [post5371, post5372, post5373, post5374, post5375],
    image: name537,
    id: 537,
    title: "",
    briefText:
      "🏫 2025 წლის 29 სექტემბერს ხანგრძლივი, წარმატებული და  ნაყოფიერი პედაგოგიური საქმიანობისთვის  საქართველოს განათლების, მეცნიერებისა და ახალგაზრდობის სამინისტროს მადლობის სიგელი გადაეცა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მასწავლებელს /n👩‍🏫 ცისანა კლდიაშვილს/nმომავალი თაობების აღზრდასა და განათლებაში შეტანილი განსაკუთრებული წვლილისთვის! /n💕გილოცავთ, ცისანა მასწავლებელო! /n💕გისურვებთ ჯანმრთელობას და დიდხანს სიცოცხლეს!",
  },
  {
    imageGallery: [post5381, post5382, post5383],
    image: name538,
    id: 538,
    title: "",
    briefText:
      "🖼🎨🖌ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის   ხელოვნების  წრის \"მანეს\" (ხელმძღვანელები სოფო სანიკიძე და ირინა სევოსტიანოვა)  ნორჩ მხატვართა დღევანდელი  ნამუშევრები სერიიდან  \"შემოდგომის ეტიუდები\" 🪾🍁🍂...",
  },

  {
    imageGallery: [post5391, post5392, post5393, post5394],
    image: name539,
    id: 539,
    title: "",
    briefText:
      "⛸️🏆წარმატებით შედგა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლის ქეთევან მახარაძის დებიუტი საერთაშორისო ასპარეზზე. /n⛸️ქეთევანმა პოლონეთის გრან პრის ეტაპს არაჩვეულებრივად გაართვა თავი. მან ჯამში 120 ქულა მოაგროვა  და ემოციური გამოსვლით დაამახსოვრა აუდიტორიას თავი. /n🩷კიდევ უამრავ წარმატებას გისურვებთ ქეთევან!👏👏",
  },

  {
    imageGallery: [post5401],
    image: name540,
    id: 540,
    title: "",
    briefText:
      "🌏🪐დიდი სიხარულით და სიამაყით გვსურს გაცნობოთ, რომ 2025 წლის 4-5 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის XII/2 კლასის მოსწავლეები /n🧑‍🎓 თომა გიორგაძე და /n🧑‍🎓საბა ჯაში /nრეგიონალური NASA Space Apps Challenge-ის გამარჯვებულები გახდნენ ინოვაციური პროექტით \" COSMOS Computing Orbital Service Management and Operations Station\".👏👏👏/n🌐 პროექტის მთავარი მიზანი იყო მდგრად კოსმოსურ ეკონომიკაზე ფოკუსირება და დედამიწის დაბალი ორბიტის კომერციალიზაციის შესაძლებლობების განვითარება./n👨‍💻🧑‍💻მოსწავლეებმა წარმოადგინეს იდეა, რომელიც მიზნად ისახავს კოსმოსური სერვისებისა და ოპერაციების მართვის ცენტრალიზებულ პლატფორმად ქცევას . /n 🪐ასეთი სისტემა მომავალში მნიშვნელოვან წვლილს შეიტანს კოსმოსის რესურსების ეფექტიან გამოყენებასა და საერთაშორისო თანამშრომლობის გაღრმავებაში./n🌏 რთულ და მრავალრიცხოვან კონკურსში ჩვენი სკოლის მოსწავლეებმა თავიანთი ხედვითა და ტექნოლოგიური ინოვაციურობით მოახერხეს რეგიონალური NASA Space Apps Challenge-ის ჟიურის აღფრთოვანება და მათგან მაღალი შეფასების მიღება./n🌏👨‍💻👏👏მათი წარმატება არა მხოლოდ სკოლის, არამედ ბათუმის ახალგაზრდების ინოვაციური პოტენციალის დასტურია ,  მაგალითი იმისა, რომ თანამედროვე ტექნოლოგიებისა და შემოქმედებითი აზროვნების შერწყმით შესაძლებელია გლობალური მასშტაბის იდეების განხორციელება./n🩷🌏ვულოცავთ ჩვენს საამაყო გიმნაზიელებს ამ წარმატებას!👏👏",
  },

  {
    imageGallery: [post5411, post5412, post5413],
    image: name541,
    id: 541,
    title: "",
    briefText:
      " ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის სხვადასხვა საფეხურის მოსწავლეებს კინგსის გაზაფხულისა და  ზაფხულის სეზონის ოლიმპიადების დიპლომები და სერტიფიკატები გადაეცათ.",
  },
  {
    imageGallery: [post5421, post5422, post5423],
    image: name542,
    id: 542,
    title: "",
    briefText: "🌲 მეტყევის დღე — 10 ოქტომბერი 🌿/n🌿10 ოქტომბერს, მეტყევის დღის აღსანიშნავად, აჭარის სატყეო სააგენტოს ორგანიზებით გაიმართა გარემოსდაცვითი ღონისძიება, რომელშიც მონაწილეობა მიიღეს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-12 კლასის მოსწავლეებმა./n🌿მოსწავლეებმა სააგენტოს თანამშრომლებთან ერთად დარგეს ნერგები. აქტივობის  მიზანი იყო ახალგაზრდებში გარემოსდაცვითი ცნობიერების ამაღლება და ტყის მნიშვნელობის პოპულარიზაცია./n🌿ღონისძიების ფარგლებში ბავშვებს მიეწოდათ ინფორმაცია ტყის რესურსების დაცვის მნიშვნელობაზე, ტყის მოვლის პროცესებზე და იმ  როლზე, რომელსაც თითოეული მოქალაქე ასრულებს ბუნების შენარჩუნებაში./n🌿მეტყევის დღე გვახსენებს, რომ ტყე ჩვენი საერთო სიმდიდრეა, მას უნდა მოვუფრთხილდეთ და შევინარჩუნოთ იგი მომავალი თაობებისთვის.",
  },
  {
    imageGallery: [post5431, post5432, post5433],
    image: name543,
    id: 543,
    title: "",
    briefText: "👩‍🎓🧑‍🎓📚ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის  IV-1 კლასის მოსწავლე ალექსანდრე გაფრინდაშვილი, IV-3 კლასის მოსწავლე ინგა ქოქოლაძე, III-4 კლასის მოსწავლეები: ლილე ჩიბურდანიძე, ტაისია კახიძე, საბა ჩიბურდანიძე, ალექსანდრე ხონელია, ერეკლე შერვაშიძე  \"ევერესტის\" ოლიმპიადაში მიღწეული წარმატებისთვის სიგელებით და სერთიფიკატებით დაჯილდოვდნენ. /n👩‍🎓🧑‍🎓გილოცავთ და გისურვებთ წარმატებებს!👏👏",
  },
  {
    imageGallery: [post5441],
    image: name544,
    id: 544,
    title: "",
    briefText: "👩‍🎓🧑‍🎓ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-4 კლასის მოსწავლე დემეტრე შერვაშიძე ქართული ენის ოლიმპიადა \"ევერესტის\"  საგაზაფხულო სეზონის ფინალისტი, დაჯილდოვდა  სიგელით საუკეთესო ასეულში მოხვედრისათვის./nგილოცავთ და გისურვებთ წარმატებებს!👏👏",
  },
  {
    imageGallery: [post5451, post5452, post5453],
    image: name545,
    id: 545,
    title: "",
    briefText: "გიმნაზიის არქივიდან..",
  },
  {
    imageGallery: [post5461,],
    image: name546,
    id: 546,
    title: "",
    briefText: "📜📚ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის “მკითხველთა კლუბი” , კლუბის ხელმძღვანელი მარინა ტალახაძე და მე-12 კლასის მოსწავლეები 2025 წლის 21 ოქტომბერს 10:30 სთ-ზე 202-ე აუდიტორიაში გიწვევთ წიგნის პრეზენტაციაზე. /nნოდარ დევაძე, შოთა ბოლქვაძე, ქეთი გიგაშვილი და ელენს დუმბაძე წარადგენენ გურამ დოჩანაშვილის ნაწარმოებს „სამოსელი პირველი“.",
  },
  {
    imageGallery: [post5471, post5472, post5473],
    image: name547,
    id: 547,
    title: "",
    briefText: "2025 წლის 16-17  ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პედაგოგები ლალი ლომთათიძე და ანა ანუშიძე იმყოფებოდნენ სასწავლო ვიზიტით პოლონეთში,  ქვემო სილეზიაში  ვროცლავის საჯარო სკოლებში. /nვიზიტის შედგა აჭარის ავტონომიური რესპუბლიკის მთავრობისა და განათლებისა და სპორტის სამინისტროს მხარდაჭერით .",
  },
  {
    imageGallery: [post5481, post5482, post5483],
    image: name548,
    id: 548,
    title: "",
    briefText: "📜📚 2025 წლის 21 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის “მკითხველთა კლუბში” , კლუბის ხელმძღვანელმა მარინა ტალახაძემ და მე-12 კლასის მოსწავლეებმა ნოდარ დევაძემ, შოთა ბოლქვაძემ, ქეთი გიგაშვილმა და ელენე დუმბაძემ /nწარადგენენ გურამ დოჩანაშვილის ნაწარმოები „სამოსელი პირველი“.",
  },
  {
    imageGallery: [post5491],
    image: name549,
    id: 549,
    title: "",
    briefText: "📚📖ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის “მკითხველთა კლუბი” , კლუბის ხელმძღვანელი მარინა ტალახაძე და მე-12 კლასის მოსწავლეები 2025 წლის 27 ოქტომბერს 9:50 სთ-ზე 202-ე აუდიტორიაში გიწვევთ წიგნის პრეზენტაციაზე./nნიკა ჩხაიძე,  გაბრიელ გოგუაძე, ანდრია ვასაძე, ალექსანდრე შამილიშვილი, ანა იაკობაძე წარადგენენ ჭაბუა ამირეჯიბის  ნაწარმოებს „დათა თუთაშხია“.",
  },
  {
    imageGallery: [post5501, post5502, post5503],
    image: name550,
    id: 550,
    title: "",
    briefText: "2025 წლის 24 ოქტომბერს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-4 კლასის მოსწავლეები იმყოფებოდნენ აჭარის ხარიტონ ახვლედიანის სახელობის მუზეუმში, სადაც მათ საგანმანათლებლო პროგრამა “შავი ზღვის მრავალფეროვნება” ჩაუტარდათ./n🔹პროგრამას უძღვებოდა მუზეუმის გიდი- კოორდინატორი თამარ დარჩია./n🔹დამრიგებელი ხათუნა მანჯგალაძე",
  },
  {
    imageGallery: [post5511, post5512, post5513],
    image: name551,
    id: 551,
    title: "",
    briefText: "👫 2025 წლის 24 ოქტომბერს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-3 კლასის მოსწავლეები აკაკი წერეთლის სახელობის ბათუმის საჯარო ბიბლიოთეკაში იმყოფებოდნენ, სადაც იტალიელი საბავშვო მწერლის ჯანი როდარის შემოქმედებითი საღამო გაიმართა.  /n👫📚პატარების საყვარელი ზღაპრები და მოთხრობები: ჩიპოლინოს და ჯელსომინოს ჯადოსნური და მხიარული თავგადასავლები, “ნაყინის სახლი“, „შოკოლადის გზა“, „მსუნაგეთის სამეფო“, „გაქცეული ცხვირი“, „უჩინმაჩინი ტონინო“…  მოსწავლეებმა საკუთარ ნახატებში გააცოცხლეს და მცირე ამონარიდებით ავტორის შემოქმედება წარადგინეს. /n👫📚როგორც შეხვედრაზე მასწავლებელმა ნინო უგულავამ აღნიშნა, მოსწავლეები ხელოვნების პედაგოგ ირინა სევასტიანოვასთან ერთად, დღევანდელი საღამოსთვის, ერთი წლის განმავლობაში ემზადებოდნენ. წაიკითხეს მწერლის სხარტი და საინტერესო ზღაპრები და ასტრიდ ლინდგერის გარდა, ახლა მათ ჯანი როდარის სახით, კიდევ ერთი საყვარელი მწერალი ჰყავთ./n👫📚ბათუმის საჯარო ბიბლიოთეკის ბიბლიოთეკარებმა სტუმრებს წიგნის კითხვისა და ბიბლიოთეკის მნიშნელობაზე ესაუბნენ, ასევე წარუდგინეს ჯანი როდარის წიგნები. ყურადღება გამახვილდა “ლექსების მატარებელზე”, რომლის 1968 წლის გამოცემა ბიბლიოთეკის წიგნად ფონდში ინახება. /n👫📚ღონისძების დასასრულს მოსწავლეებმა საკუთარი ნახატები მოსწავლეთა დარბაზს საჩუქრად დაუტოვეს და მკითხველებად დარეგისტრირდნენ./n დამრიგებელი და ხელოვნების პედაგოგი - ირინე სევოსტიანოვა/n ქართული ენის პედაგოგი - ნინო უგულავა",
  },
  {
    imageGallery: [post5521, post5522, post5523],
    image: name552,
    id: 552,
    title: "",
    briefText: "📚📖2025 წლის 27 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის “მკითხველთა კლუბში” ( კლუბის ხელმძღვანელი მარინა ტალახაძე) მე-12 კლასის მოსწავლეებმა  მოაწყვეს  წიგნის პრეზენტაცია./nნიკა ჩხაიძემ,  გაბრიელ გოგუაძემ, ანდრია ვასაძემ, ალექსანდრე შამილიშვილმა, ანა იაკობაძემ წარადგინეს ჭაბუა ამირეჯიბის  ნაწარმოები „დათა თუთაშხია“.",
  },
  {
    imageGallery: [post5531, post5532, post5533],
    image: name553,
    id: 553,
    title: "",
    briefText: "2025 წლის 25 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის კინოკლუბში (კლუბის ხელმძღვანელი ინგა მართალიშვილი) გაიმართა  ფილმის ჩვენება — „12 განრისხებული მამაკაცი“  რომელიც ერთ-ერთი ყველაზე მნიშვნელოვანი ნამუშევარია მართლმსაჯულების, პასუხისმგებლობისა და კრიტიკული აზროვნების თემებზე. /nჩვენების შემდეგ მოსწავლეებმა გამართეს დისკუსია, სადაც იმსჯელეს ისეთ მნიშვნელოვან საკითხებზე, როგორიცაა: /n- უდანაშაულობის პრეზუმფცია  და მართლმსაჯულება'/n-  კონფორმიზმი და კრიტიკული აზროვნება'/n-  სტერეოტიპები და არგუმენტირებული მსჯელობა'/nდისკუსია დაეხმარა  მოსწავლეებს გააზრებულად დაენახათ კრიტიკული აზროვნების, ღირსებისა და სამართლიანობის მნიშვნელობა საზოგადოებრივ ცხოვრებაში.",
  },
  {
    imageGallery: [post5541],
    image: name554,
    id: 554,
    title: "",
    briefText: "🤼‍♂️🏆2025 წლის 28-29 ოქტომბერს თურქეთის, ქალაქ რიზეში გაიმართა  საერთაშორისო სარეიტინგო ტურნირი ბერძნულ-რომაულ ჭიდაობაში, სადაც ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VIII-3 კლასის მოსწავლე ანდრია ტუღუში 4 გამარჯვებით მეორე ადგილის მფლობელი გახდა! /nგილოცავთ, ანდრია! 👏👏/nწარმატებებს გისურვებთ!👏👏",
  },
  {
    imageGallery: [post5551, post5552, post5553],
    image: name555,
    id: 555,
    title: "",
    briefText: "🥋🏆2025 წლის 4-5 ოქტომბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მეათე კლასის მოსწავლე ოთარ შაინიძე აჭარის ჩემპიონი გახდა კონტაქტურ კარატეში. /n🏆გილოცავთ, ოთარ!/nწარმატებებს გისურვებთ!",
  },
  {
    imageGallery: [post5561, post5562, post5563],
    image: name556,
    id: 556,
    title: "",
    briefText: "📖📚 სამი ამბავი ერთ სოფელში/n📚👩‍🎓👨‍🎓ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლაში​  ერთი ჩვეულებრივი გაკვეთილი პატარა ლიტერატურულ ექსპერიმენტად გადაიქცა, როცა ის მეხუთე კლასის მოსწავლეებმა სცენაზე გადმოიტანეს. /nქართული ენისა და ლიტერატურის მასწავლებელი ალექსანდრე მელიქაძე. ​/n\"როლური თამაშების\" ფარგლებში, ბავშვებმა საკუთარი, შეცვლილი სცენარებით  პერსონაჟები გააერთიანეს: მათ სამი სხვადასხვა ქართული მოთხრობის კოლორიტული გმირები ერთი პირობითი სოფლის მაცხოვრებლებად აქციეს!​/nწარმოდგენილი ნაწარმოებები:​/n\"ეთერი\" (რევაზ ინანიშვილი),/n​ \"უკუღმა დაჭედილი\" (რევაზ ინანიშვილი),/n​ \"განელებული კოცონი\" (გივი ბუთხუზი). /nეს პროექტი საუკეთესოდ აჩვენებს, რომ ჩვენი მოსწავლეების კრეატიულობა და ლიტერატურის სიყვარული უსაზღვროა!",
  },
  {
    imageGallery: [post5571, post5572, post5573],
    image: name557,
    id: 557,
    title: "",
    briefText: "📚📖2025 წლის 7 ნოემბერს , ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის VI-2    კლასის მოსწავლეებს ქართული ენის გაკვეთილი ჩაუტარდათ სკოლის ბიბლიოთეკაში./nქართული ენისა და ლიტერატურის მასწავლებლის მარინა მამალაძის და სკოლის ბიბლიოთეკარის ნუნუ გილის  დახმარებით მოსწავლეებმა გაიაზრეს კითხვის მნიშვნელობა; იმსჯელეს -ვინ არის კარგი მკითხველი, შეკითხვები დაუსვეს ბიბლიოთეკარს.",
  },
  {
    imageGallery: [post5581, post5582, post5583],
    image: name558,
    id: 558,
    title: "",
    briefText: "🏆მეცხრეკლასელი მსოფლიო ჩემპიონი /n🏆🥇🥊დიდი სიამაყით და სიხარულით გვსურს კიდევ ერთი დიდი გამარჯვება, მსოფლიო  ჩემპიონობა მივულოცოთ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-9 კლასის მოსწავლეს ფრიდონ ჩხარტიშვილს! /n🏆ფრიდონ, გილოცავთ!/n 🏫🏆  ვულოცავთ ჩვენს სკოლას!/n🏆ვულოცავთ  მთელ საქართველოს! 🇬🇪 /n2025 წლის 31 ოქტომბრიდან 2 ნოემბრამდე იტალიის დედაქალაქ რომში ჩატარდა მსოფლიო ჩემპიონატი კიკბოქსინგი k-1 - ში,  სადაც მონაწილეობა მიიღო  ფრიდონმა და რამდენიმე ბრძოლის გამარჯვებით დასრულების შემდეგ მსოფლიო ჩემპიონობაც დაიმსახურა! /nიცნობდეთ ფრიდონ ჩხარტიშვილს! /nის არის /n🏆მსოფლიოს ორგზის ჩემპიონი,/n🏆ევრაზიის ჩემპიონი,/n🏆საქართველოს ორგზის ჩემპიონი,/n🏆ევროპის ვიცე-ჩემპიონი,/n🏆 საერთაშორისო ტურნირების 15-გზის ჩემპიონი,/n🏆12 ქამრის მფლობელი საქართველოს ნაკრების წევრი! /nგვჯერა, მომავალშიც ბევრჯერ ვიამაყებთ ჩვენი ჩემპიონით!",
  },
  {
    imageGallery: [post5591, post5592, post5593],
    image: name559,
    id: 559,
    title: "",
    briefText: "🏛 ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მე-3 კლასის მოსწავლეების აჭარის ხელოვნების მუზეუმს ეწვივნენ.  /n👩‍🎓მოსწავლეებს  საგანმანათლებლო პროგრამა \"პორტრეტი\" ჩაუტარდათ./ n🔹ხელოვნების მასწავლებელი ირინე სევოსტიანოვა",
  },
  {
    imageGallery: [post5601, post5602, post5603],
    image: name560,
    id: 560,
    title: "",
    briefText: "2025 წლის 12 ნოემბერს, ანდრია პირველწოდებულის სახელობის სკოლის I-2 კლასის მოსწავლეებმა შემოდგომის მშვენიერი დღე გაატარეს \"ბერიძეების ღვინის მარანში\", სადაც პატარებს შემოდგომის ხილით გაუმასპინძლდნენ. ბავშვებმა მონაწილეობა მიიღეს ყურძნის დაწურვაში,უგემრიელესი ქართული ტკბილეულის-ჩურჩხელების ამოვლებაში.  /nაღმზრდელი თამარ კვერღელიძე",
  },
  {
    imageGallery: [post5611, post5612, post5613],
    image: name561,
    id: 561,
    title: "",
    briefText: "2025 წლის 12 ნოემბერს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-IV კლასის მოსწავლეები დაესწრნენ ბათუმის  თოჯინებისა და მოზარდ მაყურებელთა პროფესიულ  სახელმწიფო თეატრში გამართულ ანიმაციური ფილმების ფესტივალს \"თოფუზი\".",
  },
  {
    imageGallery: [post5621, post5622, post5623],
    image: name562,
    id: 562,
    title: "",
    briefText: "2025 წლის  12 ნოემბერს წმინდა ანდრია პირველწოდებულის სახელობის  სკოლის VI-4 კლასის მოსწავლეები ეწვივნენ ეთნოგრაფიულ მუზეუმს \"ბორჯღალო\". /nბავშვებმა დაათვალიერეს აჭარის რეგიონისათვოს დამახასიათებელი საცხოვრებელი და სამეურნეო ნაგებობათა მაკეტები, შრომის იარაღები, საყოფაცხოვრებო ნივთები. მოსწავლეები შეხვდნენ მუზეუმის დამფუძნებელს, ბატონ ქემალ თურმანიძეს, დაუსვეს შეკითხვები. ბავშვების გაოცებას არ ჰქონდა საზღვარი, როდესაც გაიგეს ,რომ მუზეუმში განთავსებული ექსპონატები შექმნილი იყო ბატონი ქემალის მიერ. საოცარი შთაბეჭდილებებით  აივსნენ და  მუზეუმის კვლავ მონახულების სურვილი გამოთქვეს . /nმასწავლებელი ნატალია სირაბიძე და ნაირა ზოიძე",
  },
  {
    imageGallery: [post5631, post5632],
    image: name563,
    id: 563,
    title: "",
    briefText: "⛸️🏆2025 წლის  წლის 13-16 ნოემბერს, ავსტრიაში, ქალაქ  ინსბრუკში ჩატარდა  საერთაშორისო შეჯიბრი ფიგურულ ციგურაობაში “Cup of Innsbruck 2025 “ რომელშიც იუნიორთა კატეგორიაში  წარმატებულად  იასპარეზა  ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლე მოციგურავე ქეთევან მახარაძემ./n🏆წარმატებებს ვუსურვებთ ქეთევანს სპორტულ კარიერაში და სწავლაში!⛸️",
  },
  {
    imageGallery: [post5641, post5642, post5643],
    image: name564,
    id: 564,
    title: "",
    briefText: "2025  წლის 20 ნოემბერს მავნებელ დაავადებებთან ბრძოლის კვირეულის ფარგლებში, სსიპ აჭარის სატყეო სააგენტოს ორგანიზებით, ცნობიერების დონის ამაღლების  და სატყეო პრინციპების გაგების გაღრმავების მიზნით, შუახევის სატყეო ადმინისტრაციის ლაბორატორიაში ქალაქ  ბათუმის წმინდა ანდრია პირველწოდებულის სკოლის მოსწავლეებს ჩაუტარდათ ლექცია - სემინარი./nღონისძიების ორგანიზატორი იყო გეოგრაფიის მასწავლებელი სესილი გათენაძე./n  📚ლექცია-სემინარი მოიცავდა ისეთ საკითხებს, როგორიც არის:/n* მავნებელი დაავადებების წინასწარი აღმოჩენა/n* ქერქიჭამიების მავნე ზემოქმედება  და მათ წინააღმდეგ ბრძოლის ბიოლოგიური მეთოდები/n* ტყის დაცვის მნიშვნელობა და მისი როლი ეკოსისტემაში/n  მოსწავლეები აქტიურად მონაწილეობდნენ პროცესში — ისინი გაეცნენ ლაბორატორიულ პრაქტიკულ საქმიანობას, დაკვირვებისა და ანალიზის მეთოდებს, დასვეს კითხვები და უშუალოდ ნახეს, თუ როგორ მიმდინარეობს მავნებელ დაავადებათა მონიტორინგი. /n  აქტივობის მიზანია მოსწავლეებში გარემოსდაცვითი ცნობიერების ამაღლება და ტყის დაცვის მნიშვნელობის ხაზგასმა.",
  },
  {
    imageGallery: [post5651, post5652],
    image: name565,
    id: 565,
    title: "",
    briefText: "2025 წლის 22-23 ნოემბერს, ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის XI-3 კლასის მოსწავლემ დავით დავითაძემ, ყაზახეთის დედაქალაქ ალმაატაში გამართულ ძალოსნობის ჩემპიონატზე 16-17 წლამდე ჭაბუკთა შორის დაიკავა პირველი ადგილი შტანგით წოლჭიმსა და სტანდარტულ აწევაში.",
  },
  {
    imageGallery: [post5661, post5662, post5663],
    image: name566,
    id: 566,
    title: "",
    briefText: "2025 წლის 23 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის III-4 კლასის მოსწავლეების ეწვივნენ ბათუმის ციფრულ სივრცეს, სადაც მათ ნახეს ვიდეო წარმოდგენა  - ზღვის სამყარო და ვაჟას \"ხმელი წიფელი\". /nმასწავლებელი ირინე სევოსტიანოვა",
  },
  {
    imageGallery: [post5671, post5672, post5673],
    image: name567,
    id: 567,
    title: "",
    briefText: "📚📖2025 წლის 23 ნოემბერს ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის “მკითხველთა კლუბში” ( კლუბის ხელმძღვანელი მარინა ტალახაძე) მე-12 კლასის მოსწავლე   გიორგი ცინცაძემ აუდიტორიას წარუდგინა ჯემალ ქარჩხაძის \"ანტონიო და დავითი\". პრეზენტაციის შემდეგ კლუბის წევრებმა ისაუბრეს ნაწარმოების შესახებ.",
  },
  {
    imageGallery: [post5681, post5682],
    image: name568,
    id: 568,
    title: "",
    briefText: "👫🌞🏆 \"კინგსის\" ოლიმპიადის გამარჯვებული ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის მოსწავლეები /n🎓მართა გალატალი,/n🎓ტაისია კახიძე, /n🎓ანამარია ბერიძე, /n🎓ანდრია ცენტერაძე, /n🎓ალექსანდრე თებიძე, /n🎓ბიძინა ჩიჯავაძე დაჯილდოვდნენ  დიპლომებით და მედლებით.",
  },
  {
    imageGallery: [post5691, post5692, post5693],
    image: name569,
    id: 569,
    title: "",
    briefText: "📚📖 2025 წლის 22-23 ნოემბერს ოზურგეთის წმ. გაბრიელ ეპისკოპოსის სახელობის  მართლმადიდებლური სკოლის ორგანიზებით გაიმართა სამეცნიერო  კონფერენცია თემაზე \"გაბრიელ ეპისკოპოსი _ მეცნიერი და მოძღვარი\". /n📚კონფერენცის მუშაობაში მონაწილეობდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის ქართული ენისა და ლიტერატურის და  საღვრთო სჯულის პედაგოგი ალექსანდრე მელიქაძე, რომელმაც დამსწრე საზოგადოებას წარუდგინა მოხსენება:  \"ქრისტიანული შემეცნება, როგორც სულიერ ფასეულობათა „ეკვილიბრიუმი\" _ წმინდა გაბრიელ ეპისკოპოსის მოძღვრება გონის, ნებისა და ქრისტიანული ზნეობის ერთიანობის შესახებ\".",
  },
  {
    imageGallery: [post5701, post5702],
    image: name570,
    id: 570,
    title: "",
    briefText: "🎉👩‍🏫🎆 დიდი სიხარულით გვსურს გაუწყოთ, რომ 2025 წლის  მასწავლებლის გლობალური ჯილდოს მფლობელი გახდა ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის პედაგოგი ანა ანუშიძე! /n ✨️დაჯილდოების ცერემონია შედგა ინდოეთში. ანას ჯილდო გადასცა  საქართველოს ელჩმა ინდოეთში. 🇬🇪 🇮🇳💕",
  },

];

export default posts;
